/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement Api Formalite
 * API de gestion des formalite
 *
 * The version of the OpenAPI document: 2.1.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActionDetailJsonldActionDetailRead
 */
export interface ActionDetailJsonldActionDetailRead {
    /**
     * 
     * @type {string}
     * @memberof ActionDetailJsonldActionDetailRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDetailJsonldActionDetailRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionDetailJsonldActionDetailRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
}
/**
 * @type ActionDetailJsonldActionDetailReadContext
 * @export
 */
export type ActionDetailJsonldActionDetailReadContext = ActionDetailJsonldActionDetailReadContextOneOf | string;

/**
 * 
 * @export
 * @interface ActionDetailJsonldActionDetailReadContextOneOf
 */
export interface ActionDetailJsonldActionDetailReadContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ActionDetailJsonldActionDetailReadContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDetailJsonldActionDetailReadContextOneOf
     */
    'hydra': ActionDetailJsonldActionDetailReadContextOneOfHydraEnum;
}

export const ActionDetailJsonldActionDetailReadContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type ActionDetailJsonldActionDetailReadContextOneOfHydraEnum = typeof ActionDetailJsonldActionDetailReadContextOneOfHydraEnum[keyof typeof ActionDetailJsonldActionDetailReadContextOneOfHydraEnum];

/**
 * 
 * @export
 * @interface ActionsEtActivitSActionCreate
 */
export interface ActionsEtActivitSActionCreate {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActionCreate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionCreate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionCreate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActionCreated
 */
export interface ActionsEtActivitSActionCreated {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActionCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActionCreated
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailActionCreated}
     * @memberof ActionsEtActivitSActionCreated
     */
    'action'?: TblActionDetailActionCreated | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionCreated
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActionRead
 */
export interface ActionsEtActivitSActionRead {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActionRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActionRead
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailActionRead}
     * @memberof ActionsEtActivitSActionRead
     */
    'action'?: TblActionDetailActionRead | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionRead
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActionUpdate
 */
export interface ActionsEtActivitSActionUpdate {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActionUpdate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionUpdate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActionUpdate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActiviteCreate
 */
export interface ActionsEtActivitSActiviteCreate {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActiviteCreate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteCreate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteCreate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActiviteCreated
 */
export interface ActionsEtActivitSActiviteCreated {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActiviteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActiviteCreated
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailActiviteCreated}
     * @memberof ActionsEtActivitSActiviteCreated
     */
    'action'?: TblActionDetailActiviteCreated | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {FproDossierActiviteCreated}
     * @memberof ActionsEtActivitSActiviteCreated
     */
    'dossier'?: FproDossierActiviteCreated | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActiviteRead
 */
export interface ActionsEtActivitSActiviteRead {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActiviteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActiviteRead
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailActiviteRead}
     * @memberof ActionsEtActivitSActiviteRead
     */
    'action'?: TblActionDetailActiviteRead | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {FproDossierActiviteRead}
     * @memberof ActionsEtActivitSActiviteRead
     */
    'dossier'?: FproDossierActiviteRead | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSActiviteUpdate
 */
export interface ActionsEtActivitSActiviteUpdate {
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSActiviteUpdate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteUpdate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSActiviteUpdate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActionCreate
 */
export interface ActionsEtActivitSJsonldActionCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActionCreated
 */
export interface ActionsEtActivitSJsonldActionCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailJsonldActionCreated}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    'action'?: TblActionDetailJsonldActionCreated | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionCreated
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActionRead
 */
export interface ActionsEtActivitSJsonldActionRead {
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailJsonldActionRead}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    'action'?: TblActionDetailJsonldActionRead | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionRead
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActionUpdate
 */
export interface ActionsEtActivitSJsonldActionUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActionUpdate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActiviteCreate
 */
export interface ActionsEtActivitSJsonldActiviteCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActiviteCreated
 */
export interface ActionsEtActivitSJsonldActiviteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailJsonldActiviteCreated}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    'action'?: TblActionDetailJsonldActiviteCreated | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {FproDossierJsonldActiviteCreated}
     * @memberof ActionsEtActivitSJsonldActiviteCreated
     */
    'dossier'?: FproDossierJsonldActiviteCreated | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActiviteRead
 */
export interface ActionsEtActivitSJsonldActiviteRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    'user'?: number | null;
    /**
     * 
     * @type {TblActionDetailJsonldActiviteRead}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    'action'?: TblActionDetailJsonldActiviteRead | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {FproDossierJsonldActiviteRead}
     * @memberof ActionsEtActivitSJsonldActiviteRead
     */
    'dossier'?: FproDossierJsonldActiviteRead | null;
}
/**
 * 
 * @export
 * @interface ActionsEtActivitSJsonldActiviteUpdate
 */
export interface ActionsEtActivitSJsonldActiviteUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionsEtActivitSJsonldActiviteUpdate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection200Response
 */
export interface ApiAcomptesGetCollection200Response {
    /**
     * 
     * @type {Array<ReglementsEtAcomptesCBJsonldAcompteRead>}
     * @memberof ApiAcomptesGetCollection200Response
     */
    'hydra:member': Array<ReglementsEtAcomptesCBJsonldAcompteRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiAcomptesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiAcomptesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiAcomptesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection200ResponseHydraSearch
 */
export interface ApiAcomptesGetCollection200ResponseHydraSearch {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearch
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearch
     */
    'hydra:template'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearch
     */
    'hydra:variableRepresentation'?: string;
    /**
     * 
     * @type {Array<ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner>}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearch
     */
    'hydra:mapping'?: Array<ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner>;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner
 */
export interface ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'variable'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'property'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAcomptesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection200ResponseHydraView
 */
export interface ApiAcomptesGetCollection200ResponseHydraView {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraView
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraView
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraView
     */
    'hydra:first'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraView
     */
    'hydra:last'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraView
     */
    'hydra:previous'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection200ResponseHydraView
     */
    'hydra:next'?: string;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection401Response
 */
export interface ApiAcomptesGetCollection401Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection403Response
 */
export interface ApiAcomptesGetCollection403Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection403Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAcomptesGetCollection403ResponseException}
     * @memberof ApiAcomptesGetCollection403Response
     */
    'exception'?: ApiAcomptesGetCollection403ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAcomptesGetCollection403ResponseException
 */
export interface ApiAcomptesGetCollection403ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesGetCollection403ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAcomptesGetCollection403ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiAcomptesIdGet404Response
 */
export interface ApiAcomptesIdGet404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesIdGet404Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAcomptesIdGet404ResponseException}
     * @memberof ApiAcomptesIdGet404Response
     */
    'exception'?: ApiAcomptesIdGet404ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAcomptesIdGet404ResponseException
 */
export interface ApiAcomptesIdGet404ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesIdGet404ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAcomptesIdGet404ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiAcomptesPost400Response
 */
export interface ApiAcomptesPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesPost400Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAcomptesPost400ResponseException}
     * @memberof ApiAcomptesPost400Response
     */
    'exception'?: ApiAcomptesPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAcomptesPost400ResponseException
 */
export interface ApiAcomptesPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesPost400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAcomptesPost400ResponseException
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface ApiActionDetailsGetCollection200Response
 */
export interface ApiActionDetailsGetCollection200Response {
    /**
     * 
     * @type {Array<ActionDetailJsonldActionDetailRead>}
     * @memberof ApiActionDetailsGetCollection200Response
     */
    'hydra:member': Array<ActionDetailJsonldActionDetailRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiActionDetailsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiActionDetailsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiActionDetailsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiActionsIdPut400Response
 */
export interface ApiActionsIdPut400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiActionsIdPut400Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiActionsIdPut400ResponseException}
     * @memberof ApiActionsIdPut400Response
     */
    'exception'?: ApiActionsIdPut400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiActionsIdPut400ResponseException
 */
export interface ApiActionsIdPut400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiActionsIdPut400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiActionsIdPut400ResponseException
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationFactureGetCollection200Response
 */
export interface ApiArticlesPrestationFactureGetCollection200Response {
    /**
     * 
     * @type {Array<PrestationArticlesJsonldPrestationrelationfactureRead>}
     * @memberof ApiArticlesPrestationFactureGetCollection200Response
     */
    'hydra:member': Array<PrestationArticlesJsonldPrestationrelationfactureRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiArticlesPrestationFactureGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiArticlesPrestationFactureGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiArticlesPrestationFactureGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationGetCollection200Response
 */
export interface ApiArticlesPrestationGetCollection200Response {
    /**
     * 
     * @type {Array<PrestationArticlesJsonldPrestationrelationRead>}
     * @memberof ApiArticlesPrestationGetCollection200Response
     */
    'hydra:member': Array<PrestationArticlesJsonldPrestationrelationRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiArticlesPrestationGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiArticlesPrestationGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiArticlesPrestationGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdAttacherAnnonceLegalePatch400Response
 */
export interface ApiArticlesPrestationIdAttacherAnnonceLegalePatch400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400Response
     */
    'exception': ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException
 */
export interface ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseExceptionViolationsInner>}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseException
     */
    'violations'?: Array<ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseExceptionViolationsInner
 */
export interface ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatch400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest
 */
export interface ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest
     */
    'idAnnonceLegale'?: number;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdPut400Response
 */
export interface ApiArticlesPrestationIdPut400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiArticlesPrestationIdPut400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiArticlesPrestationIdPut400ResponseException}
     * @memberof ApiArticlesPrestationIdPut400Response
     */
    'exception': ApiArticlesPrestationIdPut400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdPut400ResponseException
 */
export interface ApiArticlesPrestationIdPut400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiArticlesPrestationIdPut400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiArticlesPrestationIdPut400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiArticlesPrestationIdPut400ResponseExceptionViolationsInner>}
     * @memberof ApiArticlesPrestationIdPut400ResponseException
     */
    'violations'?: Array<ApiArticlesPrestationIdPut400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationIdPut400ResponseExceptionViolationsInner
 */
export interface ApiArticlesPrestationIdPut400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiArticlesPrestationIdPut400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiArticlesPrestationIdPut400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationPost400Response
 */
export interface ApiArticlesPrestationPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiArticlesPrestationPost400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiArticlesPrestationPost400ResponseException}
     * @memberof ApiArticlesPrestationPost400Response
     */
    'exception': ApiArticlesPrestationPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationPost400ResponseException
 */
export interface ApiArticlesPrestationPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiArticlesPrestationPost400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiArticlesPrestationPost400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiArticlesPrestationPost400ResponseExceptionViolationsInner>}
     * @memberof ApiArticlesPrestationPost400ResponseException
     */
    'violations'?: Array<ApiArticlesPrestationPost400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiArticlesPrestationPost400ResponseExceptionViolationsInner
 */
export interface ApiArticlesPrestationPost400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiArticlesPrestationPost400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiArticlesPrestationPost400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiCategoriesGetCollection200Response
 */
export interface ApiCategoriesGetCollection200Response {
    /**
     * 
     * @type {Array<CategorieJsonldCategorieRead>}
     * @memberof ApiCategoriesGetCollection200Response
     */
    'hydra:member': Array<CategorieJsonldCategorieRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiCategoriesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiCategoriesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiCategoriesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiCategoriesPost400Response
 */
export interface ApiCategoriesPost400Response {
    /**
     * 
     * @type {ApiCategoriesPost400ResponseError}
     * @memberof ApiCategoriesPost400Response
     */
    'error'?: ApiCategoriesPost400ResponseError;
}
/**
 * 
 * @export
 * @interface ApiCategoriesPost400ResponseError
 */
export interface ApiCategoriesPost400ResponseError {
    /**
     * 
     * @type {string}
     * @memberof ApiCategoriesPost400ResponseError
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiCategoriesPost400ResponseError
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface ApiCollectionsDossiersGetCollection200Response
 */
export interface ApiCollectionsDossiersGetCollection200Response {
    /**
     * 
     * @type {Array<CollectionDeDossierJsonldCollectiondossierRead>}
     * @memberof ApiCollectionsDossiersGetCollection200Response
     */
    'hydra:member': Array<CollectionDeDossierJsonldCollectiondossierRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiCollectionsDossiersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiCollectionsDossiersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiCollectionsDossiersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiCollectionsDossiersIdCalculatePut400Response
 */
export interface ApiCollectionsDossiersIdCalculatePut400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiCollectionsDossiersIdCalculatePut400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiCollectionsDossiersIdCalculatePut400ResponseException}
     * @memberof ApiCollectionsDossiersIdCalculatePut400Response
     */
    'exception': ApiCollectionsDossiersIdCalculatePut400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiCollectionsDossiersIdCalculatePut400ResponseException
 */
export interface ApiCollectionsDossiersIdCalculatePut400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiCollectionsDossiersIdCalculatePut400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiCollectionsDossiersIdCalculatePut400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiCollectionsDossiersIdCalculatePut400ResponseExceptionViolationsInner>}
     * @memberof ApiCollectionsDossiersIdCalculatePut400ResponseException
     */
    'violations'?: Array<ApiCollectionsDossiersIdCalculatePut400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiCollectionsDossiersIdCalculatePut400ResponseExceptionViolationsInner
 */
export interface ApiCollectionsDossiersIdCalculatePut400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiCollectionsDossiersIdCalculatePut400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiCollectionsDossiersIdCalculatePut400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiCollectionsDossiersIdDuplicatePutRequest
 */
export interface ApiCollectionsDossiersIdDuplicatePutRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiCollectionsDossiersIdDuplicatePutRequest
     */
    'prestationsIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiCollectionsDossiersIdDuplicatePutRequest
     */
    'reinitFormPrestationsIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiCollectionsDossiersIdDuplicatePutRequest
     */
    'documentsIds'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ApiCollectionsDossiersIdDuplicatePutRequest
     */
    'prescriberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiCollectionsDossiersIdDuplicatePutRequest
     */
    'operatedClientId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiCollectionsDossiersIdDuplicatePutRequest
     */
    'billedClientId'?: number;
}
/**
 * 
 * @export
 * @interface ApiDevisGetCollection200Response
 */
export interface ApiDevisGetCollection200Response {
    /**
     * 
     * @type {Array<DevisJsonldDevisRead>}
     * @memberof ApiDevisGetCollection200Response
     */
    'hydra:member': Array<DevisJsonldDevisRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDevisGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDevisGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDevisGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDocumentgedTypeApplicationtagGetCollection200Response
 */
export interface ApiDocumentgedTypeApplicationtagGetCollection200Response {
    /**
     * 
     * @type {Array<DocumentGedJsonld>}
     * @memberof ApiDocumentgedTypeApplicationtagGetCollection200Response
     */
    'hydra:member': Array<DocumentGedJsonld>;
    /**
     * 
     * @type {number}
     * @memberof ApiDocumentgedTypeApplicationtagGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDocumentgedTypeApplicationtagGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDocumentgedTypeApplicationtagGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner
 */
export interface ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner {
    /**
     * 
     * @type {string}
     * @memberof ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner
     */
    'tag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ApiDomainesGetCollection200Response
 */
export interface ApiDomainesGetCollection200Response {
    /**
     * 
     * @type {Array<DomainesJsonldDomaineRead>}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:member': Array<DomainesJsonldDomaineRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossierIdDossiersSignGetCollection200Response
 */
export interface ApiDossierIdDossiersSignGetCollection200Response {
    /**
     * 
     * @type {Array<DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead>}
     * @memberof ApiDossierIdDossiersSignGetCollection200Response
     */
    'hydra:member': Array<DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossierIdDossiersSignGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossierIdDossiersSignGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossierIdDossiersSignGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossierIdDossiersSignPost400Response
 */
export interface ApiDossierIdDossiersSignPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiDossierIdDossiersSignPost400Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiDossierIdDossiersSignPost400ResponseException}
     * @memberof ApiDossierIdDossiersSignPost400Response
     */
    'exception'?: ApiDossierIdDossiersSignPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiDossierIdDossiersSignPost400ResponseException
 */
export interface ApiDossierIdDossiersSignPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiDossierIdDossiersSignPost400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiDossierIdDossiersSignPost400ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierActionsGetCollection200Response
 */
export interface ApiDossiersDossierActionsGetCollection200Response {
    /**
     * 
     * @type {Array<ActionsEtActivitSJsonldActionRead>}
     * @memberof ApiDossiersDossierActionsGetCollection200Response
     */
    'hydra:member': Array<ActionsEtActivitSJsonldActionRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierActionsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierActionsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierActionsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierFichiersGetCollection200Response
 */
export interface ApiDossiersDossierFichiersGetCollection200Response {
    /**
     * 
     * @type {Array<FichiersDossierJsonldDocumentfileRead>}
     * @memberof ApiDossiersDossierFichiersGetCollection200Response
     */
    'hydra:member': Array<FichiersDossierJsonldDocumentfileRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierFichiersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierFichiersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierFichiersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierMessagesGetCollection200Response
 */
export interface ApiDossiersDossierMessagesGetCollection200Response {
    /**
     * 
     * @type {Array<MessageJsonldMessageRead>}
     * @memberof ApiDossiersDossierMessagesGetCollection200Response
     */
    'hydra:member': Array<MessageJsonldMessageRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierMessagesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierMessagesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierMessagesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierNotesGetCollection200Response
 */
export interface ApiDossiersDossierNotesGetCollection200Response {
    /**
     * 
     * @type {Array<NotesEtRappelsJsonldNoteRead>}
     * @memberof ApiDossiersDossierNotesGetCollection200Response
     */
    'hydra:member': Array<NotesEtRappelsJsonldNoteRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierNotesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierNotesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierNotesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierPrestationsGetCollection200Response
 */
export interface ApiDossiersDossierPrestationsGetCollection200Response {
    /**
     * 
     * @type {Array<PrestationJsonldPrestationRead>}
     * @memberof ApiDossiersDossierPrestationsGetCollection200Response
     */
    'hydra:member': Array<PrestationJsonldPrestationRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierPrestationsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierPrestationsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierPrestationsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierRappelsGetCollection200Response
 */
export interface ApiDossiersDossierRappelsGetCollection200Response {
    /**
     * 
     * @type {Array<NotesEtRappelsJsonldNoterappelReadCollection>}
     * @memberof ApiDossiersDossierRappelsGetCollection200Response
     */
    'hydra:member': Array<NotesEtRappelsJsonldNoterappelReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierRappelsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierRappelsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierRappelsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierTypesDocDossierGetCollection200Response
 */
export interface ApiDossiersDossierTypesDocDossierGetCollection200Response {
    /**
     * 
     * @type {Array<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead>}
     * @memberof ApiDossiersDossierTypesDocDossierGetCollection200Response
     */
    'hydra:member': Array<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierTypesDocDossierGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierTypesDocDossierGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierTypesDocDossierGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierValidationGetCollection200Response
 */
export interface ApiDossiersDossierValidationGetCollection200Response {
    /**
     * 
     * @type {Array<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>}
     * @memberof ApiDossiersDossierValidationGetCollection200Response
     */
    'hydra:member': Array<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierValidationGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierValidationGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierValidationGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersGetCollection200Response
 */
export interface ApiDossiersGetCollection200Response {
    /**
     * 
     * @type {Array<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof ApiDossiersGetCollection200Response
     */
    'hydra:member': Array<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdDematFacileDocumentsPut200Response
 */
export interface ApiDossiersIdDematFacileDocumentsPut200Response {
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdDematFacileDocumentsPut200Response
     */
    'idDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdDematFacileDocumentsPut200Response
     */
    'idDematfacile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdDematFacileDocumentsPut200Response
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdDematFacileDocumentsPut200Response
     */
    'success'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdDematFacileDocumentsPut200Response
     */
    'failed'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApiDossiersIdDematFacileDocumentsPut200Response
     */
    'results'?: Array<object>;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdDeplacerPatchRequest
 */
export interface ApiDossiersIdDeplacerPatchRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiDossiersIdDeplacerPatchRequest
     */
    'prestationsIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiDossiersIdDeplacerPatchRequest
     */
    'documentsIds'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdDeplacerPatchRequest
     */
    'dossierId'?: number;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdDissocierPatchRequest
 */
export interface ApiDossiersIdDissocierPatchRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiDossiersIdDissocierPatchRequest
     */
    'prestationsIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiDossiersIdDissocierPatchRequest
     */
    'documentsIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdNotesGet200Response
 */
export interface ApiDossiersIdNotesGet200Response {
    /**
     * 
     * @type {Array<ApiDossiersIdNotesGet200ResponseNotesInner>}
     * @memberof ApiDossiersIdNotesGet200Response
     */
    'notes'?: Array<ApiDossiersIdNotesGet200ResponseNotesInner>;
    /**
     * 
     * @type {ApiDossiersIdNotesGet200ResponseMeta}
     * @memberof ApiDossiersIdNotesGet200Response
     */
    'meta'?: ApiDossiersIdNotesGet200ResponseMeta;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdNotesGet200ResponseMeta
 */
export interface ApiDossiersIdNotesGet200ResponseMeta {
    /**
     * Nombre total de notes
     * @type {number}
     * @memberof ApiDossiersIdNotesGet200ResponseMeta
     */
    'total'?: number;
    /**
     * Page actuelle
     * @type {number}
     * @memberof ApiDossiersIdNotesGet200ResponseMeta
     */
    'page'?: number;
    /**
     * Nombre d\'éléments par page
     * @type {number}
     * @memberof ApiDossiersIdNotesGet200ResponseMeta
     */
    'limit'?: number;
    /**
     * Nombre total de pages
     * @type {number}
     * @memberof ApiDossiersIdNotesGet200ResponseMeta
     */
    'pages'?: number;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdNotesGet200ResponseNotesInner
 */
export interface ApiDossiersIdNotesGet200ResponseNotesInner {
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'highlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'memoClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'updatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesGet200ResponseNotesInner
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdNotesNoteIdPut200Response
 */
export interface ApiDossiersIdNotesNoteIdPut200Response {
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdNotesNoteIdPut200Response
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesNoteIdPut200Response
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersIdNotesNoteIdPut200Response
     */
    'highlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersIdNotesNoteIdPut200Response
     */
    'memoClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesNoteIdPut200Response
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesNoteIdPut200Response
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdNotesPostRequest
 */
export interface ApiDossiersIdNotesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdNotesPostRequest
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersIdNotesPostRequest
     */
    'highlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersIdNotesPostRequest
     */
    'memoClient'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdTransitionsGetCollection200Response
 */
export interface ApiDossiersIdTransitionsGetCollection200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200Response
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200Response
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner>}
     * @memberof ApiDossiersIdTransitionsGetCollection200Response
     */
    'hydra:member'?: Array<ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner>;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner
 */
export interface ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner {
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner
     */
    'identifier'?: string;
    /**
     * 
     * @type {ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner
     */
    'target'?: ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInner
     */
    'displaySortOrder'?: number;
}
/**
 * 
 * @export
 * @interface ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget
 */
export interface ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget {
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersIdTransitionsGetCollection200ResponseHydraMemberInnerTarget
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface ApiDossiersValidationIdActionPutRequest
 */
export interface ApiDossiersValidationIdActionPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersValidationIdActionPutRequest
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersValidationIdActionPutRequest
     */
    'externalUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDossiersValidationIdActionPutRequest
     */
    'deleteDetail'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiDossiersValidationPrestationArticlesIdPutRequestInner
 */
export interface ApiDossiersValidationPrestationArticlesIdPutRequestInner {
    /**
     * 
     * @type {string}
     * @memberof ApiDossiersValidationPrestationArticlesIdPutRequestInner
     */
    'action'?: ApiDossiersValidationPrestationArticlesIdPutRequestInnerActionEnum;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersValidationPrestationArticlesIdPutRequestInner
     */
    'prestaArtId'?: number;
}

export const ApiDossiersValidationPrestationArticlesIdPutRequestInnerActionEnum = {
    Add: 'ADD',
    Remove: 'REMOVE'
} as const;

export type ApiDossiersValidationPrestationArticlesIdPutRequestInnerActionEnum = typeof ApiDossiersValidationPrestationArticlesIdPutRequestInnerActionEnum[keyof typeof ApiDossiersValidationPrestationArticlesIdPutRequestInnerActionEnum];

/**
 * 
 * @export
 * @interface ApiDossiersValideursGetCollection200Response
 */
export interface ApiDossiersValideursGetCollection200Response {
    /**
     * 
     * @type {Array<ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead>}
     * @memberof ApiDossiersValideursGetCollection200Response
     */
    'hydra:member': Array<ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersValideursGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiDossiersValideursGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersValideursGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiEtapesDossiersGetCollection200Response
 */
export interface ApiEtapesDossiersGetCollection200Response {
    /**
     * 
     * @type {Array<TapesDeTraitementDesDossiersJsonldStepsDossierRead>}
     * @memberof ApiEtapesDossiersGetCollection200Response
     */
    'hydra:member': Array<TapesDeTraitementDesDossiersJsonldStepsDossierRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiEtapesDossiersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiEtapesDossiersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiEtapesDossiersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiFichiersPost400Response
 */
export interface ApiFichiersPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiFichiersPost400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiFichiersPost400ResponseException}
     * @memberof ApiFichiersPost400Response
     */
    'exception': ApiFichiersPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiFichiersPost400ResponseException
 */
export interface ApiFichiersPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiFichiersPost400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiFichiersPost400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiFichiersPost400ResponseExceptionViolationsInner>}
     * @memberof ApiFichiersPost400ResponseException
     */
    'violations'?: Array<ApiFichiersPost400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiFichiersPost400ResponseExceptionViolationsInner
 */
export interface ApiFichiersPost400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiFichiersPost400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiFichiersPost400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiFormalistesGetCollection200Response
 */
export interface ApiFormalistesGetCollection200Response {
    /**
     * 
     * @type {Array<FormalisteJsonldFormalisteRead>}
     * @memberof ApiFormalistesGetCollection200Response
     */
    'hydra:member': Array<FormalisteJsonldFormalisteRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiFormalistesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiFormalistesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiFormalistesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiFormalitesGetCollection200Response
 */
export interface ApiFormalitesGetCollection200Response {
    /**
     * 
     * @type {Array<FormaliteJsonldFormaliteRead>}
     * @memberof ApiFormalitesGetCollection200Response
     */
    'hydra:member': Array<FormaliteJsonldFormaliteRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiFormalitesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiFormalitesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiFormalitesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiFormalitesPost400Response
 */
export interface ApiFormalitesPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiFormalitesPost400Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiFormalitesPost400ResponseException}
     * @memberof ApiFormalitesPost400Response
     */
    'exception'?: ApiFormalitesPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiFormalitesPost400ResponseException
 */
export interface ApiFormalitesPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiFormalitesPost400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiFormalitesPost400ResponseException
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface ApiFormesJuridiquesGetCollection200Response
 */
export interface ApiFormesJuridiquesGetCollection200Response {
    /**
     * 
     * @type {Array<FormeJuridiqueJsonldFormejuridiqueRead>}
     * @memberof ApiFormesJuridiquesGetCollection200Response
     */
    'hydra:member': Array<FormeJuridiqueJsonldFormejuridiqueRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiFormesJuridiquesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiFormesJuridiquesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiFormesJuridiquesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiGreffesGetCollection200Response
 */
export interface ApiGreffesGetCollection200Response {
    /**
     * 
     * @type {Array<GreffeJsonldGreffeRead>}
     * @memberof ApiGreffesGetCollection200Response
     */
    'hydra:member': Array<GreffeJsonldGreffeRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiGreffesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiGreffesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiGreffesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response
 */
export interface ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response {
    /**
     * 
     * @type {Array<LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded>}
     * @memberof ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response
     */
    'hydra:member': Array<LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionDevisGetActionLoggerDevisClientCollection200Response
 */
export interface ApiLogActionDevisGetActionLoggerDevisClientCollection200Response {
    /**
     * 
     * @type {Array<LogActionDevisLogActionDtoJsonldLogRead>}
     * @memberof ApiLogActionDevisGetActionLoggerDevisClientCollection200Response
     */
    'hydra:member': Array<LogActionDevisLogActionDtoJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionDevisGetActionLoggerDevisClientCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionDevisGetActionLoggerDevisClientCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionDevisGetActionLoggerDevisClientCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionDevisGetActionLoggerDevisCollection200Response
 */
export interface ApiLogActionDevisGetActionLoggerDevisCollection200Response {
    /**
     * 
     * @type {Array<LogActionDevisLogActionDtoJsonldLogReadExpanded>}
     * @memberof ApiLogActionDevisGetActionLoggerDevisCollection200Response
     */
    'hydra:member': Array<LogActionDevisLogActionDtoJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionDevisGetActionLoggerDevisCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionDevisGetActionLoggerDevisCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionDevisGetActionLoggerDevisCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response
 */
export interface ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response {
    /**
     * 
     * @type {Array<LogActionDossierJsonldLogRead>}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response
     */
    'hydra:member': Array<LogActionDossierJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionDossiersGetActionLoggerDossierCollection200Response
 */
export interface ApiLogActionDossiersGetActionLoggerDossierCollection200Response {
    /**
     * 
     * @type {Array<LogActionDossierLogActionDtoJsonldLogReadExpanded>}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierCollection200Response
     */
    'hydra:member': Array<LogActionDossierLogActionDtoJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionDossiersGetActionLoggerDossierCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response
 */
export interface ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response {
    /**
     * 
     * @type {Array<LogActionFactureLogActionDtoJsonldLogRead>}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response
     */
    'hydra:member': Array<LogActionFactureLogActionDtoJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionFacturesGetActionLoggerFactureCollection200Response
 */
export interface ApiLogActionFacturesGetActionLoggerFactureCollection200Response {
    /**
     * 
     * @type {Array<LogActionFactureLogActionDtoJsonldLogReadExpanded>}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureCollection200Response
     */
    'hydra:member': Array<LogActionFactureLogActionDtoJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionFacturesGetActionLoggerFactureCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionTiersGetActionLoggerTiersClientCollection200Response
 */
export interface ApiLogActionTiersGetActionLoggerTiersClientCollection200Response {
    /**
     * 
     * @type {Array<LogActionTiersLogActionDtoJsonldLogRead>}
     * @memberof ApiLogActionTiersGetActionLoggerTiersClientCollection200Response
     */
    'hydra:member': Array<LogActionTiersLogActionDtoJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionTiersGetActionLoggerTiersClientCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionTiersGetActionLoggerTiersClientCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionTiersGetActionLoggerTiersClientCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionTiersGetActionLoggerTiersCollection200Response
 */
export interface ApiLogActionTiersGetActionLoggerTiersCollection200Response {
    /**
     * 
     * @type {Array<LogActionTiersLogActionDtoJsonldLogReadExpanded>}
     * @memberof ApiLogActionTiersGetActionLoggerTiersCollection200Response
     */
    'hydra:member': Array<LogActionTiersLogActionDtoJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionTiersGetActionLoggerTiersCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionTiersGetActionLoggerTiersCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionTiersGetActionLoggerTiersCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response
 */
export interface ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response {
    /**
     * 
     * @type {Array<LogActionUtilisateurLogActionDtoJsonldLogRead>}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response
     */
    'hydra:member': Array<LogActionUtilisateurLogActionDtoJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response
 */
export interface ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response {
    /**
     * 
     * @type {Array<LogActionUtilisateurLogActionDtoJsonldLogReadExpanded>}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response
     */
    'hydra:member': Array<LogActionUtilisateurLogActionDtoJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiObjectGroupsGetCollection200Response
 */
export interface ApiObjectGroupsGetCollection200Response {
    /**
     * 
     * @type {Array<ObjectGroupsJsonldObjectGroupRead>}
     * @memberof ApiObjectGroupsGetCollection200Response
     */
    'hydra:member': Array<ObjectGroupsJsonldObjectGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiObjectGroupsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiObjectGroupsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiObjectGroupsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiObjectGroupsPost400Response
 */
export interface ApiObjectGroupsPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiObjectGroupsPost400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiObjectGroupsPost400ResponseException}
     * @memberof ApiObjectGroupsPost400Response
     */
    'exception': ApiObjectGroupsPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiObjectGroupsPost400ResponseException
 */
export interface ApiObjectGroupsPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiObjectGroupsPost400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiObjectGroupsPost400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiObjectGroupsPost400ResponseExceptionViolationsInner>}
     * @memberof ApiObjectGroupsPost400ResponseException
     */
    'violations'?: Array<ApiObjectGroupsPost400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiObjectGroupsPost400ResponseExceptionViolationsInner
 */
export interface ApiObjectGroupsPost400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiObjectGroupsPost400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiObjectGroupsPost400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiOpensearchClientsGetCollection200Response
 */
export interface ApiOpensearchClientsGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierClientRead>}
     * @memberof ApiOpensearchClientsGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierClientRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchClientsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchClientsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchClientsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchCollectionsClientsGetCollection200Response
 */
export interface ApiOpensearchCollectionsClientsGetCollection200Response {
    /**
     * 
     * @type {Array<CollectionOpenSearchJsonldOpensearchCollectionClientRead>}
     * @memberof ApiOpensearchCollectionsClientsGetCollection200Response
     */
    'hydra:member': Array<CollectionOpenSearchJsonldOpensearchCollectionClientRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchCollectionsClientsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchCollectionsClientsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchCollectionsClientsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchCollectionsGetCollection200Response
 */
export interface ApiOpensearchCollectionsGetCollection200Response {
    /**
     * 
     * @type {Array<CollectionOpenSearchCombinedJsonld>}
     * @memberof ApiOpensearchCollectionsGetCollection200Response
     */
    'hydra:member': Array<CollectionOpenSearchCombinedJsonld>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchCollectionsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchCollectionsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchCollectionsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchCollectionsOffersGetCollection200Response
 */
export interface ApiOpensearchCollectionsOffersGetCollection200Response {
    /**
     * 
     * @type {Array<CollectionOpenSearchJsonldOpensearchCollectionOfferRead>}
     * @memberof ApiOpensearchCollectionsOffersGetCollection200Response
     */
    'hydra:member': Array<CollectionOpenSearchJsonldOpensearchCollectionOfferRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchCollectionsOffersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchCollectionsOffersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchCollectionsOffersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchCollectionsPrescripteursGetCollection200Response
 */
export interface ApiOpensearchCollectionsPrescripteursGetCollection200Response {
    /**
     * 
     * @type {Array<CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead>}
     * @memberof ApiOpensearchCollectionsPrescripteursGetCollection200Response
     */
    'hydra:member': Array<CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchCollectionsPrescripteursGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchCollectionsPrescripteursGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchCollectionsPrescripteursGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchContactsGetCollection200Response
 */
export interface ApiOpensearchContactsGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierContactRead>}
     * @memberof ApiOpensearchContactsGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierContactRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchContactsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchContactsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchContactsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchDossiersCollectionsGetCollection200Response
 */
export interface ApiOpensearchDossiersCollectionsGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierCollectionRead>}
     * @memberof ApiOpensearchDossiersCollectionsGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierCollectionRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchDossiersCollectionsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchDossiersCollectionsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchDossiersCollectionsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchDossiersGetCollection200Response
 */
export interface ApiOpensearchDossiersGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchCombinedJsonld>}
     * @memberof ApiOpensearchDossiersGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchCombinedJsonld>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchDossiersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchDossiersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchDossiersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchFormalistesGetCollection200Response
 */
export interface ApiOpensearchFormalistesGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierFormalisteRead>}
     * @memberof ApiOpensearchFormalistesGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierFormalisteRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchFormalistesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchFormalistesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchFormalistesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchFormalitesGetCollection200Response
 */
export interface ApiOpensearchFormalitesGetCollection200Response {
    /**
     * 
     * @type {Array<FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead>}
     * @memberof ApiOpensearchFormalitesGetCollection200Response
     */
    'hydra:member': Array<FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchFormalitesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchFormalitesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchFormalitesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchGreffesGetCollection200Response
 */
export interface ApiOpensearchGreffesGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierGreffeRead>}
     * @memberof ApiOpensearchGreffesGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierGreffeRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchGreffesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchGreffesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchGreffesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchObjectGroupsGetCollection200Response
 */
export interface ApiOpensearchObjectGroupsGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierObjectGroupRead>}
     * @memberof ApiOpensearchObjectGroupsGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierObjectGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchObjectGroupsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchObjectGroupsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchObjectGroupsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchOffersGetCollection200Response
 */
export interface ApiOpensearchOffersGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierOfferRead>}
     * @memberof ApiOpensearchOffersGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierOfferRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchOffersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchOffersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchOffersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchPrefiltersGetCollection200Response
 */
export interface ApiOpensearchPrefiltersGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierPrefiltersRead>}
     * @memberof ApiOpensearchPrefiltersGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierPrefiltersRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchPrefiltersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchPrefiltersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchPrefiltersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchPrescripteursGetCollection200Response
 */
export interface ApiOpensearchPrescripteursGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierPrescripteurRead>}
     * @memberof ApiOpensearchPrescripteursGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierPrescripteurRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchPrescripteursGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchPrescripteursGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchPrescripteursGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchSocieteReferenceGetCollection200Response
 */
export interface ApiOpensearchSocieteReferenceGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierSocieteRefRead>}
     * @memberof ApiOpensearchSocieteReferenceGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierSocieteRefRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchSocieteReferenceGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchSocieteReferenceGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchSocieteReferenceGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchStatusesGetCollection200Response
 */
export interface ApiOpensearchStatusesGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierStatutRead>}
     * @memberof ApiOpensearchStatusesGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierStatutRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchStatusesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchStatusesGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchStatusesGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchValideursStatusGetCollection200Response
 */
export interface ApiOpensearchValideursStatusGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierValideursStatusRead>}
     * @memberof ApiOpensearchValideursStatusGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierValideursStatusRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchValideursStatusGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchValideursStatusGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchValideursStatusGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchWorkingGroupsGetCollection200Response
 */
export interface ApiOpensearchWorkingGroupsGetCollection200Response {
    /**
     * 
     * @type {Array<DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead>}
     * @memberof ApiOpensearchWorkingGroupsGetCollection200Response
     */
    'hydra:member': Array<DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchWorkingGroupsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchWorkingGroupsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchWorkingGroupsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response
 */
export interface ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response {
    /**
     * 
     * @type {Array<TiersJsonldDossierRead>}
     * @memberof ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response
     */
    'hydra:member': Array<TiersJsonldDossierRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiPrestationsIdGreffesPutRequest
 */
export interface ApiPrestationsIdGreffesPutRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiPrestationsIdGreffesPutRequest
     */
    'greffes': Array<number>;
}
/**
 * 
 * @export
 * @interface ApiReglementsDetailsGetCollection200Response
 */
export interface ApiReglementsDetailsGetCollection200Response {
    /**
     * 
     * @type {Array<ReglementsDetailsJsonldReglementdetailsRead>}
     * @memberof ApiReglementsDetailsGetCollection200Response
     */
    'hydra:member': Array<ReglementsDetailsJsonldReglementdetailsRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiReglementsDetailsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiReglementsDetailsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiReglementsDetailsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiReglementsDocumentsGetCollection200Response
 */
export interface ApiReglementsDocumentsGetCollection200Response {
    /**
     * 
     * @type {Array<ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner>}
     * @memberof ApiReglementsDocumentsGetCollection200Response
     */
    'hydra:member'?: Array<ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner>;
    /**
     * 
     * @type {number}
     * @memberof ApiReglementsDocumentsGetCollection200Response
     */
    'hydra:totalItems'?: number;
}
/**
 * 
 * @export
 * @interface ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
 */
export interface ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner {
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'created'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'fgDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'idDocument'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'idDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'idReglement'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'update'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollection200ResponseHydraMemberInner
     */
    'urlDoc'?: string;
}
/**
 * 
 * @export
 * @interface ApiReglementsDocumentsGetCollectionTagsParameterInner
 */
export interface ApiReglementsDocumentsGetCollectionTagsParameterInner {
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollectionTagsParameterInner
     */
    'tag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiReglementsDocumentsGetCollectionTagsParameterInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ApiReglementsGetCollection200Response
 */
export interface ApiReglementsGetCollection200Response {
    /**
     * 
     * @type {Array<ReglementsEtAcomptesCBJsonldReglementRead>}
     * @memberof ApiReglementsGetCollection200Response
     */
    'hydra:member': Array<ReglementsEtAcomptesCBJsonldReglementRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiReglementsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiReglementsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiReglementsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiStatutsGetCollection200Response
 */
export interface ApiStatutsGetCollection200Response {
    /**
     * 
     * @type {Array<StatutJsonldStatutRead>}
     * @memberof ApiStatutsGetCollection200Response
     */
    'hydra:member': Array<StatutJsonldStatutRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiStatutsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiStatutsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiStatutsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiTacheDossierPostRequest
 */
export interface ApiTacheDossierPostRequest {
    /**
     * 
     * @type {ApiTacheDossierPostRequestTache}
     * @memberof ApiTacheDossierPostRequest
     */
    'tache'?: ApiTacheDossierPostRequestTache;
    /**
     * 
     * @type {number}
     * @memberof ApiTacheDossierPostRequest
     */
    'dossier'?: number;
}
/**
 * 
 * @export
 * @interface ApiTacheDossierPostRequestTache
 */
export interface ApiTacheDossierPostRequestTache {
    /**
     * 
     * @type {string}
     * @memberof ApiTacheDossierPostRequestTache
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTacheDossierPostRequestTache
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTacheDossierPostRequestTache
     */
    'expiredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTacheDossierPostRequestTache
     */
    'remindAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTacheDossierPostRequestTache
     */
    'assignTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiTacheDossierPostRequestTache
     */
    'priority'?: number;
}
/**
 * 
 * @export
 * @interface ApiTachesDossierGetCollection200Response
 */
export interface ApiTachesDossierGetCollection200Response {
    /**
     * 
     * @type {Array<TachesEtRappelsDesDossierJsonldTacheRead>}
     * @memberof ApiTachesDossierGetCollection200Response
     */
    'hydra:member': Array<TachesEtRappelsDesDossierJsonldTacheRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiTachesDossierGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiTachesDossierGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiTachesDossierGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiTypesDocDossierIdPut400Response
 */
export interface ApiTypesDocDossierIdPut400Response {
    /**
     * 
     * @type {ApiActionsIdPut400ResponseException}
     * @memberof ApiTypesDocDossierIdPut400Response
     */
    'error'?: ApiActionsIdPut400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiTypesDocDossierPost400Response
 */
export interface ApiTypesDocDossierPost400Response {
    /**
     * 
     * @type {ApiAcomptesPost400ResponseException}
     * @memberof ApiTypesDocDossierPost400Response
     */
    'error'?: ApiAcomptesPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiTypesDocumentsGetCollection200Response
 */
export interface ApiTypesDocumentsGetCollection200Response {
    /**
     * 
     * @type {Array<TypeDeDocumentJsonldTypedocumentRead>}
     * @memberof ApiTypesDocumentsGetCollection200Response
     */
    'hydra:member': Array<TypeDeDocumentJsonldTypedocumentRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiTypesDocumentsGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiTypesDocumentsGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiTypesDocumentsGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiValideursStatusGetCollection200Response
 */
export interface ApiValideursStatusGetCollection200Response {
    /**
     * 
     * @type {Array<ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead>}
     * @memberof ApiValideursStatusGetCollection200Response
     */
    'hydra:member': Array<ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiValideursStatusGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof ApiValideursStatusGetCollection200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof ApiValideursStatusGetCollection200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ArticlesDeFacturationFactArticleRead
 */
export interface ArticlesDeFacturationFactArticleRead {
    /**
     * 
     * @type {number}
     * @memberof ArticlesDeFacturationFactArticleRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ArticlesDeFacturationJsonldFactArticleRead
 */
export interface ArticlesDeFacturationJsonldFactArticleRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ArticlesDeFacturationJsonldFactArticleRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ArticlesDeFacturationJsonldFactArticleRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesDeFacturationJsonldFactArticleRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticlesDeFacturationJsonldFactArticleRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CallbackDematFacile
 */
export interface CallbackDematFacile {
    /**
     * type du callback
     * @type {string}
     * @memberof CallbackDematFacile
     */
    'type'?: string;
    /**
     * 
     * @type {CallbackRecu}
     * @memberof CallbackDematFacile
     */
    'dossier'?: CallbackRecu;
}
/**
 * 
 * @export
 * @interface CallbackDematFacileJsonld
 */
export interface CallbackDematFacileJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CallbackDematFacileJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CallbackDematFacileJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackDematFacileJsonld
     */
    '@type'?: string;
    /**
     * type du callback
     * @type {string}
     * @memberof CallbackDematFacileJsonld
     */
    'type'?: string;
    /**
     * 
     * @type {CallbackRecuJsonld}
     * @memberof CallbackDematFacileJsonld
     */
    'dossier'?: CallbackRecuJsonld;
}
/**
 * 
 * @export
 * @interface CallbackDocument
 */
export interface CallbackDocument {
    /**
     * identifiant du document
     * @type {number}
     * @memberof CallbackDocument
     */
    'id'?: number;
    /**
     * type du document
     * @type {string}
     * @memberof CallbackDocument
     */
    'type'?: string;
    /**
     * contenu du document (en base64)
     * @type {string}
     * @memberof CallbackDocument
     */
    'fichier'?: string;
    /**
     * nom du document
     * @type {string}
     * @memberof CallbackDocument
     */
    'nom'?: string;
    /**
     * cheksum du document
     * @type {string}
     * @memberof CallbackDocument
     */
    'somme_controle'?: string;
    /**
     * Identifiant inpi
     * @type {number}
     * @memberof CallbackDocument
     */
    'id_inpi'?: number;
}
/**
 * 
 * @export
 * @interface CallbackDocumentJsonld
 */
export interface CallbackDocumentJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CallbackDocumentJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CallbackDocumentJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackDocumentJsonld
     */
    '@type'?: string;
    /**
     * identifiant du document
     * @type {number}
     * @memberof CallbackDocumentJsonld
     */
    'id'?: number;
    /**
     * type du document
     * @type {string}
     * @memberof CallbackDocumentJsonld
     */
    'type'?: string;
    /**
     * contenu du document (en base64)
     * @type {string}
     * @memberof CallbackDocumentJsonld
     */
    'fichier'?: string;
    /**
     * nom du document
     * @type {string}
     * @memberof CallbackDocumentJsonld
     */
    'nom'?: string;
    /**
     * cheksum du document
     * @type {string}
     * @memberof CallbackDocumentJsonld
     */
    'somme_controle'?: string;
    /**
     * Identifiant inpi
     * @type {number}
     * @memberof CallbackDocumentJsonld
     */
    'id_inpi'?: number;
}
/**
 * 
 * @export
 * @interface CallbackPaiement
 */
export interface CallbackPaiement {
    /**
     * Get the value of id
     * @type {number}
     * @memberof CallbackPaiement
     */
    'id'?: number;
    /**
     * 
     * @type {Array<CallbackPaiementCartRate>}
     * @memberof CallbackPaiement
     */
    'cartRates'?: Array<CallbackPaiementCartRate>;
    /**
     * Get the value of total
     * @type {number}
     * @memberof CallbackPaiement
     */
    'total'?: number;
    /**
     * Get the value of mipOrderNum
     * @type {number}
     * @memberof CallbackPaiement
     */
    'mipOrderNum'?: number;
    /**
     * Get the value of paymentDate
     * @type {string}
     * @memberof CallbackPaiement
     */
    'paymentDate'?: string;
    /**
     * Get the value of paymentType
     * @type {string}
     * @memberof CallbackPaiement
     */
    'paymentType'?: string;
    /**
     * Get the value of status
     * @type {string}
     * @memberof CallbackPaiement
     */
    'status'?: string;
    /**
     * Get the value of created
     * @type {string}
     * @memberof CallbackPaiement
     */
    'created'?: string;
    /**
     * Get the value of updated
     * @type {string}
     * @memberof CallbackPaiement
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface CallbackPaiementCartRate
 */
export interface CallbackPaiementCartRate {
    /**
     * Get the value of id
     * @type {number}
     * @memberof CallbackPaiementCartRate
     */
    'id'?: number;
    /**
     * 
     * @type {CallbackPaiementRate}
     * @memberof CallbackPaiementCartRate
     */
    'rate'?: CallbackPaiementRate;
    /**
     * Get the value of quantity
     * @type {number}
     * @memberof CallbackPaiementCartRate
     */
    'quantity'?: number;
    /**
     * Get the value of amount
     * @type {number}
     * @memberof CallbackPaiementCartRate
     */
    'amount'?: number;
    /**
     * Get the value of isForcedManually
     * @type {boolean}
     * @memberof CallbackPaiementCartRate
     */
    'isForcedManually'?: boolean;
    /**
     * Get the value of htAmount
     * @type {number}
     * @memberof CallbackPaiementCartRate
     */
    'htAmount'?: number;
    /**
     * Get the value of recipientCode
     * @type {string}
     * @memberof CallbackPaiementCartRate
     */
    'recipientCode'?: string | null;
    /**
     * Get the value of recipientName
     * @type {string}
     * @memberof CallbackPaiementCartRate
     */
    'recipientName'?: string | null;
    /**
     * Get the value of subTotal
     * @type {number}
     * @memberof CallbackPaiementCartRate
     */
    'subTotal'?: number;
}
/**
 * 
 * @export
 * @interface CallbackPaiementCartRateJsonld
 */
export interface CallbackPaiementCartRateJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CallbackPaiementCartRateJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CallbackPaiementCartRateJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackPaiementCartRateJsonld
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {CallbackPaiementRateJsonld}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'rate'?: CallbackPaiementRateJsonld;
    /**
     * Get the value of quantity
     * @type {number}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'quantity'?: number;
    /**
     * Get the value of amount
     * @type {number}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'amount'?: number;
    /**
     * Get the value of isForcedManually
     * @type {boolean}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'isForcedManually'?: boolean;
    /**
     * Get the value of htAmount
     * @type {number}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'htAmount'?: number;
    /**
     * Get the value of recipientCode
     * @type {string}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'recipientCode'?: string | null;
    /**
     * Get the value of recipientName
     * @type {string}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'recipientName'?: string | null;
    /**
     * Get the value of subTotal
     * @type {number}
     * @memberof CallbackPaiementCartRateJsonld
     */
    'subTotal'?: number;
}
/**
 * 
 * @export
 * @interface CallbackPaiementJsonld
 */
export interface CallbackPaiementJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CallbackPaiementJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof CallbackPaiementJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {Array<CallbackPaiementCartRateJsonld>}
     * @memberof CallbackPaiementJsonld
     */
    'cartRates'?: Array<CallbackPaiementCartRateJsonld>;
    /**
     * Get the value of total
     * @type {number}
     * @memberof CallbackPaiementJsonld
     */
    'total'?: number;
    /**
     * Get the value of mipOrderNum
     * @type {number}
     * @memberof CallbackPaiementJsonld
     */
    'mipOrderNum'?: number;
    /**
     * Get the value of paymentDate
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    'paymentDate'?: string;
    /**
     * Get the value of paymentType
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    'paymentType'?: string;
    /**
     * Get the value of status
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    'status'?: string;
    /**
     * Get the value of created
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    'created'?: string;
    /**
     * Get the value of updated
     * @type {string}
     * @memberof CallbackPaiementJsonld
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface CallbackPaiementRate
 */
export interface CallbackPaiementRate {
    /**
     * Get the value of htAmount
     * @type {number}
     * @memberof CallbackPaiementRate
     */
    'htAmount'?: number;
    /**
     * Get the value of code
     * @type {string}
     * @memberof CallbackPaiementRate
     */
    'code'?: string;
    /**
     * Get the value of label
     * @type {string}
     * @memberof CallbackPaiementRate
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface CallbackPaiementRateJsonld
 */
export interface CallbackPaiementRateJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CallbackPaiementRateJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CallbackPaiementRateJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackPaiementRateJsonld
     */
    '@type'?: string;
    /**
     * Get the value of htAmount
     * @type {number}
     * @memberof CallbackPaiementRateJsonld
     */
    'htAmount'?: number;
    /**
     * Get the value of code
     * @type {string}
     * @memberof CallbackPaiementRateJsonld
     */
    'code'?: string;
    /**
     * Get the value of label
     * @type {string}
     * @memberof CallbackPaiementRateJsonld
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface CallbackRecu
 */
export interface CallbackRecu {
    /**
     * identifiant du dossier côté demat facile
     * @type {number}
     * @memberof CallbackRecu
     */
    'id'?: number;
    /**
     * 
     * @type {CallbackDocument}
     * @memberof CallbackRecu
     */
    'document'?: CallbackDocument;
    /**
     * 
     * @type {CallbackPaiement}
     * @memberof CallbackRecu
     */
    'paiement'?: CallbackPaiement;
}
/**
 * 
 * @export
 * @interface CallbackRecuJsonld
 */
export interface CallbackRecuJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CallbackRecuJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CallbackRecuJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackRecuJsonld
     */
    '@type'?: string;
    /**
     * identifiant du dossier côté demat facile
     * @type {number}
     * @memberof CallbackRecuJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {CallbackDocumentJsonld}
     * @memberof CallbackRecuJsonld
     */
    'document'?: CallbackDocumentJsonld;
    /**
     * 
     * @type {CallbackPaiementJsonld}
     * @memberof CallbackRecuJsonld
     */
    'paiement'?: CallbackPaiementJsonld;
}
/**
 * 
 * @export
 * @interface CategorieCategorieCreate
 */
export interface CategorieCategorieCreate {
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieCreate
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieCreate
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieCategorieCreated
 */
export interface CategorieCategorieCreated {
    /**
     * 
     * @type {number}
     * @memberof CategorieCategorieCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieCreated
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieCreated
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieCategorieRead
 */
export interface CategorieCategorieRead {
    /**
     * 
     * @type {number}
     * @memberof CategorieCategorieRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieRead
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieRead
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieCategorieUpdate
 */
export interface CategorieCategorieUpdate {
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieUpdate
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieCategorieUpdate
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieJsonldCategorieCreate
 */
export interface CategorieJsonldCategorieCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CategorieJsonldCategorieCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreate
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreate
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieJsonldCategorieCreated
 */
export interface CategorieJsonldCategorieCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CategorieJsonldCategorieCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategorieJsonldCategorieCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreated
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieCreated
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieJsonldCategorieRead
 */
export interface CategorieJsonldCategorieRead {
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CategorieJsonldCategorieRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof CategorieJsonldCategorieRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieRead
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieRead
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CategorieJsonldCategorieUpdate
 */
export interface CategorieJsonldCategorieUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CategorieJsonldCategorieUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieUpdate
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldCategorieUpdate
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierCollectiondevisCreate
 */
export interface CollectionDeDossierCollectiondevisCreate {
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierCollectiondevisCreate
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierCollectiondossierCreate
 */
export interface CollectionDeDossierCollectiondossierCreate {
    /**
     * 
     * @type {Array<FproDossierCollectiondossierCreate>}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'dossiers'?: Array<FproDossierCollectiondossierCreate>;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'infoComp'?: string | null;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'client'?: string;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreate
     */
    'acompteAttendu'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierCollectiondossierCreated
 */
export interface CollectionDeDossierCollectiondossierCreated {
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {Array<FproDossierCollectiondossierCreated>}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'dossiers'?: Array<FproDossierCollectiondossierCreated>;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'numero'?: string | null;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'domaine'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'client'?: string;
    /**
     * 
     * @type {object}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'statut'?: object;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'paye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'acompteAttendu'?: string | null;
    /**
     * Get the value of typeFacturation
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'typeFacturation'?: CollectionDeDossierCollectiondossierCreatedTypeFacturationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierCreated
     */
    'venteIndirecte'?: boolean;
}

export const CollectionDeDossierCollectiondossierCreatedTypeFacturationEnum = {
    Complete: 'COMPLETE',
    Simplifiee: 'SIMPLIFIEE',
    Agregee: 'AGREGEE'
} as const;

export type CollectionDeDossierCollectiondossierCreatedTypeFacturationEnum = typeof CollectionDeDossierCollectiondossierCreatedTypeFacturationEnum[keyof typeof CollectionDeDossierCollectiondossierCreatedTypeFacturationEnum];

/**
 * 
 * @export
 * @interface CollectionDeDossierCollectiondossierRead
 */
export interface CollectionDeDossierCollectiondossierRead {
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {Array<FproDossierCollectiondossierRead>}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'dossiers'?: Array<FproDossierCollectiondossierRead>;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'numero'?: string | null;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'domaine'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'client'?: string;
    /**
     * 
     * @type {object}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'statut'?: object;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'paye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'acompteAttendu'?: string | null;
    /**
     * Get the value of typeFacturation
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'typeFacturation'?: CollectionDeDossierCollectiondossierReadTypeFacturationEnum;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'uuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierRead
     */
    'venteIndirecte'?: boolean;
}

export const CollectionDeDossierCollectiondossierReadTypeFacturationEnum = {
    Complete: 'COMPLETE',
    Simplifiee: 'SIMPLIFIEE',
    Agregee: 'AGREGEE'
} as const;

export type CollectionDeDossierCollectiondossierReadTypeFacturationEnum = typeof CollectionDeDossierCollectiondossierReadTypeFacturationEnum[keyof typeof CollectionDeDossierCollectiondossierReadTypeFacturationEnum];

/**
 * 
 * @export
 * @interface CollectionDeDossierCollectiondossierUpdate
 */
export interface CollectionDeDossierCollectiondossierUpdate {
    /**
     * 
     * @type {Array<FproDossierCollectiondossierUpdate>}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'dossiers'?: Array<FproDossierCollectiondossierUpdate>;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'infoComp'?: string | null;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'client'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'acompteAttendu'?: string | null;
    /**
     * Get the value of typeFacturation
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'typeFacturation'?: CollectionDeDossierCollectiondossierUpdateTypeFacturationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierUpdate
     */
    'venteIndirecte'?: boolean;
}

export const CollectionDeDossierCollectiondossierUpdateTypeFacturationEnum = {
    Complete: 'COMPLETE',
    Simplifiee: 'SIMPLIFIEE',
    Agregee: 'AGREGEE'
} as const;

export type CollectionDeDossierCollectiondossierUpdateTypeFacturationEnum = typeof CollectionDeDossierCollectiondossierUpdateTypeFacturationEnum[keyof typeof CollectionDeDossierCollectiondossierUpdateTypeFacturationEnum];

/**
 * 
 * @export
 * @interface CollectionDeDossierCollectiondossierValidated
 */
export interface CollectionDeDossierCollectiondossierValidated {
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'id'?: number;
    /**
     * 
     * @type {Array<FproDossierCollectiondossierValidated>}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'dossiers'?: Array<FproDossierCollectiondossierValidated>;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'numero'?: string | null;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'domaine'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'client'?: string;
    /**
     * 
     * @type {object}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'statut'?: object;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'paye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierCollectiondossierValidated
     */
    'acompteAttendu'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierJsonld
 */
export interface CollectionDeDossierJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonld
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierJsonldCollectiondevisCreate
 */
export interface CollectionDeDossierJsonldCollectiondevisCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonldCollectiondevisCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondevisCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondevisCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondevisCreate
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierJsonldCollectiondossierCreate
 */
export interface CollectionDeDossierJsonldCollectiondossierCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<FproDossierJsonldCollectiondossierCreate>}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'dossiers'?: Array<FproDossierJsonldCollectiondossierCreate>;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'infoComp'?: string | null;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'client'?: string;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreate
     */
    'acompteAttendu'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionDeDossierJsonldCollectiondossierCreated
 */
export interface CollectionDeDossierJsonldCollectiondossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {Array<FproDossierJsonldCollectiondossierCreated>}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'dossiers'?: Array<FproDossierJsonldCollectiondossierCreated>;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'numero'?: string | null;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'domaine'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'client'?: string;
    /**
     * 
     * @type {TblCollectionDossierStatusJsonldCollectiondossierCreated}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'statut'?: TblCollectionDossierStatusJsonldCollectiondossierCreated;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'paye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'acompteAttendu'?: string | null;
    /**
     * Get the value of typeFacturation
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'typeFacturation'?: CollectionDeDossierJsonldCollectiondossierCreatedTypeFacturationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierCreated
     */
    'venteIndirecte'?: boolean;
}

export const CollectionDeDossierJsonldCollectiondossierCreatedTypeFacturationEnum = {
    Complete: 'COMPLETE',
    Simplifiee: 'SIMPLIFIEE',
    Agregee: 'AGREGEE'
} as const;

export type CollectionDeDossierJsonldCollectiondossierCreatedTypeFacturationEnum = typeof CollectionDeDossierJsonldCollectiondossierCreatedTypeFacturationEnum[keyof typeof CollectionDeDossierJsonldCollectiondossierCreatedTypeFacturationEnum];

/**
 * 
 * @export
 * @interface CollectionDeDossierJsonldCollectiondossierRead
 */
export interface CollectionDeDossierJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {Array<FproDossierJsonldCollectiondossierRead>}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'dossiers'?: Array<FproDossierJsonldCollectiondossierRead>;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'numero'?: string | null;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'domaine'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'client'?: string;
    /**
     * 
     * @type {TblCollectionDossierStatusJsonldCollectiondossierRead}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'statut'?: TblCollectionDossierStatusJsonldCollectiondossierRead;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'paye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'acompteAttendu'?: string | null;
    /**
     * Get the value of typeFacturation
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'typeFacturation'?: CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'uuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierRead
     */
    'venteIndirecte'?: boolean;
}

export const CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum = {
    Complete: 'COMPLETE',
    Simplifiee: 'SIMPLIFIEE',
    Agregee: 'AGREGEE'
} as const;

export type CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum = typeof CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum[keyof typeof CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum];

/**
 * 
 * @export
 * @interface CollectionDeDossierJsonldCollectiondossierUpdate
 */
export interface CollectionDeDossierJsonldCollectiondossierUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<FproDossierJsonldCollectiondossierUpdate>}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'dossiers'?: Array<FproDossierJsonldCollectiondossierUpdate>;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'infoComp'?: string | null;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'client'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'acompteAttendu'?: string | null;
    /**
     * Get the value of typeFacturation
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'typeFacturation'?: CollectionDeDossierJsonldCollectiondossierUpdateTypeFacturationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierUpdate
     */
    'venteIndirecte'?: boolean;
}

export const CollectionDeDossierJsonldCollectiondossierUpdateTypeFacturationEnum = {
    Complete: 'COMPLETE',
    Simplifiee: 'SIMPLIFIEE',
    Agregee: 'AGREGEE'
} as const;

export type CollectionDeDossierJsonldCollectiondossierUpdateTypeFacturationEnum = typeof CollectionDeDossierJsonldCollectiondossierUpdateTypeFacturationEnum[keyof typeof CollectionDeDossierJsonldCollectiondossierUpdateTypeFacturationEnum];

/**
 * 
 * @export
 * @interface CollectionDeDossierJsonldCollectiondossierValidated
 */
export interface CollectionDeDossierJsonldCollectiondossierValidated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'id'?: number;
    /**
     * 
     * @type {Array<FproDossierJsonldCollectiondossierValidated>}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'dossiers'?: Array<FproDossierJsonldCollectiondossierValidated>;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'numero'?: string | null;
    /**
     * Intitulé de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'libelle'?: string | null;
    /**
     * Information complémentaire pour la gestion de la collection
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'domaine'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'client'?: string;
    /**
     * 
     * @type {TblCollectionDossierStatusJsonldCollectiondossierValidated}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'statut'?: TblCollectionDossierStatusJsonldCollectiondossierValidated;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'societe'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'paye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierJsonldCollectiondossierValidated
     */
    'acompteAttendu'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionJsonldLogRead
 */
export interface CollectionJsonldLogRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionJsonldLogRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionJsonldLogRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface CollectionJsonldLogReadExpanded
 */
export interface CollectionJsonldLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionJsonldLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionJsonldLogReadExpanded
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface CollectionJsonldLogReadLogReadExpanded
 */
export interface CollectionJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionJsonldLogReadLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
}
/**
 * @type CollectionOpenSearchCombined
 * @export
 */
export type CollectionOpenSearchCombined = CollectionOpenSearchOpensearchCollectionRead | CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull;

/**
 * @type CollectionOpenSearchCombinedJsonld
 * @export
 */
export type CollectionOpenSearchCombinedJsonld = CollectionOpenSearchJsonldOpensearchCollectionRead | CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull;

/**
 * 
 * @export
 * @interface CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch
 */
export interface CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch
     */
    'items'?: Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatch
 */
export interface CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatch {
    /**
     * 
     * @type {Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatch
     */
    'items'?: Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner
 */
export interface CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner {
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner
     */
    'status'?: CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInnerStatusEnum;
}

export const CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInnerStatusEnum = {
    Ok: 'OK',
    NotFound: 'NOT FOUND'
} as const;

export type CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInnerStatusEnum = typeof CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInnerStatusEnum[keyof typeof CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInnerStatusEnum];

/**
 * 
 * @export
 * @interface CollectionOpenSearchJsonldOpensearchCollectionClientRead
 */
export interface CollectionOpenSearchJsonldOpensearchCollectionClientRead {
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionClientRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionClientRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionClientRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionClientRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchJsonldOpensearchCollectionIndexBatch
 */
export interface CollectionOpenSearchJsonldOpensearchCollectionIndexBatch {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionIndexBatch
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionIndexBatch
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionIndexBatch
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionIndexBatch
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchJsonldOpensearchCollectionOfferRead
 */
export interface CollectionOpenSearchJsonldOpensearchCollectionOfferRead {
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionOfferRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionOfferRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionOfferRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionOfferRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionOfferRead
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead
 */
export interface CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead {
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead
     */
    'codeCompta'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchJsonldOpensearchCollectionRead
 */
export interface CollectionOpenSearchJsonldOpensearchCollectionRead {
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'statutInvoceLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'statutQuoteLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'incompleteForBilling'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'prescripteurCollapseKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'clientCollapseKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'typeFacturation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'offreVisibilite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'informationComplementaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'paye'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'dossiers'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionRead
     */
    'venteIndirecte'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
 */
export interface CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull {
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'statutInvoceLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'statutQuoteLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'incompleteForBilling'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurCollapseKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientCollapseKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'typeFacturation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreVisibilite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'informationComplementaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'paye'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'dossiers'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchJsonldOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'venteIndirecte'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchOpensearchCollectionClientRead
 */
export interface CollectionOpenSearchOpensearchCollectionClientRead {
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionClientRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionClientRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchOpensearchCollectionIndexBatch
 */
export interface CollectionOpenSearchOpensearchCollectionIndexBatch {
    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionOpenSearchOpensearchCollectionIndexBatch
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchOpensearchCollectionOfferRead
 */
export interface CollectionOpenSearchOpensearchCollectionOfferRead {
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionOfferRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionOfferRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionOfferRead
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchOpensearchCollectionPrescripteurRead
 */
export interface CollectionOpenSearchOpensearchCollectionPrescripteurRead {
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionPrescripteurRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionPrescripteurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionPrescripteurRead
     */
    'codeCompta'?: string | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchOpensearchCollectionRead
 */
export interface CollectionOpenSearchOpensearchCollectionRead {
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'statutInvoceLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'statutQuoteLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'incompleteForBilling'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'prescripteurCollapseKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'clientCollapseKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'typeFacturation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'offreVisibilite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'informationComplementaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'paye'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'dossiers'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionRead
     */
    'venteIndirecte'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
 */
export interface CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull {
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'statutInvoceLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'statutQuoteLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'incompleteForBilling'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'prescripteurCollapseKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientCollapseKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'typeFacturation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreVisibilite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'informationComplementaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'paye'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'dossiers'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionOpenSearchOpensearchCollectionReadOpensearchCollectionReadFull
     */
    'venteIndirecte'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DevisDevisRead
 */
export interface DevisDevisRead {
    /**
     * 
     * @type {number}
     * @memberof DevisDevisRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisDevisRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisDevisRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisDevisRead
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisDevisRead
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisDevisRead
     */
    'totalTtc'?: string | null;
}
/**
 * 
 * @export
 * @interface DevisJsonldDevisRead
 */
export interface DevisJsonldDevisRead {
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DevisJsonldDevisRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof DevisJsonldDevisRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisJsonldDevisRead
     */
    'totalTtc'?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentGed
 */
export interface DocumentGed {
    /**
     * identifiant du document
     * @type {string}
     * @memberof DocumentGed
     */
    'idDocument'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentGed
     */
    '_ged_visibilty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'api_application_tag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentGed
     */
    'fgDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'update'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'urlDoc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGed
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentGed
     */
    'idReglement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentGed
     */
    'idDossierFormalite'?: number | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DocumentGed
     */
    'tags'?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof DocumentGed
     */
    'idDossier'?: number | null;
}
/**
 * 
 * @export
 * @interface DocumentGedGedDocumentRead
 */
export interface DocumentGedGedDocumentRead {
    /**
     * identifiant du document
     * @type {string}
     * @memberof DocumentGedGedDocumentRead
     */
    'idDocument'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedGedDocumentRead
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentGedGedDocumentRead
     */
    'fgDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedGedDocumentRead
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedGedDocumentRead
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedGedDocumentRead
     */
    'update'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedGedDocumentRead
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentGedGedDocumentRead
     */
    'idReglement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentGedGedDocumentRead
     */
    'idDossierFormalite'?: number | null;
}
/**
 * 
 * @export
 * @interface DocumentGedJsonld
 */
export interface DocumentGedJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DocumentGedJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    '@type'?: string;
    /**
     * identifiant du document
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'idDocument'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentGedJsonld
     */
    '_ged_visibilty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'api_application_tag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentGedJsonld
     */
    'fgDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'update'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'urlDoc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonld
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentGedJsonld
     */
    'idReglement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentGedJsonld
     */
    'idDossierFormalite'?: number | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DocumentGedJsonld
     */
    'tags'?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof DocumentGedJsonld
     */
    'idDossier'?: number | null;
}
/**
 * 
 * @export
 * @interface DocumentGedJsonldGedDocumentRead
 */
export interface DocumentGedJsonldGedDocumentRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    '@type'?: string;
    /**
     * identifiant du document
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'idDocument'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'fgDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'update'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'idReglement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentGedJsonldGedDocumentRead
     */
    'idDossierFormalite'?: number | null;
}
/**
 * 
 * @export
 * @interface DomainesJsonldDomaineRead
 */
export interface DomainesJsonldDomaineRead {
    /**
     * 
     * @type {string}
     * @memberof DomainesJsonldDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainesJsonldDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DomainesJsonldDomaineRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
}
/**
 * 
 * @export
 * @interface DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
 */
export interface DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    'idAnnonce'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    'statut'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead
     */
    'justifLienPublic'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierAnnonceLegaleDtoValidatorsAlProcessRead
 */
export interface DossierAnnonceLegaleDtoValidatorsAlProcessRead {
    /**
     * 
     * @type {number}
     * @memberof DossierAnnonceLegaleDtoValidatorsAlProcessRead
     */
    'idAnnonce'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierAnnonceLegaleDtoValidatorsAlProcessRead
     */
    'statut'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierAnnonceLegaleDtoValidatorsAlProcessRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierAnnonceLegaleDtoValidatorsAlProcessRead
     */
    'justifLienPublic'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierDossierCreate
 */
export interface DossierDossierCreate {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierDossierCreate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof DossierDossierCreate
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof DossierDossierCreate
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof DossierDossierCreate
     */
    'societeSiren'?: string | null;
    /**
     * ID du client
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof DossierDossierCreate
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof DossierDossierCreate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierCreate
     */
    'affaire'?: string | null;
    /**
     * Identifiant de la collection
     * @type {string}
     * @memberof DossierDossierCreate
     */
    'collection'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationDossierCreate>}
     * @memberof DossierDossierCreate
     */
    'prestations'?: Array<FproPrestationDossierCreate>;
}
/**
 * 
 * @export
 * @interface DossierDossierCreateJsonObject
 */
export interface DossierDossierCreateJsonObject {
    /**
     * 
     * @type {number}
     * @memberof DossierDossierCreateJsonObject
     */
    'dos_cap'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierCreateJsonObject
     */
    'dos_rbe'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierCreateJsonObject
     */
    'dos_cdm'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierCreateJsonObject
     */
    'dos_rpi'?: boolean;
    /**
     * 0: hors ressort, 1: même ressort
     * @type {boolean}
     * @memberof DossierDossierCreateJsonObject
     */
    'dos_res'?: boolean;
}
/**
 * 
 * @export
 * @interface DossierDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface DossierDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'contact'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'numero'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dateMaj'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeDenomination'?: string | null;
    /**
     * Forme juridique de la société
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeFormeJuridique'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'paye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'cheminDoc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dateFinalise'?: string | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'cegidRegimetva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'recuPaiement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idDematfacile'?: number;
    /**
     * ID du client
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'clientOpere'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factureActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factureBrouillon'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factActiveSansAvoir'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiant de la formalite
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'formalite'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'formaliste'?: number | null;
    /**
     * 
     * @type {Array<FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'documents'?: Array<FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<FproDosDocFileDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fichiers'?: Array<FproDosDocFileDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'marque'?: number | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factures'?: Array<object>;
    /**
     * Identifiant de la collection
     * @type {string}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'collection'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'prestations'?: Array<FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'objectGroups'?: Array<string>;
    /**
     * 
     * @type {Array<FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'notes'?: Array<FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup>;
}
/**
 * 
 * @export
 * @interface DossierDossierUpdate
 */
export interface DossierDossierUpdate {
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierDossierUpdate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof DossierDossierUpdate
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof DossierDossierUpdate
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof DossierDossierUpdate
     */
    'societeSiren'?: string | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof DossierDossierUpdate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDossierUpdate
     */
    'affaire'?: string | null;
    /**
     * Identifiant de la collection
     * @type {string}
     * @memberof DossierDossierUpdate
     */
    'collection'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierDossierUpdatePartial
 */
export interface DossierDossierUpdatePartial {
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof DossierDossierUpdatePartial
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierDossierUpdatePartial
     */
    'societeRef'?: string | null;
    /**
     * ID du client
     * @type {number}
     * @memberof DossierDossierUpdatePartial
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof DossierDossierUpdatePartial
     */
    'clientOpere'?: number;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof DossierDossierUpdatePartial
     */
    'formaliste'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierDossierUpdatePartial
     */
    'objectGroups'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle
 */
export interface DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle {
    /**
     * 
     * @type {Array<FproPrestationArticleDtoDossierUpdateArticle>}
     * @memberof DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle
     */
    'articles'?: Array<FproPrestationArticleDtoDossierUpdateArticle>;
}
/**
 * 
 * @export
 * @interface DossierDossiersArticlesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface DossierDossiersArticlesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersArticlesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dossiers'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dossiers'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DossierDossiersGroupesPatchRequestDto
 */
export interface DossierDossiersGroupesPatchRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersGroupesPatchRequestDto
     */
    'dossiers'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersGroupesPatchRequestDto
     */
    'groups'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DossierDossiersGroupesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface DossierDossiersGroupesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersGroupesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dossiers'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersGroupesPatchResponseDtoDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'groups'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dossiers'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'groups'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DossierJsonld
 */
export interface DossierJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonld
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface DossierJsonldDossierCreate
 */
export interface DossierJsonldDossierCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierJsonldDossierCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    '@type'?: string;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof DossierJsonldDossierCreate
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    'societeSiren'?: string | null;
    /**
     * ID du client
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof DossierJsonldDossierCreate
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    'affaire'?: string | null;
    /**
     * Identifiant de la collection
     * @type {string}
     * @memberof DossierJsonldDossierCreate
     */
    'collection'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationJsonldDossierCreate>}
     * @memberof DossierJsonldDossierCreate
     */
    'prestations'?: Array<FproPrestationJsonldDossierCreate>;
}
/**
 * 
 * @export
 * @interface DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'contact'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'numero'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dateMaj'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeDenomination'?: string | null;
    /**
     * Forme juridique de la société
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeFormeJuridique'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'paye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'cheminDoc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'dateFinalise'?: string | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'cegidRegimetva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'recuPaiement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idDematfacile'?: number;
    /**
     * ID du client
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'clientOpere'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factureActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factureBrouillon'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factActiveSansAvoir'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiant de la formalite
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'formalite'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'formaliste'?: number | null;
    /**
     * 
     * @type {Array<FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'documents'?: Array<FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fichiers'?: Array<FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'marque'?: number | null;
    /**
     * 
     * @type {Array<TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factures'?: Array<TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * Identifiant de la collection
     * @type {string}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'collection'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'prestations'?: Array<FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'objectGroups'?: Array<string>;
    /**
     * 
     * @type {Array<FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'notes'?: Array<FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
}
/**
 * 
 * @export
 * @interface DossierJsonldDossierTransitionRead
 */
export interface DossierJsonldDossierTransitionRead {
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierTransitionRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierTransitionRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface DossierJsonldDossierUpdate
 */
export interface DossierJsonldDossierUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierJsonldDossierUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    '@type'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof DossierJsonldDossierUpdate
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    'societeSiren'?: string | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    'affaire'?: string | null;
    /**
     * Identifiant de la collection
     * @type {string}
     * @memberof DossierJsonldDossierUpdate
     */
    'collection'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierJsonldValidatorsAlProcessRead
 */
export interface DossierJsonldValidatorsAlProcessRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierJsonldValidatorsAlProcessRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldValidatorsAlProcessRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierJsonldValidatorsAlProcessRead
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead>}
     * @memberof DossierJsonldValidatorsAlProcessRead
     */
    'annonces'?: Array<DossierAnnonceLegaleDtoJsonldValidatorsAlProcessRead>;
}
/**
 * @type DossierOpenSearchCombined
 * @export
 */
export type DossierOpenSearchCombined = DossierOpenSearchOpensearchDossierRead | DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull;

/**
 * @type DossierOpenSearchCombinedJsonld
 * @export
 */
export type DossierOpenSearchCombinedJsonld = DossierOpenSearchJsonldOpensearchDossierRead | DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull;

/**
 * 
 * @export
 * @interface DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch
 */
export interface DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>}
     * @memberof DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch
     */
    'items'?: Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchIndexBatchDossierResponseOpensearchDossierIndexBatch
 */
export interface DossierOpenSearchIndexBatchDossierResponseOpensearchDossierIndexBatch {
    /**
     * 
     * @type {Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>}
     * @memberof DossierOpenSearchIndexBatchDossierResponseOpensearchDossierIndexBatch
     */
    'items'?: Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierClientRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierClientRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierClientRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierClientRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierClientRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierClientRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierCollectionRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierCollectionRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierCollectionRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierCollectionRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierCollectionRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierCollectionRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierContactRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierContactRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierContactRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierContactRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierContactRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierContactRead
     */
    'nomComplet'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierFormalisteRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierFormalisteRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormalisteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormalisteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormalisteRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormalisteRead
     */
    'nomComplet'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormalisteRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierFormaliteRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierFormaliteRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    'groupementId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    'groupementLibelle'?: string | null;
    /**
     * 
     * @type {Array<DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierFormaliteRead
     */
    'greffes'?: Array<DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner>;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierGreffeRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierGreffeRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierGreffeRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierGreffeRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierGreffeRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierGreffeRead
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierIndexBatch
 */
export interface DossierOpenSearchJsonldOpensearchDossierIndexBatch {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierOpenSearchJsonldOpensearchDossierIndexBatch
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierIndexBatch
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierIndexBatch
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierIndexBatch
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierObjectGroupRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierObjectGroupRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierOfferRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierOfferRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierOfferRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierOfferRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierOfferRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierOfferRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierOfferRead
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierPrefiltersRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
     */
    'value'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
     */
    'property'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrefiltersRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierPrescripteurRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierPrescripteurRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrescripteurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrescripteurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrescripteurRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrescripteurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierPrescripteurRead
     */
    'codeCompta'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'prescripteurEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'collectionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'collectionNumero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'siblingCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientOpereId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientOpereLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientOpereSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientOpereAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'contactId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'contactNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'contactPrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'contactNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'contactUserIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'documentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'missingRequiredDocumentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'statutId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'statutLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'stepId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'stepLabel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'stepCompletion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formalisteId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formalisteNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formalistePrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formalisteNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formalisteUserIdentifier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'societeRef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formaliteLibAutre'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'formalites'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'groups'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'transitions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'validationProcesses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'workGroups'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'countUnreadClient'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'countUnreadFormaliste'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierRead
     */
    'invoiced'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
 */
export interface DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'numero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'collectionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'collectionNumero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'siblingCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactPrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactUserIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'documentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'missingRequiredDocumentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'statutId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'statutLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'stepId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'stepLabel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'stepCompletion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalistePrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteUserIdentifier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeRef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formaliteLibAutre'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalites'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'groups'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'transitions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'validationProcesses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'workGroups'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'countUnreadClient'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'countUnreadFormaliste'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchJsonldOpensearchDossierReadOpensearchDossierReadFull
     */
    'invoiced'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierSocieteRefRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierSocieteRefRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierSocieteRefRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierSocieteRefRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierSocieteRefRead
     */
    'reference'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierStatutRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierStatutRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    'stepId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    'stepLabel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierStatutRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierValideursStatusRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'idValideur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'libelleValideur'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'idStatus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'statusFlag'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'libelleStatus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'sortOrder'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierValideursStatusRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead
 */
export interface DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierClientRead
 */
export interface DossierOpenSearchOpensearchDossierClientRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierClientRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierClientRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierCollectionRead
 */
export interface DossierOpenSearchOpensearchDossierCollectionRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierCollectionRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierCollectionRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierContactRead
 */
export interface DossierOpenSearchOpensearchDossierContactRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierContactRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierContactRead
     */
    'nomComplet'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierFormalisteRead
 */
export interface DossierOpenSearchOpensearchDossierFormalisteRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierFormalisteRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierFormalisteRead
     */
    'nomComplet'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierFormalisteRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierFormaliteRead
 */
export interface DossierOpenSearchOpensearchDossierFormaliteRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteRead
     */
    'groupementId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteRead
     */
    'groupementLibelle'?: string | null;
    /**
     * 
     * @type {Array<DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner>}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteRead
     */
    'greffes'?: Array<DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner>;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner
 */
export interface DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierFormaliteReadGreffesInner
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierGreffeRead
 */
export interface DossierOpenSearchOpensearchDossierGreffeRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierGreffeRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierGreffeRead
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierIndexBatch
 */
export interface DossierOpenSearchOpensearchDossierIndexBatch {
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierOpenSearchOpensearchDossierIndexBatch
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierObjectGroupRead
 */
export interface DossierOpenSearchOpensearchDossierObjectGroupRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierObjectGroupRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierObjectGroupRead
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierObjectGroupRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierObjectGroupRead
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierObjectGroupRead
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierObjectGroupRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierOfferRead
 */
export interface DossierOpenSearchOpensearchDossierOfferRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierOfferRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierOfferRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierOfferRead
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierPrefiltersRead
 */
export interface DossierOpenSearchOpensearchDossierPrefiltersRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierPrefiltersRead
     */
    'value'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierPrefiltersRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierPrefiltersRead
     */
    'property'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierPrefiltersRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierPrescripteurRead
 */
export interface DossierOpenSearchOpensearchDossierPrescripteurRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierPrescripteurRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierPrescripteurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierPrescripteurRead
     */
    'codeCompta'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierRead
 */
export interface DossierOpenSearchOpensearchDossierRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'prescripteurEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'collectionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'collectionNumero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'siblingCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientOpereId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientOpereLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientOpereSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientOpereAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'contactId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'contactNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'contactPrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'contactNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'contactUserIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'documentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'missingRequiredDocumentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'statutId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'statutLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'stepId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'stepLabel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'stepCompletion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formalisteId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formalisteNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formalistePrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formalisteNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formalisteUserIdentifier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'societeRef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formaliteLibAutre'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'formalites'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'groups'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'transitions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'validationProcesses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'workGroups'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'countUnreadClient'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'countUnreadFormaliste'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierRead
     */
    'invoiced'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
 */
export interface DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'numero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'prescripteurCodeCompta'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'collectionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'collectionNumero'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'siblingCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientOpereAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'clientAdresseComplete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactPrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'contactUserIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'documentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'missingRequiredDocumentsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'statutId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'statutLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'stepId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'stepLabel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'stepCompletion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalistePrenom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteNomComplet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalisteUserIdentifier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeRef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeDenomination'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formaliteLibAutre'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'formalites'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'groups'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'transitions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'validationProcesses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'workGroups'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'offreId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'offreLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'offreIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'countUnreadClient'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'countUnreadFormaliste'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierOpenSearchOpensearchDossierReadOpensearchDossierReadFull
     */
    'invoiced'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierSocieteRefRead
 */
export interface DossierOpenSearchOpensearchDossierSocieteRefRead {
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierSocieteRefRead
     */
    'reference'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierStatutRead
 */
export interface DossierOpenSearchOpensearchDossierStatutRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierStatutRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierStatutRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierStatutRead
     */
    'stepId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierStatutRead
     */
    'stepLabel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierStatutRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierValideursStatusRead
 */
export interface DossierOpenSearchOpensearchDossierValideursStatusRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'idValideur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'libelleValideur'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'idStatus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'statusFlag'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'libelleStatus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'sortOrder'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierValideursStatusRead
     */
    'childsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface DossierOpenSearchOpensearchDossierWorkingGroupRead
 */
export interface DossierOpenSearchOpensearchDossierWorkingGroupRead {
    /**
     * 
     * @type {number}
     * @memberof DossierOpenSearchOpensearchDossierWorkingGroupRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierOpenSearchOpensearchDossierWorkingGroupRead
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierReport
 */
export interface DossierReport {
    /**
     * 
     * @type {string}
     * @memberof DossierReport
     */
    'message': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierReport
     */
    'dossiers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierReport
     */
    'contacts'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DossierReportJsonld
 */
export interface DossierReportJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossierReportJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossierReportJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierReportJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierReportJsonld
     */
    'message': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierReportJsonld
     */
    'dossiers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossierReportJsonld
     */
    'contacts'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DossierValidatorsAlProcessRead
 */
export interface DossierValidatorsAlProcessRead {
    /**
     * 
     * @type {Array<DossierAnnonceLegaleDtoValidatorsAlProcessRead>}
     * @memberof DossierValidatorsAlProcessRead
     */
    'annonces'?: Array<DossierAnnonceLegaleDtoValidatorsAlProcessRead>;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectronique
 */
export interface DossiersDeSignatureLectronique {
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectronique
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectronique
     */
    'signDossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectronique
     */
    'file'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectronique
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectronique
     */
    'idGed'?: string | null;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueCallbackDossierDossierSignCallback
 */
export interface DossiersDeSignatureLectroniqueCallbackDossierDossierSignCallback {
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCallbackDossierDossierSignCallback
     */
    'referenceExterne'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossiersDeSignatureLectroniqueCallbackDossierDossierSignCallback
     */
    'documents'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
 */
export interface DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
     */
    'referenceExterne'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
     */
    'documents'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWrite
 */
export interface DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWrite {
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWrite
     */
    'subject'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWrite
     */
    'prescriberId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWrite
     */
    'documentIds'?: Array<number>;
    /**
     * 
     * @type {Array<DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner>}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWrite
     */
    'recipients'?: Array<DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner>;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner
 */
export interface DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner {
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner
     */
    'mobile'?: string;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
 */
export interface DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    'subject'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    'prescriberId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    'documentIds'?: Array<number>;
    /**
     * 
     * @type {Array<DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner>}
     * @memberof DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
     */
    'recipients'?: Array<DossiersDeSignatureLectroniqueCreateDossierSignDossierDossierSignWriteRecipientsInner>;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueDossierDossierSignRead
 */
export interface DossiersDeSignatureLectroniqueDossierDossierSignRead {
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueDossierDossierSignRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierDossierSignRead
     */
    'referenceExterne'?: string;
    /**
     * 
     * @type {Array<FproDossierDossierSignDocumentDossierDossierSignRead>}
     * @memberof DossiersDeSignatureLectroniqueDossierDossierSignRead
     */
    'documents'?: Array<FproDossierDossierSignDocumentDossierDossierSignRead>;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignRead
 */
export interface DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignRead {
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {Array<DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner>}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignRead
     */
    'documents'?: Array<DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner> | null;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner
 */
export interface DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner {
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner
     */
    'fileName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner
     */
    'signed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner
     */
    'externalId'?: string;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
 */
export interface DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {Array<DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner>}
     * @memberof DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead
     */
    'documents'?: Array<DossiersDeSignatureLectroniqueDossierSignDtoDossierDossierSignReadDocumentsInner> | null;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueJsonld
 */
export interface DossiersDeSignatureLectroniqueJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    'signDossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    'file'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonld
     */
    'idGed'?: string | null;
}
/**
 * 
 * @export
 * @interface DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
 */
export interface DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
     */
    'referenceExterne'?: string;
    /**
     * 
     * @type {Array<FproDossierDossierSignDocumentJsonldDossierDossierSignRead>}
     * @memberof DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead
     */
    'documents'?: Array<FproDossierDossierSignDocumentJsonldDossierDossierSignRead>;
}
/**
 * 
 * @export
 * @interface FichiersDossierCreatedFilesPostResponseDtoDocumentfileRead
 */
export interface FichiersDossierCreatedFilesPostResponseDtoDocumentfileRead {
    /**
     * 
     * @type {Array<FproDosDocFileDocumentfileRead>}
     * @memberof FichiersDossierCreatedFilesPostResponseDtoDocumentfileRead
     */
    'files'?: Array<FproDosDocFileDocumentfileRead>;
}
/**
 * 
 * @export
 * @interface FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead
 */
export interface FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldDocumentfileRead>}
     * @memberof FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead
     */
    'files'?: Array<FproDosDocFileJsonldDocumentfileRead>;
}
/**
 * 
 * @export
 * @interface FichiersDossierDocumentfileRead
 */
export interface FichiersDossierDocumentfileRead {
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'chemin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'idGed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierDocumentfileRead
     */
    'expediteur'?: FichiersDossierDocumentfileReadExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierDocumentfileRead
     */
    'expedition'?: FichiersDossierDocumentfileReadExpeditionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierDocumentfileRead
     */
    'idDocDf'?: number;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierDocumentfileRead
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocDocumentfileRead}
     * @memberof FichiersDossierDocumentfileRead
     */
    'typeDocDossier'?: FproDossierDocDocumentfileRead;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {FproDosStatutDocumentfileRead}
     * @memberof FichiersDossierDocumentfileRead
     */
    'statut'?: FproDosStatutDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileDocumentfileRead}
     * @memberof FichiersDossierDocumentfileRead
     */
    'docSigned'?: FproDosDocFileDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileDocumentfileRead}
     * @memberof FichiersDossierDocumentfileRead
     */
    'docOriginal'?: FproDosDocFileDocumentfileRead | null;
    /**
     * 
     * @type {TblTypeDocumentDocumentfileRead}
     * @memberof FichiersDossierDocumentfileRead
     */
    'typedocIADoc'?: TblTypeDocumentDocumentfileRead | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierDocumentfileRead
     */
    'jsonIADoc'?: string | null;
}

export const FichiersDossierDocumentfileReadExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FichiersDossierDocumentfileReadExpediteurEnum = typeof FichiersDossierDocumentfileReadExpediteurEnum[keyof typeof FichiersDossierDocumentfileReadExpediteurEnum];
export const FichiersDossierDocumentfileReadExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FichiersDossierDocumentfileReadExpeditionEnum = typeof FichiersDossierDocumentfileReadExpeditionEnum[keyof typeof FichiersDossierDocumentfileReadExpeditionEnum];

/**
 * 
 * @export
 * @interface FichiersDossierJsonldDocumentfileRead
 */
export interface FichiersDossierJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'chemin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'idGed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'expediteur'?: FichiersDossierJsonldDocumentfileReadExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'expedition'?: FichiersDossierJsonldDocumentfileReadExpeditionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'idDocDf'?: number;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocJsonldDocumentfileRead}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'typeDocDossier'?: FproDossierDocJsonldDocumentfileRead;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {FproDosStatutJsonldDocumentfileRead}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'statut'?: FproDosStatutJsonldDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileJsonldDocumentfileRead}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'docSigned'?: FproDosDocFileJsonldDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileJsonldDocumentfileRead}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'docOriginal'?: FproDosDocFileJsonldDocumentfileRead | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldDocumentfileRead}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'typedocIADoc'?: TblTypeDocumentJsonldDocumentfileRead | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierJsonldDocumentfileRead
     */
    'jsonIADoc'?: string | null;
}

export const FichiersDossierJsonldDocumentfileReadExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FichiersDossierJsonldDocumentfileReadExpediteurEnum = typeof FichiersDossierJsonldDocumentfileReadExpediteurEnum[keyof typeof FichiersDossierJsonldDocumentfileReadExpediteurEnum];
export const FichiersDossierJsonldDocumentfileReadExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FichiersDossierJsonldDocumentfileReadExpeditionEnum = typeof FichiersDossierJsonldDocumentfileReadExpeditionEnum[keyof typeof FichiersDossierJsonldDocumentfileReadExpeditionEnum];

/**
 * 
 * @export
 * @interface FichiersDossierUpdateDocumentFileDocumentfileUpdate
 */
export interface FichiersDossierUpdateDocumentFileDocumentfileUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof FichiersDossierUpdateDocumentFileDocumentfileUpdate
     */
    'typageAuto'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FichiersDossierUpdateDocumentFileDocumentfileUpdate
     */
    'deliassageAuto'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierUpdateDocumentFileDocumentfileUpdate
     */
    'typeDocDossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierUpdateDocumentFileDocumentfileUpdate
     */
    'status'?: FichiersDossierUpdateDocumentFileDocumentfileUpdateStatusEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FichiersDossierUpdateDocumentFileDocumentfileUpdate
     */
    'expediteur'?: FichiersDossierUpdateDocumentFileDocumentfileUpdateExpediteurEnum | null;
}

export const FichiersDossierUpdateDocumentFileDocumentfileUpdateStatusEnum = {
    _7: '7',
    _9: '9',
    _10: '10'
} as const;

export type FichiersDossierUpdateDocumentFileDocumentfileUpdateStatusEnum = typeof FichiersDossierUpdateDocumentFileDocumentfileUpdateStatusEnum[keyof typeof FichiersDossierUpdateDocumentFileDocumentfileUpdateStatusEnum];
export const FichiersDossierUpdateDocumentFileDocumentfileUpdateExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type FichiersDossierUpdateDocumentFileDocumentfileUpdateExpediteurEnum = typeof FichiersDossierUpdateDocumentFileDocumentfileUpdateExpediteurEnum[keyof typeof FichiersDossierUpdateDocumentFileDocumentfileUpdateExpediteurEnum];

/**
 * 
 * @export
 * @interface FichiersDossierUpdatedFilePatchResponseDtoDocumentfileRead
 */
export interface FichiersDossierUpdatedFilePatchResponseDtoDocumentfileRead {
    /**
     * 
     * @type {Array<FproDosDocFileDocumentfileRead>}
     * @memberof FichiersDossierUpdatedFilePatchResponseDtoDocumentfileRead
     */
    'files'?: Array<FproDosDocFileDocumentfileRead>;
}
/**
 * 
 * @export
 * @interface FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead
 */
export interface FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldDocumentfileRead>}
     * @memberof FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead
     */
    'files'?: Array<FproDosDocFileJsonldDocumentfileRead>;
}
/**
 * 
 * @export
 * @interface FormalisteFormalisteRead
 */
export interface FormalisteFormalisteRead {
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormalisteFormalisteRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteFormalisteRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteFormalisteRead
     */
    'initiales'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteFormalisteRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteFormalisteRead
     */
    'fmistDemo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteFormalisteRead
     */
    'fmistAdmin'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'fmistDroitDosMod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'fmistDroitDosLect'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'fmistDroitGestMod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'fmistDroitGestLect'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'fmistDroitDosSup'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteFormalisteRead
     */
    'fmistFormaliste'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteFormalisteRead
     */
    'societe'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteFormalisteRead
     */
    'accesFpro'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormalisteFormalisteRead
     */
    'userIdentifier'?: string | null;
}
/**
 * 
 * @export
 * @interface FormalisteJsonldFormalisteRead
 */
export interface FormalisteJsonldFormalisteRead {
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormalisteJsonldFormalisteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'initiales'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistDemo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistAdmin'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistDroitDosMod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistDroitDosLect'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistDroitGestMod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistDroitGestLect'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistDroitDosSup'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'fmistFormaliste'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'societe'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'accesFpro'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormalisteJsonldFormalisteRead
     */
    'userIdentifier'?: string | null;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch
 */
export interface FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>}
     * @memberof FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch
     */
    'items'?: Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchIndexBatchFormaliteResponseOpensearchFormaliteIndexBatch
 */
export interface FormaliteArticleOpenSearchIndexBatchFormaliteResponseOpensearchFormaliteIndexBatch {
    /**
     * 
     * @type {Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>}
     * @memberof FormaliteArticleOpenSearchIndexBatchFormaliteResponseOpensearchFormaliteIndexBatch
     */
    'items'?: Array<CollectionOpenSearchIndexBatchCollectionDossierResponseOpensearchCollectionIndexBatchItemsInner>;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
 */
export interface FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'rang'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'charge'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'typeRecupGreffe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'formulaire'?: number | null;
    /**
     * 
     * @type {Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'categorie'?: Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'documents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'legalStatuses'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'compatibilities'?: Array<number> | null;
    /**
     * 
     * @type {Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'validators'?: Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'groupements'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead
     */
    'sirenRequired'?: boolean | null;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch
 */
export interface FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
 */
export interface FormaliteArticleOpenSearchOpensearchFormaliteArticleRead {
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'rang'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'charge'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'typeRecupGreffe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'formulaire'?: number | null;
    /**
     * 
     * @type {Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'categorie'?: Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'documents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'legalStatuses'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'compatibilities'?: Array<number> | null;
    /**
     * 
     * @type {Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'validators'?: Array<FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'groupements'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleRead
     */
    'sirenRequired'?: boolean | null;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner
 */
export interface FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner {
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadCategorieInner
     */
    'iconeName'?: string;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner
 */
export interface FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner {
    /**
     * 
     * @type {number}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner
     */
    'validator'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteArticleReadValidatorsInner
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface FormaliteArticleOpenSearchOpensearchFormaliteIndexBatch
 */
export interface FormaliteArticleOpenSearchOpensearchFormaliteIndexBatch {
    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchOpensearchFormaliteIndexBatch
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FormaliteFormaliteCreate
 */
export interface FormaliteFormaliteCreate {
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'libelle': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteCreate
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteCreate
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteCreate
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteCreate
     */
    'compatibilities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteFormaliteCreate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorFormaliteCreate>}
     * @memberof FormaliteFormaliteCreate
     */
    'validators'?: Array<TblFormalityFproDossierValidatorFormaliteCreate>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteCreate
     */
    'charge'?: FormaliteFormaliteCreateChargeEnum;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreate
     */
    'typeRecupGreffe'?: FormaliteFormaliteCreateTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteCreate
     */
    'sirenRequired'?: boolean;
}

export const FormaliteFormaliteCreateChargeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type FormaliteFormaliteCreateChargeEnum = typeof FormaliteFormaliteCreateChargeEnum[keyof typeof FormaliteFormaliteCreateChargeEnum];
export const FormaliteFormaliteCreateTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteFormaliteCreateTypeRecupGreffeEnum = typeof FormaliteFormaliteCreateTypeRecupGreffeEnum[keyof typeof FormaliteFormaliteCreateTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteFormaliteCreated
 */
export interface FormaliteFormaliteCreated {
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'libelle': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteCreated
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteCreated
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteCreated
     */
    'compatibilities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteFormaliteCreated
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorFormaliteCreated>}
     * @memberof FormaliteFormaliteCreated
     */
    'validators'?: Array<TblFormalityFproDossierValidatorFormaliteCreated>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteCreated
     */
    'charge'?: FormaliteFormaliteCreatedChargeEnum;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteCreated
     */
    'typeRecupGreffe'?: FormaliteFormaliteCreatedTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteCreated
     */
    'sirenRequired'?: boolean;
}

export const FormaliteFormaliteCreatedChargeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type FormaliteFormaliteCreatedChargeEnum = typeof FormaliteFormaliteCreatedChargeEnum[keyof typeof FormaliteFormaliteCreatedChargeEnum];
export const FormaliteFormaliteCreatedTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteFormaliteCreatedTypeRecupGreffeEnum = typeof FormaliteFormaliteCreatedTypeRecupGreffeEnum[keyof typeof FormaliteFormaliteCreatedTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteFormaliteRead
 */
export interface FormaliteFormaliteRead {
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteRead
     */
    'id'?: number;
    /**
     * 
     * @type {FproFormaliteCategorieFormaliteRead}
     * @memberof FormaliteFormaliteRead
     */
    'categorie'?: FproFormaliteCategorieFormaliteRead | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteRead
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteRead
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteRead
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteRead
     */
    'compatibilities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteRead
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteRead
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteFormaliteRead
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteRead
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorFormaliteRead>}
     * @memberof FormaliteFormaliteRead
     */
    'validators'?: Array<TblFormalityFproDossierValidatorFormaliteRead>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteRead
     */
    'charge'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteRead
     */
    'typeRecupGreffe'?: FormaliteFormaliteReadTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteRead
     */
    'sirenRequired'?: boolean;
}

export const FormaliteFormaliteReadTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteFormaliteReadTypeRecupGreffeEnum = typeof FormaliteFormaliteReadTypeRecupGreffeEnum[keyof typeof FormaliteFormaliteReadTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteFormaliteUpdate
 */
export interface FormaliteFormaliteUpdate {
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'libelle': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteUpdate
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteUpdate
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteUpdate
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteFormaliteUpdate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorFormaliteUpdate>}
     * @memberof FormaliteFormaliteUpdate
     */
    'validators'?: Array<TblFormalityFproDossierValidatorFormaliteUpdate>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteUpdate
     */
    'charge'?: FormaliteFormaliteUpdateChargeEnum;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdate
     */
    'typeRecupGreffe'?: FormaliteFormaliteUpdateTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteUpdate
     */
    'sirenRequired'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteFormaliteUpdate
     */
    'compatibilities'?: Array<string>;
}

export const FormaliteFormaliteUpdateChargeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type FormaliteFormaliteUpdateChargeEnum = typeof FormaliteFormaliteUpdateChargeEnum[keyof typeof FormaliteFormaliteUpdateChargeEnum];
export const FormaliteFormaliteUpdateTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteFormaliteUpdateTypeRecupGreffeEnum = typeof FormaliteFormaliteUpdateTypeRecupGreffeEnum[keyof typeof FormaliteFormaliteUpdateTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteFormaliteUpdatePartial
 */
export interface FormaliteFormaliteUpdatePartial {
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'rang'?: number;
    /**
     * 
     * @type {number}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'charge'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'typeRecupGreffe'?: FormaliteFormaliteUpdatePartialTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteFormaliteUpdatePartial
     */
    'sirenRequired'?: boolean;
}

export const FormaliteFormaliteUpdatePartialTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteFormaliteUpdatePartialTypeRecupGreffeEnum = typeof FormaliteFormaliteUpdatePartialTypeRecupGreffeEnum[keyof typeof FormaliteFormaliteUpdatePartialTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteJsonldFormaliteCreate
 */
export interface FormaliteJsonldFormaliteCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'libelle': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'compatibilities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorJsonldFormaliteCreate>}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'validators'?: Array<TblFormalityFproDossierValidatorJsonldFormaliteCreate>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'charge'?: FormaliteJsonldFormaliteCreateChargeEnum;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'typeRecupGreffe'?: FormaliteJsonldFormaliteCreateTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteCreate
     */
    'sirenRequired'?: boolean;
}

export const FormaliteJsonldFormaliteCreateChargeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type FormaliteJsonldFormaliteCreateChargeEnum = typeof FormaliteJsonldFormaliteCreateChargeEnum[keyof typeof FormaliteJsonldFormaliteCreateChargeEnum];
export const FormaliteJsonldFormaliteCreateTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteJsonldFormaliteCreateTypeRecupGreffeEnum = typeof FormaliteJsonldFormaliteCreateTypeRecupGreffeEnum[keyof typeof FormaliteJsonldFormaliteCreateTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteJsonldFormaliteCreated
 */
export interface FormaliteJsonldFormaliteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'libelle': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'compatibilities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorJsonldFormaliteCreated>}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'validators'?: Array<TblFormalityFproDossierValidatorJsonldFormaliteCreated>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'charge'?: FormaliteJsonldFormaliteCreatedChargeEnum;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'typeRecupGreffe'?: FormaliteJsonldFormaliteCreatedTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteCreated
     */
    'sirenRequired'?: boolean;
}

export const FormaliteJsonldFormaliteCreatedChargeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type FormaliteJsonldFormaliteCreatedChargeEnum = typeof FormaliteJsonldFormaliteCreatedChargeEnum[keyof typeof FormaliteJsonldFormaliteCreatedChargeEnum];
export const FormaliteJsonldFormaliteCreatedTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteJsonldFormaliteCreatedTypeRecupGreffeEnum = typeof FormaliteJsonldFormaliteCreatedTypeRecupGreffeEnum[keyof typeof FormaliteJsonldFormaliteCreatedTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteJsonldFormaliteRead
 */
export interface FormaliteJsonldFormaliteRead {
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteJsonldFormaliteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'id'?: number;
    /**
     * 
     * @type {FproFormaliteCategorieJsonldFormaliteRead}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'categorie'?: FproFormaliteCategorieJsonldFormaliteRead | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'compatibilities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorJsonldFormaliteRead>}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'validators'?: Array<TblFormalityFproDossierValidatorJsonldFormaliteRead>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'charge'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'typeRecupGreffe'?: FormaliteJsonldFormaliteReadTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteRead
     */
    'sirenRequired'?: boolean;
}

export const FormaliteJsonldFormaliteReadTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteJsonldFormaliteReadTypeRecupGreffeEnum = typeof FormaliteJsonldFormaliteReadTypeRecupGreffeEnum[keyof typeof FormaliteJsonldFormaliteReadTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormaliteJsonldFormaliteUpdate
 */
export interface FormaliteJsonldFormaliteUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'categorie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'libelle': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'informationsSupplementaires'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'documents': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'legalStatuses'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'iconeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'formulaire'?: string | null;
    /**
     * Ordonnancement des formalités
     * @type {number}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'libDematfacile'?: string | null;
    /**
     * 
     * @type {Array<TblFormalityFproDossierValidatorJsonldFormaliteUpdate>}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'validators'?: Array<TblFormalityFproDossierValidatorJsonldFormaliteUpdate>;
    /**
     * 
     * @type {number}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'charge'?: FormaliteJsonldFormaliteUpdateChargeEnum;
    /**
     * 
     * @type {string}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'typeRecupGreffe'?: FormaliteJsonldFormaliteUpdateTypeRecupGreffeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'sirenRequired'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormaliteJsonldFormaliteUpdate
     */
    'compatibilities'?: Array<string>;
}

export const FormaliteJsonldFormaliteUpdateChargeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type FormaliteJsonldFormaliteUpdateChargeEnum = typeof FormaliteJsonldFormaliteUpdateChargeEnum[keyof typeof FormaliteJsonldFormaliteUpdateChargeEnum];
export const FormaliteJsonldFormaliteUpdateTypeRecupGreffeEnum = {
    Clientopere: 'CLIENTOPERE',
    Greffeformulaire: 'GREFFEFORMULAIRE'
} as const;

export type FormaliteJsonldFormaliteUpdateTypeRecupGreffeEnum = typeof FormaliteJsonldFormaliteUpdateTypeRecupGreffeEnum[keyof typeof FormaliteJsonldFormaliteUpdateTypeRecupGreffeEnum];

/**
 * 
 * @export
 * @interface FormeJuridiqueFormejuridiqueRead
 */
export interface FormeJuridiqueFormejuridiqueRead {
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'abreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'dirigeant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'dirigeance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'fObjetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'fCapvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'fAgrement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'fSci'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'nomenclature'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'rang'?: number;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'idparent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueFormejuridiqueRead
     */
    'fAfficheform'?: boolean;
}
/**
 * 
 * @export
 * @interface FormeJuridiqueJsonldFormejuridiqueRead
 */
export interface FormeJuridiqueJsonldFormejuridiqueRead {
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'abreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'dirigeant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'dirigeance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'fObjetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'fCapvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'fAgrement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'fSci'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'nomenclature'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'rang'?: number;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'idparent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldFormejuridiqueRead
     */
    'fAfficheform'?: boolean;
}
/**
 * 
 * @export
 * @interface FproDosDocFileCollectiondossierRead
 */
export interface FproDosDocFileCollectiondossierRead {
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileCollectiondossierRead
     */
    'idGed'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosDocFileDocumentfileCreate
 */
export interface FproDosDocFileDocumentfileCreate {
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'expediteur'?: FproDosDocFileDocumentfileCreateExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'expedition'?: FproDosDocFileDocumentfileCreateExpeditionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'idDocDf'?: number;
    /**
     * 
     * @type {FproDosDocFileDocumentfileCreate}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'docSigned'?: FproDosDocFileDocumentfileCreate | null;
    /**
     * 
     * @type {FproDosDocFileDocumentfileCreate}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'docOriginal'?: FproDosDocFileDocumentfileCreate | null;
    /**
     * 
     * @type {File}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'file'?: File | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosDocFileDocumentfileCreate
     */
    'typageAuto'?: boolean;
}

export const FproDosDocFileDocumentfileCreateExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileDocumentfileCreateExpediteurEnum = typeof FproDosDocFileDocumentfileCreateExpediteurEnum[keyof typeof FproDosDocFileDocumentfileCreateExpediteurEnum];
export const FproDosDocFileDocumentfileCreateExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileDocumentfileCreateExpeditionEnum = typeof FproDosDocFileDocumentfileCreateExpeditionEnum[keyof typeof FproDosDocFileDocumentfileCreateExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosDocFileDocumentfileRead
 */
export interface FproDosDocFileDocumentfileRead {
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'chemin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'idGed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'expediteur'?: FproDosDocFileDocumentfileReadExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'expedition'?: FproDosDocFileDocumentfileReadExpeditionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'idDocDf'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocDocumentfileRead}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'typeDocDossier'?: FproDossierDocDocumentfileRead;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {FproDosStatutDocumentfileRead}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'statut'?: FproDosStatutDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileDocumentfileRead}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'docSigned'?: FproDosDocFileDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileDocumentfileRead}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'docOriginal'?: FproDosDocFileDocumentfileRead | null;
    /**
     * 
     * @type {TblTypeDocumentDocumentfileRead}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'typedocIADoc'?: TblTypeDocumentDocumentfileRead | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDocumentfileRead
     */
    'jsonIADoc'?: string | null;
}

export const FproDosDocFileDocumentfileReadExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileDocumentfileReadExpediteurEnum = typeof FproDosDocFileDocumentfileReadExpediteurEnum[keyof typeof FproDosDocFileDocumentfileReadExpediteurEnum];
export const FproDosDocFileDocumentfileReadExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileDocumentfileReadExpeditionEnum = typeof FproDosDocFileDocumentfileReadExpeditionEnum[keyof typeof FproDosDocFileDocumentfileReadExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosDocFileDossierDossierSignRead
 */
export interface FproDosDocFileDossierDossierSignRead {
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileDossierDossierSignRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDosDocFileDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproDosDocFileDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idGed'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosDocFileJsonldCollectiondossierRead
 */
export interface FproDosDocFileJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosDocFileJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldCollectiondossierRead
     */
    'idGed'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosDocFileJsonldDocumentfileRead
 */
export interface FproDosDocFileJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'chemin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'idGed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'expediteur'?: FproDosDocFileJsonldDocumentfileReadExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'expedition'?: FproDosDocFileJsonldDocumentfileReadExpeditionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'idDocDf'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocJsonldDocumentfileRead}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'typeDocDossier'?: FproDossierDocJsonldDocumentfileRead;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {FproDosStatutJsonldDocumentfileRead}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'statut'?: FproDosStatutJsonldDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileJsonldDocumentfileRead}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'docSigned'?: FproDosDocFileJsonldDocumentfileRead | null;
    /**
     * 
     * @type {FproDosDocFileJsonldDocumentfileRead}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'docOriginal'?: FproDosDocFileJsonldDocumentfileRead | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldDocumentfileRead}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'typedocIADoc'?: TblTypeDocumentJsonldDocumentfileRead | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDocumentfileRead
     */
    'jsonIADoc'?: string | null;
}

export const FproDosDocFileJsonldDocumentfileReadExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileJsonldDocumentfileReadExpediteurEnum = typeof FproDosDocFileJsonldDocumentfileReadExpediteurEnum[keyof typeof FproDosDocFileJsonldDocumentfileReadExpediteurEnum];
export const FproDosDocFileJsonldDocumentfileReadExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileJsonldDocumentfileReadExpeditionEnum = typeof FproDosDocFileJsonldDocumentfileReadExpeditionEnum[keyof typeof FproDosDocFileJsonldDocumentfileReadExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosDocFileJsonldDossierDossierSignRead
 */
export interface FproDosDocFileJsonldDossierDossierSignRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosDocFileJsonldDossierDossierSignRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDossierDossierSignRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDossierDossierSignRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldDossierDossierSignRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idGed'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosDocFileJsonldTypedocumentdossierCreated
 */
export interface FproDosDocFileJsonldTypedocumentdossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'expediteur'?: FproDosDocFileJsonldTypedocumentdossierCreatedExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'expedition'?: FproDosDocFileJsonldTypedocumentdossierCreatedExpeditionEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocJsonldTypedocumentdossierCreated}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'typeDocDossier'?: FproDossierDocJsonldTypedocumentdossierCreated;
    /**
     * 
     * @type {FproDosStatutJsonldTypedocumentdossierCreated}
     * @memberof FproDosDocFileJsonldTypedocumentdossierCreated
     */
    'statut'?: FproDosStatutJsonldTypedocumentdossierCreated | null;
}

export const FproDosDocFileJsonldTypedocumentdossierCreatedExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileJsonldTypedocumentdossierCreatedExpediteurEnum = typeof FproDosDocFileJsonldTypedocumentdossierCreatedExpediteurEnum[keyof typeof FproDosDocFileJsonldTypedocumentdossierCreatedExpediteurEnum];
export const FproDosDocFileJsonldTypedocumentdossierCreatedExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileJsonldTypedocumentdossierCreatedExpeditionEnum = typeof FproDosDocFileJsonldTypedocumentdossierCreatedExpeditionEnum[keyof typeof FproDosDocFileJsonldTypedocumentdossierCreatedExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosDocFileJsonldTypedocumentdossierRead
 */
export interface FproDosDocFileJsonldTypedocumentdossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'expediteur'?: FproDosDocFileJsonldTypedocumentdossierReadExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'expedition'?: FproDosDocFileJsonldTypedocumentdossierReadExpeditionEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocJsonldTypedocumentdossierRead}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'typeDocDossier'?: FproDossierDocJsonldTypedocumentdossierRead;
    /**
     * 
     * @type {FproDosStatutJsonldTypedocumentdossierRead}
     * @memberof FproDosDocFileJsonldTypedocumentdossierRead
     */
    'statut'?: FproDosStatutJsonldTypedocumentdossierRead | null;
}

export const FproDosDocFileJsonldTypedocumentdossierReadExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileJsonldTypedocumentdossierReadExpediteurEnum = typeof FproDosDocFileJsonldTypedocumentdossierReadExpediteurEnum[keyof typeof FproDosDocFileJsonldTypedocumentdossierReadExpediteurEnum];
export const FproDosDocFileJsonldTypedocumentdossierReadExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileJsonldTypedocumentdossierReadExpeditionEnum = typeof FproDosDocFileJsonldTypedocumentdossierReadExpeditionEnum[keyof typeof FproDosDocFileJsonldTypedocumentdossierReadExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosDocFileTypedocumentdossierCreated
 */
export interface FproDosDocFileTypedocumentdossierCreated {
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'expediteur'?: FproDosDocFileTypedocumentdossierCreatedExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'expedition'?: FproDosDocFileTypedocumentdossierCreatedExpeditionEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocTypedocumentdossierCreated}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'typeDocDossier'?: FproDossierDocTypedocumentdossierCreated;
    /**
     * 
     * @type {FproDosStatutTypedocumentdossierCreated}
     * @memberof FproDosDocFileTypedocumentdossierCreated
     */
    'statut'?: FproDosStatutTypedocumentdossierCreated | null;
}

export const FproDosDocFileTypedocumentdossierCreatedExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileTypedocumentdossierCreatedExpediteurEnum = typeof FproDosDocFileTypedocumentdossierCreatedExpediteurEnum[keyof typeof FproDosDocFileTypedocumentdossierCreatedExpediteurEnum];
export const FproDosDocFileTypedocumentdossierCreatedExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileTypedocumentdossierCreatedExpeditionEnum = typeof FproDosDocFileTypedocumentdossierCreatedExpeditionEnum[keyof typeof FproDosDocFileTypedocumentdossierCreatedExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosDocFileTypedocumentdossierRead
 */
export interface FproDosDocFileTypedocumentdossierRead {
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'fichier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'dateAjout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'dateUpdate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'expediteur'?: FproDosDocFileTypedocumentdossierReadExpediteurEnum | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'expedition'?: FproDosDocFileTypedocumentdossierReadExpeditionEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'signed'?: number;
    /**
     * 
     * @type {FproDossierDocTypedocumentdossierRead}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'typeDocDossier'?: FproDossierDocTypedocumentdossierRead;
    /**
     * 
     * @type {FproDosStatutTypedocumentdossierRead}
     * @memberof FproDosDocFileTypedocumentdossierRead
     */
    'statut'?: FproDosStatutTypedocumentdossierRead | null;
}

export const FproDosDocFileTypedocumentdossierReadExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type FproDosDocFileTypedocumentdossierReadExpediteurEnum = typeof FproDosDocFileTypedocumentdossierReadExpediteurEnum[keyof typeof FproDosDocFileTypedocumentdossierReadExpediteurEnum];
export const FproDosDocFileTypedocumentdossierReadExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type FproDosDocFileTypedocumentdossierReadExpeditionEnum = typeof FproDosDocFileTypedocumentdossierReadExpeditionEnum[keyof typeof FproDosDocFileTypedocumentdossierReadExpeditionEnum];

/**
 * 
 * @export
 * @interface FproDosStatutDocumentfileRead
 */
export interface FproDosStatutDocumentfileRead {
    /**
     * 
     * @type {number}
     * @memberof FproDosStatutDocumentfileRead
     */
    'id'?: number;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof FproDosStatutDocumentfileRead
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutDocumentfileRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutDocumentfileRead
     */
    'class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutDocumentfileRead
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosStatutDocumentfileRead
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosStatutDocumentfileRead
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosStatutDocumentfileRead
     */
    'affichefront'?: boolean;
}
/**
 * 
 * @export
 * @interface FproDosStatutJsonldDocumentfileRead
 */
export interface FproDosStatutJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'id'?: number;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FproDosStatutJsonldDocumentfileRead
     */
    'affichefront'?: boolean;
}
/**
 * 
 * @export
 * @interface FproDosStatutJsonldTypedocumentdossierCreated
 */
export interface FproDosStatutJsonldTypedocumentdossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosStatutJsonldTypedocumentdossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldTypedocumentdossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldTypedocumentdossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosStatutJsonldTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldTypedocumentdossierCreated
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosStatutJsonldTypedocumentdossierRead
 */
export interface FproDosStatutJsonldTypedocumentdossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDosStatutJsonldTypedocumentdossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldTypedocumentdossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldTypedocumentdossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDosStatutJsonldTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutJsonldTypedocumentdossierRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosStatutTypedocumentdossierCreated
 */
export interface FproDosStatutTypedocumentdossierCreated {
    /**
     * 
     * @type {number}
     * @memberof FproDosStatutTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutTypedocumentdossierCreated
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDosStatutTypedocumentdossierRead
 */
export interface FproDosStatutTypedocumentdossierRead {
    /**
     * 
     * @type {number}
     * @memberof FproDosStatutTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDosStatutTypedocumentdossierRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDossierActiviteCreated
 */
export interface FproDossierActiviteCreated {
    /**
     * 
     * @type {number}
     * @memberof FproDossierActiviteCreated
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierActiviteRead
 */
export interface FproDossierActiviteRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierActiviteRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierCollectiondossierCreate
 */
export interface FproDossierCollectiondossierCreate {
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierCollectiondossierCreate
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierCollectiondossierCreate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierCollectiondossierCreate
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierCreate
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierCollectiondossierCreate
     */
    'societeSiren'?: string | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierCollectiondossierCreate
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierCollectiondossierCreate
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierCollectiondossierCreate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierCreate
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationCollectiondossierCreate>}
     * @memberof FproDossierCollectiondossierCreate
     */
    'prestations'?: Array<FproPrestationCollectiondossierCreate>;
}
/**
 * 
 * @export
 * @interface FproDossierCollectiondossierCreated
 */
export interface FproDossierCollectiondossierCreated {
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierCollectiondossierCreated
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierCollectiondossierCreated
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierCollectiondossierCreated
     */
    'societeSiren'?: string | null;
    /**
     * ID du client
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'idFormeJuridique'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierCollectiondossierCreated
     */
    'formaliste'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierCollectiondossierCreated
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierCreated
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationCollectiondossierCreated>}
     * @memberof FproDossierCollectiondossierCreated
     */
    'prestations'?: Array<FproPrestationCollectiondossierCreated>;
}
/**
 * 
 * @export
 * @interface FproDossierCollectiondossierRead
 */
export interface FproDossierCollectiondossierRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'contact'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'numero'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierCollectiondossierRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'dateMaj'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'societeDenomination'?: string | null;
    /**
     * Forme juridique de la société
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'societeFormeJuridique'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierCollectiondossierRead
     */
    'paye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'cheminDoc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierCollectiondossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof FproDossierCollectiondossierRead
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'dateFinalise'?: string | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'cegidRegimetva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierCollectiondossierRead
     */
    'recuPaiement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'idDematfacile'?: number;
    /**
     * ID du client
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'clientOpere'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'factureActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'factureBrouillon'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'factActiveSansAvoir'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiant de la formalite
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'formalite'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'formaliste'?: number | null;
    /**
     * 
     * @type {Array<FproDossierDocCollectiondossierRead>}
     * @memberof FproDossierCollectiondossierRead
     */
    'documents'?: Array<FproDossierDocCollectiondossierRead>;
    /**
     * 
     * @type {Array<FproDosDocFileCollectiondossierRead>}
     * @memberof FproDossierCollectiondossierRead
     */
    'fichiers'?: Array<FproDosDocFileCollectiondossierRead>;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierRead
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierRead
     */
    'marque'?: number | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof FproDossierCollectiondossierRead
     */
    'factures'?: Array<object>;
    /**
     * 
     * @type {Array<FproPrestationCollectiondossierRead>}
     * @memberof FproDossierCollectiondossierRead
     */
    'prestations'?: Array<FproPrestationCollectiondossierRead>;
}
/**
 * 
 * @export
 * @interface FproDossierCollectiondossierUpdate
 */
export interface FproDossierCollectiondossierUpdate {
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'societeSiren'?: string | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'formaliste'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationCollectiondossierUpdate>}
     * @memberof FproDossierCollectiondossierUpdate
     */
    'prestations'?: Array<FproPrestationCollectiondossierUpdate>;
}
/**
 * 
 * @export
 * @interface FproDossierCollectiondossierValidated
 */
export interface FproDossierCollectiondossierValidated {
    /**
     * 
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierCollectiondossierValidated
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierCollectiondossierValidated
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierCollectiondossierValidated
     */
    'societeSiren'?: string | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'idFormeJuridique'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierCollectiondossierValidated
     */
    'formaliste'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierCollectiondossierValidated
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierCollectiondossierValidated
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationCollectiondossierValidated>}
     * @memberof FproDossierCollectiondossierValidated
     */
    'prestations'?: Array<FproPrestationCollectiondossierValidated>;
}
/**
 * 
 * @export
 * @interface FproDossierDocCollectiondossierRead
 */
export interface FproDossierDocCollectiondossierRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocCollectiondossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocCollectiondossierRead
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocCollectiondossierRead
     */
    'statut'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDossierDocDocumentfileRead
 */
export interface FproDossierDocDocumentfileRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocDocumentfileRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocDocumentfileRead
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {TblTypeDocumentDocumentfileRead}
     * @memberof FproDossierDocDocumentfileRead
     */
    'document'?: TblTypeDocumentDocumentfileRead | null;
    /**
     * 
     * @type {FproDosStatutDocumentfileRead}
     * @memberof FproDossierDocDocumentfileRead
     */
    'statut'?: FproDosStatutDocumentfileRead | null;
}
/**
 * 
 * @export
 * @interface FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'statut'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDossierDocJsonldCollectiondossierRead
 */
export interface FproDossierDocJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldCollectiondossierRead
     */
    'statut'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDossierDocJsonldDocumentfileRead
 */
export interface FproDossierDocJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldDocumentfileRead}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    'document'?: TblTypeDocumentJsonldDocumentfileRead | null;
    /**
     * 
     * @type {FproDosStatutJsonldDocumentfileRead}
     * @memberof FproDossierDocJsonldDocumentfileRead
     */
    'statut'?: FproDosStatutJsonldDocumentfileRead | null;
}
/**
 * 
 * @export
 * @interface FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'statut'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDossierDocJsonldTypedocumentdossierCreated
 */
export interface FproDossierDocJsonldTypedocumentdossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldTypedocumentdossierCreated}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'document'?: TblTypeDocumentJsonldTypedocumentdossierCreated | null;
    /**
     * 
     * @type {FproDosStatutJsonldTypedocumentdossierCreated}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'statut'?: FproDosStatutJsonldTypedocumentdossierCreated | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldTypedocumentdossierCreated>}
     * @memberof FproDossierDocJsonldTypedocumentdossierCreated
     */
    'fichiers'?: Array<FproDosDocFileJsonldTypedocumentdossierCreated>;
}
/**
 * 
 * @export
 * @interface FproDossierDocJsonldTypedocumentdossierRead
 */
export interface FproDossierDocJsonldTypedocumentdossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldTypedocumentdossierRead}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'document'?: TblTypeDocumentJsonldTypedocumentdossierRead | null;
    /**
     * 
     * @type {FproDosStatutJsonldTypedocumentdossierRead}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'statut'?: FproDosStatutJsonldTypedocumentdossierRead | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldTypedocumentdossierRead>}
     * @memberof FproDossierDocJsonldTypedocumentdossierRead
     */
    'fichiers'?: Array<FproDosDocFileJsonldTypedocumentdossierRead>;
}
/**
 * 
 * @export
 * @interface FproDossierDocTypedocumentdossierCreated
 */
export interface FproDossierDocTypedocumentdossierCreated {
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentTypedocumentdossierCreated}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'document'?: TblTypeDocumentTypedocumentdossierCreated | null;
    /**
     * 
     * @type {FproDosStatutTypedocumentdossierCreated}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'statut'?: FproDosStatutTypedocumentdossierCreated | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileTypedocumentdossierCreated>}
     * @memberof FproDossierDocTypedocumentdossierCreated
     */
    'fichiers'?: Array<FproDosDocFileTypedocumentdossierCreated>;
}
/**
 * 
 * @export
 * @interface FproDossierDocTypedocumentdossierRead
 */
export interface FproDossierDocTypedocumentdossierRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentTypedocumentdossierRead}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'document'?: TblTypeDocumentTypedocumentdossierRead | null;
    /**
     * 
     * @type {FproDosStatutTypedocumentdossierRead}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'statut'?: FproDosStatutTypedocumentdossierRead | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileTypedocumentdossierRead>}
     * @memberof FproDossierDocTypedocumentdossierRead
     */
    'fichiers'?: Array<FproDosDocFileTypedocumentdossierRead>;
}
/**
 * 
 * @export
 * @interface FproDossierDossierSignDocumentDossierDossierSignRead
 */
export interface FproDossierDossierSignDocumentDossierDossierSignRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierDossierSignDocumentDossierDossierSignRead
     */
    'id'?: number;
    /**
     * 
     * @type {FproDosDocFileDossierDossierSignRead}
     * @memberof FproDossierDossierSignDocumentDossierDossierSignRead
     */
    'file'?: FproDosDocFileDossierDossierSignRead | null;
}
/**
 * 
 * @export
 * @interface FproDossierDossierSignDocumentJsonldDossierDossierSignRead
 */
export interface FproDossierDossierSignDocumentJsonldDossierDossierSignRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierDossierSignDocumentJsonldDossierDossierSignRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDossierSignDocumentJsonldDossierDossierSignRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierDossierSignDocumentJsonldDossierDossierSignRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierDossierSignDocumentJsonldDossierDossierSignRead
     */
    'id'?: number;
    /**
     * 
     * @type {FproDosDocFileJsonldDossierDossierSignRead}
     * @memberof FproDossierDossierSignDocumentJsonldDossierDossierSignRead
     */
    'file'?: FproDosDocFileJsonldDossierDossierSignRead | null;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldActiviteCreated
 */
export interface FproDossierJsonldActiviteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldActiviteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldActiviteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldActiviteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldActiviteCreated
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldActiviteRead
 */
export interface FproDossierJsonldActiviteRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldActiviteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldActiviteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldActiviteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldActiviteRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldCollectiondossierCreate
 */
export interface FproDossierJsonldCollectiondossierCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    '@type'?: string;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'societeSiren'?: string | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationJsonldCollectiondossierCreate>}
     * @memberof FproDossierJsonldCollectiondossierCreate
     */
    'prestations'?: Array<FproPrestationJsonldCollectiondossierCreate>;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldCollectiondossierCreated
 */
export interface FproDossierJsonldCollectiondossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'societeSiren'?: string | null;
    /**
     * ID du client
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'idFormeJuridique'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'formaliste'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationJsonldCollectiondossierCreated>}
     * @memberof FproDossierJsonldCollectiondossierCreated
     */
    'prestations'?: Array<FproPrestationJsonldCollectiondossierCreated>;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldCollectiondossierRead
 */
export interface FproDossierJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'contact'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'numero'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'dateMaj'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'societeDenomination'?: string | null;
    /**
     * Forme juridique de la société
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'societeFormeJuridique'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'paye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'cheminDoc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {DossierDossierCreateJsonObject}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'jsonObject'?: DossierDossierCreateJsonObject;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'dateFinalise'?: string | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'societeSiren'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'cegidRegimetva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'recuPaiement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'idDematfacile'?: number;
    /**
     * ID du client
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'client'?: number | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'clientOpere'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'factureActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'factureBrouillon'?: number;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'factActiveSansAvoir'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiant de la formalite
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'formalite'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'formaliste'?: number | null;
    /**
     * 
     * @type {Array<FproDossierDocJsonldCollectiondossierRead>}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'documents'?: Array<FproDossierDocJsonldCollectiondossierRead>;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldCollectiondossierRead>}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'fichiers'?: Array<FproDosDocFileJsonldCollectiondossierRead>;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'marque'?: number | null;
    /**
     * 
     * @type {Array<TblFactureMultipleJsonldCollectiondossierRead>}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'factures'?: Array<TblFactureMultipleJsonldCollectiondossierRead>;
    /**
     * 
     * @type {Array<FproPrestationJsonldCollectiondossierRead>}
     * @memberof FproDossierJsonldCollectiondossierRead
     */
    'prestations'?: Array<FproPrestationJsonldCollectiondossierRead>;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldCollectiondossierUpdate
 */
export interface FproDossierJsonldCollectiondossierUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    '@type'?: string;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'societeSiren'?: string | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'idFormeJuridique'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'formaliste'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationJsonldCollectiondossierUpdate>}
     * @memberof FproDossierJsonldCollectiondossierUpdate
     */
    'prestations'?: Array<FproPrestationJsonldCollectiondossierUpdate>;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldCollectiondossierValidated
 */
export interface FproDossierJsonldCollectiondossierValidated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'societe'?: number;
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'prescripteur'?: number;
    /**
     * Identifiant du contact
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'contact'?: number | null;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'societeDenomination'?: string | null;
    /**
     * Origine de création du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'origine'?: number | null;
    /**
     * Siren de la société liée à la formalité
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'societeSiren'?: string | null;
    /**
     * ID du client opéré
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'clientOpere'?: number;
    /**
     * ID dde la forme juridique de la société concernée par la formalité
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'idFormeJuridique'?: number | null;
    /**
     * Statut du dossier
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'statut'?: number | null;
    /**
     * Identifiant du formaliste
     * @type {number}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'formaliste'?: number | null;
    /**
     * Identifiants des formalites
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'affaire'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationJsonldCollectiondossierValidated>}
     * @memberof FproDossierJsonldCollectiondossierValidated
     */
    'prestations'?: Array<FproPrestationJsonldCollectiondossierValidated>;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldTacheRead
 */
export interface FproDossierJsonldTacheRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierJsonldTacheRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldTacheRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldTacheRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonldTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldTacheRead
     */
    'numero'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierJsonldTacheRead
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierJsonldTacheRead
     */
    'societeDenomination'?: string | null;
}
/**
 * 
 * @export
 * @interface FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'highlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'memoClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'highlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'memoClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierNoteJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierStepJsonldStatutRead
 */
export interface FproDossierStepJsonldStatutRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproDossierStepJsonldStatutRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierStepJsonldStatutRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierStepJsonldStatutRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierStepJsonldStatutRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierStepStatutRead
 */
export interface FproDossierStepStatutRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierStepStatutRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierTacheRead
 */
export interface FproDossierTacheRead {
    /**
     * 
     * @type {number}
     * @memberof FproDossierTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierTacheRead
     */
    'numero'?: string;
    /**
     * Référence du tiers pour ce dossier (La référence sera notée sur la facture)
     * @type {string}
     * @memberof FproDossierTacheRead
     */
    'societeRef'?: string | null;
    /**
     * Dénomination de la société
     * @type {string}
     * @memberof FproDossierTacheRead
     */
    'societeDenomination'?: string | null;
}
/**
 * 
 * @export
 * @interface FproFormaliteCategorieFormaliteRead
 */
export interface FproFormaliteCategorieFormaliteRead {
    /**
     * 
     * @type {number}
     * @memberof FproFormaliteCategorieFormaliteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieFormaliteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieFormaliteRead
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieFormaliteRead
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface FproFormaliteCategorieJsonldFormaliteRead
 */
export interface FproFormaliteCategorieJsonldFormaliteRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    'libelleDematFacile'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproFormaliteCategorieJsonldFormaliteRead
     */
    'iconeName'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleCollectiondossierCreated
 */
export interface FproPrestationArticleCollectiondossierCreated {
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierCreated
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierCreated
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierCreated
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierCreated
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierCreated
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierCreated
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleCollectiondossierRead
 */
export interface FproPrestationArticleCollectiondossierRead {
    /**
     * 
     * @type {TblFactArticlesCollectiondossierRead}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'factArticle': TblFactArticlesCollectiondossierRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeCollectiondossierRead}
     * @memberof FproPrestationArticleCollectiondossierRead
     */
    'idstype'?: TblAnnonceSTypeCollectiondossierRead | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleCollectiondossierUpdate
 */
export interface FproPrestationArticleCollectiondossierUpdate {
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierUpdate
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierUpdate
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierUpdate
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierUpdate
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierUpdate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierUpdate
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleCollectiondossierValidated
 */
export interface FproPrestationArticleCollectiondossierValidated {
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierValidated
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierValidated
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierValidated
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierValidated
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleCollectiondossierValidated
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleCollectiondossierValidated
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factArticle': TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeDossierReadNoteGroupTimestampableBlameambleGroup}
     * @memberof FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idstype'?: TblAnnonceSTypeDossierReadNoteGroupTimestampableBlameambleGroup | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleDtoDossierUpdateArticle
 */
export interface FproPrestationArticleDtoDossierUpdateArticle {
    /**
     * Id de l\'article
     * @type {number}
     * @memberof FproPrestationArticleDtoDossierUpdateArticle
     */
    'id'?: number;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleDtoDossierUpdateArticle
     */
    'libelle': string | null;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleDtoDossierUpdateArticle
     */
    'rang'?: number;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleJsonldCollectiondossierCreated
 */
export interface FproPrestationArticleJsonldCollectiondossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    '@type'?: string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierCreated
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleJsonldCollectiondossierRead
 */
export interface FproPrestationArticleJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {TblFactArticlesJsonldCollectiondossierRead}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'factArticle': TblFactArticlesJsonldCollectiondossierRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeJsonldCollectiondossierRead}
     * @memberof FproPrestationArticleJsonldCollectiondossierRead
     */
    'idstype'?: TblAnnonceSTypeJsonldCollectiondossierRead | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleJsonldCollectiondossierUpdate
 */
export interface FproPrestationArticleJsonldCollectiondossierUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    '@type'?: string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierUpdate
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleJsonldCollectiondossierValidated
 */
export interface FproPrestationArticleJsonldCollectiondossierValidated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    '@type'?: string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldCollectiondossierValidated
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'factArticle': TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup}
     * @memberof FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'idstype'?: TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticleJsonldPrestationRead
 */
export interface FproPrestationArticleJsonldPrestationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {TblFactArticlesJsonldPrestationRead}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'factArticle': TblFactArticlesJsonldPrestationRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeJsonldPrestationRead}
     * @memberof FproPrestationArticleJsonldPrestationRead
     */
    'idstype'?: TblAnnonceSTypeJsonldPrestationRead | null;
}
/**
 * 
 * @export
 * @interface FproPrestationArticlePrestationRead
 */
export interface FproPrestationArticlePrestationRead {
    /**
     * 
     * @type {TblFactArticlesPrestationRead}
     * @memberof FproPrestationArticlePrestationRead
     */
    'factArticle': TblFactArticlesPrestationRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof FproPrestationArticlePrestationRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof FproPrestationArticlePrestationRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof FproPrestationArticlePrestationRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof FproPrestationArticlePrestationRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof FproPrestationArticlePrestationRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticlePrestationRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof FproPrestationArticlePrestationRead
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypePrestationRead}
     * @memberof FproPrestationArticlePrestationRead
     */
    'idstype'?: TblAnnonceSTypePrestationRead | null;
}
/**
 * 
 * @export
 * @interface FproPrestationCollectiondossierCreate
 */
export interface FproPrestationCollectiondossierCreate {
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreate
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationCollectiondossierCreate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreate
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreate
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreate
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationCollectiondossierCreated
 */
export interface FproPrestationCollectiondossierCreated {
    /**
     * 
     * @type {number}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleCollectiondossierCreated>}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'articles'?: Array<FproPrestationArticleCollectiondossierCreated>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationCollectiondossierCreated
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationCollectiondossierRead
 */
export interface FproPrestationCollectiondossierRead {
    /**
     * 
     * @type {number}
     * @memberof FproPrestationCollectiondossierRead
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationCollectiondossierRead
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationCollectiondossierRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierRead
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierRead
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierRead
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleCollectiondossierRead>}
     * @memberof FproPrestationCollectiondossierRead
     */
    'articles'?: Array<FproPrestationArticleCollectiondossierRead>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationCollectiondossierRead
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationCollectiondossierUpdate
 */
export interface FproPrestationCollectiondossierUpdate {
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationCollectiondossierUpdate
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationCollectiondossierUpdate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierUpdate
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierUpdate
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierUpdate
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleCollectiondossierUpdate>}
     * @memberof FproPrestationCollectiondossierUpdate
     */
    'articles'?: Array<FproPrestationArticleCollectiondossierUpdate>;
}
/**
 * 
 * @export
 * @interface FproPrestationCollectiondossierValidated
 */
export interface FproPrestationCollectiondossierValidated {
    /**
     * 
     * @type {number}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleCollectiondossierValidated>}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'articles'?: Array<FproPrestationArticleCollectiondossierValidated>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationCollectiondossierValidated
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationDossierCreate
 */
export interface FproPrestationDossierCreate {
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationDossierCreate
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationDossierCreate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationDossierCreate
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationDossierCreate
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationDossierCreate
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {TblCatalogueDossierReadNoteGroupTimestampableBlameambleGroup}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'catalogue'?: TblCatalogueDossierReadNoteGroupTimestampableBlameambleGroup | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'articles'?: Array<FproPrestationArticleDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldCollectiondossierCreate
 */
export interface FproPrestationJsonldCollectiondossierCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    '@type'?: string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreate
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldCollectiondossierCreated
 */
export interface FproPrestationJsonldCollectiondossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleJsonldCollectiondossierCreated>}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'articles'?: Array<FproPrestationArticleJsonldCollectiondossierCreated>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationJsonldCollectiondossierCreated
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldCollectiondossierRead
 */
export interface FproPrestationJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleJsonldCollectiondossierRead>}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'articles'?: Array<FproPrestationArticleJsonldCollectiondossierRead>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationJsonldCollectiondossierRead
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldCollectiondossierUpdate
 */
export interface FproPrestationJsonldCollectiondossierUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    '@type'?: string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleJsonldCollectiondossierUpdate>}
     * @memberof FproPrestationJsonldCollectiondossierUpdate
     */
    'articles'?: Array<FproPrestationArticleJsonldCollectiondossierUpdate>;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldCollectiondossierValidated
 */
export interface FproPrestationJsonldCollectiondossierValidated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleJsonldCollectiondossierValidated>}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'articles'?: Array<FproPrestationArticleJsonldCollectiondossierValidated>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationJsonldCollectiondossierValidated
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldDossierCreate
 */
export interface FproPrestationJsonldDossierCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldDossierCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierCreate
     */
    '@type'?: string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldDossierCreate
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldDossierCreate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierCreate
     */
    'catalogue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierCreate
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierCreate
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'catalogue'?: TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup | null;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup>}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'articles'?: Array<FproPrestationArticleJsonldDossierReadNoteGroupTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'greffes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetActionLoggerCategory200Response
 */
export interface GetActionLoggerCategory200Response {
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogRead>}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:member': Array<LogActionMapCategoryJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:view'?: ApiAcomptesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAcomptesGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:search'?: ApiAcomptesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface Greffe
 */
export interface Greffe {
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'greffes'?: string;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'art'?: string;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefAp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefEp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'idTiers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefGen'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'mailBodacc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Greffe
     */
    'bodaccMailPossible'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'aresseComplete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'dateLastModif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'idUserLastModif'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Greffe
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'idUserCreation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefGenSpel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefApForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefEpForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefGenForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefGenSpelForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefJalCaractere'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefSpelCaractere'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefJalCaractereXl'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefSpelCaractereXl'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefJalForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefSpelForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefJalForfaitXl'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Greffe
     */
    'prefSpelForfaitXl'?: number | null;
}
/**
 * 
 * @export
 * @interface GreffeGreffeRead
 */
export interface GreffeGreffeRead {
    /**
     * 
     * @type {number}
     * @memberof GreffeGreffeRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GreffeGreffeRead
     */
    'greffes'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeGreffeRead
     */
    'art'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeGreffeRead
     */
    'dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof GreffeGreffeRead
     */
    'prefAp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeGreffeRead
     */
    'prefEp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeGreffeRead
     */
    'prefGen'?: number | null;
}
/**
 * 
 * @export
 * @interface GreffeJsonld
 */
export interface GreffeJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof GreffeJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'greffes'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'art'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefAp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefEp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'idTiers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefGen'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'mailBodacc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GreffeJsonld
     */
    'bodaccMailPossible'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'aresseComplete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'dateLastModif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'idUserLastModif'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonld
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'idUserCreation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefGenSpel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefApForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefEpForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefGenForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefGenSpelForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefJalCaractere'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefSpelCaractere'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefJalCaractereXl'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefSpelCaractereXl'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefJalForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefSpelForfait'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefJalForfaitXl'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonld
     */
    'prefSpelForfaitXl'?: number | null;
}
/**
 * 
 * @export
 * @interface GreffeJsonldGreffeRead
 */
export interface GreffeJsonldGreffeRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof GreffeJsonldGreffeRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonldGreffeRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonldGreffeRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonldGreffeRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonldGreffeRead
     */
    'greffes'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonldGreffeRead
     */
    'art'?: string;
    /**
     * 
     * @type {string}
     * @memberof GreffeJsonldGreffeRead
     */
    'dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonldGreffeRead
     */
    'prefAp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonldGreffeRead
     */
    'prefEp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GreffeJsonldGreffeRead
     */
    'prefGen'?: number | null;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossier
 */
export interface LogActionCollectionDossier {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossier
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionCollectionDossier
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierJsonld
 */
export interface LogActionCollectionDossierJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionCollectionDossierJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionCollectionDossierJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierJsonldLogReadLogReadExpanded
 */
export interface LogActionCollectionDossierJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadLogReadExpanded}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogActionDtoJsonldLogRead
 */
export interface LogActionCollectionDossierLogActionDtoJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogRead}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogRead
     */
    'logCategories'?: CollectionJsonldLogRead;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
 */
export interface LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadExpanded}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
 */
export interface LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadLogReadExpanded}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadLogReadExpanded}
     * @memberof LogActionCollectionDossierLogActionDtoJsonldLogReadLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogActionDtoLogRead
 */
export interface LogActionCollectionDossierLogActionDtoLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionCollectionDossierLogActionDtoLogRead
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogActionDtoLogReadExpanded
 */
export interface LogActionCollectionDossierLogActionDtoLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
 */
export interface LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadLogReadExpanded}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionCollectionDossierLogActionDtoLogReadLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogReadLogReadExpanded
 */
export interface LogActionCollectionDossierLogReadLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadLogReadExpanded}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDevis
 */
export interface LogActionDevis {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevis
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionDevis
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDevisJsonld
 */
export interface LogActionDevisJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionDevisJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionDevisJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDevisJsonldLogReadLogReadExpanded
 */
export interface LogActionDevisJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadLogReadExpanded}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogActionDtoJsonldLogRead
 */
export interface LogActionDevisLogActionDtoJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogRead}
     * @memberof LogActionDevisLogActionDtoJsonldLogRead
     */
    'logCategories'?: CollectionJsonldLogRead;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogActionDtoJsonldLogReadExpanded
 */
export interface LogActionDevisLogActionDtoJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadExpanded}
     * @memberof LogActionDevisLogActionDtoJsonldLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogActionDtoLogRead
 */
export interface LogActionDevisLogActionDtoLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionDevisLogActionDtoLogRead
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogActionDtoLogReadExpanded
 */
export interface LogActionDevisLogActionDtoLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionDevisLogActionDtoLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogReadLogReadExpanded
 */
export interface LogActionDevisLogReadLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadLogReadExpanded}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDossier
 */
export interface LogActionDossier {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossier
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossier
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionDossier
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDossierJsonld
 */
export interface LogActionDossierJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionDossierJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonld
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionDossierJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDossierJsonldLogRead
 */
export interface LogActionDossierJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogRead
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionDossierJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDossierJsonldLogReadExpandedLogRead
 */
export interface LogActionDossierJsonldLogReadExpandedLogRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpandedLogRead}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'actionType'?: LogActionTypeJsonldLogReadExpandedLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpandedLogRead
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogActionDtoJsonldLogRead
 */
export interface LogActionDossierLogActionDtoJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogRead}
     * @memberof LogActionDossierLogActionDtoJsonldLogRead
     */
    'logCategories'?: CollectionJsonldLogRead;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogActionDtoJsonldLogReadExpanded
 */
export interface LogActionDossierLogActionDtoJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadExpanded}
     * @memberof LogActionDossierLogActionDtoJsonldLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogActionDtoLogRead
 */
export interface LogActionDossierLogActionDtoLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionDossierLogActionDtoLogRead
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogActionDtoLogReadExpanded
 */
export interface LogActionDossierLogActionDtoLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionDossierLogActionDtoLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogRead
 */
export interface LogActionDossierLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogRead
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionDossierLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogReadExpandedLogRead
 */
export interface LogActionDossierLogReadExpandedLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpandedLogRead}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'actionType'?: LogActionTypeLogReadExpandedLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpandedLogRead
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionFacture
 */
export interface LogActionFacture {
    /**
     * 
     * @type {number}
     * @memberof LogActionFacture
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionFacture
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionFactureJsonld
 */
export interface LogActionFactureJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionFactureJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionFactureJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionFactureJsonldLogReadLogReadExpanded
 */
export interface LogActionFactureJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadLogReadExpanded}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogActionDtoJsonldLogRead
 */
export interface LogActionFactureLogActionDtoJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogRead}
     * @memberof LogActionFactureLogActionDtoJsonldLogRead
     */
    'logCategories'?: CollectionJsonldLogRead;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogActionDtoJsonldLogReadExpanded
 */
export interface LogActionFactureLogActionDtoJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadExpanded}
     * @memberof LogActionFactureLogActionDtoJsonldLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogActionDtoLogRead
 */
export interface LogActionFactureLogActionDtoLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionFactureLogActionDtoLogRead
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogActionDtoLogReadExpanded
 */
export interface LogActionFactureLogActionDtoLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionFactureLogActionDtoLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogReadLogReadExpanded
 */
export interface LogActionFactureLogReadLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadLogReadExpanded}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryJsonldLogRead
 */
export interface LogActionMapCategoryJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryJsonldLogReadExpanded
 */
export interface LogActionMapCategoryJsonldLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryJsonldLogReadExpandedLogRead
 */
export interface LogActionMapCategoryJsonldLogReadExpandedLogRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionMapCategoryJsonldLogReadExpandedLogRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpandedLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpandedLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpandedLogRead
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryJsonldLogReadLogReadExpanded
 */
export interface LogActionMapCategoryJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionMapCategoryJsonldLogReadLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadLogReadExpanded
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryLogRead
 */
export interface LogActionMapCategoryLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryLogRead
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryLogReadExpanded
 */
export interface LogActionMapCategoryLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryLogReadExpanded
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryLogReadExpandedLogRead
 */
export interface LogActionMapCategoryLogReadExpandedLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryLogReadExpandedLogRead
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryLogReadLogReadExpanded
 */
export interface LogActionMapCategoryLogReadLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryLogReadLogReadExpanded
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiers
 */
export interface LogActionTiers {
    /**
     * 
     * @type {number}
     * @memberof LogActionTiers
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiers
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionTiers
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionTiersJsonld
 */
export interface LogActionTiersJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionTiersJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionTiersJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionTiersLogActionDtoJsonldLogRead
 */
export interface LogActionTiersLogActionDtoJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogRead}
     * @memberof LogActionTiersLogActionDtoJsonldLogRead
     */
    'logCategories'?: CollectionJsonldLogRead;
}
/**
 * 
 * @export
 * @interface LogActionTiersLogActionDtoJsonldLogReadExpanded
 */
export interface LogActionTiersLogActionDtoJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadExpanded}
     * @memberof LogActionTiersLogActionDtoJsonldLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionTiersLogActionDtoLogRead
 */
export interface LogActionTiersLogActionDtoLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionTiersLogActionDtoLogRead
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionTiersLogActionDtoLogReadExpanded
 */
export interface LogActionTiersLogActionDtoLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionTiersLogActionDtoLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionType
 */
export interface LogActionType {
    /**
     * 
     * @type {string}
     * @memberof LogActionType
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionType
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof LogActionType
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogActionType
     */
    'logCategories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogActionType
     */
    'actionType'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonld
 */
export interface LogActionTypeJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionTypeJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTypeJsonld
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogActionTypeJsonld
     */
    'logCategories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    'actionType'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonldLogRead
 */
export interface LogActionTypeJsonldLogRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionTypeJsonldLogRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogRead>}
     * @memberof LogActionTypeJsonldLogRead
     */
    'logCategories'?: Array<LogActionMapCategoryJsonldLogRead>;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonldLogReadExpanded
 */
export interface LogActionTypeJsonldLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogReadExpanded>}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    'logCategories'?: Array<LogActionMapCategoryJsonldLogReadExpanded>;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonldLogReadExpandedLogRead
 */
export interface LogActionTypeJsonldLogReadExpandedLogRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionTypeJsonldLogReadExpandedLogRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpandedLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpandedLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpandedLogRead
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpandedLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogReadExpandedLogRead>}
     * @memberof LogActionTypeJsonldLogReadExpandedLogRead
     */
    'logCategories'?: Array<LogActionMapCategoryJsonldLogReadExpandedLogRead>;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonldLogReadLogReadExpanded
 */
export interface LogActionTypeJsonldLogReadLogReadExpanded {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionTypeJsonldLogReadLogReadExpanded
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadLogReadExpanded
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogReadLogReadExpanded>}
     * @memberof LogActionTypeJsonldLogReadLogReadExpanded
     */
    'logCategories'?: Array<LogActionMapCategoryJsonldLogReadLogReadExpanded>;
}
/**
 * 
 * @export
 * @interface LogActionTypeLogRead
 */
export interface LogActionTypeLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogRead
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryLogRead>}
     * @memberof LogActionTypeLogRead
     */
    'logCategories'?: Array<LogActionMapCategoryLogRead>;
}
/**
 * 
 * @export
 * @interface LogActionTypeLogReadExpanded
 */
export interface LogActionTypeLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadExpanded
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryLogReadExpanded>}
     * @memberof LogActionTypeLogReadExpanded
     */
    'logCategories'?: Array<LogActionMapCategoryLogReadExpanded>;
}
/**
 * 
 * @export
 * @interface LogActionTypeLogReadExpandedLogRead
 */
export interface LogActionTypeLogReadExpandedLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadExpandedLogRead
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadExpandedLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryLogReadExpandedLogRead>}
     * @memberof LogActionTypeLogReadExpandedLogRead
     */
    'logCategories'?: Array<LogActionMapCategoryLogReadExpandedLogRead>;
}
/**
 * 
 * @export
 * @interface LogActionTypeLogReadLogReadExpanded
 */
export interface LogActionTypeLogReadLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadLogReadExpanded
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryLogReadLogReadExpanded>}
     * @memberof LogActionTypeLogReadLogReadExpanded
     */
    'logCategories'?: Array<LogActionMapCategoryLogReadLogReadExpanded>;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateur
 */
export interface LogActionUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateur
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionUtilisateur
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurJsonld
 */
export interface LogActionUtilisateurJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof LogActionUtilisateurJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionUtilisateurJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurJsonldLogRead
 */
export interface LogActionUtilisateurJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurJsonldLogReadExpanded
 */
export interface LogActionUtilisateurJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogActionDtoJsonldLogRead
 */
export interface LogActionUtilisateurLogActionDtoJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogRead}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogRead
     */
    'logCategories'?: CollectionJsonldLogRead;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
 */
export interface LogActionUtilisateurLogActionDtoJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {CollectionJsonldLogReadExpanded}
     * @memberof LogActionUtilisateurLogActionDtoJsonldLogReadExpanded
     */
    'logCategories'?: CollectionJsonldLogReadExpanded;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogActionDtoLogRead
 */
export interface LogActionUtilisateurLogActionDtoLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionUtilisateurLogActionDtoLogRead
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogActionDtoLogReadExpanded
 */
export interface LogActionUtilisateurLogActionDtoLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'idCollectionDossier'?: number | null;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'logMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'actionTypeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'idUserKeycloak'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof LogActionUtilisateurLogActionDtoLogReadExpanded
     */
    'logCategories'?: object;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogRead
 */
export interface LogActionUtilisateurLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionUtilisateurLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogReadExpanded
 */
export interface LogActionUtilisateurLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface MessageJsonld
 */
export interface MessageJsonld {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof MessageJsonld
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonld
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface MessageJsonldMessageCreate
 */
export interface MessageJsonldMessageCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof MessageJsonldMessageCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageJsonldMessageCreate
     */
    'expediteur': MessageJsonldMessageCreateExpediteurEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreate
     */
    'expediteurNom': string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreate
     */
    'message': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageCreate
     */
    'readByPrescri'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageCreate
     */
    'readByFrmlist'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreate
     */
    'dossier'?: string | null;
}

export const MessageJsonldMessageCreateExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type MessageJsonldMessageCreateExpediteurEnum = typeof MessageJsonldMessageCreateExpediteurEnum[keyof typeof MessageJsonldMessageCreateExpediteurEnum];

/**
 * 
 * @export
 * @interface MessageJsonldMessageCreated
 */
export interface MessageJsonldMessageCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof MessageJsonldMessageCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageJsonldMessageCreated
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageJsonldMessageCreated
     */
    'expediteur': MessageJsonldMessageCreatedExpediteurEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreated
     */
    'expediteurNom': string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreated
     */
    'message': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageCreated
     */
    'readByPrescri'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageCreated
     */
    'readByFrmlist'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageCreated
     */
    'dossier'?: string | null;
}

export const MessageJsonldMessageCreatedExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type MessageJsonldMessageCreatedExpediteurEnum = typeof MessageJsonldMessageCreatedExpediteurEnum[keyof typeof MessageJsonldMessageCreatedExpediteurEnum];

/**
 * 
 * @export
 * @interface MessageJsonldMessageRead
 */
export interface MessageJsonldMessageRead {
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof MessageJsonldMessageRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof MessageJsonldMessageRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MessageJsonldMessageRead
     */
    'expediteur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageRead
     */
    'expediteurNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageRead
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageRead
     */
    'readByPrescri'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageRead
     */
    'readByFrmlist'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageJsonldMessageRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MessageJsonldMessageRead
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface MessageMessageCreate
 */
export interface MessageMessageCreate {
    /**
     * 
     * @type {number}
     * @memberof MessageMessageCreate
     */
    'expediteur': MessageMessageCreateExpediteurEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageCreate
     */
    'expediteurNom': string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageCreate
     */
    'message': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageCreate
     */
    'readByPrescri'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageCreate
     */
    'readByFrmlist'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageCreate
     */
    'dossier'?: string | null;
}

export const MessageMessageCreateExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type MessageMessageCreateExpediteurEnum = typeof MessageMessageCreateExpediteurEnum[keyof typeof MessageMessageCreateExpediteurEnum];

/**
 * 
 * @export
 * @interface MessageMessageCreated
 */
export interface MessageMessageCreated {
    /**
     * 
     * @type {number}
     * @memberof MessageMessageCreated
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageMessageCreated
     */
    'expediteur': MessageMessageCreatedExpediteurEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageCreated
     */
    'expediteurNom': string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageCreated
     */
    'message': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageCreated
     */
    'readByPrescri'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageCreated
     */
    'readByFrmlist'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageCreated
     */
    'dossier'?: string | null;
}

export const MessageMessageCreatedExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type MessageMessageCreatedExpediteurEnum = typeof MessageMessageCreatedExpediteurEnum[keyof typeof MessageMessageCreatedExpediteurEnum];

/**
 * 
 * @export
 * @interface MessageMessageRead
 */
export interface MessageMessageRead {
    /**
     * 
     * @type {number}
     * @memberof MessageMessageRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MessageMessageRead
     */
    'expediteur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageRead
     */
    'expediteurNom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageRead
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageRead
     */
    'readByPrescri'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageRead
     */
    'readByFrmlist'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageMessageRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MessageMessageRead
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoteCreate
 */
export interface NotesEtRappelsJsonldNoteCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    'userCreation'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoteCreated
 */
export interface NotesEtRappelsJsonldNoteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'clos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'userCreation'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteCreated
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoteRead
 */
export interface NotesEtRappelsJsonldNoteRead {
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'dateProgramme'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'clos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'userCreation'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteRead
     */
    'dateProgrammeFin'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoteUpdate
 */
export interface NotesEtRappelsJsonldNoteUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'clos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoteUpdate
     */
    'userCreation'?: number;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoterappelCreate
 */
export interface NotesEtRappelsJsonldNoterappelCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelCreate}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'evenement'?: TblEvenementJsonldNoterappelCreate;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoterappelCreate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoterappelCreated
 */
export interface NotesEtRappelsJsonldNoterappelCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelCreated}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'evenement'?: TblEvenementJsonldNoterappelCreated;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoterappelCreated
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoterappelRead
 */
export interface NotesEtRappelsJsonldNoterappelRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelRead}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'evenement'?: TblEvenementJsonldNoterappelRead;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoterappelRead
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoterappelReadCollection
 */
export interface NotesEtRappelsJsonldNoterappelReadCollection {
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelReadCollection
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelJsonldNoterappelReadCollection>}
     * @memberof NotesEtRappelsJsonldNoterappelReadCollection
     */
    'rappels'?: Array<TblEvenementRappelJsonldNoterappelReadCollection>;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsJsonldNoterappelUpdate
 */
export interface NotesEtRappelsJsonldNoterappelUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelUpdate}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'evenement'?: TblEvenementJsonldNoterappelUpdate;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsJsonldNoterappelUpdate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoteCreate
 */
export interface NotesEtRappelsNoteCreate {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreate
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreate
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreate
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteCreate
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreate
     */
    'userCreation'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteCreate
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoteCreated
 */
export interface NotesEtRappelsNoteCreated {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreated
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreated
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteCreated
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoteCreated
     */
    'clos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoteCreated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteCreated
     */
    'userCreation'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteCreated
     */
    'dossier'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoteRead
 */
export interface NotesEtRappelsNoteRead {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteRead
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteRead
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteRead
     */
    'dateProgramme'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteRead
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteRead
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoteRead
     */
    'clos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoteRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteRead
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteRead
     */
    'userCreation'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteRead
     */
    'dateProgrammeFin'?: string | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoteUpdate
 */
export interface NotesEtRappelsNoteUpdate {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'idPrescripteur'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'userProgramme'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'clos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoteUpdate
     */
    'userCreation'?: number;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoterappelCreate
 */
export interface NotesEtRappelsNoterappelCreate {
    /**
     * 
     * @type {TblEvenementNoterappelCreate}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'evenement'?: TblEvenementNoterappelCreate;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoterappelCreate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoterappelCreated
 */
export interface NotesEtRappelsNoterappelCreated {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementNoterappelCreated}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'evenement'?: TblEvenementNoterappelCreated;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoterappelCreated
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoterappelRead
 */
export interface NotesEtRappelsNoterappelRead {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementNoterappelRead}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'evenement'?: TblEvenementNoterappelRead;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoterappelRead
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoterappelReadCollection
 */
export interface NotesEtRappelsNoterappelReadCollection {
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelReadCollection
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelNoterappelReadCollection>}
     * @memberof NotesEtRappelsNoterappelReadCollection
     */
    'rappels'?: Array<TblEvenementRappelNoterappelReadCollection>;
}
/**
 * 
 * @export
 * @interface NotesEtRappelsNoterappelUpdate
 */
export interface NotesEtRappelsNoterappelUpdate {
    /**
     * 
     * @type {TblEvenementNoterappelUpdate}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'evenement'?: TblEvenementNoterappelUpdate;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotesEtRappelsNoterappelUpdate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ObjectGroupsJsonldObjectGroupCreate
 */
export interface ObjectGroupsJsonldObjectGroupCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ObjectGroupsJsonldObjectGroupCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupCreate
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupCreate
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupCreate
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface ObjectGroupsJsonldObjectGroupRead
 */
export interface ObjectGroupsJsonldObjectGroupRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsJsonldObjectGroupRead
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface ObjectGroupsObjectGroupCreate
 */
export interface ObjectGroupsObjectGroupCreate {
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupCreate
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupCreate
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupCreate
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface ObjectGroupsObjectGroupRead
 */
export interface ObjectGroupsObjectGroupRead {
    /**
     * 
     * @type {number}
     * @memberof ObjectGroupsObjectGroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupRead
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupRead
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupRead
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupRead
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface ObjectGroupsObjectGroupUpdate
 */
export interface ObjectGroupsObjectGroupUpdate {
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupUpdate
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupUpdate
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsObjectGroupUpdate
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesJsonldPrestationrelationCreate
 */
export interface PrestationArticlesJsonldPrestationrelationCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    'idPresta'?: string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    'factArticle'?: string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    'libelle'?: string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    'quantite'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationCreate
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesJsonldPrestationrelationRead
 */
export interface PrestationArticlesJsonldPrestationrelationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'idPresta': string;
    /**
     * 
     * @type {TblFactArticlesJsonldPrestationrelationRead}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'factArticle': TblFactArticlesJsonldPrestationrelationRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeJsonldPrestationrelationRead}
     * @memberof PrestationArticlesJsonldPrestationrelationRead
     */
    'idstype'?: TblAnnonceSTypeJsonldPrestationrelationRead | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesJsonldPrestationrelationUpdate
 */
export interface PrestationArticlesJsonldPrestationrelationUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'idPresta': string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationUpdate
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesJsonldPrestationrelationfactureRead
 */
export interface PrestationArticlesJsonldPrestationrelationfactureRead {
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'idPresta': string;
    /**
     * 
     * @type {TblFactArticlesJsonldPrestationrelationfactureRead}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'factArticle': TblFactArticlesJsonldPrestationrelationfactureRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypeJsonldPrestationrelationfactureRead}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'idstype'?: TblAnnonceSTypeJsonldPrestationrelationfactureRead | null;
    /**
     * 
     * @type {Array<TblFligneJsonldPrestationrelationfactureRead>}
     * @memberof PrestationArticlesJsonldPrestationrelationfactureRead
     */
    'flignes'?: Array<TblFligneJsonldPrestationrelationfactureRead>;
}
/**
 * 
 * @export
 * @interface PrestationArticlesPrestationrelationCreate
 */
export interface PrestationArticlesPrestationrelationCreate {
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationCreate
     */
    'idPresta'?: string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationCreate
     */
    'factArticle'?: string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationCreate
     */
    'libelle'?: string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationCreate
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationCreate
     */
    'quantite'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationCreate
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesPrestationrelationRead
 */
export interface PrestationArticlesPrestationrelationRead {
    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'idPresta': string;
    /**
     * 
     * @type {TblFactArticlesPrestationrelationRead}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'factArticle': TblFactArticlesPrestationrelationRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * Article masqué par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * Article ajouté par le calcul du tarif de la collection
     * @type {boolean}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'fAjouteCalcul'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypePrestationrelationRead}
     * @memberof PrestationArticlesPrestationrelationRead
     */
    'idstype'?: TblAnnonceSTypePrestationrelationRead | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesPrestationrelationUpdate
 */
export interface PrestationArticlesPrestationrelationUpdate {
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'idPresta': string;
    /**
     * Id de l\'article de facturation lié
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'factArticle': string;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'rang'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationUpdate
     */
    'idstype'?: string | null;
}
/**
 * 
 * @export
 * @interface PrestationArticlesPrestationrelationfactureRead
 */
export interface PrestationArticlesPrestationrelationfactureRead {
    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'idPresta': string;
    /**
     * 
     * @type {TblFactArticlesPrestationrelationfactureRead}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'factArticle': TblFactArticlesPrestationrelationfactureRead;
    /**
     * Libellé de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'libelle': string | null;
    /**
     * Tarif de l\'article
     * @type {string}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'tarif'?: string | null;
    /**
     * Quantité de l\'article
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'quantite'?: number;
    /**
     * Ordonnancement des articles
     * @type {number}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'rang'?: number;
    /**
     * Article vérifié, prêt pour la facturation
     * @type {boolean}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'fDonneesVerifiees'?: boolean;
    /**
     * 
     * @type {TblAnnonceSTypePrestationrelationfactureRead}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'idstype'?: TblAnnonceSTypePrestationrelationfactureRead | null;
    /**
     * 
     * @type {Array<TblFlignePrestationrelationfactureRead>}
     * @memberof PrestationArticlesPrestationrelationfactureRead
     */
    'flignes'?: Array<TblFlignePrestationrelationfactureRead>;
}
/**
 * 
 * @export
 * @interface PrestationCreatePrestationDtoJsonldPrestationCreate
 */
export interface PrestationCreatePrestationDtoJsonldPrestationCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    'dossier': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    'catalogue': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    'formalite': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    'json': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationCreatePrestationDtoJsonldPrestationCreate
     */
    'resetStatus'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PrestationCreatePrestationDtoPrestationCreate
 */
export interface PrestationCreatePrestationDtoPrestationCreate {
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoPrestationCreate
     */
    'dossier': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoPrestationCreate
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoPrestationCreate
     */
    'catalogue': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoPrestationCreate
     */
    'formalite': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationCreatePrestationDtoPrestationCreate
     */
    'json': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationCreatePrestationDtoPrestationCreate
     */
    'resetStatus'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PrestationJsonldPrestationCreated
 */
export interface PrestationJsonldPrestationCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationJsonldPrestationCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrestationJsonldPrestationCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationCreated
     */
    'dossier': string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof PrestationJsonldPrestationCreated
     */
    'libelle': string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof PrestationJsonldPrestationCreated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {TblCatalogueJsonldPrestationCreated}
     * @memberof PrestationJsonldPrestationCreated
     */
    'catalogue': TblCatalogueJsonldPrestationCreated | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationCreated
     */
    'formalite': string;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationCreated
     */
    'json': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationJsonldPrestationCreated
     */
    'articles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PrestationJsonldPrestationRead
 */
export interface PrestationJsonldPrestationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationJsonldPrestationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrestationJsonldPrestationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationRead
     */
    'dossier'?: string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof PrestationJsonldPrestationRead
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof PrestationJsonldPrestationRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {TblCatalogueJsonldPrestationRead}
     * @memberof PrestationJsonldPrestationRead
     */
    'catalogue'?: TblCatalogueJsonldPrestationRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationRead
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationRead
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticleJsonldPrestationRead>}
     * @memberof PrestationJsonldPrestationRead
     */
    'articles'?: Array<FproPrestationArticleJsonldPrestationRead>;
}
/**
 * 
 * @export
 * @interface PrestationJsonldPrestationUpdate
 */
export interface PrestationJsonldPrestationUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof PrestationJsonldPrestationUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationUpdate
     */
    '@type'?: string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof PrestationJsonldPrestationUpdate
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationJsonldPrestationUpdate
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface PrestationPrestationCreated
 */
export interface PrestationPrestationCreated {
    /**
     * 
     * @type {number}
     * @memberof PrestationPrestationCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationCreated
     */
    'dossier': string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof PrestationPrestationCreated
     */
    'libelle': string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof PrestationPrestationCreated
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {TblCataloguePrestationCreated}
     * @memberof PrestationPrestationCreated
     */
    'catalogue': TblCataloguePrestationCreated | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationCreated
     */
    'formalite': string;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationCreated
     */
    'json': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationPrestationCreated
     */
    'articles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PrestationPrestationRead
 */
export interface PrestationPrestationRead {
    /**
     * 
     * @type {number}
     * @memberof PrestationPrestationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationRead
     */
    'dossier'?: string;
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof PrestationPrestationRead
     */
    'libelle'?: string;
    /**
     * Article supprimé
     * @type {boolean}
     * @memberof PrestationPrestationRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {TblCataloguePrestationRead}
     * @memberof PrestationPrestationRead
     */
    'catalogue'?: TblCataloguePrestationRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationRead
     */
    'formalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationRead
     */
    'json'?: string | null;
    /**
     * 
     * @type {Array<FproPrestationArticlePrestationRead>}
     * @memberof PrestationPrestationRead
     */
    'articles'?: Array<FproPrestationArticlePrestationRead>;
}
/**
 * 
 * @export
 * @interface PrestationPrestationUpdate
 */
export interface PrestationPrestationUpdate {
    /**
     * Libellé de la prestation
     * @type {string}
     * @memberof PrestationPrestationUpdate
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationPrestationUpdate
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
 */
export interface ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    'articles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
     */
    'validator'?: string | null;
}
/**
 * 
 * @export
 * @interface ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate
 */
export interface ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate {
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate
     */
    'articles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoValidatorsProcessCreate
     */
    'validator'?: string | null;
}
/**
 * 
 * @export
 * @interface ProcDureDeValidationDesDossiersDossierValideursStatusRead
 */
export interface ProcDureDeValidationDesDossiersDossierValideursStatusRead {
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersDossierValideursStatusRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersDossierValideursStatusRead
     */
    'validator'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersDossierValideursStatusRead
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersDossierValideursStatusRead
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersDossierValideursStatusRead
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersDossierValideursStatusRead
     */
    'statusFlag'?: number;
}
/**
 * 
 * @export
 * @interface ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
 */
export interface ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead {
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    'validator'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead
     */
    'statusFlag'?: number;
}
/**
 * 
 * @export
 * @interface ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
 */
export interface ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'articles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'validator'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'status'?: ProcDureDeValidationDesDossiersJsonldValidatorsProcessReadStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead
     */
    'externalUrl'?: string | null;
}

export const ProcDureDeValidationDesDossiersJsonldValidatorsProcessReadStatusEnum = {
    Default: 'default',
    Rescheduled: 'rescheduled',
    Failed: 'failed',
    Validate: 'validate'
} as const;

export type ProcDureDeValidationDesDossiersJsonldValidatorsProcessReadStatusEnum = typeof ProcDureDeValidationDesDossiersJsonldValidatorsProcessReadStatusEnum[keyof typeof ProcDureDeValidationDesDossiersJsonldValidatorsProcessReadStatusEnum];

/**
 * 
 * @export
 * @interface ProcDureDeValidationDesDossiersValidatorsProcessRead
 */
export interface ProcDureDeValidationDesDossiersValidatorsProcessRead {
    /**
     * 
     * @type {number}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'articles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'validator'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'status'?: ProcDureDeValidationDesDossiersValidatorsProcessReadStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcDureDeValidationDesDossiersValidatorsProcessRead
     */
    'externalUrl'?: string | null;
}

export const ProcDureDeValidationDesDossiersValidatorsProcessReadStatusEnum = {
    Default: 'default',
    Rescheduled: 'rescheduled',
    Failed: 'failed',
    Validate: 'validate'
} as const;

export type ProcDureDeValidationDesDossiersValidatorsProcessReadStatusEnum = typeof ProcDureDeValidationDesDossiersValidatorsProcessReadStatusEnum[keyof typeof ProcDureDeValidationDesDossiersValidatorsProcessReadStatusEnum];

/**
 * 
 * @export
 * @interface ReglementsDetailsJsonldReglementdetailsRead
 */
export interface ReglementsDetailsJsonldReglementdetailsRead {
    /**
     * 
     * @type {string}
     * @memberof ReglementsDetailsJsonldReglementdetailsRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsDetailsJsonldReglementdetailsRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsDetailsJsonldReglementdetailsRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBAcompteCreate
 */
export interface ReglementsEtAcomptesCBAcompteCreate {
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'origine'?: number | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsAcompteCreate>}
     * @memberof ReglementsEtAcomptesCBAcompteCreate
     */
    'detailsReglements'?: Array<TblReglement2DetailsAcompteCreate>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBAcompteCreated
 */
export interface ReglementsEtAcomptesCBAcompteCreated {
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsAcompteCreated>}
     * @memberof ReglementsEtAcomptesCBAcompteCreated
     */
    'detailsReglements'?: Array<TblReglement2DetailsAcompteCreated>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBAcompteRead
 */
export interface ReglementsEtAcomptesCBAcompteRead {
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsAcompteRead>}
     * @memberof ReglementsEtAcomptesCBAcompteRead
     */
    'detailsReglements'?: Array<TblReglement2DetailsAcompteRead>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBAcompteUpdate
 */
export interface ReglementsEtAcomptesCBAcompteUpdate {
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteUpdate
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteUpdate
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBAcompteUpdate
     */
    'dreception'?: string | null;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldAcompteCreate
 */
export interface ReglementsEtAcomptesCBJsonldAcompteCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'origine'?: number | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldAcompteCreate>}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreate
     */
    'detailsReglements'?: Array<TblReglement2DetailsJsonldAcompteCreate>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldAcompteCreated
 */
export interface ReglementsEtAcomptesCBJsonldAcompteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldAcompteCreated>}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteCreated
     */
    'detailsReglements'?: Array<TblReglement2DetailsJsonldAcompteCreated>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldAcompteRead
 */
export interface ReglementsEtAcomptesCBJsonldAcompteRead {
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldAcompteRead>}
     * @memberof ReglementsEtAcomptesCBJsonldAcompteRead
     */
    'detailsReglements'?: Array<TblReglement2DetailsJsonldAcompteRead>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldGedDocumentRead
 */
export interface ReglementsEtAcomptesCBJsonldGedDocumentRead {
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldGedDocumentRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldGedDocumentRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldReglementCreate
 */
export interface ReglementsEtAcomptesCBJsonldReglementCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'origine'?: number | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldReglementCreate>}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreate
     */
    'detailsReglements'?: Array<TblReglement2DetailsJsonldReglementCreate>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldReglementCreated
 */
export interface ReglementsEtAcomptesCBJsonldReglementCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldReglementCreated>}
     * @memberof ReglementsEtAcomptesCBJsonldReglementCreated
     */
    'detailsReglements'?: Array<TblReglement2DetailsJsonldReglementCreated>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBJsonldReglementRead
 */
export interface ReglementsEtAcomptesCBJsonldReglementRead {
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldReglementRead>}
     * @memberof ReglementsEtAcomptesCBJsonldReglementRead
     */
    'detailsReglements'?: Array<TblReglement2DetailsJsonldReglementRead>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBReglementCreate
 */
export interface ReglementsEtAcomptesCBReglementCreate {
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'origine'?: number | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsReglementCreate>}
     * @memberof ReglementsEtAcomptesCBReglementCreate
     */
    'detailsReglements'?: Array<TblReglement2DetailsReglementCreate>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBReglementCreated
 */
export interface ReglementsEtAcomptesCBReglementCreated {
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsReglementCreated>}
     * @memberof ReglementsEtAcomptesCBReglementCreated
     */
    'detailsReglements'?: Array<TblReglement2DetailsReglementCreated>;
}
/**
 * 
 * @export
 * @interface ReglementsEtAcomptesCBReglementRead
 */
export interface ReglementsEtAcomptesCBReglementRead {
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'id'?: number;
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'societe'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'tiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'transactioncb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'dreception'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'flgexport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'dexport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'usercreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'datecreation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'dexportCegid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'origine'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'dremisebanque'?: string | null;
    /**
     * 
     * @type {Array<TblReglement2DetailsReglementRead>}
     * @memberof ReglementsEtAcomptesCBReglementRead
     */
    'detailsReglements'?: Array<TblReglement2DetailsReglementRead>;
}
/**
 * 
 * @export
 * @interface StatutJsonldStatutCreate
 */
export interface StatutJsonldStatutCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof StatutJsonldStatutCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreate
     */
    '@type'?: string;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutJsonldStatutCreate
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreate
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreate
     */
    'class': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreate
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreate
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreate
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreate
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreate
     */
    'maildossencours'?: boolean;
}
/**
 * 
 * @export
 * @interface StatutJsonldStatutCreated
 */
export interface StatutJsonldStatutCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof StatutJsonldStatutCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof StatutJsonldStatutCreated
     */
    'id'?: number;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutJsonldStatutCreated
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreated
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreated
     */
    'class': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreated
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutCreated
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreated
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreated
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreated
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutCreated
     */
    'maildossencours'?: boolean;
}
/**
 * 
 * @export
 * @interface StatutJsonldStatutRead
 */
export interface StatutJsonldStatutRead {
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof StatutJsonldStatutRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof StatutJsonldStatutRead
     */
    'id'?: number;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutJsonldStatutRead
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutRead
     */
    'class'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutRead
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutRead
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutRead
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutRead
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutRead
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutRead
     */
    'maildossencours'?: boolean;
    /**
     * 
     * @type {FproDossierStepJsonldStatutRead}
     * @memberof StatutJsonldStatutRead
     */
    'step'?: FproDossierStepJsonldStatutRead | null;
}
/**
 * 
 * @export
 * @interface StatutJsonldStatutUpdate
 */
export interface StatutJsonldStatutUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof StatutJsonldStatutUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutUpdate
     */
    '@type'?: string;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutJsonldStatutUpdate
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutUpdate
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutUpdate
     */
    'class': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutUpdate
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutJsonldStatutUpdate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutUpdate
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutUpdate
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutUpdate
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutJsonldStatutUpdate
     */
    'maildossencours'?: boolean;
}
/**
 * 
 * @export
 * @interface StatutStatutCreate
 */
export interface StatutStatutCreate {
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutStatutCreate
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutCreate
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutCreate
     */
    'class': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreate
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutCreate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreate
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreate
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreate
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreate
     */
    'maildossencours'?: boolean;
}
/**
 * 
 * @export
 * @interface StatutStatutCreated
 */
export interface StatutStatutCreated {
    /**
     * 
     * @type {number}
     * @memberof StatutStatutCreated
     */
    'id'?: number;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutStatutCreated
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutCreated
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutCreated
     */
    'class': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreated
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutCreated
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreated
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreated
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreated
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutCreated
     */
    'maildossencours'?: boolean;
}
/**
 * 
 * @export
 * @interface StatutStatutRead
 */
export interface StatutStatutRead {
    /**
     * 
     * @type {number}
     * @memberof StatutStatutRead
     */
    'id'?: number;
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutStatutRead
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutRead
     */
    'class'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutRead
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutRead
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutRead
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutRead
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutRead
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutRead
     */
    'maildossencours'?: boolean;
    /**
     * 
     * @type {FproDossierStepStatutRead}
     * @memberof StatutStatutRead
     */
    'step'?: FproDossierStepStatutRead | null;
}
/**
 * 
 * @export
 * @interface StatutStatutUpdate
 */
export interface StatutStatutUpdate {
    /**
     * 1:Statut d\'un dossier - 2:Statut d\'un article - 3:Statut d\'un dossier niveau impôt - 4:Statut d\'un dossier niveau greffe - 5:Statut d\'un dossier niveau annonce légale
     * @type {number}
     * @memberof StatutStatutUpdate
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutUpdate
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutUpdate
     */
    'class': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutUpdate
     */
    'pardefaut'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StatutStatutUpdate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutUpdate
     */
    'cacheFront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutUpdate
     */
    'supprimable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutUpdate
     */
    'affichefront'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatutStatutUpdate
     */
    'maildossencours'?: boolean;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategorieJsonldPrestationRead
 */
export interface TBLFactArticlesCategorieJsonldPrestationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TBLFactArticlesCategorieJsonldPrestationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldPrestationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldPrestationRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategorieJsonldPrestationrelationRead
 */
export interface TBLFactArticlesCategorieJsonldPrestationrelationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategorieJsonldPrestationrelationfactureRead
 */
export interface TBLFactArticlesCategorieJsonldPrestationrelationfactureRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationfactureRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationfactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationfactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TBLFactArticlesCategorieJsonldPrestationrelationfactureRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategoriePrestationrelationRead
 */
export interface TBLFactArticlesCategoriePrestationrelationRead {
    /**
     * 
     * @type {number}
     * @memberof TBLFactArticlesCategoriePrestationrelationRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategoriePrestationrelationfactureRead
 */
export interface TBLFactArticlesCategoriePrestationrelationfactureRead {
    /**
     * 
     * @type {number}
     * @memberof TBLFactArticlesCategoriePrestationrelationfactureRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TachesEtRappelsDesDossierJsonldTacheRead
 */
export interface TachesEtRappelsDesDossierJsonldTacheRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TachesEtRappelsDesDossierJsonldTacheRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierJsonldTacheRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierJsonldTacheRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TachesEtRappelsDesDossierJsonldTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblTacheJsonldTacheRead}
     * @memberof TachesEtRappelsDesDossierJsonldTacheRead
     */
    'tache'?: TblTacheJsonldTacheRead;
    /**
     * 
     * @type {FproDossierJsonldTacheRead}
     * @memberof TachesEtRappelsDesDossierJsonldTacheRead
     */
    'dossier': FproDossierJsonldTacheRead;
}
/**
 * 
 * @export
 * @interface TachesEtRappelsDesDossierTacheRead
 */
export interface TachesEtRappelsDesDossierTacheRead {
    /**
     * 
     * @type {number}
     * @memberof TachesEtRappelsDesDossierTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblTacheTacheRead}
     * @memberof TachesEtRappelsDesDossierTacheRead
     */
    'tache'?: TblTacheTacheRead;
    /**
     * 
     * @type {FproDossierTacheRead}
     * @memberof TachesEtRappelsDesDossierTacheRead
     */
    'dossier': FproDossierTacheRead;
}
/**
 * 
 * @export
 * @interface TachesEtRappelsDesDossierTacheUpdate
 */
export interface TachesEtRappelsDesDossierTacheUpdate {
    /**
     * 
     * @type {TblTacheTacheUpdate}
     * @memberof TachesEtRappelsDesDossierTacheUpdate
     */
    'tache'?: TblTacheTacheUpdate;
}
/**
 * 
 * @export
 * @interface TapesDeTraitementDesDossiersJsonldStepsDossierRead
 */
export interface TapesDeTraitementDesDossiersJsonldStepsDossierRead {
    /**
     * 
     * @type {string}
     * @memberof TapesDeTraitementDesDossiersJsonldStepsDossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TapesDeTraitementDesDossiersJsonldStepsDossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TapesDeTraitementDesDossiersJsonldStepsDossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TapesDeTraitementDesDossiersJsonldStepsDossierRead
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof TapesDeTraitementDesDossiersJsonldStepsDossierRead
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface TapesDeTraitementDesDossiersStepsDossierRead
 */
export interface TapesDeTraitementDesDossiersStepsDossierRead {
    /**
     * 
     * @type {number}
     * @memberof TapesDeTraitementDesDossiersStepsDossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TapesDeTraitementDesDossiersStepsDossierRead
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof TapesDeTraitementDesDossiersStepsDossierRead
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface TblActionDetailActionCreated
 */
export interface TblActionDetailActionCreated {
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailActionCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailActionCreated
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailActionRead
 */
export interface TblActionDetailActionRead {
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailActionRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailActionRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailActiviteCreated
 */
export interface TblActionDetailActiviteCreated {
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailActiviteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailActiviteCreated
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailActiviteRead
 */
export interface TblActionDetailActiviteRead {
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailActiviteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailActiviteRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailJsonldActionCreated
 */
export interface TblActionDetailJsonldActionCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblActionDetailJsonldActionCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActionCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActionCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailJsonldActionCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActionCreated
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailJsonldActionRead
 */
export interface TblActionDetailJsonldActionRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblActionDetailJsonldActionRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActionRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActionRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailJsonldActionRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActionRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailJsonldActiviteCreated
 */
export interface TblActionDetailJsonldActiviteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblActionDetailJsonldActiviteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActiviteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActiviteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailJsonldActiviteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActiviteCreated
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblActionDetailJsonldActiviteRead
 */
export interface TblActionDetailJsonldActiviteRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblActionDetailJsonldActiviteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActiviteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActiviteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblActionDetailJsonldActiviteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblActionDetailJsonldActiviteRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeCollectiondossierRead
 */
export interface TblAnnonceSTypeCollectiondossierRead {
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeCollectiondossierRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblAnnonceSTypeDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeJsonldCollectiondossierRead
 */
export interface TblAnnonceSTypeJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblAnnonceSTypeJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeJsonldCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldCollectiondossierRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeJsonldPrestationRead
 */
export interface TblAnnonceSTypeJsonldPrestationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblAnnonceSTypeJsonldPrestationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationRead
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeJsonldPrestationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeJsonldPrestationrelationRead
 */
export interface TblAnnonceSTypeJsonldPrestationrelationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationRead
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeJsonldPrestationrelationfactureRead
 */
export interface TblAnnonceSTypeJsonldPrestationrelationfactureRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationfactureRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationfactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationfactureRead
     */
    '@type'?: string;
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeJsonldPrestationrelationfactureRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypePrestationRead
 */
export interface TblAnnonceSTypePrestationRead {
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypePrestationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypePrestationRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypePrestationrelationRead
 */
export interface TblAnnonceSTypePrestationrelationRead {
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypePrestationrelationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypePrestationrelationRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypePrestationrelationfactureRead
 */
export interface TblAnnonceSTypePrestationrelationfactureRead {
    /**
     * Get the value of id
     * @type {number}
     * @memberof TblAnnonceSTypePrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypePrestationrelationfactureRead
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TblCatalogueDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblCatalogueDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof TblCatalogueDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblCatalogueJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblCatalogueJsonldPrestationCreated
 */
export interface TblCatalogueJsonldPrestationCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblCatalogueJsonldPrestationCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblCatalogueJsonldPrestationCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCatalogueJsonldPrestationCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblCatalogueJsonldPrestationCreated
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblCatalogueJsonldPrestationRead
 */
export interface TblCatalogueJsonldPrestationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblCatalogueJsonldPrestationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblCatalogueJsonldPrestationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCatalogueJsonldPrestationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblCatalogueJsonldPrestationRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblCataloguePrestationCreated
 */
export interface TblCataloguePrestationCreated {
    /**
     * 
     * @type {number}
     * @memberof TblCataloguePrestationCreated
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblCataloguePrestationRead
 */
export interface TblCataloguePrestationRead {
    /**
     * 
     * @type {number}
     * @memberof TblCataloguePrestationRead
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierStatusJsonldCollectiondossierCreated
 */
export interface TblCollectionDossierStatusJsonldCollectiondossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierCreated
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierStatusJsonldCollectiondossierRead
 */
export interface TblCollectionDossierStatusJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierStatusJsonldCollectiondossierValidated
 */
export interface TblCollectionDossierStatusJsonldCollectiondossierValidated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierValidated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierValidated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierStatusJsonldCollectiondossierValidated
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblEvenementJsonldNoterappelCreate
 */
export interface TblEvenementJsonldNoterappelCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementJsonldNoterappelCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementJsonldNoterappelCreate
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelJsonldNoterappelCreate>}
     * @memberof TblEvenementJsonldNoterappelCreate
     */
    'rappels'?: Array<TblEvenementRappelJsonldNoterappelCreate>;
}
/**
 * 
 * @export
 * @interface TblEvenementJsonldNoterappelCreated
 */
export interface TblEvenementJsonldNoterappelCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementJsonldNoterappelCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementJsonldNoterappelCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelJsonldNoterappelCreated>}
     * @memberof TblEvenementJsonldNoterappelCreated
     */
    'rappels'?: Array<TblEvenementRappelJsonldNoterappelCreated>;
}
/**
 * 
 * @export
 * @interface TblEvenementJsonldNoterappelRead
 */
export interface TblEvenementJsonldNoterappelRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementJsonldNoterappelRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementJsonldNoterappelRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementJsonldNoterappelRead
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelJsonldNoterappelRead>}
     * @memberof TblEvenementJsonldNoterappelRead
     */
    'rappels'?: Array<TblEvenementRappelJsonldNoterappelRead>;
}
/**
 * 
 * @export
 * @interface TblEvenementJsonldNoterappelUpdate
 */
export interface TblEvenementJsonldNoterappelUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementJsonldNoterappelUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementJsonldNoterappelUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementJsonldNoterappelUpdate
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelJsonldNoterappelUpdate>}
     * @memberof TblEvenementJsonldNoterappelUpdate
     */
    'rappels'?: Array<TblEvenementRappelJsonldNoterappelUpdate>;
}
/**
 * 
 * @export
 * @interface TblEvenementNoterappelCreate
 */
export interface TblEvenementNoterappelCreate {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementNoterappelCreate
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelNoterappelCreate>}
     * @memberof TblEvenementNoterappelCreate
     */
    'rappels'?: Array<TblEvenementRappelNoterappelCreate>;
}
/**
 * 
 * @export
 * @interface TblEvenementNoterappelCreated
 */
export interface TblEvenementNoterappelCreated {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementNoterappelCreated
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelNoterappelCreated>}
     * @memberof TblEvenementNoterappelCreated
     */
    'rappels'?: Array<TblEvenementRappelNoterappelCreated>;
}
/**
 * 
 * @export
 * @interface TblEvenementNoterappelRead
 */
export interface TblEvenementNoterappelRead {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementNoterappelRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementNoterappelRead
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelNoterappelRead>}
     * @memberof TblEvenementNoterappelRead
     */
    'rappels'?: Array<TblEvenementRappelNoterappelRead>;
}
/**
 * 
 * @export
 * @interface TblEvenementNoterappelUpdate
 */
export interface TblEvenementNoterappelUpdate {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementNoterappelUpdate
     */
    'societe'?: number;
    /**
     * 
     * @type {Array<TblEvenementRappelNoterappelUpdate>}
     * @memberof TblEvenementNoterappelUpdate
     */
    'rappels'?: Array<TblEvenementRappelNoterappelUpdate>;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelJsonldNoterappelCreate
 */
export interface TblEvenementRappelJsonldNoterappelCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelCreate}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'evenement'?: TblEvenementJsonldNoterappelCreate;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelCreate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelJsonldNoterappelCreated
 */
export interface TblEvenementRappelJsonldNoterappelCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelCreated}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'evenement'?: TblEvenementJsonldNoterappelCreated;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelCreated
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelJsonldNoterappelRead
 */
export interface TblEvenementRappelJsonldNoterappelRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelRead}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'evenement'?: TblEvenementJsonldNoterappelRead;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelRead
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelJsonldNoterappelReadCollection
 */
export interface TblEvenementRappelJsonldNoterappelReadCollection {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelReadCollection
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelJsonldNoterappelUpdate
 */
export interface TblEvenementRappelJsonldNoterappelUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {TblEvenementJsonldNoterappelUpdate}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'evenement'?: TblEvenementJsonldNoterappelUpdate;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelJsonldNoterappelUpdate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelNoterappelCreate
 */
export interface TblEvenementRappelNoterappelCreate {
    /**
     * 
     * @type {TblEvenementNoterappelCreate}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'evenement'?: TblEvenementNoterappelCreate;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelCreate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelNoterappelCreated
 */
export interface TblEvenementRappelNoterappelCreated {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementNoterappelCreated}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'evenement'?: TblEvenementNoterappelCreated;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelCreated
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelNoterappelRead
 */
export interface TblEvenementRappelNoterappelRead {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblEvenementNoterappelRead}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'evenement'?: TblEvenementNoterappelRead;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelRead
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelNoterappelReadCollection
 */
export interface TblEvenementRappelNoterappelReadCollection {
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'closed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelReadCollection
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblEvenementRappelNoterappelUpdate
 */
export interface TblEvenementRappelNoterappelUpdate {
    /**
     * 
     * @type {TblEvenementNoterappelUpdate}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'evenement'?: TblEvenementNoterappelUpdate;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'actionDetail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'motif'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'idUser'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblEvenementRappelNoterappelUpdate
     */
    'closed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblFactArticlesCollectiondossierRead
 */
export interface TblFactArticlesCollectiondossierRead {
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesCollectiondossierRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesCollectiondossierRead
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldCollectiondossierRead
 */
export interface TblFactArticlesJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactArticlesJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldCollectiondossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesJsonldCollectiondossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldCollectiondossierRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldCollectiondossierRead
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldPrestationRead
 */
export interface TblFactArticlesJsonldPrestationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    'id'?: number;
    /**
     * 
     * @type {TBLFactArticlesCategorieJsonldPrestationRead}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    'category'?: TBLFactArticlesCategorieJsonldPrestationRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationRead
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldPrestationrelationRead
 */
export interface TblFactArticlesJsonldPrestationrelationRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    'id'?: number;
    /**
     * 
     * @type {TBLFactArticlesCategorieJsonldPrestationrelationRead}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    'category'?: TBLFactArticlesCategorieJsonldPrestationrelationRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationRead
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldPrestationrelationfactureRead
 */
export interface TblFactArticlesJsonldPrestationrelationfactureRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactArticlesJsonldPrestationrelationfactureRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationfactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationfactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesJsonldPrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {TBLFactArticlesCategorieJsonldPrestationrelationfactureRead}
     * @memberof TblFactArticlesJsonldPrestationrelationfactureRead
     */
    'category'?: TBLFactArticlesCategorieJsonldPrestationrelationfactureRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldPrestationrelationfactureRead
     */
    'rubArticle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFactArticlesPrestationRead
 */
export interface TblFactArticlesPrestationRead {
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesPrestationRead
     */
    'id'?: number;
    /**
     * 
     * @type {object}
     * @memberof TblFactArticlesPrestationRead
     */
    'category'?: object;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationRead
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesPrestationrelationRead
 */
export interface TblFactArticlesPrestationrelationRead {
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesPrestationrelationRead
     */
    'id'?: number;
    /**
     * 
     * @type {TBLFactArticlesCategoriePrestationrelationRead}
     * @memberof TblFactArticlesPrestationrelationRead
     */
    'category'?: TBLFactArticlesCategoriePrestationrelationRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationrelationRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationrelationRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationrelationRead
     */
    'natureTva'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesPrestationrelationfactureRead
 */
export interface TblFactArticlesPrestationrelationfactureRead {
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesPrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {TBLFactArticlesCategoriePrestationrelationfactureRead}
     * @memberof TblFactArticlesPrestationrelationfactureRead
     */
    'category'?: TBLFactArticlesCategoriePrestationrelationfactureRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesPrestationrelationfactureRead
     */
    'rubArticle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldPrestationrelationfactureRead
 */
export interface TblFacture2JsonldPrestationrelationfactureRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFacture2JsonldPrestationrelationfactureRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPrestationrelationfactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPrestationrelationfactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPrestationrelationfactureRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldReglementCreate
 */
export interface TblFacture2JsonldReglementCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFacture2JsonldReglementCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFacture2JsonldReglementCreate
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldReglementCreated
 */
export interface TblFacture2JsonldReglementCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFacture2JsonldReglementCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFacture2JsonldReglementCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementCreated
     */
    'numero'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFacture2JsonldReglementCreated
     */
    'factureEnPreparation'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldReglementRead
 */
export interface TblFacture2JsonldReglementRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFacture2JsonldReglementRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFacture2JsonldReglementRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldReglementRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFacture2JsonldReglementRead
     */
    'factureEnPreparation'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblFacture2PrestationrelationfactureRead
 */
export interface TblFacture2PrestationrelationfactureRead {
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PrestationrelationfactureRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFacture2ReglementCreate
 */
export interface TblFacture2ReglementCreate {
    /**
     * 
     * @type {number}
     * @memberof TblFacture2ReglementCreate
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TblFacture2ReglementCreated
 */
export interface TblFacture2ReglementCreated {
    /**
     * 
     * @type {number}
     * @memberof TblFacture2ReglementCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2ReglementCreated
     */
    'numero'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFacture2ReglementCreated
     */
    'factureEnPreparation'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblFacture2ReglementRead
 */
export interface TblFacture2ReglementRead {
    /**
     * 
     * @type {number}
     * @memberof TblFacture2ReglementRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2ReglementRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFacture2ReglementRead
     */
    'factureEnPreparation'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblFactureMultipleJsonldCollectiondossierRead
 */
export interface TblFactureMultipleJsonldCollectiondossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactureMultipleJsonldCollectiondossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactureMultipleJsonldCollectiondossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactureMultipleJsonldCollectiondossierRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
 */
export interface TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactureMultipleJsonldDossierReadNoteGroupTimestampableBlameambleGroup
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblFligneJsonldPrestationrelationfactureRead
 */
export interface TblFligneJsonldPrestationrelationfactureRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFligneJsonldPrestationrelationfactureRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldPrestationrelationfactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldPrestationrelationfactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldPrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblFacture2JsonldPrestationrelationfactureRead}
     * @memberof TblFligneJsonldPrestationrelationfactureRead
     */
    'facture'?: TblFacture2JsonldPrestationrelationfactureRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldPrestationrelationfactureRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFlignePrestationrelationfactureRead
 */
export interface TblFlignePrestationrelationfactureRead {
    /**
     * 
     * @type {number}
     * @memberof TblFlignePrestationrelationfactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblFacture2PrestationrelationfactureRead}
     * @memberof TblFlignePrestationrelationfactureRead
     */
    'facture'?: TblFacture2PrestationrelationfactureRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFlignePrestationrelationfactureRead
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorFormaliteCreate
 */
export interface TblFormalityFproDossierValidatorFormaliteCreate {
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreate
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreate
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreate
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreate
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorFormaliteCreated
 */
export interface TblFormalityFproDossierValidatorFormaliteCreated {
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreated
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreated
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreated
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteCreated
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorFormaliteRead
 */
export interface TblFormalityFproDossierValidatorFormaliteRead {
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorFormaliteRead
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteRead
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteRead
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteRead
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorFormaliteUpdate
 */
export interface TblFormalityFproDossierValidatorFormaliteUpdate {
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorFormaliteUpdate
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteUpdate
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteUpdate
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorFormaliteUpdate
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorJsonldFormaliteCreate
 */
export interface TblFormalityFproDossierValidatorJsonldFormaliteCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreate
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorJsonldFormaliteCreated
 */
export interface TblFormalityFproDossierValidatorJsonldFormaliteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteCreated
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorJsonldFormaliteRead
 */
export interface TblFormalityFproDossierValidatorJsonldFormaliteRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteRead
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblFormalityFproDossierValidatorJsonldFormaliteUpdate
 */
export interface TblFormalityFproDossierValidatorJsonldFormaliteUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    'validator'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    'documents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFormalityFproDossierValidatorJsonldFormaliteUpdate
     */
    'forms'?: boolean;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsAcompteCreate
 */
export interface TblReglement2DetailsAcompteCreate {
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreate
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreate
     */
    'ttc'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsAcompteCreated
 */
export interface TblReglement2DetailsAcompteCreated {
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteCreated
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsAcompteRead
 */
export interface TblReglement2DetailsAcompteRead {
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsAcompteRead
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldAcompteCreate
 */
export interface TblReglement2DetailsJsonldAcompteCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblReglement2DetailsJsonldAcompteCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreate
     */
    '@type'?: string;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreate
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreate
     */
    'ttc'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldAcompteCreated
 */
export interface TblReglement2DetailsJsonldAcompteCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteCreated
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldAcompteRead
 */
export interface TblReglement2DetailsJsonldAcompteRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldAcompteRead
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldReglementCreate
 */
export interface TblReglement2DetailsJsonldReglementCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblReglement2DetailsJsonldReglementCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreate
     */
    '@type'?: string;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreate
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {TblFacture2JsonldReglementCreate}
     * @memberof TblReglement2DetailsJsonldReglementCreate
     */
    'facture'?: TblFacture2JsonldReglementCreate | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreate
     */
    'ttc'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldReglementCreated
 */
export interface TblReglement2DetailsJsonldReglementCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {TblFacture2JsonldReglementCreated}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'facture'?: TblFacture2JsonldReglementCreated | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementCreated
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldReglementRead
 */
export interface TblReglement2DetailsJsonldReglementRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {TblFacture2JsonldReglementRead}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'facture'?: TblFacture2JsonldReglementRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldReglementRead
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsReglementCreate
 */
export interface TblReglement2DetailsReglementCreate {
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreate
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {TblFacture2ReglementCreate}
     * @memberof TblReglement2DetailsReglementCreate
     */
    'facture'?: TblFacture2ReglementCreate | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreate
     */
    'ttc'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsReglementCreated
 */
export interface TblReglement2DetailsReglementCreated {
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {TblFacture2ReglementCreated}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'facture'?: TblFacture2ReglementCreated | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementCreated
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsReglementRead
 */
export interface TblReglement2DetailsReglementRead {
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsReglementRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'societe'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'idPrescripteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'tpeSha1'?: string | null;
    /**
     * Get the value of idCollection
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'idCollection'?: string | null;
    /**
     * 
     * @type {TblFacture2ReglementRead}
     * @memberof TblReglement2DetailsReglementRead
     */
    'facture'?: TblFacture2ReglementRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'dateRelance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'idTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'dateTransaction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblReglement2DetailsReglementRead
     */
    'ttcTransaction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'dateAcces'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblReglement2DetailsReglementRead
     */
    'fComptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsReglementRead
     */
    'dexportCegid'?: string | null;
}
/**
 * 
 * @export
 * @interface TblTacheJsonldTacheRead
 */
export interface TblTacheJsonldTacheRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblTacheJsonldTacheRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblTacheJsonldTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTacheJsonldTacheRead
     */
    'isDone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    'expiredAt'?: string;
    /**
     * Hydrated from event listener OnPresist
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheJsonldTacheRead
     */
    'remindAt'?: string | null;
    /**
     * 
     * @type {TblUtilisateurJsonldTacheRead}
     * @memberof TblTacheJsonldTacheRead
     */
    'createdBy'?: TblUtilisateurJsonldTacheRead;
    /**
     * 
     * @type {TblUtilisateurJsonldTacheRead}
     * @memberof TblTacheJsonldTacheRead
     */
    'assignTo'?: TblUtilisateurJsonldTacheRead;
    /**
     * 
     * @type {number}
     * @memberof TblTacheJsonldTacheRead
     */
    'priority'?: TblTacheJsonldTacheReadPriorityEnum;
}

export const TblTacheJsonldTacheReadPriorityEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type TblTacheJsonldTacheReadPriorityEnum = typeof TblTacheJsonldTacheReadPriorityEnum[keyof typeof TblTacheJsonldTacheReadPriorityEnum];

/**
 * 
 * @export
 * @interface TblTacheTacheRead
 */
export interface TblTacheTacheRead {
    /**
     * 
     * @type {number}
     * @memberof TblTacheTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheRead
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheRead
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTacheTacheRead
     */
    'isDone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheRead
     */
    'expiredAt'?: string;
    /**
     * Hydrated from event listener OnPresist
     * @type {string}
     * @memberof TblTacheTacheRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheRead
     */
    'remindAt'?: string | null;
    /**
     * 
     * @type {TblUtilisateurTacheRead}
     * @memberof TblTacheTacheRead
     */
    'createdBy'?: TblUtilisateurTacheRead;
    /**
     * 
     * @type {TblUtilisateurTacheRead}
     * @memberof TblTacheTacheRead
     */
    'assignTo'?: TblUtilisateurTacheRead;
    /**
     * 
     * @type {number}
     * @memberof TblTacheTacheRead
     */
    'priority'?: TblTacheTacheReadPriorityEnum;
}

export const TblTacheTacheReadPriorityEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type TblTacheTacheReadPriorityEnum = typeof TblTacheTacheReadPriorityEnum[keyof typeof TblTacheTacheReadPriorityEnum];

/**
 * 
 * @export
 * @interface TblTacheTacheUpdate
 */
export interface TblTacheTacheUpdate {
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheUpdate
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTacheTacheUpdate
     */
    'isDone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheUpdate
     */
    'expiredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheUpdate
     */
    'remindAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTacheTacheUpdate
     */
    'assignTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblTacheTacheUpdate
     */
    'priority'?: TblTacheTacheUpdatePriorityEnum;
}

export const TblTacheTacheUpdatePriorityEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type TblTacheTacheUpdatePriorityEnum = typeof TblTacheTacheUpdatePriorityEnum[keyof typeof TblTacheTacheUpdatePriorityEnum];

/**
 * 
 * @export
 * @interface TblTypeDocumentDocumentfileRead
 */
export interface TblTypeDocumentDocumentfileRead {
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'signable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentDocumentfileRead
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TblTypeDocumentJsonldDocumentfileRead
 */
export interface TblTypeDocumentJsonldDocumentfileRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'signable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldDocumentfileRead
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TblTypeDocumentJsonldTypedocumentdossierCreated
 */
export interface TblTypeDocumentJsonldTypedocumentdossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'signable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierCreated
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TblTypeDocumentJsonldTypedocumentdossierRead
 */
export interface TblTypeDocumentJsonldTypedocumentdossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'signable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentJsonldTypedocumentdossierRead
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TblTypeDocumentTypedocumentdossierCreated
 */
export interface TblTypeDocumentTypedocumentdossierCreated {
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'signable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentTypedocumentdossierCreated
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TblTypeDocumentTypedocumentdossierRead
 */
export interface TblTypeDocumentTypedocumentdossierRead {
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'signable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblTypeDocumentTypedocumentdossierRead
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TblUtilisateurJsonldTacheRead
 */
export interface TblUtilisateurJsonldTacheRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonldTacheRead
     */
    'userIdentifier'?: string | null;
}
/**
 * 
 * @export
 * @interface TblUtilisateurTacheRead
 */
export interface TblUtilisateurTacheRead {
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurTacheRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurTacheRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurTacheRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurTacheRead
     */
    'userIdentifier'?: string | null;
}
/**
 * 
 * @export
 * @interface TiersJsonldDossierRead
 */
export interface TiersJsonldDossierRead {
    /**
     * 
     * @type {string}
     * @memberof TiersJsonldDossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TiersJsonldDossierRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
 */
export interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    'statut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
     */
    'dossier'?: string;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
 */
export interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldTypedocumentdossierCreated}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'document'?: TblTypeDocumentJsonldTypedocumentdossierCreated | null;
    /**
     * 
     * @type {FproDosStatutJsonldTypedocumentdossierCreated}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'statut'?: FproDosStatutJsonldTypedocumentdossierCreated | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldTypedocumentdossierCreated>}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated
     */
    'fichiers'?: Array<FproDosDocFileJsonldTypedocumentdossierCreated>;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
 */
export interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentJsonldTypedocumentdossierRead}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'document'?: TblTypeDocumentJsonldTypedocumentdossierRead | null;
    /**
     * 
     * @type {FproDosStatutJsonldTypedocumentdossierRead}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'statut'?: FproDosStatutJsonldTypedocumentdossierRead | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileJsonldTypedocumentdossierRead>}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead
     */
    'fichiers'?: Array<FproDosDocFileJsonldTypedocumentdossierRead>;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
 */
export interface TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
     */
    'statut'?: string | null;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersTypedocumentPatch
 */
export interface TypeDeDocumentDesDossiersTypedocumentPatch {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentPatch
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentPatch
     */
    'document'?: string | null;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersTypedocumentdossierCreate
 */
export interface TypeDeDocumentDesDossiersTypedocumentdossierCreate {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreate
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreate
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreate
     */
    'statut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreate
     */
    'dossier'?: string;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersTypedocumentdossierCreated
 */
export interface TypeDeDocumentDesDossiersTypedocumentdossierCreated {
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentTypedocumentdossierCreated}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'document'?: TblTypeDocumentTypedocumentdossierCreated | null;
    /**
     * 
     * @type {FproDosStatutTypedocumentdossierCreated}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'statut'?: FproDosStatutTypedocumentdossierCreated | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileTypedocumentdossierCreated>}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierCreated
     */
    'fichiers'?: Array<FproDosDocFileTypedocumentdossierCreated>;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersTypedocumentdossierRead
 */
export interface TypeDeDocumentDesDossiersTypedocumentdossierRead {
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {TblTypeDocumentTypedocumentdossierRead}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'document'?: TblTypeDocumentTypedocumentdossierRead | null;
    /**
     * 
     * @type {FproDosStatutTypedocumentdossierRead}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'statut'?: FproDosStatutTypedocumentdossierRead | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {Array<FproDosDocFileTypedocumentdossierRead>}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierRead
     */
    'fichiers'?: Array<FproDosDocFileTypedocumentdossierRead>;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentDesDossiersTypedocumentdossierUpdate
 */
export interface TypeDeDocumentDesDossiersTypedocumentdossierUpdate {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierUpdate
     */
    'noteFormaliste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierUpdate
     */
    'document'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersTypedocumentdossierUpdate
     */
    'statut'?: string | null;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentJsonldTypedocumentCreate
 */
export interface TypeDeDocumentJsonldTypedocumentCreate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'type'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'statut'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'signable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreate
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentJsonldTypedocumentCreated
 */
export interface TypeDeDocumentJsonldTypedocumentCreated {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'statut'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'signable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentCreated
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentJsonldTypedocumentRead
 */
export interface TypeDeDocumentJsonldTypedocumentRead {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    '@type'?: string;
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'statut'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'signable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentRead
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentJsonldTypedocumentUpdate
 */
export interface TypeDeDocumentJsonldTypedocumentUpdate {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'type'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentJsonldTypedocumentUpdate
     */
    'statut'?: number | null;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentTypedocumentCreate
 */
export interface TypeDeDocumentTypedocumentCreate {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'type'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'statut'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'signable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreate
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentTypedocumentCreated
 */
export interface TypeDeDocumentTypedocumentCreated {
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'statut'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'signable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentCreated
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentTypedocumentRead
 */
export interface TypeDeDocumentTypedocumentRead {
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'type'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'statut'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'signable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentRead
     */
    'typageAuto'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeDeDocumentTypedocumentUpdate
 */
export interface TypeDeDocumentTypedocumentUpdate {
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'help'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'type'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'fichierHelp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'vide'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'libelleDF'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentTypedocumentUpdate
     */
    'statut'?: number | null;
}
/**
 * 
 * @export
 * @interface ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
 */
export interface ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead {
    /**
     * 
     * @type {ActionDetailJsonldActionDetailReadContext}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    '@context'?: ActionDetailJsonldActionDetailReadContext;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    'typeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    'typeLabel'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    'dossierStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner>}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead
     */
    'statuses'?: Array<ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner>;
}
/**
 * 
 * @export
 * @interface ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
 */
export interface ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead {
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
     */
    'typeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
     */
    'typeLabel'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
     */
    'dossierStatuses'?: Array<string>;
    /**
     * 
     * @type {Array<ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner>}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead
     */
    'statuses'?: Array<ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner>;
}
/**
 * 
 * @export
 * @interface ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner
 */
export interface ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner {
    /**
     * 
     * @type {number}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierReadStatusesInner
     */
    'sortOrder'?: number;
}

/**
 * AcomptesApi - axios parameter creator
 * @export
 */
export const AcomptesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des acomptes
         * @summary Obtenir la liste des acomptes
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [dossierFormaliteId] 
         * @param {Array<number>} [dossierFormaliteId2] 
         * @param {number} [detailsReglementsIdCollectionId] 
         * @param {Array<number>} [detailsReglementsIdCollectionId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesGetCollection: async (page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, dossierFormaliteId?: number, dossierFormaliteId2?: Array<number>, detailsReglementsIdCollectionId?: number, detailsReglementsIdCollectionId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/acomptes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (dossierFormaliteId !== undefined) {
                localVarQueryParameter['dossierFormalite.id'] = dossierFormaliteId;
            }

            if (dossierFormaliteId2) {
                localVarQueryParameter['dossierFormalite.id[]'] = dossierFormaliteId2;
            }

            if (detailsReglementsIdCollectionId !== undefined) {
                localVarQueryParameter['detailsReglements.idCollection.id'] = detailsReglementsIdCollectionId;
            }

            if (detailsReglementsIdCollectionId2) {
                localVarQueryParameter['detailsReglements.idCollection.id[]'] = detailsReglementsIdCollectionId2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un acompte
         * @summary Supprimer un acompte
         * @param {string} id TblReglement2 identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAcomptesIdDelete', 'id', id)
            const localVarPath = `/formalite/acomptes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'acomptes
         * @summary Récupérer les informations d\'acomptes
         * @param {string} id TblReglement2 identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAcomptesIdGet', 'id', id)
            const localVarPath = `/formalite/acomptes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Reglements et acomptes CB resource.
         * @summary Modifier un acompte
         * @param {string} id TblReglement2 identifier
         * @param {ReglementsEtAcomptesCBAcompteUpdate} reglementsEtAcomptesCBAcompteUpdate The updated Reglements et acomptes CB resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesIdPatch: async (id: string, reglementsEtAcomptesCBAcompteUpdate: ReglementsEtAcomptesCBAcompteUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAcomptesIdPatch', 'id', id)
            // verify required parameter 'reglementsEtAcomptesCBAcompteUpdate' is not null or undefined
            assertParamExists('apiAcomptesIdPatch', 'reglementsEtAcomptesCBAcompteUpdate', reglementsEtAcomptesCBAcompteUpdate)
            const localVarPath = `/formalite/acomptes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reglementsEtAcomptesCBAcompteUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Reglements et acomptes CB resource.
         * @summary Créer un acompte
         * @param {ReglementsEtAcomptesCBJsonldAcompteCreate} reglementsEtAcomptesCBJsonldAcompteCreate The new Reglements et acomptes CB resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesPost: async (reglementsEtAcomptesCBJsonldAcompteCreate: ReglementsEtAcomptesCBJsonldAcompteCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reglementsEtAcomptesCBJsonldAcompteCreate' is not null or undefined
            assertParamExists('apiAcomptesPost', 'reglementsEtAcomptesCBJsonldAcompteCreate', reglementsEtAcomptesCBJsonldAcompteCreate)
            const localVarPath = `/formalite/acomptes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reglementsEtAcomptesCBJsonldAcompteCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AcomptesApi - functional programming interface
 * @export
 */
export const AcomptesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AcomptesApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des acomptes
         * @summary Obtenir la liste des acomptes
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [dossierFormaliteId] 
         * @param {Array<number>} [dossierFormaliteId2] 
         * @param {number} [detailsReglementsIdCollectionId] 
         * @param {Array<number>} [detailsReglementsIdCollectionId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAcomptesGetCollection(page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, dossierFormaliteId?: number, dossierFormaliteId2?: Array<number>, detailsReglementsIdCollectionId?: number, detailsReglementsIdCollectionId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAcomptesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAcomptesGetCollection(page, itemsPerPage, id, id2, dossierFormaliteId, dossierFormaliteId2, detailsReglementsIdCollectionId, detailsReglementsIdCollectionId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AcomptesApi.apiAcomptesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un acompte
         * @summary Supprimer un acompte
         * @param {string} id TblReglement2 identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAcomptesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAcomptesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AcomptesApi.apiAcomptesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'acomptes
         * @summary Récupérer les informations d\'acomptes
         * @param {string} id TblReglement2 identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAcomptesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReglementsEtAcomptesCBJsonldAcompteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAcomptesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AcomptesApi.apiAcomptesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Reglements et acomptes CB resource.
         * @summary Modifier un acompte
         * @param {string} id TblReglement2 identifier
         * @param {ReglementsEtAcomptesCBAcompteUpdate} reglementsEtAcomptesCBAcompteUpdate The updated Reglements et acomptes CB resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAcomptesIdPatch(id: string, reglementsEtAcomptesCBAcompteUpdate: ReglementsEtAcomptesCBAcompteUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReglementsEtAcomptesCBJsonldAcompteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAcomptesIdPatch(id, reglementsEtAcomptesCBAcompteUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AcomptesApi.apiAcomptesIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Reglements et acomptes CB resource.
         * @summary Créer un acompte
         * @param {ReglementsEtAcomptesCBJsonldAcompteCreate} reglementsEtAcomptesCBJsonldAcompteCreate The new Reglements et acomptes CB resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAcomptesPost(reglementsEtAcomptesCBJsonldAcompteCreate: ReglementsEtAcomptesCBJsonldAcompteCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReglementsEtAcomptesCBJsonldAcompteCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAcomptesPost(reglementsEtAcomptesCBJsonldAcompteCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AcomptesApi.apiAcomptesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AcomptesApi - factory interface
 * @export
 */
export const AcomptesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AcomptesApiFp(configuration)
    return {
        /**
         * Obtenir la liste des acomptes
         * @summary Obtenir la liste des acomptes
         * @param {AcomptesApiApiAcomptesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesGetCollection(requestParameters: AcomptesApiApiAcomptesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiAcomptesGetCollection200Response> {
            return localVarFp.apiAcomptesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.dossierFormaliteId, requestParameters.dossierFormaliteId2, requestParameters.detailsReglementsIdCollectionId, requestParameters.detailsReglementsIdCollectionId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un acompte
         * @summary Supprimer un acompte
         * @param {AcomptesApiApiAcomptesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesIdDelete(requestParameters: AcomptesApiApiAcomptesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAcomptesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'acomptes
         * @summary Récupérer les informations d\'acomptes
         * @param {AcomptesApiApiAcomptesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesIdGet(requestParameters: AcomptesApiApiAcomptesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReglementsEtAcomptesCBJsonldAcompteRead> {
            return localVarFp.apiAcomptesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Reglements et acomptes CB resource.
         * @summary Modifier un acompte
         * @param {AcomptesApiApiAcomptesIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesIdPatch(requestParameters: AcomptesApiApiAcomptesIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReglementsEtAcomptesCBJsonldAcompteRead> {
            return localVarFp.apiAcomptesIdPatch(requestParameters.id, requestParameters.reglementsEtAcomptesCBAcompteUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Reglements et acomptes CB resource.
         * @summary Créer un acompte
         * @param {AcomptesApiApiAcomptesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAcomptesPost(requestParameters: AcomptesApiApiAcomptesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReglementsEtAcomptesCBJsonldAcompteCreated> {
            return localVarFp.apiAcomptesPost(requestParameters.reglementsEtAcomptesCBJsonldAcompteCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAcomptesGetCollection operation in AcomptesApi.
 * @export
 * @interface AcomptesApiApiAcomptesGetCollectionRequest
 */
export interface AcomptesApiApiAcomptesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly id2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly dossierFormaliteId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly dossierFormaliteId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly detailsReglementsIdCollectionId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AcomptesApiApiAcomptesGetCollection
     */
    readonly detailsReglementsIdCollectionId2?: Array<number>
}

/**
 * Request parameters for apiAcomptesIdDelete operation in AcomptesApi.
 * @export
 * @interface AcomptesApiApiAcomptesIdDeleteRequest
 */
export interface AcomptesApiApiAcomptesIdDeleteRequest {
    /**
     * TblReglement2 identifier
     * @type {string}
     * @memberof AcomptesApiApiAcomptesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiAcomptesIdGet operation in AcomptesApi.
 * @export
 * @interface AcomptesApiApiAcomptesIdGetRequest
 */
export interface AcomptesApiApiAcomptesIdGetRequest {
    /**
     * TblReglement2 identifier
     * @type {string}
     * @memberof AcomptesApiApiAcomptesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiAcomptesIdPatch operation in AcomptesApi.
 * @export
 * @interface AcomptesApiApiAcomptesIdPatchRequest
 */
export interface AcomptesApiApiAcomptesIdPatchRequest {
    /**
     * TblReglement2 identifier
     * @type {string}
     * @memberof AcomptesApiApiAcomptesIdPatch
     */
    readonly id: string

    /**
     * The updated Reglements et acomptes CB resource
     * @type {ReglementsEtAcomptesCBAcompteUpdate}
     * @memberof AcomptesApiApiAcomptesIdPatch
     */
    readonly reglementsEtAcomptesCBAcompteUpdate: ReglementsEtAcomptesCBAcompteUpdate
}

/**
 * Request parameters for apiAcomptesPost operation in AcomptesApi.
 * @export
 * @interface AcomptesApiApiAcomptesPostRequest
 */
export interface AcomptesApiApiAcomptesPostRequest {
    /**
     * The new Reglements et acomptes CB resource
     * @type {ReglementsEtAcomptesCBJsonldAcompteCreate}
     * @memberof AcomptesApiApiAcomptesPost
     */
    readonly reglementsEtAcomptesCBJsonldAcompteCreate: ReglementsEtAcomptesCBJsonldAcompteCreate
}

/**
 * AcomptesApi - object-oriented interface
 * @export
 * @class AcomptesApi
 * @extends {BaseAPI}
 */
export class AcomptesApi extends BaseAPI {
    /**
     * Obtenir la liste des acomptes
     * @summary Obtenir la liste des acomptes
     * @param {AcomptesApiApiAcomptesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcomptesApi
     */
    public apiAcomptesGetCollection(requestParameters: AcomptesApiApiAcomptesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return AcomptesApiFp(this.configuration).apiAcomptesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.dossierFormaliteId, requestParameters.dossierFormaliteId2, requestParameters.detailsReglementsIdCollectionId, requestParameters.detailsReglementsIdCollectionId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un acompte
     * @summary Supprimer un acompte
     * @param {AcomptesApiApiAcomptesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcomptesApi
     */
    public apiAcomptesIdDelete(requestParameters: AcomptesApiApiAcomptesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AcomptesApiFp(this.configuration).apiAcomptesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'acomptes
     * @summary Récupérer les informations d\'acomptes
     * @param {AcomptesApiApiAcomptesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcomptesApi
     */
    public apiAcomptesIdGet(requestParameters: AcomptesApiApiAcomptesIdGetRequest, options?: RawAxiosRequestConfig) {
        return AcomptesApiFp(this.configuration).apiAcomptesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Reglements et acomptes CB resource.
     * @summary Modifier un acompte
     * @param {AcomptesApiApiAcomptesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcomptesApi
     */
    public apiAcomptesIdPatch(requestParameters: AcomptesApiApiAcomptesIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AcomptesApiFp(this.configuration).apiAcomptesIdPatch(requestParameters.id, requestParameters.reglementsEtAcomptesCBAcompteUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Reglements et acomptes CB resource.
     * @summary Créer un acompte
     * @param {AcomptesApiApiAcomptesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcomptesApi
     */
    public apiAcomptesPost(requestParameters: AcomptesApiApiAcomptesPostRequest, options?: RawAxiosRequestConfig) {
        return AcomptesApiFp(this.configuration).apiAcomptesPost(requestParameters.reglementsEtAcomptesCBJsonldAcompteCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActionDetailApi - axios parameter creator
 * @export
 */
export const ActionDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer la liste des action-details
         * @summary Récupérer la liste des action-details
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionDetailsGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/action-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une action-detail
         * @summary Récupérer les informations d\'une action-detail
         * @param {string} id TblActionDetail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionDetailsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiActionDetailsIdGet', 'id', id)
            const localVarPath = `/formalite/action-details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionDetailApi - functional programming interface
 * @export
 */
export const ActionDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer la liste des action-details
         * @summary Récupérer la liste des action-details
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionDetailsGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiActionDetailsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionDetailsGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionDetailApi.apiActionDetailsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une action-detail
         * @summary Récupérer les informations d\'une action-detail
         * @param {string} id TblActionDetail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionDetailsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionDetailJsonldActionDetailRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionDetailsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionDetailApi.apiActionDetailsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionDetailApi - factory interface
 * @export
 */
export const ActionDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionDetailApiFp(configuration)
    return {
        /**
         * Récupérer la liste des action-details
         * @summary Récupérer la liste des action-details
         * @param {ActionDetailApiApiActionDetailsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionDetailsGetCollection(requestParameters: ActionDetailApiApiActionDetailsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiActionDetailsGetCollection200Response> {
            return localVarFp.apiActionDetailsGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une action-detail
         * @summary Récupérer les informations d\'une action-detail
         * @param {ActionDetailApiApiActionDetailsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionDetailsIdGet(requestParameters: ActionDetailApiApiActionDetailsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionDetailJsonldActionDetailRead> {
            return localVarFp.apiActionDetailsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiActionDetailsGetCollection operation in ActionDetailApi.
 * @export
 * @interface ActionDetailApiApiActionDetailsGetCollectionRequest
 */
export interface ActionDetailApiApiActionDetailsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ActionDetailApiApiActionDetailsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionDetailApiApiActionDetailsGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiActionDetailsIdGet operation in ActionDetailApi.
 * @export
 * @interface ActionDetailApiApiActionDetailsIdGetRequest
 */
export interface ActionDetailApiApiActionDetailsIdGetRequest {
    /**
     * TblActionDetail identifier
     * @type {string}
     * @memberof ActionDetailApiApiActionDetailsIdGet
     */
    readonly id: string
}

/**
 * ActionDetailApi - object-oriented interface
 * @export
 * @class ActionDetailApi
 * @extends {BaseAPI}
 */
export class ActionDetailApi extends BaseAPI {
    /**
     * Récupérer la liste des action-details
     * @summary Récupérer la liste des action-details
     * @param {ActionDetailApiApiActionDetailsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionDetailApi
     */
    public apiActionDetailsGetCollection(requestParameters: ActionDetailApiApiActionDetailsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ActionDetailApiFp(this.configuration).apiActionDetailsGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une action-detail
     * @summary Récupérer les informations d\'une action-detail
     * @param {ActionDetailApiApiActionDetailsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionDetailApi
     */
    public apiActionDetailsIdGet(requestParameters: ActionDetailApiApiActionDetailsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ActionDetailApiFp(this.configuration).apiActionDetailsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActionLoggerApi - axios parameter creator
 * @export
 */
export const ActionLoggerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection: async (entityId: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-collection-dossier-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste des logs pour une collection dossier
         * @param {number} entityId ID du dossier
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection: async (entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-collection-dossier/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionCollectionDossier resource.
         * @summary Création de logs callback
         * @param {LogActionCollectionDossierJsonld} logActionCollectionDossierJsonld The new LogActionCollectionDossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersPostCollection: async (logActionCollectionDossierJsonld: LogActionCollectionDossierJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionCollectionDossierJsonld' is not null or undefined
            assertParamExists('apiLogActionCollectionDossiersPostCollection', 'logActionCollectionDossierJsonld', logActionCollectionDossierJsonld)
            const localVarPath = `/formalite/log_action_collection_dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionCollectionDossierJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID devis
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisGetActionLoggerDevisClientCollection: async (entityId: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionDevisGetActionLoggerDevisClientCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-devis-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste des logs pour un devis de formalité
         * @param {number} entityId ID fonctionnel
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisGetActionLoggerDevisCollection: async (entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionDevisGetActionLoggerDevisCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-devis/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionDevis resource.
         * @summary Création de logs callback
         * @param {LogActionDevisJsonld} logActionDevisJsonld The new LogActionDevis resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisPostCollection: async (logActionDevisJsonld: LogActionDevisJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionDevisJsonld' is not null or undefined
            assertParamExists('apiLogActionDevisPostCollection', 'logActionDevisJsonld', logActionDevisJsonld)
            const localVarPath = `/formalite/log_action_devis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionDevisJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersGetActionLoggerDossierClientCollection: async (entityId: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionDossiersGetActionLoggerDossierClientCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-dossier-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste des logs pour un dossier
         * @param {number} entityId ID du dossier
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersGetActionLoggerDossierCollection: async (entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionDossiersGetActionLoggerDossierCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-dossier/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionDossier resource.
         * @summary Création de logs callback
         * @param {LogActionDossierJsonld} logActionDossierJsonld The new LogActionDossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersPostCollection: async (logActionDossierJsonld: LogActionDossierJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionDossierJsonld' is not null or undefined
            assertParamExists('apiLogActionDossiersPostCollection', 'logActionDossierJsonld', logActionDossierJsonld)
            const localVarPath = `/formalite/log_action_dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionDossierJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID facture
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesGetActionLoggerFactureClientCollection: async (entityId: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionFacturesGetActionLoggerFactureClientCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-facture-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste des logs pour un facture de formalité
         * @param {number} entityId ID facture
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesGetActionLoggerFactureCollection: async (entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionFacturesGetActionLoggerFactureCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-facture/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionFacture resource.
         * @summary Création de logs callback
         * @param {LogActionFactureJsonld} logActionFactureJsonld The new LogActionFacture resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesPostCollection: async (logActionFactureJsonld: LogActionFactureJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionFactureJsonld' is not null or undefined
            assertParamExists('apiLogActionFacturesPostCollection', 'logActionFactureJsonld', logActionFactureJsonld)
            const localVarPath = `/formalite/log_action_factures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionFactureJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID tiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersGetActionLoggerTiersClientCollection: async (entityId: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionTiersGetActionLoggerTiersClientCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-tiers-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste des logs pour un tiers
         * @param {number} entityId ID tiers
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersGetActionLoggerTiersCollection: async (entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionTiersGetActionLoggerTiersCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-tiers/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionTiers resource.
         * @summary Création de logs callback
         * @param {LogActionTiersJsonld} logActionTiersJsonld The new LogActionTiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersPostCollection: async (logActionTiersJsonld: LogActionTiersJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionTiersJsonld' is not null or undefined
            assertParamExists('apiLogActionTiersPostCollection', 'logActionTiersJsonld', logActionTiersJsonld)
            const localVarPath = `/formalite/log_action_tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionTiersJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID utilisateur
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection: async (entityId: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-utilisateur-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste des logs pour un utilisateur
         * @param {number} entityId ID utilisateur
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursGetActionLoggerUtilisateurCollection: async (entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionUtilisateursGetActionLoggerUtilisateurCollection', 'entityId', entityId)
            const localVarPath = `/formalite/log-action-utilisateur/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionUtilisateur resource.
         * @summary Création de logs callback
         * @param {LogActionUtilisateurJsonld} logActionUtilisateurJsonld The new LogActionUtilisateur resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursPostCollection: async (logActionUtilisateurJsonld: LogActionUtilisateurJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionUtilisateurJsonld' is not null or undefined
            assertParamExists('apiLogActionUtilisateursPostCollection', 'logActionUtilisateurJsonld', logActionUtilisateurJsonld)
            const localVarPath = `/formalite/log_action_utilisateurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionUtilisateurJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs lié à une catégorie (admin)
         * @param {string} category LogActionMapCategory identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerByCategory: async (category: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getActionLoggerByCategory', 'category', category)
            const localVarPath = `/formalite/log-action-category/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerCategory: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/log-action-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionLoggerApi - functional programming interface
 * @export
 */
export const ActionLoggerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionLoggerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection(entityId: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection(entityId, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste des logs pour une collection dossier
         * @param {number} entityId ID du dossier
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection(entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection(entityId, withTech, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionCollectionDossier resource.
         * @summary Création de logs callback
         * @param {LogActionCollectionDossierJsonld} logActionCollectionDossierJsonld The new LogActionCollectionDossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionCollectionDossiersPostCollection(logActionCollectionDossierJsonld: LogActionCollectionDossierJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionCollectionDossierJsonldLogReadLogReadExpanded>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionCollectionDossiersPostCollection(logActionCollectionDossierJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionCollectionDossiersPostCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID devis
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDevisGetActionLoggerDevisClientCollection(entityId: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionDevisGetActionLoggerDevisClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDevisGetActionLoggerDevisClientCollection(entityId, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDevisGetActionLoggerDevisClientCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste des logs pour un devis de formalité
         * @param {number} entityId ID fonctionnel
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDevisGetActionLoggerDevisCollection(entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionDevisGetActionLoggerDevisCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDevisGetActionLoggerDevisCollection(entityId, withTech, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDevisGetActionLoggerDevisCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionDevis resource.
         * @summary Création de logs callback
         * @param {LogActionDevisJsonld} logActionDevisJsonld The new LogActionDevis resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDevisPostCollection(logActionDevisJsonld: LogActionDevisJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionDevisJsonldLogReadLogReadExpanded>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDevisPostCollection(logActionDevisJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDevisPostCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDossiersGetActionLoggerDossierClientCollection(entityId: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDossiersGetActionLoggerDossierClientCollection(entityId, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDossiersGetActionLoggerDossierClientCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste des logs pour un dossier
         * @param {number} entityId ID du dossier
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDossiersGetActionLoggerDossierCollection(entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionDossiersGetActionLoggerDossierCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDossiersGetActionLoggerDossierCollection(entityId, withTech, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDossiersGetActionLoggerDossierCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionDossier resource.
         * @summary Création de logs callback
         * @param {LogActionDossierJsonld} logActionDossierJsonld The new LogActionDossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDossiersPostCollection(logActionDossierJsonld: LogActionDossierJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionDossierJsonldLogReadExpandedLogRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDossiersPostCollection(logActionDossierJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDossiersPostCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID facture
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionFacturesGetActionLoggerFactureClientCollection(entityId: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionFacturesGetActionLoggerFactureClientCollection(entityId, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionFacturesGetActionLoggerFactureClientCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste des logs pour un facture de formalité
         * @param {number} entityId ID facture
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionFacturesGetActionLoggerFactureCollection(entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionFacturesGetActionLoggerFactureCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionFacturesGetActionLoggerFactureCollection(entityId, withTech, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionFacturesGetActionLoggerFactureCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionFacture resource.
         * @summary Création de logs callback
         * @param {LogActionFactureJsonld} logActionFactureJsonld The new LogActionFacture resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionFacturesPostCollection(logActionFactureJsonld: LogActionFactureJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionFactureJsonldLogReadLogReadExpanded>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionFacturesPostCollection(logActionFactureJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionFacturesPostCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID tiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionTiersGetActionLoggerTiersClientCollection(entityId: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionTiersGetActionLoggerTiersClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionTiersGetActionLoggerTiersClientCollection(entityId, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionTiersGetActionLoggerTiersClientCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste des logs pour un tiers
         * @param {number} entityId ID tiers
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionTiersGetActionLoggerTiersCollection(entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionTiersGetActionLoggerTiersCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionTiersGetActionLoggerTiersCollection(entityId, withTech, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionTiersGetActionLoggerTiersCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionTiers resource.
         * @summary Création de logs callback
         * @param {LogActionTiersJsonld} logActionTiersJsonld The new LogActionTiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionTiersPostCollection(logActionTiersJsonld: LogActionTiersJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionTiersJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionTiersPostCollection(logActionTiersJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionTiersPostCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste filtrée pour le client
         * @param {number} entityId ID utilisateur
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection(entityId: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection(entityId, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste des logs pour un utilisateur
         * @param {number} entityId ID utilisateur
         * @param {boolean} [withTech] 
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionUtilisateursGetActionLoggerUtilisateurCollection(entityId: number, withTech?: boolean, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionUtilisateursGetActionLoggerUtilisateurCollection(entityId, withTech, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionUtilisateursGetActionLoggerUtilisateurCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionUtilisateur resource.
         * @summary Création de logs callback
         * @param {LogActionUtilisateurJsonld} logActionUtilisateurJsonld The new LogActionUtilisateur resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionUtilisateursPostCollection(logActionUtilisateurJsonld: LogActionUtilisateurJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionUtilisateurJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionUtilisateursPostCollection(logActionUtilisateurJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionUtilisateursPostCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs lié à une catégorie (admin)
         * @param {string} category LogActionMapCategory identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerByCategory(category: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerCategory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerByCategory(category, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerCategory(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerCategory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerCategory(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionLoggerApi - factory interface
 * @export
 */
export const ActionLoggerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionLoggerApiFp(configuration)
    return {
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste filtrée pour le client
         * @param {ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response> {
            return localVarFp.apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste des logs pour une collection dossier
         * @param {ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection200Response> {
            return localVarFp.apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionCollectionDossier resource.
         * @summary Création de logs callback
         * @param {ActionLoggerApiApiLogActionCollectionDossiersPostCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersPostCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersPostCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionCollectionDossierJsonldLogReadLogReadExpanded> {
            return localVarFp.apiLogActionCollectionDossiersPostCollection(requestParameters.logActionCollectionDossierJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste filtrée pour le client
         * @param {ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisGetActionLoggerDevisClientCollection(requestParameters: ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionDevisGetActionLoggerDevisClientCollection200Response> {
            return localVarFp.apiLogActionDevisGetActionLoggerDevisClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste des logs pour un devis de formalité
         * @param {ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisGetActionLoggerDevisCollection(requestParameters: ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionDevisGetActionLoggerDevisCollection200Response> {
            return localVarFp.apiLogActionDevisGetActionLoggerDevisCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionDevis resource.
         * @summary Création de logs callback
         * @param {ActionLoggerApiApiLogActionDevisPostCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisPostCollection(requestParameters: ActionLoggerApiApiLogActionDevisPostCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionDevisJsonldLogReadLogReadExpanded> {
            return localVarFp.apiLogActionDevisPostCollection(requestParameters.logActionDevisJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste filtrée pour le client
         * @param {ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersGetActionLoggerDossierClientCollection(requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionDossiersGetActionLoggerDossierClientCollection200Response> {
            return localVarFp.apiLogActionDossiersGetActionLoggerDossierClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste des logs pour un dossier
         * @param {ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersGetActionLoggerDossierCollection(requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionDossiersGetActionLoggerDossierCollection200Response> {
            return localVarFp.apiLogActionDossiersGetActionLoggerDossierCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionDossier resource.
         * @summary Création de logs callback
         * @param {ActionLoggerApiApiLogActionDossiersPostCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersPostCollection(requestParameters: ActionLoggerApiApiLogActionDossiersPostCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionDossierJsonldLogReadExpandedLogRead> {
            return localVarFp.apiLogActionDossiersPostCollection(requestParameters.logActionDossierJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste filtrée pour le client
         * @param {ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesGetActionLoggerFactureClientCollection(requestParameters: ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionFacturesGetActionLoggerFactureClientCollection200Response> {
            return localVarFp.apiLogActionFacturesGetActionLoggerFactureClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste des logs pour un facture de formalité
         * @param {ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesGetActionLoggerFactureCollection(requestParameters: ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionFacturesGetActionLoggerFactureCollection200Response> {
            return localVarFp.apiLogActionFacturesGetActionLoggerFactureCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionFacture resource.
         * @summary Création de logs callback
         * @param {ActionLoggerApiApiLogActionFacturesPostCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesPostCollection(requestParameters: ActionLoggerApiApiLogActionFacturesPostCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionFactureJsonldLogReadLogReadExpanded> {
            return localVarFp.apiLogActionFacturesPostCollection(requestParameters.logActionFactureJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste filtrée pour le client
         * @param {ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersGetActionLoggerTiersClientCollection(requestParameters: ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionTiersGetActionLoggerTiersClientCollection200Response> {
            return localVarFp.apiLogActionTiersGetActionLoggerTiersClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste des logs pour un tiers
         * @param {ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersGetActionLoggerTiersCollection(requestParameters: ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionTiersGetActionLoggerTiersCollection200Response> {
            return localVarFp.apiLogActionTiersGetActionLoggerTiersCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionTiers resource.
         * @summary Création de logs callback
         * @param {ActionLoggerApiApiLogActionTiersPostCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersPostCollection(requestParameters: ActionLoggerApiApiLogActionTiersPostCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionTiersJsonld> {
            return localVarFp.apiLogActionTiersPostCollection(requestParameters.logActionTiersJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste filtrée pour le client
         * @param {ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection200Response> {
            return localVarFp.apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste des logs pour un utilisateur
         * @param {ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursGetActionLoggerUtilisateurCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionUtilisateursGetActionLoggerUtilisateurCollection200Response> {
            return localVarFp.apiLogActionUtilisateursGetActionLoggerUtilisateurCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionUtilisateur resource.
         * @summary Création de logs callback
         * @param {ActionLoggerApiApiLogActionUtilisateursPostCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursPostCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateursPostCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionUtilisateurJsonld> {
            return localVarFp.apiLogActionUtilisateursPostCollection(requestParameters.logActionUtilisateurJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs lié à une catégorie (admin)
         * @param {ActionLoggerApiGetActionLoggerByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerByCategory(requestParameters: ActionLoggerApiGetActionLoggerByCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerCategory200Response> {
            return localVarFp.getActionLoggerByCategory(requestParameters.category, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerCategory(requestParameters: ActionLoggerApiGetActionLoggerCategoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerCategory200Response> {
            return localVarFp.getActionLoggerCategory(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollectionRequest
 */
export interface ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollectionRequest {
    /**
     * ID du dossier
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection
     */
    readonly entityId: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollectionRequest
 */
export interface ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollectionRequest {
    /**
     * ID du dossier
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection
     */
    readonly entityId: number

    /**
     * 
     * @type {boolean}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionCollectionDossiersPostCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionCollectionDossiersPostCollectionRequest
 */
export interface ActionLoggerApiApiLogActionCollectionDossiersPostCollectionRequest {
    /**
     * The new LogActionCollectionDossier resource
     * @type {LogActionCollectionDossierJsonld}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersPostCollection
     */
    readonly logActionCollectionDossierJsonld: LogActionCollectionDossierJsonld
}

/**
 * Request parameters for apiLogActionDevisGetActionLoggerDevisClientCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollectionRequest {
    /**
     * ID devis
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollection
     */
    readonly entityId: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionDevisGetActionLoggerDevisCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollectionRequest {
    /**
     * ID fonctionnel
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollection
     */
    readonly entityId: number

    /**
     * 
     * @type {boolean}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollection
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionDevisPostCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDevisPostCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDevisPostCollectionRequest {
    /**
     * The new LogActionDevis resource
     * @type {LogActionDevisJsonld}
     * @memberof ActionLoggerApiApiLogActionDevisPostCollection
     */
    readonly logActionDevisJsonld: LogActionDevisJsonld
}

/**
 * Request parameters for apiLogActionDossiersGetActionLoggerDossierClientCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollectionRequest {
    /**
     * ID du dossier
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollection
     */
    readonly entityId: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionDossiersGetActionLoggerDossierCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest {
    /**
     * ID du dossier
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollection
     */
    readonly entityId: number

    /**
     * 
     * @type {boolean}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollection
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionDossiersPostCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDossiersPostCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDossiersPostCollectionRequest {
    /**
     * The new LogActionDossier resource
     * @type {LogActionDossierJsonld}
     * @memberof ActionLoggerApiApiLogActionDossiersPostCollection
     */
    readonly logActionDossierJsonld: LogActionDossierJsonld
}

/**
 * Request parameters for apiLogActionFacturesGetActionLoggerFactureClientCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollectionRequest
 */
export interface ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollectionRequest {
    /**
     * ID facture
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollection
     */
    readonly entityId: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionFacturesGetActionLoggerFactureCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollectionRequest
 */
export interface ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollectionRequest {
    /**
     * ID facture
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollection
     */
    readonly entityId: number

    /**
     * 
     * @type {boolean}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollection
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionFacturesPostCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionFacturesPostCollectionRequest
 */
export interface ActionLoggerApiApiLogActionFacturesPostCollectionRequest {
    /**
     * The new LogActionFacture resource
     * @type {LogActionFactureJsonld}
     * @memberof ActionLoggerApiApiLogActionFacturesPostCollection
     */
    readonly logActionFactureJsonld: LogActionFactureJsonld
}

/**
 * Request parameters for apiLogActionTiersGetActionLoggerTiersClientCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollectionRequest
 */
export interface ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollectionRequest {
    /**
     * ID tiers
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollection
     */
    readonly entityId: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionTiersGetActionLoggerTiersCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollectionRequest
 */
export interface ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollectionRequest {
    /**
     * ID tiers
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollection
     */
    readonly entityId: number

    /**
     * 
     * @type {boolean}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollection
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionTiersPostCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionTiersPostCollectionRequest
 */
export interface ActionLoggerApiApiLogActionTiersPostCollectionRequest {
    /**
     * The new LogActionTiers resource
     * @type {LogActionTiersJsonld}
     * @memberof ActionLoggerApiApiLogActionTiersPostCollection
     */
    readonly logActionTiersJsonld: LogActionTiersJsonld
}

/**
 * Request parameters for apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollectionRequest
 */
export interface ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollectionRequest {
    /**
     * ID utilisateur
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection
     */
    readonly entityId: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionUtilisateursGetActionLoggerUtilisateurCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollectionRequest
 */
export interface ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollectionRequest {
    /**
     * ID utilisateur
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollection
     */
    readonly entityId: number

    /**
     * 
     * @type {boolean}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollection
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiLogActionUtilisateursPostCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionUtilisateursPostCollectionRequest
 */
export interface ActionLoggerApiApiLogActionUtilisateursPostCollectionRequest {
    /**
     * The new LogActionUtilisateur resource
     * @type {LogActionUtilisateurJsonld}
     * @memberof ActionLoggerApiApiLogActionUtilisateursPostCollection
     */
    readonly logActionUtilisateurJsonld: LogActionUtilisateurJsonld
}

/**
 * Request parameters for getActionLoggerByCategory operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerByCategoryRequest
 */
export interface ActionLoggerApiGetActionLoggerByCategoryRequest {
    /**
     * LogActionMapCategory identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerByCategory
     */
    readonly category: string

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerByCategory
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerByCategory
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for getActionLoggerCategory operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerCategoryRequest
 */
export interface ActionLoggerApiGetActionLoggerCategoryRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerCategory
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerCategory
     */
    readonly itemsPerPage?: number
}

/**
 * ActionLoggerApi - object-oriented interface
 * @export
 * @class ActionLoggerApi
 * @extends {BaseAPI}
 */
export class ActionLoggerApi extends BaseAPI {
    /**
     * Retrieves the collection of LogActionCollectionDossier resources.
     * @summary Liste filtrée pour le client
     * @param {ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionCollectionDossiersGetActionLoggerCollectionDossierClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionCollectionDossier resources.
     * @summary Liste des logs pour une collection dossier
     * @param {ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionCollectionDossiersGetActionLoggerCollectionDossierCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionCollectionDossier resource.
     * @summary Création de logs callback
     * @param {ActionLoggerApiApiLogActionCollectionDossiersPostCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionCollectionDossiersPostCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersPostCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionCollectionDossiersPostCollection(requestParameters.logActionCollectionDossierJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDevis resources.
     * @summary Liste filtrée pour le client
     * @param {ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDevisGetActionLoggerDevisClientCollection(requestParameters: ActionLoggerApiApiLogActionDevisGetActionLoggerDevisClientCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDevisGetActionLoggerDevisClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDevis resources.
     * @summary Liste des logs pour un devis de formalité
     * @param {ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDevisGetActionLoggerDevisCollection(requestParameters: ActionLoggerApiApiLogActionDevisGetActionLoggerDevisCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDevisGetActionLoggerDevisCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionDevis resource.
     * @summary Création de logs callback
     * @param {ActionLoggerApiApiLogActionDevisPostCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDevisPostCollection(requestParameters: ActionLoggerApiApiLogActionDevisPostCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDevisPostCollection(requestParameters.logActionDevisJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDossier resources.
     * @summary Liste filtrée pour le client
     * @param {ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDossiersGetActionLoggerDossierClientCollection(requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierClientCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDossiersGetActionLoggerDossierClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDossier resources.
     * @summary Liste des logs pour un dossier
     * @param {ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDossiersGetActionLoggerDossierCollection(requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDossiersGetActionLoggerDossierCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionDossier resource.
     * @summary Création de logs callback
     * @param {ActionLoggerApiApiLogActionDossiersPostCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDossiersPostCollection(requestParameters: ActionLoggerApiApiLogActionDossiersPostCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDossiersPostCollection(requestParameters.logActionDossierJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionFacture resources.
     * @summary Liste filtrée pour le client
     * @param {ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionFacturesGetActionLoggerFactureClientCollection(requestParameters: ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureClientCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionFacturesGetActionLoggerFactureClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionFacture resources.
     * @summary Liste des logs pour un facture de formalité
     * @param {ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionFacturesGetActionLoggerFactureCollection(requestParameters: ActionLoggerApiApiLogActionFacturesGetActionLoggerFactureCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionFacturesGetActionLoggerFactureCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionFacture resource.
     * @summary Création de logs callback
     * @param {ActionLoggerApiApiLogActionFacturesPostCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionFacturesPostCollection(requestParameters: ActionLoggerApiApiLogActionFacturesPostCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionFacturesPostCollection(requestParameters.logActionFactureJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionTiers resources.
     * @summary Liste filtrée pour le client
     * @param {ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionTiersGetActionLoggerTiersClientCollection(requestParameters: ActionLoggerApiApiLogActionTiersGetActionLoggerTiersClientCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionTiersGetActionLoggerTiersClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionTiers resources.
     * @summary Liste des logs pour un tiers
     * @param {ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionTiersGetActionLoggerTiersCollection(requestParameters: ActionLoggerApiApiLogActionTiersGetActionLoggerTiersCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionTiersGetActionLoggerTiersCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionTiers resource.
     * @summary Création de logs callback
     * @param {ActionLoggerApiApiLogActionTiersPostCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionTiersPostCollection(requestParameters: ActionLoggerApiApiLogActionTiersPostCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionTiersPostCollection(requestParameters.logActionTiersJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionUtilisateur resources.
     * @summary Liste filtrée pour le client
     * @param {ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurClientCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionUtilisateursGetActionLoggerUtilisateurClientCollection(requestParameters.entityId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionUtilisateur resources.
     * @summary Liste des logs pour un utilisateur
     * @param {ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionUtilisateursGetActionLoggerUtilisateurCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateursGetActionLoggerUtilisateurCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionUtilisateursGetActionLoggerUtilisateurCollection(requestParameters.entityId, requestParameters.withTech, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionUtilisateur resource.
     * @summary Création de logs callback
     * @param {ActionLoggerApiApiLogActionUtilisateursPostCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionUtilisateursPostCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateursPostCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionUtilisateursPostCollection(requestParameters.logActionUtilisateurJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionMapCategory resources.
     * @summary Liste tous les logs lié à une catégorie (admin)
     * @param {ActionLoggerApiGetActionLoggerByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerByCategory(requestParameters: ActionLoggerApiGetActionLoggerByCategoryRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerByCategory(requestParameters.category, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionMapCategory resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerCategory(requestParameters: ActionLoggerApiGetActionLoggerCategoryRequest = {}, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerCategory(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActionsApi - axios parameter creator
 * @export
 */
export const ActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer les informations d\'une action
         * @summary Récupérer les informations d\'une action
         * @param {string} id TblAction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiActionsIdGet', 'id', id)
            const localVarPath = `/formalite/actions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Actions et activités resource.
         * @summary Modifier une action
         * @param {string} id TblAction identifier
         * @param {ActionsEtActivitSJsonldActionUpdate} actionsEtActivitSJsonldActionUpdate The updated Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionsIdPut: async (id: string, actionsEtActivitSJsonldActionUpdate: ActionsEtActivitSJsonldActionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiActionsIdPut', 'id', id)
            // verify required parameter 'actionsEtActivitSJsonldActionUpdate' is not null or undefined
            assertParamExists('apiActionsIdPut', 'actionsEtActivitSJsonldActionUpdate', actionsEtActivitSJsonldActionUpdate)
            const localVarPath = `/formalite/actions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionsEtActivitSJsonldActionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Actions et activités resource.
         * @summary Créer une action
         * @param {ActionsEtActivitSJsonldActionCreate} actionsEtActivitSJsonldActionCreate The new Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionsPost: async (actionsEtActivitSJsonldActionCreate: ActionsEtActivitSJsonldActionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionsEtActivitSJsonldActionCreate' is not null or undefined
            assertParamExists('apiActionsPost', 'actionsEtActivitSJsonldActionCreate', actionsEtActivitSJsonldActionCreate)
            const localVarPath = `/formalite/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionsEtActivitSJsonldActionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des actions
         * @summary Obtenir la liste des actions
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierActionsGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierActionsGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/actions`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionsApi - functional programming interface
 * @export
 */
export const ActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer les informations d\'une action
         * @summary Récupérer les informations d\'une action
         * @param {string} id TblAction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsEtActivitSJsonldActionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.apiActionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Actions et activités resource.
         * @summary Modifier une action
         * @param {string} id TblAction identifier
         * @param {ActionsEtActivitSJsonldActionUpdate} actionsEtActivitSJsonldActionUpdate The updated Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionsIdPut(id: string, actionsEtActivitSJsonldActionUpdate: ActionsEtActivitSJsonldActionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsEtActivitSJsonldActionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionsIdPut(id, actionsEtActivitSJsonldActionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.apiActionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Actions et activités resource.
         * @summary Créer une action
         * @param {ActionsEtActivitSJsonldActionCreate} actionsEtActivitSJsonldActionCreate The new Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionsPost(actionsEtActivitSJsonldActionCreate: ActionsEtActivitSJsonldActionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsEtActivitSJsonldActionCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionsPost(actionsEtActivitSJsonldActionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.apiActionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des actions
         * @summary Obtenir la liste des actions
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierActionsGetCollection(dossier: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierActionsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierActionsGetCollection(dossier, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.apiDossiersDossierActionsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionsApi - factory interface
 * @export
 */
export const ActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionsApiFp(configuration)
    return {
        /**
         * Récupérer les informations d\'une action
         * @summary Récupérer les informations d\'une action
         * @param {ActionsApiApiActionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionsIdGet(requestParameters: ActionsApiApiActionsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionsEtActivitSJsonldActionRead> {
            return localVarFp.apiActionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Actions et activités resource.
         * @summary Modifier une action
         * @param {ActionsApiApiActionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionsIdPut(requestParameters: ActionsApiApiActionsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionsEtActivitSJsonldActionRead> {
            return localVarFp.apiActionsIdPut(requestParameters.id, requestParameters.actionsEtActivitSJsonldActionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Actions et activités resource.
         * @summary Créer une action
         * @param {ActionsApiApiActionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionsPost(requestParameters: ActionsApiApiActionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionsEtActivitSJsonldActionCreated> {
            return localVarFp.apiActionsPost(requestParameters.actionsEtActivitSJsonldActionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des actions
         * @summary Obtenir la liste des actions
         * @param {ActionsApiApiDossiersDossierActionsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierActionsGetCollection(requestParameters: ActionsApiApiDossiersDossierActionsGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierActionsGetCollection200Response> {
            return localVarFp.apiDossiersDossierActionsGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiActionsIdGet operation in ActionsApi.
 * @export
 * @interface ActionsApiApiActionsIdGetRequest
 */
export interface ActionsApiApiActionsIdGetRequest {
    /**
     * TblAction identifier
     * @type {string}
     * @memberof ActionsApiApiActionsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiActionsIdPut operation in ActionsApi.
 * @export
 * @interface ActionsApiApiActionsIdPutRequest
 */
export interface ActionsApiApiActionsIdPutRequest {
    /**
     * TblAction identifier
     * @type {string}
     * @memberof ActionsApiApiActionsIdPut
     */
    readonly id: string

    /**
     * The updated Actions et activités resource
     * @type {ActionsEtActivitSJsonldActionUpdate}
     * @memberof ActionsApiApiActionsIdPut
     */
    readonly actionsEtActivitSJsonldActionUpdate: ActionsEtActivitSJsonldActionUpdate
}

/**
 * Request parameters for apiActionsPost operation in ActionsApi.
 * @export
 * @interface ActionsApiApiActionsPostRequest
 */
export interface ActionsApiApiActionsPostRequest {
    /**
     * The new Actions et activités resource
     * @type {ActionsEtActivitSJsonldActionCreate}
     * @memberof ActionsApiApiActionsPost
     */
    readonly actionsEtActivitSJsonldActionCreate: ActionsEtActivitSJsonldActionCreate
}

/**
 * Request parameters for apiDossiersDossierActionsGetCollection operation in ActionsApi.
 * @export
 * @interface ActionsApiApiDossiersDossierActionsGetCollectionRequest
 */
export interface ActionsApiApiDossiersDossierActionsGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof ActionsApiApiDossiersDossierActionsGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionsApiApiDossiersDossierActionsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActionsApiApiDossiersDossierActionsGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * ActionsApi - object-oriented interface
 * @export
 * @class ActionsApi
 * @extends {BaseAPI}
 */
export class ActionsApi extends BaseAPI {
    /**
     * Récupérer les informations d\'une action
     * @summary Récupérer les informations d\'une action
     * @param {ActionsApiApiActionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public apiActionsIdGet(requestParameters: ActionsApiApiActionsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).apiActionsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Actions et activités resource.
     * @summary Modifier une action
     * @param {ActionsApiApiActionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public apiActionsIdPut(requestParameters: ActionsApiApiActionsIdPutRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).apiActionsIdPut(requestParameters.id, requestParameters.actionsEtActivitSJsonldActionUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Actions et activités resource.
     * @summary Créer une action
     * @param {ActionsApiApiActionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public apiActionsPost(requestParameters: ActionsApiApiActionsPostRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).apiActionsPost(requestParameters.actionsEtActivitSJsonldActionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des actions
     * @summary Obtenir la liste des actions
     * @param {ActionsApiApiDossiersDossierActionsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public apiDossiersDossierActionsGetCollection(requestParameters: ActionsApiApiDossiersDossierActionsGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).apiDossiersDossierActionsGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActivitsApi - axios parameter creator
 * @export
 */
export const ActivitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer les informations d\'une activité
         * @summary Récupérer les informations d\'une action
         * @param {string} id TblAction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivitesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiActivitesIdGet', 'id', id)
            const localVarPath = `/formalite/activites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Actions et activités resource.
         * @summary Modifier une activité
         * @param {string} id TblAction identifier
         * @param {ActionsEtActivitSJsonldActiviteUpdate} actionsEtActivitSJsonldActiviteUpdate The updated Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivitesIdPut: async (id: string, actionsEtActivitSJsonldActiviteUpdate: ActionsEtActivitSJsonldActiviteUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiActivitesIdPut', 'id', id)
            // verify required parameter 'actionsEtActivitSJsonldActiviteUpdate' is not null or undefined
            assertParamExists('apiActivitesIdPut', 'actionsEtActivitSJsonldActiviteUpdate', actionsEtActivitSJsonldActiviteUpdate)
            const localVarPath = `/formalite/activites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionsEtActivitSJsonldActiviteUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Actions et activités resource.
         * @summary Créer une activité
         * @param {ActionsEtActivitSJsonldActiviteCreate} actionsEtActivitSJsonldActiviteCreate The new Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivitesPost: async (actionsEtActivitSJsonldActiviteCreate: ActionsEtActivitSJsonldActiviteCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionsEtActivitSJsonldActiviteCreate' is not null or undefined
            assertParamExists('apiActivitesPost', 'actionsEtActivitSJsonldActiviteCreate', actionsEtActivitSJsonldActiviteCreate)
            const localVarPath = `/formalite/activites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionsEtActivitSJsonldActiviteCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des activités
         * @summary Obtenir la liste des activités
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierActivitesGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierActivitesGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/activites`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitsApi - functional programming interface
 * @export
 */
export const ActivitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitsApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer les informations d\'une activité
         * @summary Récupérer les informations d\'une action
         * @param {string} id TblAction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActivitesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsEtActivitSJsonldActionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActivitesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitsApi.apiActivitesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Actions et activités resource.
         * @summary Modifier une activité
         * @param {string} id TblAction identifier
         * @param {ActionsEtActivitSJsonldActiviteUpdate} actionsEtActivitSJsonldActiviteUpdate The updated Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActivitesIdPut(id: string, actionsEtActivitSJsonldActiviteUpdate: ActionsEtActivitSJsonldActiviteUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsEtActivitSJsonldActiviteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActivitesIdPut(id, actionsEtActivitSJsonldActiviteUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitsApi.apiActivitesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Actions et activités resource.
         * @summary Créer une activité
         * @param {ActionsEtActivitSJsonldActiviteCreate} actionsEtActivitSJsonldActiviteCreate The new Actions et activités resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActivitesPost(actionsEtActivitSJsonldActiviteCreate: ActionsEtActivitSJsonldActiviteCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsEtActivitSJsonldActiviteCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActivitesPost(actionsEtActivitSJsonldActiviteCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitsApi.apiActivitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des activités
         * @summary Obtenir la liste des activités
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierActivitesGetCollection(dossier: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierActionsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierActivitesGetCollection(dossier, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitsApi.apiDossiersDossierActivitesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitsApi - factory interface
 * @export
 */
export const ActivitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitsApiFp(configuration)
    return {
        /**
         * Récupérer les informations d\'une activité
         * @summary Récupérer les informations d\'une action
         * @param {ActivitsApiApiActivitesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivitesIdGet(requestParameters: ActivitsApiApiActivitesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionsEtActivitSJsonldActionRead> {
            return localVarFp.apiActivitesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Actions et activités resource.
         * @summary Modifier une activité
         * @param {ActivitsApiApiActivitesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivitesIdPut(requestParameters: ActivitsApiApiActivitesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionsEtActivitSJsonldActiviteRead> {
            return localVarFp.apiActivitesIdPut(requestParameters.id, requestParameters.actionsEtActivitSJsonldActiviteUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Actions et activités resource.
         * @summary Créer une activité
         * @param {ActivitsApiApiActivitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivitesPost(requestParameters: ActivitsApiApiActivitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionsEtActivitSJsonldActiviteCreated> {
            return localVarFp.apiActivitesPost(requestParameters.actionsEtActivitSJsonldActiviteCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des activités
         * @summary Obtenir la liste des activités
         * @param {ActivitsApiApiDossiersDossierActivitesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierActivitesGetCollection(requestParameters: ActivitsApiApiDossiersDossierActivitesGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierActionsGetCollection200Response> {
            return localVarFp.apiDossiersDossierActivitesGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiActivitesIdGet operation in ActivitsApi.
 * @export
 * @interface ActivitsApiApiActivitesIdGetRequest
 */
export interface ActivitsApiApiActivitesIdGetRequest {
    /**
     * TblAction identifier
     * @type {string}
     * @memberof ActivitsApiApiActivitesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiActivitesIdPut operation in ActivitsApi.
 * @export
 * @interface ActivitsApiApiActivitesIdPutRequest
 */
export interface ActivitsApiApiActivitesIdPutRequest {
    /**
     * TblAction identifier
     * @type {string}
     * @memberof ActivitsApiApiActivitesIdPut
     */
    readonly id: string

    /**
     * The updated Actions et activités resource
     * @type {ActionsEtActivitSJsonldActiviteUpdate}
     * @memberof ActivitsApiApiActivitesIdPut
     */
    readonly actionsEtActivitSJsonldActiviteUpdate: ActionsEtActivitSJsonldActiviteUpdate
}

/**
 * Request parameters for apiActivitesPost operation in ActivitsApi.
 * @export
 * @interface ActivitsApiApiActivitesPostRequest
 */
export interface ActivitsApiApiActivitesPostRequest {
    /**
     * The new Actions et activités resource
     * @type {ActionsEtActivitSJsonldActiviteCreate}
     * @memberof ActivitsApiApiActivitesPost
     */
    readonly actionsEtActivitSJsonldActiviteCreate: ActionsEtActivitSJsonldActiviteCreate
}

/**
 * Request parameters for apiDossiersDossierActivitesGetCollection operation in ActivitsApi.
 * @export
 * @interface ActivitsApiApiDossiersDossierActivitesGetCollectionRequest
 */
export interface ActivitsApiApiDossiersDossierActivitesGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof ActivitsApiApiDossiersDossierActivitesGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof ActivitsApiApiDossiersDossierActivitesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ActivitsApiApiDossiersDossierActivitesGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * ActivitsApi - object-oriented interface
 * @export
 * @class ActivitsApi
 * @extends {BaseAPI}
 */
export class ActivitsApi extends BaseAPI {
    /**
     * Récupérer les informations d\'une activité
     * @summary Récupérer les informations d\'une action
     * @param {ActivitsApiApiActivitesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitsApi
     */
    public apiActivitesIdGet(requestParameters: ActivitsApiApiActivitesIdGetRequest, options?: RawAxiosRequestConfig) {
        return ActivitsApiFp(this.configuration).apiActivitesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Actions et activités resource.
     * @summary Modifier une activité
     * @param {ActivitsApiApiActivitesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitsApi
     */
    public apiActivitesIdPut(requestParameters: ActivitsApiApiActivitesIdPutRequest, options?: RawAxiosRequestConfig) {
        return ActivitsApiFp(this.configuration).apiActivitesIdPut(requestParameters.id, requestParameters.actionsEtActivitSJsonldActiviteUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Actions et activités resource.
     * @summary Créer une activité
     * @param {ActivitsApiApiActivitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitsApi
     */
    public apiActivitesPost(requestParameters: ActivitsApiApiActivitesPostRequest, options?: RawAxiosRequestConfig) {
        return ActivitsApiFp(this.configuration).apiActivitesPost(requestParameters.actionsEtActivitSJsonldActiviteCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des activités
     * @summary Obtenir la liste des activités
     * @param {ActivitsApiApiDossiersDossierActivitesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitsApi
     */
    public apiDossiersDossierActivitesGetCollection(requestParameters: ActivitsApiApiDossiersDossierActivitesGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActivitsApiFp(this.configuration).apiDossiersDossierActivitesGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArticlesDeFacturationApi - axios parameter creator
 * @export
 */
export const ArticlesDeFacturationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer les informations d\'un article
         * @summary Récupérer les informations d\'un article
         * @param {string} id TblFactArticles identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesFacturationIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiArticlesFacturationIdGet', 'id', id)
            const localVarPath = `/formalite/articles-facturation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticlesDeFacturationApi - functional programming interface
 * @export
 */
export const ArticlesDeFacturationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArticlesDeFacturationApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer les informations d\'un article
         * @summary Récupérer les informations d\'un article
         * @param {string} id TblFactArticles identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesFacturationIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticlesDeFacturationJsonldFactArticleRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesFacturationIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticlesDeFacturationApi.apiArticlesFacturationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArticlesDeFacturationApi - factory interface
 * @export
 */
export const ArticlesDeFacturationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArticlesDeFacturationApiFp(configuration)
    return {
        /**
         * Récupérer les informations d\'un article
         * @summary Récupérer les informations d\'un article
         * @param {ArticlesDeFacturationApiApiArticlesFacturationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesFacturationIdGet(requestParameters: ArticlesDeFacturationApiApiArticlesFacturationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticlesDeFacturationJsonldFactArticleRead> {
            return localVarFp.apiArticlesFacturationIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiArticlesFacturationIdGet operation in ArticlesDeFacturationApi.
 * @export
 * @interface ArticlesDeFacturationApiApiArticlesFacturationIdGetRequest
 */
export interface ArticlesDeFacturationApiApiArticlesFacturationIdGetRequest {
    /**
     * TblFactArticles identifier
     * @type {string}
     * @memberof ArticlesDeFacturationApiApiArticlesFacturationIdGet
     */
    readonly id: string
}

/**
 * ArticlesDeFacturationApi - object-oriented interface
 * @export
 * @class ArticlesDeFacturationApi
 * @extends {BaseAPI}
 */
export class ArticlesDeFacturationApi extends BaseAPI {
    /**
     * Récupérer les informations d\'un article
     * @summary Récupérer les informations d\'un article
     * @param {ArticlesDeFacturationApiApiArticlesFacturationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesDeFacturationApi
     */
    public apiArticlesFacturationIdGet(requestParameters: ArticlesDeFacturationApiApiArticlesFacturationIdGetRequest, options?: RawAxiosRequestConfig) {
        return ArticlesDeFacturationApiFp(this.configuration).apiArticlesFacturationIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallbackDematFacileApi - axios parameter creator
 * @export
 */
export const CallbackDematFacileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Callback DematFacile
         * @summary Callback DematFacile
         * @param {CallbackDematFacileJsonld} callbackDematFacileJsonld The new Callback DematFacile resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDematFacileCallbackPost: async (callbackDematFacileJsonld: CallbackDematFacileJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackDematFacileJsonld' is not null or undefined
            assertParamExists('apiDematFacileCallbackPost', 'callbackDematFacileJsonld', callbackDematFacileJsonld)
            const localVarPath = `/formalite/demat-facile/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackDematFacileJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbackDematFacileApi - functional programming interface
 * @export
 */
export const CallbackDematFacileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbackDematFacileApiAxiosParamCreator(configuration)
    return {
        /**
         * Callback DematFacile
         * @summary Callback DematFacile
         * @param {CallbackDematFacileJsonld} callbackDematFacileJsonld The new Callback DematFacile resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDematFacileCallbackPost(callbackDematFacileJsonld: CallbackDematFacileJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackDematFacileJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDematFacileCallbackPost(callbackDematFacileJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbackDematFacileApi.apiDematFacileCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallbackDematFacileApi - factory interface
 * @export
 */
export const CallbackDematFacileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbackDematFacileApiFp(configuration)
    return {
        /**
         * Callback DematFacile
         * @summary Callback DematFacile
         * @param {CallbackDematFacileApiApiDematFacileCallbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDematFacileCallbackPost(requestParameters: CallbackDematFacileApiApiDematFacileCallbackPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallbackDematFacileJsonld> {
            return localVarFp.apiDematFacileCallbackPost(requestParameters.callbackDematFacileJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDematFacileCallbackPost operation in CallbackDematFacileApi.
 * @export
 * @interface CallbackDematFacileApiApiDematFacileCallbackPostRequest
 */
export interface CallbackDematFacileApiApiDematFacileCallbackPostRequest {
    /**
     * The new Callback DematFacile resource
     * @type {CallbackDematFacileJsonld}
     * @memberof CallbackDematFacileApiApiDematFacileCallbackPost
     */
    readonly callbackDematFacileJsonld: CallbackDematFacileJsonld
}

/**
 * CallbackDematFacileApi - object-oriented interface
 * @export
 * @class CallbackDematFacileApi
 * @extends {BaseAPI}
 */
export class CallbackDematFacileApi extends BaseAPI {
    /**
     * Callback DematFacile
     * @summary Callback DematFacile
     * @param {CallbackDematFacileApiApiDematFacileCallbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackDematFacileApi
     */
    public apiDematFacileCallbackPost(requestParameters: CallbackDematFacileApiApiDematFacileCallbackPostRequest, options?: RawAxiosRequestConfig) {
        return CallbackDematFacileApiFp(this.configuration).apiDematFacileCallbackPost(requestParameters.callbackDematFacileJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CataloguesApi - axios parameter creator
 * @export
 */
export const CataloguesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * hidden
         * @summary Retrieves a Catalogues resource.
         * @param {string} id TblCatalogue identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCataloguesIdFormatGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCataloguesIdFormatGet', 'id', id)
            const localVarPath = `/formalite/catalogues/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CataloguesApi - functional programming interface
 * @export
 */
export const CataloguesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CataloguesApiAxiosParamCreator(configuration)
    return {
        /**
         * hidden
         * @summary Retrieves a Catalogues resource.
         * @param {string} id TblCatalogue identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCataloguesIdFormatGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCataloguesIdFormatGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CataloguesApi.apiCataloguesIdFormatGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CataloguesApi - factory interface
 * @export
 */
export const CataloguesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CataloguesApiFp(configuration)
    return {
        /**
         * hidden
         * @summary Retrieves a Catalogues resource.
         * @param {CataloguesApiApiCataloguesIdFormatGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCataloguesIdFormatGet(requestParameters: CataloguesApiApiCataloguesIdFormatGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCataloguesIdFormatGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCataloguesIdFormatGet operation in CataloguesApi.
 * @export
 * @interface CataloguesApiApiCataloguesIdFormatGetRequest
 */
export interface CataloguesApiApiCataloguesIdFormatGetRequest {
    /**
     * TblCatalogue identifier
     * @type {string}
     * @memberof CataloguesApiApiCataloguesIdFormatGet
     */
    readonly id: string
}

/**
 * CataloguesApi - object-oriented interface
 * @export
 * @class CataloguesApi
 * @extends {BaseAPI}
 */
export class CataloguesApi extends BaseAPI {
    /**
     * hidden
     * @summary Retrieves a Catalogues resource.
     * @param {CataloguesApiApiCataloguesIdFormatGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CataloguesApi
     */
    public apiCataloguesIdFormatGet(requestParameters: CataloguesApiApiCataloguesIdFormatGetRequest, options?: RawAxiosRequestConfig) {
        return CataloguesApiFp(this.configuration).apiCataloguesIdFormatGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategorieApi - axios parameter creator
 * @export
 */
export const CategorieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des categories
         * @summary Obtenir la liste des categories
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une categorie
         * @summary Récupérer les informations d\'une categorie
         * @param {string} id FproFormaliteCategorie identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCategoriesIdGet', 'id', id)
            const localVarPath = `/formalite/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Categorie resource.
         * @summary Modifier une catégorie
         * @param {string} id FproFormaliteCategorie identifier
         * @param {CategorieJsonldCategorieUpdate} categorieJsonldCategorieUpdate The updated Categorie resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdPut: async (id: string, categorieJsonldCategorieUpdate: CategorieJsonldCategorieUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCategoriesIdPut', 'id', id)
            // verify required parameter 'categorieJsonldCategorieUpdate' is not null or undefined
            assertParamExists('apiCategoriesIdPut', 'categorieJsonldCategorieUpdate', categorieJsonldCategorieUpdate)
            const localVarPath = `/formalite/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categorieJsonldCategorieUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Categorie resource.
         * @summary Créer une categorie
         * @param {CategorieJsonldCategorieCreate} categorieJsonldCategorieCreate The new Categorie resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesPost: async (categorieJsonldCategorieCreate: CategorieJsonldCategorieCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categorieJsonldCategorieCreate' is not null or undefined
            assertParamExists('apiCategoriesPost', 'categorieJsonldCategorieCreate', categorieJsonldCategorieCreate)
            const localVarPath = `/formalite/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categorieJsonldCategorieCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategorieApi - functional programming interface
 * @export
 */
export const CategorieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategorieApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des categories
         * @summary Obtenir la liste des categories
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCategoriesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategorieApi.apiCategoriesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une categorie
         * @summary Récupérer les informations d\'une categorie
         * @param {string} id FproFormaliteCategorie identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategorieJsonldCategorieRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategorieApi.apiCategoriesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Categorie resource.
         * @summary Modifier une catégorie
         * @param {string} id FproFormaliteCategorie identifier
         * @param {CategorieJsonldCategorieUpdate} categorieJsonldCategorieUpdate The updated Categorie resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesIdPut(id: string, categorieJsonldCategorieUpdate: CategorieJsonldCategorieUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategorieJsonldCategorieRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesIdPut(id, categorieJsonldCategorieUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategorieApi.apiCategoriesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Categorie resource.
         * @summary Créer une categorie
         * @param {CategorieJsonldCategorieCreate} categorieJsonldCategorieCreate The new Categorie resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesPost(categorieJsonldCategorieCreate: CategorieJsonldCategorieCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategorieJsonldCategorieCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesPost(categorieJsonldCategorieCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategorieApi.apiCategoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategorieApi - factory interface
 * @export
 */
export const CategorieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategorieApiFp(configuration)
    return {
        /**
         * Obtenir la liste des categories
         * @summary Obtenir la liste des categories
         * @param {CategorieApiApiCategoriesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesGetCollection(requestParameters: CategorieApiApiCategoriesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiCategoriesGetCollection200Response> {
            return localVarFp.apiCategoriesGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une categorie
         * @summary Récupérer les informations d\'une categorie
         * @param {CategorieApiApiCategoriesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdGet(requestParameters: CategorieApiApiCategoriesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategorieJsonldCategorieRead> {
            return localVarFp.apiCategoriesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Categorie resource.
         * @summary Modifier une catégorie
         * @param {CategorieApiApiCategoriesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdPut(requestParameters: CategorieApiApiCategoriesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategorieJsonldCategorieRead> {
            return localVarFp.apiCategoriesIdPut(requestParameters.id, requestParameters.categorieJsonldCategorieUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Categorie resource.
         * @summary Créer une categorie
         * @param {CategorieApiApiCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesPost(requestParameters: CategorieApiApiCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategorieJsonldCategorieCreated> {
            return localVarFp.apiCategoriesPost(requestParameters.categorieJsonldCategorieCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCategoriesGetCollection operation in CategorieApi.
 * @export
 * @interface CategorieApiApiCategoriesGetCollectionRequest
 */
export interface CategorieApiApiCategoriesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CategorieApiApiCategoriesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CategorieApiApiCategoriesGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiCategoriesIdGet operation in CategorieApi.
 * @export
 * @interface CategorieApiApiCategoriesIdGetRequest
 */
export interface CategorieApiApiCategoriesIdGetRequest {
    /**
     * FproFormaliteCategorie identifier
     * @type {string}
     * @memberof CategorieApiApiCategoriesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiCategoriesIdPut operation in CategorieApi.
 * @export
 * @interface CategorieApiApiCategoriesIdPutRequest
 */
export interface CategorieApiApiCategoriesIdPutRequest {
    /**
     * FproFormaliteCategorie identifier
     * @type {string}
     * @memberof CategorieApiApiCategoriesIdPut
     */
    readonly id: string

    /**
     * The updated Categorie resource
     * @type {CategorieJsonldCategorieUpdate}
     * @memberof CategorieApiApiCategoriesIdPut
     */
    readonly categorieJsonldCategorieUpdate: CategorieJsonldCategorieUpdate
}

/**
 * Request parameters for apiCategoriesPost operation in CategorieApi.
 * @export
 * @interface CategorieApiApiCategoriesPostRequest
 */
export interface CategorieApiApiCategoriesPostRequest {
    /**
     * The new Categorie resource
     * @type {CategorieJsonldCategorieCreate}
     * @memberof CategorieApiApiCategoriesPost
     */
    readonly categorieJsonldCategorieCreate: CategorieJsonldCategorieCreate
}

/**
 * CategorieApi - object-oriented interface
 * @export
 * @class CategorieApi
 * @extends {BaseAPI}
 */
export class CategorieApi extends BaseAPI {
    /**
     * Obtenir la liste des categories
     * @summary Obtenir la liste des categories
     * @param {CategorieApiApiCategoriesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategorieApi
     */
    public apiCategoriesGetCollection(requestParameters: CategorieApiApiCategoriesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CategorieApiFp(this.configuration).apiCategoriesGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une categorie
     * @summary Récupérer les informations d\'une categorie
     * @param {CategorieApiApiCategoriesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategorieApi
     */
    public apiCategoriesIdGet(requestParameters: CategorieApiApiCategoriesIdGetRequest, options?: RawAxiosRequestConfig) {
        return CategorieApiFp(this.configuration).apiCategoriesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Categorie resource.
     * @summary Modifier une catégorie
     * @param {CategorieApiApiCategoriesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategorieApi
     */
    public apiCategoriesIdPut(requestParameters: CategorieApiApiCategoriesIdPutRequest, options?: RawAxiosRequestConfig) {
        return CategorieApiFp(this.configuration).apiCategoriesIdPut(requestParameters.id, requestParameters.categorieJsonldCategorieUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Categorie resource.
     * @summary Créer une categorie
     * @param {CategorieApiApiCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategorieApi
     */
    public apiCategoriesPost(requestParameters: CategorieApiApiCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return CategorieApiFp(this.configuration).apiCategoriesPost(requestParameters.categorieJsonldCategorieCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CollectionDeDossierApi - axios parameter creator
 * @export
 */
export const CollectionDeDossierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les collections de dossiers
         * @summary Lister les collections de dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [numero] 
         * @param {string} [libelle] 
         * @param {string} [dossiersNumero] 
         * @param {number} [prescripteurId] 
         * @param {Array<number>} [prescripteurId2] 
         * @param {number} [clientId] 
         * @param {Array<number>} [clientId2] 
         * @param {number} [societeId] 
         * @param {Array<number>} [societeId2] 
         * @param {number} [statutId] 
         * @param {Array<number>} [statutId2] 
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersGetCollection: async (page?: number, itemsPerPage?: number, numero?: string, libelle?: string, dossiersNumero?: string, prescripteurId?: number, prescripteurId2?: Array<number>, clientId?: number, clientId2?: Array<number>, societeId?: number, societeId2?: Array<number>, statutId?: number, statutId2?: Array<number>, id?: number, id2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/collections-dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (numero !== undefined) {
                localVarQueryParameter['numero'] = numero;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }

            if (dossiersNumero !== undefined) {
                localVarQueryParameter['dossiers.numero'] = dossiersNumero;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteur.id'] = prescripteurId;
            }

            if (prescripteurId2) {
                localVarQueryParameter['prescripteur.id[]'] = prescripteurId2;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['client.id'] = clientId;
            }

            if (clientId2) {
                localVarQueryParameter['client.id[]'] = clientId2;
            }

            if (societeId !== undefined) {
                localVarQueryParameter['societe.id'] = societeId;
            }

            if (societeId2) {
                localVarQueryParameter['societe.id[]'] = societeId2;
            }

            if (statutId !== undefined) {
                localVarQueryParameter['statut.id'] = statutId;
            }

            if (statutId2) {
                localVarQueryParameter['statut.id[]'] = statutId2;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recalculer les articles des dossiers de la collection suivant les règles liées
         * @summary Recalculer les articles des dossiers de la collection
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonld} collectionDeDossierJsonld The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdCalculatePut: async (id: string, collectionDeDossierJsonld: CollectionDeDossierJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdCalculatePut', 'id', id)
            // verify required parameter 'collectionDeDossierJsonld' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdCalculatePut', 'collectionDeDossierJsonld', collectionDeDossierJsonld)
            const localVarPath = `/formalite/collections-dossiers/{id}/calculate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionDeDossierJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer une collection de dossier
         * @summary Supprimer une collection de dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdDelete', 'id', id)
            const localVarPath = `/formalite/collections-dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un devis pour une collection de dossier
         * @summary Créer un devis pour une collection de dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonldCollectiondevisCreate} collectionDeDossierJsonldCollectiondevisCreate The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdDevisPut: async (id: string, collectionDeDossierJsonldCollectiondevisCreate: CollectionDeDossierJsonldCollectiondevisCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdDevisPut', 'id', id)
            // verify required parameter 'collectionDeDossierJsonldCollectiondevisCreate' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdDevisPut', 'collectionDeDossierJsonldCollectiondevisCreate', collectionDeDossierJsonldCollectiondevisCreate)
            const localVarPath = `/formalite/collections-dossiers/{id}/devis`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionDeDossierJsonldCollectiondevisCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dupliquer une collection de dossiers
         * @summary Dupliquer une collection de dossiers
         * @param {number} id L\&#39;identifiant de la
         * @param {ApiCollectionsDossiersIdDuplicatePutRequest} [apiCollectionsDossiersIdDuplicatePutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdDuplicatePut: async (id: number, apiCollectionsDossiersIdDuplicatePutRequest?: ApiCollectionsDossiersIdDuplicatePutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdDuplicatePut', 'id', id)
            const localVarPath = `/formalite/collections-dossiers/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiCollectionsDossiersIdDuplicatePutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une collection de dossier
         * @summary Récupérer les informations d\'une collection de dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdGet', 'id', id)
            const localVarPath = `/formalite/collections-dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifier en partie les informations d\'une collection dossier
         * @summary Modifier en partie les informations d\'une collection dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierCollectiondossierUpdate} collectionDeDossierCollectiondossierUpdate The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdPatch: async (id: string, collectionDeDossierCollectiondossierUpdate: CollectionDeDossierCollectiondossierUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdPatch', 'id', id)
            // verify required parameter 'collectionDeDossierCollectiondossierUpdate' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdPatch', 'collectionDeDossierCollectiondossierUpdate', collectionDeDossierCollectiondossierUpdate)
            const localVarPath = `/formalite/collections-dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionDeDossierCollectiondossierUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifier les informations d\'une collection dossier
         * @summary Modifier les informations d\'une collection dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonldCollectiondossierUpdate} collectionDeDossierJsonldCollectiondossierUpdate The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdPut: async (id: string, collectionDeDossierJsonldCollectiondossierUpdate: CollectionDeDossierJsonldCollectiondossierUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdPut', 'id', id)
            // verify required parameter 'collectionDeDossierJsonldCollectiondossierUpdate' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdPut', 'collectionDeDossierJsonldCollectiondossierUpdate', collectionDeDossierJsonldCollectiondossierUpdate)
            const localVarPath = `/formalite/collections-dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionDeDossierJsonldCollectiondossierUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Valider une collection de dossiers
         * @summary Valider une collection de dossiers
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonldCollectiondossierValidated} collectionDeDossierJsonldCollectiondossierValidated The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdValidatePut: async (id: string, collectionDeDossierJsonldCollectiondossierValidated: CollectionDeDossierJsonldCollectiondossierValidated, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdValidatePut', 'id', id)
            // verify required parameter 'collectionDeDossierJsonldCollectiondossierValidated' is not null or undefined
            assertParamExists('apiCollectionsDossiersIdValidatePut', 'collectionDeDossierJsonldCollectiondossierValidated', collectionDeDossierJsonldCollectiondossierValidated)
            const localVarPath = `/formalite/collections-dossiers/{id}/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionDeDossierJsonldCollectiondossierValidated, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer une collection de dossier
         * @summary Créer une collection de dossier
         * @param {CollectionDeDossierJsonldCollectiondossierCreate} collectionDeDossierJsonldCollectiondossierCreate The new Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersPost: async (collectionDeDossierJsonldCollectiondossierCreate: CollectionDeDossierJsonldCollectiondossierCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionDeDossierJsonldCollectiondossierCreate' is not null or undefined
            assertParamExists('apiCollectionsDossiersPost', 'collectionDeDossierJsonldCollectiondossierCreate', collectionDeDossierJsonldCollectiondossierCreate)
            const localVarPath = `/formalite/collections-dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionDeDossierJsonldCollectiondossierCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionDeDossierApi - functional programming interface
 * @export
 */
export const CollectionDeDossierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollectionDeDossierApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les collections de dossiers
         * @summary Lister les collections de dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [numero] 
         * @param {string} [libelle] 
         * @param {string} [dossiersNumero] 
         * @param {number} [prescripteurId] 
         * @param {Array<number>} [prescripteurId2] 
         * @param {number} [clientId] 
         * @param {Array<number>} [clientId2] 
         * @param {number} [societeId] 
         * @param {Array<number>} [societeId2] 
         * @param {number} [statutId] 
         * @param {Array<number>} [statutId2] 
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersGetCollection(page?: number, itemsPerPage?: number, numero?: string, libelle?: string, dossiersNumero?: string, prescripteurId?: number, prescripteurId2?: Array<number>, clientId?: number, clientId2?: Array<number>, societeId?: number, societeId2?: Array<number>, statutId?: number, statutId2?: Array<number>, id?: number, id2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCollectionsDossiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersGetCollection(page, itemsPerPage, numero, libelle, dossiersNumero, prescripteurId, prescripteurId2, clientId, clientId2, societeId, societeId2, statutId, statutId2, id, id2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Recalculer les articles des dossiers de la collection suivant les règles liées
         * @summary Recalculer les articles des dossiers de la collection
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonld} collectionDeDossierJsonld The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdCalculatePut(id: string, collectionDeDossierJsonld: CollectionDeDossierJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdCalculatePut(id, collectionDeDossierJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdCalculatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer une collection de dossier
         * @summary Supprimer une collection de dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un devis pour une collection de dossier
         * @summary Créer un devis pour une collection de dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonldCollectiondevisCreate} collectionDeDossierJsonldCollectiondevisCreate The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdDevisPut(id: string, collectionDeDossierJsonldCollectiondevisCreate: CollectionDeDossierJsonldCollectiondevisCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdDevisPut(id, collectionDeDossierJsonldCollectiondevisCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdDevisPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dupliquer une collection de dossiers
         * @summary Dupliquer une collection de dossiers
         * @param {number} id L\&#39;identifiant de la
         * @param {ApiCollectionsDossiersIdDuplicatePutRequest} [apiCollectionsDossiersIdDuplicatePutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdDuplicatePut(id: number, apiCollectionsDossiersIdDuplicatePutRequest?: ApiCollectionsDossiersIdDuplicatePutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdDuplicatePut(id, apiCollectionsDossiersIdDuplicatePutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdDuplicatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une collection de dossier
         * @summary Récupérer les informations d\'une collection de dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifier en partie les informations d\'une collection dossier
         * @summary Modifier en partie les informations d\'une collection dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierCollectiondossierUpdate} collectionDeDossierCollectiondossierUpdate The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdPatch(id: string, collectionDeDossierCollectiondossierUpdate: CollectionDeDossierCollectiondossierUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdPatch(id, collectionDeDossierCollectiondossierUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifier les informations d\'une collection dossier
         * @summary Modifier les informations d\'une collection dossier
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonldCollectiondossierUpdate} collectionDeDossierJsonldCollectiondossierUpdate The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdPut(id: string, collectionDeDossierJsonldCollectiondossierUpdate: CollectionDeDossierJsonldCollectiondossierUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdPut(id, collectionDeDossierJsonldCollectiondossierUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Valider une collection de dossiers
         * @summary Valider une collection de dossiers
         * @param {string} id TblCollectionDossier identifier
         * @param {CollectionDeDossierJsonldCollectiondossierValidated} collectionDeDossierJsonldCollectiondossierValidated The updated Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersIdValidatePut(id: string, collectionDeDossierJsonldCollectiondossierValidated: CollectionDeDossierJsonldCollectiondossierValidated, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierValidated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersIdValidatePut(id, collectionDeDossierJsonldCollectiondossierValidated, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersIdValidatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer une collection de dossier
         * @summary Créer une collection de dossier
         * @param {CollectionDeDossierJsonldCollectiondossierCreate} collectionDeDossierJsonldCollectiondossierCreate The new Collection de dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCollectionsDossiersPost(collectionDeDossierJsonldCollectiondossierCreate: CollectionDeDossierJsonldCollectiondossierCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDeDossierJsonldCollectiondossierCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCollectionsDossiersPost(collectionDeDossierJsonldCollectiondossierCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionDeDossierApi.apiCollectionsDossiersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollectionDeDossierApi - factory interface
 * @export
 */
export const CollectionDeDossierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollectionDeDossierApiFp(configuration)
    return {
        /**
         * Lister les collections de dossiers
         * @summary Lister les collections de dossiers
         * @param {CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersGetCollection(requestParameters: CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiCollectionsDossiersGetCollection200Response> {
            return localVarFp.apiCollectionsDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.numero, requestParameters.libelle, requestParameters.dossiersNumero, requestParameters.prescripteurId, requestParameters.prescripteurId2, requestParameters.clientId, requestParameters.clientId2, requestParameters.societeId, requestParameters.societeId2, requestParameters.statutId, requestParameters.statutId2, requestParameters.id, requestParameters.id2, options).then((request) => request(axios, basePath));
        },
        /**
         * Recalculer les articles des dossiers de la collection suivant les règles liées
         * @summary Recalculer les articles des dossiers de la collection
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdCalculatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdCalculatePut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdCalculatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead> {
            return localVarFp.apiCollectionsDossiersIdCalculatePut(requestParameters.id, requestParameters.collectionDeDossierJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer une collection de dossier
         * @summary Supprimer une collection de dossier
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdDelete(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCollectionsDossiersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un devis pour une collection de dossier
         * @summary Créer un devis pour une collection de dossier
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdDevisPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdDevisPut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdDevisPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead> {
            return localVarFp.apiCollectionsDossiersIdDevisPut(requestParameters.id, requestParameters.collectionDeDossierJsonldCollectiondevisCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Dupliquer une collection de dossiers
         * @summary Dupliquer une collection de dossiers
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdDuplicatePut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead> {
            return localVarFp.apiCollectionsDossiersIdDuplicatePut(requestParameters.id, requestParameters.apiCollectionsDossiersIdDuplicatePutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une collection de dossier
         * @summary Récupérer les informations d\'une collection de dossier
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdGet(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead> {
            return localVarFp.apiCollectionsDossiersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifier en partie les informations d\'une collection dossier
         * @summary Modifier en partie les informations d\'une collection dossier
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdPatch(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead> {
            return localVarFp.apiCollectionsDossiersIdPatch(requestParameters.id, requestParameters.collectionDeDossierCollectiondossierUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifier les informations d\'une collection dossier
         * @summary Modifier les informations d\'une collection dossier
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdPut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierRead> {
            return localVarFp.apiCollectionsDossiersIdPut(requestParameters.id, requestParameters.collectionDeDossierJsonldCollectiondossierUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Valider une collection de dossiers
         * @summary Valider une collection de dossiers
         * @param {CollectionDeDossierApiApiCollectionsDossiersIdValidatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersIdValidatePut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdValidatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierValidated> {
            return localVarFp.apiCollectionsDossiersIdValidatePut(requestParameters.id, requestParameters.collectionDeDossierJsonldCollectiondossierValidated, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer une collection de dossier
         * @summary Créer une collection de dossier
         * @param {CollectionDeDossierApiApiCollectionsDossiersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCollectionsDossiersPost(requestParameters: CollectionDeDossierApiApiCollectionsDossiersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDeDossierJsonldCollectiondossierCreated> {
            return localVarFp.apiCollectionsDossiersPost(requestParameters.collectionDeDossierJsonldCollectiondossierCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCollectionsDossiersGetCollection operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly numero?: string

    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly libelle?: string

    /**
     * 
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly dossiersNumero?: string

    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly prescripteurId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly prescripteurId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly clientId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly clientId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly societeId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly societeId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly statutId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly statutId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersGetCollection
     */
    readonly id2?: Array<number>
}

/**
 * Request parameters for apiCollectionsDossiersIdCalculatePut operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdCalculatePutRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdCalculatePutRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdCalculatePut
     */
    readonly id: string

    /**
     * The updated Collection de dossier resource
     * @type {CollectionDeDossierJsonld}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdCalculatePut
     */
    readonly collectionDeDossierJsonld: CollectionDeDossierJsonld
}

/**
 * Request parameters for apiCollectionsDossiersIdDelete operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdDeleteRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdDeleteRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiCollectionsDossiersIdDevisPut operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdDevisPutRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdDevisPutRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdDevisPut
     */
    readonly id: string

    /**
     * The updated Collection de dossier resource
     * @type {CollectionDeDossierJsonldCollectiondevisCreate}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdDevisPut
     */
    readonly collectionDeDossierJsonldCollectiondevisCreate: CollectionDeDossierJsonldCollectiondevisCreate
}

/**
 * Request parameters for apiCollectionsDossiersIdDuplicatePut operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePutRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePutRequest {
    /**
     * L\&#39;identifiant de la
     * @type {number}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePut
     */
    readonly id: number

    /**
     * 
     * @type {ApiCollectionsDossiersIdDuplicatePutRequest}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePut
     */
    readonly apiCollectionsDossiersIdDuplicatePutRequest?: ApiCollectionsDossiersIdDuplicatePutRequest
}

/**
 * Request parameters for apiCollectionsDossiersIdGet operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdGetRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdGetRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiCollectionsDossiersIdPatch operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdPatchRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdPatchRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdPatch
     */
    readonly id: string

    /**
     * The updated Collection de dossier resource
     * @type {CollectionDeDossierCollectiondossierUpdate}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdPatch
     */
    readonly collectionDeDossierCollectiondossierUpdate: CollectionDeDossierCollectiondossierUpdate
}

/**
 * Request parameters for apiCollectionsDossiersIdPut operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdPutRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdPutRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdPut
     */
    readonly id: string

    /**
     * The updated Collection de dossier resource
     * @type {CollectionDeDossierJsonldCollectiondossierUpdate}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdPut
     */
    readonly collectionDeDossierJsonldCollectiondossierUpdate: CollectionDeDossierJsonldCollectiondossierUpdate
}

/**
 * Request parameters for apiCollectionsDossiersIdValidatePut operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersIdValidatePutRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersIdValidatePutRequest {
    /**
     * TblCollectionDossier identifier
     * @type {string}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdValidatePut
     */
    readonly id: string

    /**
     * The updated Collection de dossier resource
     * @type {CollectionDeDossierJsonldCollectiondossierValidated}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersIdValidatePut
     */
    readonly collectionDeDossierJsonldCollectiondossierValidated: CollectionDeDossierJsonldCollectiondossierValidated
}

/**
 * Request parameters for apiCollectionsDossiersPost operation in CollectionDeDossierApi.
 * @export
 * @interface CollectionDeDossierApiApiCollectionsDossiersPostRequest
 */
export interface CollectionDeDossierApiApiCollectionsDossiersPostRequest {
    /**
     * The new Collection de dossier resource
     * @type {CollectionDeDossierJsonldCollectiondossierCreate}
     * @memberof CollectionDeDossierApiApiCollectionsDossiersPost
     */
    readonly collectionDeDossierJsonldCollectiondossierCreate: CollectionDeDossierJsonldCollectiondossierCreate
}

/**
 * CollectionDeDossierApi - object-oriented interface
 * @export
 * @class CollectionDeDossierApi
 * @extends {BaseAPI}
 */
export class CollectionDeDossierApi extends BaseAPI {
    /**
     * Lister les collections de dossiers
     * @summary Lister les collections de dossiers
     * @param {CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersGetCollection(requestParameters: CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.numero, requestParameters.libelle, requestParameters.dossiersNumero, requestParameters.prescripteurId, requestParameters.prescripteurId2, requestParameters.clientId, requestParameters.clientId2, requestParameters.societeId, requestParameters.societeId2, requestParameters.statutId, requestParameters.statutId2, requestParameters.id, requestParameters.id2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recalculer les articles des dossiers de la collection suivant les règles liées
     * @summary Recalculer les articles des dossiers de la collection
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdCalculatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdCalculatePut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdCalculatePutRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdCalculatePut(requestParameters.id, requestParameters.collectionDeDossierJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer une collection de dossier
     * @summary Supprimer une collection de dossier
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdDelete(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un devis pour une collection de dossier
     * @summary Créer un devis pour une collection de dossier
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdDevisPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdDevisPut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdDevisPutRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdDevisPut(requestParameters.id, requestParameters.collectionDeDossierJsonldCollectiondevisCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dupliquer une collection de dossiers
     * @summary Dupliquer une collection de dossiers
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdDuplicatePut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdDuplicatePutRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdDuplicatePut(requestParameters.id, requestParameters.apiCollectionsDossiersIdDuplicatePutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une collection de dossier
     * @summary Récupérer les informations d\'une collection de dossier
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdGet(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdGetRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifier en partie les informations d\'une collection dossier
     * @summary Modifier en partie les informations d\'une collection dossier
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdPatch(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdPatchRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdPatch(requestParameters.id, requestParameters.collectionDeDossierCollectiondossierUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifier les informations d\'une collection dossier
     * @summary Modifier les informations d\'une collection dossier
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdPut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdPutRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdPut(requestParameters.id, requestParameters.collectionDeDossierJsonldCollectiondossierUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Valider une collection de dossiers
     * @summary Valider une collection de dossiers
     * @param {CollectionDeDossierApiApiCollectionsDossiersIdValidatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersIdValidatePut(requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdValidatePutRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersIdValidatePut(requestParameters.id, requestParameters.collectionDeDossierJsonldCollectiondossierValidated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer une collection de dossier
     * @summary Créer une collection de dossier
     * @param {CollectionDeDossierApiApiCollectionsDossiersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionDeDossierApi
     */
    public apiCollectionsDossiersPost(requestParameters: CollectionDeDossierApiApiCollectionsDossiersPostRequest, options?: RawAxiosRequestConfig) {
        return CollectionDeDossierApiFp(this.configuration).apiCollectionsDossiersPost(requestParameters.collectionDeDossierJsonldCollectiondossierCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CollectionOpenSearchApi - axios parameter creator
 * @export
 */
export const CollectionOpenSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les clients des collections indexés sur Open Search
         * @summary Lister les clients des collections indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsClientsGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/collections/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les collections indexées sur Open Search
         * @summary Lister les collections indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [clientId] Filter collections list by client
         * @param {Array<string>} [numero] Filter collections list by number
         * @param {Array<number>} [prescripteurId] Filter collections list by prescriber ID
         * @param {Array<number>} [societeId] Filter collections list by societe ID
         * @param {Array<number>} [offerId] Filter collections list by offer ID
         * @param {boolean} [critical] Filter list by critical flag
         * @param {boolean} [incompleteForBilling] Filter list by incompleteForBilling flag
         * @param {boolean} [demo] Filter list by only showing collections demo
         * @param {Array<string>} [statutInvoceLibelle] Filter collections list by statutInvoceLibelle
         * @param {Array<string>} [statutQuoteLibelle] Filter collections list by statutQuoteLibelle
         * @param {string} [orderNumero] Sort collections by numero
         * @param {string} [orderPrescripteurLibelle] Sort collections by prescriber\&#39;s name
         * @param {string} [orderOffreLibelle] Sort collections by offer\&#39;s name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsGetCollection: async (page?: number, itemsPerPage?: number, clientId?: Array<number>, numero?: Array<string>, prescripteurId?: Array<number>, societeId?: Array<number>, offerId?: Array<number>, critical?: boolean, incompleteForBilling?: boolean, demo?: boolean, statutInvoceLibelle?: Array<string>, statutQuoteLibelle?: Array<string>, orderNumero?: string, orderPrescripteurLibelle?: string, orderOffreLibelle?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (clientId) {
                localVarQueryParameter['clientId[]'] = clientId;
            }

            if (numero) {
                localVarQueryParameter['numero[]'] = numero;
            }

            if (prescripteurId) {
                localVarQueryParameter['prescripteurId[]'] = prescripteurId;
            }

            if (societeId) {
                localVarQueryParameter['societeId[]'] = societeId;
            }

            if (offerId) {
                localVarQueryParameter['offerId[]'] = offerId;
            }

            if (critical !== undefined) {
                localVarQueryParameter['critical'] = critical;
            }

            if (incompleteForBilling !== undefined) {
                localVarQueryParameter['incompleteForBilling'] = incompleteForBilling;
            }

            if (demo !== undefined) {
                localVarQueryParameter['demo'] = demo;
            }

            if (statutInvoceLibelle) {
                localVarQueryParameter['statutInvoceLibelle[]'] = statutInvoceLibelle;
            }

            if (statutQuoteLibelle) {
                localVarQueryParameter['statutQuoteLibelle[]'] = statutQuoteLibelle;
            }

            if (orderNumero !== undefined) {
                localVarQueryParameter['order[numero]'] = orderNumero;
            }

            if (orderPrescripteurLibelle !== undefined) {
                localVarQueryParameter['order[prescripteurLibelle]'] = orderPrescripteurLibelle;
            }

            if (orderOffreLibelle !== undefined) {
                localVarQueryParameter['order[offreLibelle]'] = orderOffreLibelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une collection indexée sur Open Search
         * @summary Récupérer les informations d\'une collection indexée sur Open Search
         * @param {string} id CollectionDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOpensearchCollectionsIdGet', 'id', id)
            const localVarPath = `/formalite/opensearch/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Indexer un lot de collections sur Open Search
         * @summary Indexer un lot de collections sur Open Search
         * @param {CollectionOpenSearchJsonldOpensearchCollectionIndexBatch} collectionOpenSearchJsonldOpensearchCollectionIndexBatch The new Collection Open Search resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsIndexByIdsPost: async (collectionOpenSearchJsonldOpensearchCollectionIndexBatch: CollectionOpenSearchJsonldOpensearchCollectionIndexBatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionOpenSearchJsonldOpensearchCollectionIndexBatch' is not null or undefined
            assertParamExists('apiOpensearchCollectionsIndexByIdsPost', 'collectionOpenSearchJsonldOpensearchCollectionIndexBatch', collectionOpenSearchJsonldOpensearchCollectionIndexBatch)
            const localVarPath = `/formalite/opensearch/collections/index-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionOpenSearchJsonldOpensearchCollectionIndexBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les numéros des collections indexés sur Open Search
         * @summary Lister les numéros des collections indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsNumerosGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/collections/numeros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les offres des collections indexées sur Open Search
         * @summary Lister les offres des collections indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsOffersGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/collections/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les prescripteurs des collections indexées sur Open Search
         * @summary Lister les prescripteurs des collections indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsPrescripteursGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/collections/prescripteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionOpenSearchApi - functional programming interface
 * @export
 */
export const CollectionOpenSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollectionOpenSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les clients des collections indexés sur Open Search
         * @summary Lister les clients des collections indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsClientsGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchCollectionsClientsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsClientsGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsClientsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les collections indexées sur Open Search
         * @summary Lister les collections indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [clientId] Filter collections list by client
         * @param {Array<string>} [numero] Filter collections list by number
         * @param {Array<number>} [prescripteurId] Filter collections list by prescriber ID
         * @param {Array<number>} [societeId] Filter collections list by societe ID
         * @param {Array<number>} [offerId] Filter collections list by offer ID
         * @param {boolean} [critical] Filter list by critical flag
         * @param {boolean} [incompleteForBilling] Filter list by incompleteForBilling flag
         * @param {boolean} [demo] Filter list by only showing collections demo
         * @param {Array<string>} [statutInvoceLibelle] Filter collections list by statutInvoceLibelle
         * @param {Array<string>} [statutQuoteLibelle] Filter collections list by statutQuoteLibelle
         * @param {string} [orderNumero] Sort collections by numero
         * @param {string} [orderPrescripteurLibelle] Sort collections by prescriber\&#39;s name
         * @param {string} [orderOffreLibelle] Sort collections by offer\&#39;s name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsGetCollection(page?: number, itemsPerPage?: number, clientId?: Array<number>, numero?: Array<string>, prescripteurId?: Array<number>, societeId?: Array<number>, offerId?: Array<number>, critical?: boolean, incompleteForBilling?: boolean, demo?: boolean, statutInvoceLibelle?: Array<string>, statutQuoteLibelle?: Array<string>, orderNumero?: string, orderPrescripteurLibelle?: string, orderOffreLibelle?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchCollectionsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsGetCollection(page, itemsPerPage, clientId, numero, prescripteurId, societeId, offerId, critical, incompleteForBilling, demo, statutInvoceLibelle, statutQuoteLibelle, orderNumero, orderPrescripteurLibelle, orderOffreLibelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une collection indexée sur Open Search
         * @summary Récupérer les informations d\'une collection indexée sur Open Search
         * @param {string} id CollectionDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionOpenSearchCombinedJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Indexer un lot de collections sur Open Search
         * @summary Indexer un lot de collections sur Open Search
         * @param {CollectionOpenSearchJsonldOpensearchCollectionIndexBatch} collectionOpenSearchJsonldOpensearchCollectionIndexBatch The new Collection Open Search resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsIndexByIdsPost(collectionOpenSearchJsonldOpensearchCollectionIndexBatch: CollectionOpenSearchJsonldOpensearchCollectionIndexBatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsIndexByIdsPost(collectionOpenSearchJsonldOpensearchCollectionIndexBatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsIndexByIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les numéros des collections indexés sur Open Search
         * @summary Lister les numéros des collections indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsNumerosGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchCollectionsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsNumerosGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsNumerosGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les offres des collections indexées sur Open Search
         * @summary Lister les offres des collections indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsOffersGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchCollectionsOffersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsOffersGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsOffersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les prescripteurs des collections indexées sur Open Search
         * @summary Lister les prescripteurs des collections indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchCollectionsPrescripteursGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchCollectionsPrescripteursGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchCollectionsPrescripteursGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionOpenSearchApi.apiOpensearchCollectionsPrescripteursGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollectionOpenSearchApi - factory interface
 * @export
 */
export const CollectionOpenSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollectionOpenSearchApiFp(configuration)
    return {
        /**
         * Lister les clients des collections indexés sur Open Search
         * @summary Lister les clients des collections indexés sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsClientsGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchCollectionsClientsGetCollection200Response> {
            return localVarFp.apiOpensearchCollectionsClientsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les collections indexées sur Open Search
         * @summary Lister les collections indexées sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchCollectionsGetCollection200Response> {
            return localVarFp.apiOpensearchCollectionsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.clientId, requestParameters.numero, requestParameters.prescripteurId, requestParameters.societeId, requestParameters.offerId, requestParameters.critical, requestParameters.incompleteForBilling, requestParameters.demo, requestParameters.statutInvoceLibelle, requestParameters.statutQuoteLibelle, requestParameters.orderNumero, requestParameters.orderPrescripteurLibelle, requestParameters.orderOffreLibelle, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une collection indexée sur Open Search
         * @summary Récupérer les informations d\'une collection indexée sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsIdGet(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionOpenSearchCombinedJsonld> {
            return localVarFp.apiOpensearchCollectionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Indexer un lot de collections sur Open Search
         * @summary Indexer un lot de collections sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsIndexByIdsPost(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionOpenSearchIndexBatchCollectionDossierResponseJsonldOpensearchCollectionIndexBatch> {
            return localVarFp.apiOpensearchCollectionsIndexByIdsPost(requestParameters.collectionOpenSearchJsonldOpensearchCollectionIndexBatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les numéros des collections indexés sur Open Search
         * @summary Lister les numéros des collections indexés sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsNumerosGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchCollectionsGetCollection200Response> {
            return localVarFp.apiOpensearchCollectionsNumerosGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les offres des collections indexées sur Open Search
         * @summary Lister les offres des collections indexées sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsOffersGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchCollectionsOffersGetCollection200Response> {
            return localVarFp.apiOpensearchCollectionsOffersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les prescripteurs des collections indexées sur Open Search
         * @summary Lister les prescripteurs des collections indexées sur Open Search
         * @param {CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchCollectionsPrescripteursGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchCollectionsPrescripteursGetCollection200Response> {
            return localVarFp.apiOpensearchCollectionsPrescripteursGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiOpensearchCollectionsClientsGetCollection operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollectionRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchCollectionsGetCollection operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter collections list by client
     * @type {Array<number>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly clientId?: Array<number>

    /**
     * Filter collections list by number
     * @type {Array<string>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly numero?: Array<string>

    /**
     * Filter collections list by prescriber ID
     * @type {Array<number>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly prescripteurId?: Array<number>

    /**
     * Filter collections list by societe ID
     * @type {Array<number>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly societeId?: Array<number>

    /**
     * Filter collections list by offer ID
     * @type {Array<number>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly offerId?: Array<number>

    /**
     * Filter list by critical flag
     * @type {boolean}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly critical?: boolean

    /**
     * Filter list by incompleteForBilling flag
     * @type {boolean}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly incompleteForBilling?: boolean

    /**
     * Filter list by only showing collections demo
     * @type {boolean}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly demo?: boolean

    /**
     * Filter collections list by statutInvoceLibelle
     * @type {Array<string>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly statutInvoceLibelle?: Array<string>

    /**
     * Filter collections list by statutQuoteLibelle
     * @type {Array<string>}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly statutQuoteLibelle?: Array<string>

    /**
     * Sort collections by numero
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly orderNumero?: string

    /**
     * Sort collections by prescriber\&#39;s name
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly orderPrescripteurLibelle?: string

    /**
     * Sort collections by offer\&#39;s name
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsGetCollection
     */
    readonly orderOffreLibelle?: string
}

/**
 * Request parameters for apiOpensearchCollectionsIdGet operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsIdGetRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsIdGetRequest {
    /**
     * CollectionDossier identifier
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiOpensearchCollectionsIndexByIdsPost operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPostRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPostRequest {
    /**
     * The new Collection Open Search resource
     * @type {CollectionOpenSearchJsonldOpensearchCollectionIndexBatch}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPost
     */
    readonly collectionOpenSearchJsonldOpensearchCollectionIndexBatch: CollectionOpenSearchJsonldOpensearchCollectionIndexBatch
}

/**
 * Request parameters for apiOpensearchCollectionsNumerosGetCollection operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollectionRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchCollectionsOffersGetCollection operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollectionRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchCollectionsPrescripteursGetCollection operation in CollectionOpenSearchApi.
 * @export
 * @interface CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollectionRequest
 */
export interface CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollection
     */
    readonly q?: string
}

/**
 * CollectionOpenSearchApi - object-oriented interface
 * @export
 * @class CollectionOpenSearchApi
 * @extends {BaseAPI}
 */
export class CollectionOpenSearchApi extends BaseAPI {
    /**
     * Lister les clients des collections indexés sur Open Search
     * @summary Lister les clients des collections indexés sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsClientsGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsClientsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsClientsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les collections indexées sur Open Search
     * @summary Lister les collections indexées sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.clientId, requestParameters.numero, requestParameters.prescripteurId, requestParameters.societeId, requestParameters.offerId, requestParameters.critical, requestParameters.incompleteForBilling, requestParameters.demo, requestParameters.statutInvoceLibelle, requestParameters.statutQuoteLibelle, requestParameters.orderNumero, requestParameters.orderPrescripteurLibelle, requestParameters.orderOffreLibelle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une collection indexée sur Open Search
     * @summary Récupérer les informations d\'une collection indexée sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsIdGet(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsIdGetRequest, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Indexer un lot de collections sur Open Search
     * @summary Indexer un lot de collections sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsIndexByIdsPost(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsIndexByIdsPostRequest, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsIndexByIdsPost(requestParameters.collectionOpenSearchJsonldOpensearchCollectionIndexBatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les numéros des collections indexés sur Open Search
     * @summary Lister les numéros des collections indexés sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsNumerosGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsNumerosGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsNumerosGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les offres des collections indexées sur Open Search
     * @summary Lister les offres des collections indexées sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsOffersGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsOffersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsOffersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les prescripteurs des collections indexées sur Open Search
     * @summary Lister les prescripteurs des collections indexées sur Open Search
     * @param {CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionOpenSearchApi
     */
    public apiOpensearchCollectionsPrescripteursGetCollection(requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsPrescripteursGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionOpenSearchApiFp(this.configuration).apiOpensearchCollectionsPrescripteursGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommunesApi - axios parameter creator
 * @export
 */
export const CommunesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Communes resource.
         * @summary Retrieves a Communes resource.
         * @param {string} insee TblCommune identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunesInseeFormatGet: async (insee: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'insee' is not null or undefined
            assertParamExists('apiCommunesInseeFormatGet', 'insee', insee)
            const localVarPath = `/formalite/communes/{insee}`
                .replace(`{${"insee"}}`, encodeURIComponent(String(insee)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunesApi - functional programming interface
 * @export
 */
export const CommunesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Communes resource.
         * @summary Retrieves a Communes resource.
         * @param {string} insee TblCommune identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunesInseeFormatGet(insee: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunesInseeFormatGet(insee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunesApi.apiCommunesInseeFormatGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunesApi - factory interface
 * @export
 */
export const CommunesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunesApiFp(configuration)
    return {
        /**
         * Retrieves a Communes resource.
         * @summary Retrieves a Communes resource.
         * @param {CommunesApiApiCommunesInseeFormatGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunesInseeFormatGet(requestParameters: CommunesApiApiCommunesInseeFormatGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCommunesInseeFormatGet(requestParameters.insee, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCommunesInseeFormatGet operation in CommunesApi.
 * @export
 * @interface CommunesApiApiCommunesInseeFormatGetRequest
 */
export interface CommunesApiApiCommunesInseeFormatGetRequest {
    /**
     * TblCommune identifier
     * @type {string}
     * @memberof CommunesApiApiCommunesInseeFormatGet
     */
    readonly insee: string
}

/**
 * CommunesApi - object-oriented interface
 * @export
 * @class CommunesApi
 * @extends {BaseAPI}
 */
export class CommunesApi extends BaseAPI {
    /**
     * Retrieves a Communes resource.
     * @summary Retrieves a Communes resource.
     * @param {CommunesApiApiCommunesInseeFormatGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunesApi
     */
    public apiCommunesInseeFormatGet(requestParameters: CommunesApiApiCommunesInseeFormatGetRequest, options?: RawAxiosRequestConfig) {
        return CommunesApiFp(this.configuration).apiCommunesInseeFormatGet(requestParameters.insee, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevisApi - axios parameter creator
 * @export
 */
export const DevisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des devis
         * @summary Obtenir la liste des devis
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisGetCollection: async (page?: number, itemsPerPage?: number, dossierNumero?: string, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/devis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (dossierId !== undefined) {
                localVarQueryParameter['dossier.id'] = dossierId;
            }

            if (dossierId2) {
                localVarQueryParameter['dossier.id[]'] = dossierId2;
            }

            if (dossierPrescripteurId !== undefined) {
                localVarQueryParameter['dossier.prescripteur.id'] = dossierPrescripteurId;
            }

            if (dossierPrescripteurId2) {
                localVarQueryParameter['dossier.prescripteur.id[]'] = dossierPrescripteurId2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un devis
         * @summary Récupérer les informations d\'un devis
         * @param {string} id TblDevis identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDevisIdGet', 'id', id)
            const localVarPath = `/formalite/devis/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des devis d\'un dossier
         * @summary Obtenir la liste des devis d\'un dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierDevisGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierDevisGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/devis`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevisApi - functional programming interface
 * @export
 */
export const DevisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevisApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des devis
         * @summary Obtenir la liste des devis
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisGetCollection(page?: number, itemsPerPage?: number, dossierNumero?: string, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDevisGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisGetCollection(page, itemsPerPage, dossierNumero, dossierId, dossierId2, dossierPrescripteurId, dossierPrescripteurId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisApi.apiDevisGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un devis
         * @summary Récupérer les informations d\'un devis
         * @param {string} id TblDevis identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevisJsonldDevisRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisApi.apiDevisIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des devis d\'un dossier
         * @summary Obtenir la liste des devis d\'un dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierDevisGetCollection(dossier: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDevisGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierDevisGetCollection(dossier, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisApi.apiDossiersDossierDevisGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevisApi - factory interface
 * @export
 */
export const DevisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevisApiFp(configuration)
    return {
        /**
         * Obtenir la liste des devis
         * @summary Obtenir la liste des devis
         * @param {DevisApiApiDevisGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisGetCollection(requestParameters: DevisApiApiDevisGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDevisGetCollection200Response> {
            return localVarFp.apiDevisGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un devis
         * @summary Récupérer les informations d\'un devis
         * @param {DevisApiApiDevisIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisIdGet(requestParameters: DevisApiApiDevisIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevisJsonldDevisRead> {
            return localVarFp.apiDevisIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des devis d\'un dossier
         * @summary Obtenir la liste des devis d\'un dossier
         * @param {DevisApiApiDossiersDossierDevisGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierDevisGetCollection(requestParameters: DevisApiApiDossiersDossierDevisGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDevisGetCollection200Response> {
            return localVarFp.apiDossiersDossierDevisGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDevisGetCollection operation in DevisApi.
 * @export
 * @interface DevisApiApiDevisGetCollectionRequest
 */
export interface DevisApiApiDevisGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {number}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly dossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly dossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly dossierPrescripteurId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisApiApiDevisGetCollection
     */
    readonly dossierPrescripteurId2?: Array<number>
}

/**
 * Request parameters for apiDevisIdGet operation in DevisApi.
 * @export
 * @interface DevisApiApiDevisIdGetRequest
 */
export interface DevisApiApiDevisIdGetRequest {
    /**
     * TblDevis identifier
     * @type {string}
     * @memberof DevisApiApiDevisIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiDossiersDossierDevisGetCollection operation in DevisApi.
 * @export
 * @interface DevisApiApiDossiersDossierDevisGetCollectionRequest
 */
export interface DevisApiApiDossiersDossierDevisGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DevisApiApiDossiersDossierDevisGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof DevisApiApiDossiersDossierDevisGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DevisApiApiDossiersDossierDevisGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * DevisApi - object-oriented interface
 * @export
 * @class DevisApi
 * @extends {BaseAPI}
 */
export class DevisApi extends BaseAPI {
    /**
     * Obtenir la liste des devis
     * @summary Obtenir la liste des devis
     * @param {DevisApiApiDevisGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisApi
     */
    public apiDevisGetCollection(requestParameters: DevisApiApiDevisGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DevisApiFp(this.configuration).apiDevisGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un devis
     * @summary Récupérer les informations d\'un devis
     * @param {DevisApiApiDevisIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisApi
     */
    public apiDevisIdGet(requestParameters: DevisApiApiDevisIdGetRequest, options?: RawAxiosRequestConfig) {
        return DevisApiFp(this.configuration).apiDevisIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des devis d\'un dossier
     * @summary Obtenir la liste des devis d\'un dossier
     * @param {DevisApiApiDossiersDossierDevisGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisApi
     */
    public apiDossiersDossierDevisGetCollection(requestParameters: DevisApiApiDossiersDossierDevisGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return DevisApiFp(this.configuration).apiDossiersDossierDevisGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentGedApi - axios parameter creator
 * @export
 */
export const DocumentGedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Document Ged resource.
         * @summary Retrieves a Document Ged resource.
         * @param {string} idDocument DocumentGed identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFileContentIdDocumentGet: async (idDocument: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiDocumentgedFileContentIdDocumentGet', 'idDocument', idDocument)
            const localVarPath = `/formalite/documentged-file-content/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the Document Ged resource.
         * @summary Removes the Document Ged resource.
         * @param {string} idDocument DocumentGed identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFileIdDocumentDelete: async (idDocument: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiDocumentgedFileIdDocumentDelete', 'idDocument', idDocument)
            const localVarPath = `/formalite/documentged-file/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Document Ged resource.
         * @summary Retrieves a Document Ged resource.
         * @param {string} idDocument DocumentGed identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFileIdDocumentGet: async (idDocument: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiDocumentgedFileIdDocumentGet', 'idDocument', idDocument)
            const localVarPath = `/formalite/documentged-file/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document Ged resource.
         * @summary Créer un document GED
         * @param {File} file 
         * @param {string} fileName 
         * @param {number} idPrescripteur 
         * @param {number} idSociete 
         * @param {string} [chemin] 
         * @param {number} [idReglement] 
         * @param {number} [idDossierFormalite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFilePost: async (file: File, fileName: string, idPrescripteur: number, idSociete: number, chemin?: string, idReglement?: number, idDossierFormalite?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiDocumentgedFilePost', 'file', file)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiDocumentgedFilePost', 'fileName', fileName)
            // verify required parameter 'idPrescripteur' is not null or undefined
            assertParamExists('apiDocumentgedFilePost', 'idPrescripteur', idPrescripteur)
            // verify required parameter 'idSociete' is not null or undefined
            assertParamExists('apiDocumentgedFilePost', 'idSociete', idSociete)
            const localVarPath = `/formalite/documentged-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (chemin !== undefined) { 
                localVarFormParams.append('chemin', chemin as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }
    
            if (idPrescripteur !== undefined) { 
                localVarFormParams.append('idPrescripteur', idPrescripteur as any);
            }
    
            if (idSociete !== undefined) { 
                localVarFormParams.append('idSociete', idSociete as any);
            }
    
            if (idReglement !== undefined) { 
                localVarFormParams.append('idReglement', idReglement as any);
            }
    
            if (idDossierFormalite !== undefined) { 
                localVarFormParams.append('idDossierFormalite', idDossierFormalite as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les documents de la ged parmis ceux autorisés et en filtrant sur l\'idPrescripteur si besoin
         * @summary Lister les documents de la ged
         * @param {string} type DocumentGed identifier
         * @param {string} applicationtag DocumentGed identifier
         * @param {Array<ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner>} [tags] Map of tags
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedTypeApplicationtagGetCollection: async (type: string, applicationtag: string, tags?: Array<ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner>, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiDocumentgedTypeApplicationtagGetCollection', 'type', type)
            // verify required parameter 'applicationtag' is not null or undefined
            assertParamExists('apiDocumentgedTypeApplicationtagGetCollection', 'applicationtag', applicationtag)
            const localVarPath = `/formalite/documentged/{type}/{applicationtag}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"applicationtag"}}`, encodeURIComponent(String(applicationtag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (tags) {
                localVarQueryParameter['tags'] = tags.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentGedApi - functional programming interface
 * @export
 */
export const DocumentGedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentGedApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Document Ged resource.
         * @summary Retrieves a Document Ged resource.
         * @param {string} idDocument DocumentGed identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentgedFileContentIdDocumentGet(idDocument: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentgedFileContentIdDocumentGet(idDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentGedApi.apiDocumentgedFileContentIdDocumentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the Document Ged resource.
         * @summary Removes the Document Ged resource.
         * @param {string} idDocument DocumentGed identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentgedFileIdDocumentDelete(idDocument: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentgedFileIdDocumentDelete(idDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentGedApi.apiDocumentgedFileIdDocumentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Document Ged resource.
         * @summary Retrieves a Document Ged resource.
         * @param {string} idDocument DocumentGed identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentgedFileIdDocumentGet(idDocument: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentGedJsonldGedDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentgedFileIdDocumentGet(idDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentGedApi.apiDocumentgedFileIdDocumentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Document Ged resource.
         * @summary Créer un document GED
         * @param {File} file 
         * @param {string} fileName 
         * @param {number} idPrescripteur 
         * @param {number} idSociete 
         * @param {string} [chemin] 
         * @param {number} [idReglement] 
         * @param {number} [idDossierFormalite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentgedFilePost(file: File, fileName: string, idPrescripteur: number, idSociete: number, chemin?: string, idReglement?: number, idDossierFormalite?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentGedJsonldGedDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentgedFilePost(file, fileName, idPrescripteur, idSociete, chemin, idReglement, idDossierFormalite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentGedApi.apiDocumentgedFilePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les documents de la ged parmis ceux autorisés et en filtrant sur l\'idPrescripteur si besoin
         * @summary Lister les documents de la ged
         * @param {string} type DocumentGed identifier
         * @param {string} applicationtag DocumentGed identifier
         * @param {Array<ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner>} [tags] Map of tags
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentgedTypeApplicationtagGetCollection(type: string, applicationtag: string, tags?: Array<ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner>, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDocumentgedTypeApplicationtagGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentgedTypeApplicationtagGetCollection(type, applicationtag, tags, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentGedApi.apiDocumentgedTypeApplicationtagGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentGedApi - factory interface
 * @export
 */
export const DocumentGedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentGedApiFp(configuration)
    return {
        /**
         * Retrieves a Document Ged resource.
         * @summary Retrieves a Document Ged resource.
         * @param {DocumentGedApiApiDocumentgedFileContentIdDocumentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFileContentIdDocumentGet(requestParameters: DocumentGedApiApiDocumentgedFileContentIdDocumentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDocumentgedFileContentIdDocumentGet(requestParameters.idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the Document Ged resource.
         * @summary Removes the Document Ged resource.
         * @param {DocumentGedApiApiDocumentgedFileIdDocumentDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFileIdDocumentDelete(requestParameters: DocumentGedApiApiDocumentgedFileIdDocumentDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDocumentgedFileIdDocumentDelete(requestParameters.idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Document Ged resource.
         * @summary Retrieves a Document Ged resource.
         * @param {DocumentGedApiApiDocumentgedFileIdDocumentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFileIdDocumentGet(requestParameters: DocumentGedApiApiDocumentgedFileIdDocumentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentGedJsonldGedDocumentRead> {
            return localVarFp.apiDocumentgedFileIdDocumentGet(requestParameters.idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document Ged resource.
         * @summary Créer un document GED
         * @param {DocumentGedApiApiDocumentgedFilePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedFilePost(requestParameters: DocumentGedApiApiDocumentgedFilePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentGedJsonldGedDocumentRead> {
            return localVarFp.apiDocumentgedFilePost(requestParameters.file, requestParameters.fileName, requestParameters.idPrescripteur, requestParameters.idSociete, requestParameters.chemin, requestParameters.idReglement, requestParameters.idDossierFormalite, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les documents de la ged parmis ceux autorisés et en filtrant sur l\'idPrescripteur si besoin
         * @summary Lister les documents de la ged
         * @param {DocumentGedApiApiDocumentgedTypeApplicationtagGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentgedTypeApplicationtagGetCollection(requestParameters: DocumentGedApiApiDocumentgedTypeApplicationtagGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDocumentgedTypeApplicationtagGetCollection200Response> {
            return localVarFp.apiDocumentgedTypeApplicationtagGetCollection(requestParameters.type, requestParameters.applicationtag, requestParameters.tags, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDocumentgedFileContentIdDocumentGet operation in DocumentGedApi.
 * @export
 * @interface DocumentGedApiApiDocumentgedFileContentIdDocumentGetRequest
 */
export interface DocumentGedApiApiDocumentgedFileContentIdDocumentGetRequest {
    /**
     * DocumentGed identifier
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedFileContentIdDocumentGet
     */
    readonly idDocument: string
}

/**
 * Request parameters for apiDocumentgedFileIdDocumentDelete operation in DocumentGedApi.
 * @export
 * @interface DocumentGedApiApiDocumentgedFileIdDocumentDeleteRequest
 */
export interface DocumentGedApiApiDocumentgedFileIdDocumentDeleteRequest {
    /**
     * DocumentGed identifier
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedFileIdDocumentDelete
     */
    readonly idDocument: string
}

/**
 * Request parameters for apiDocumentgedFileIdDocumentGet operation in DocumentGedApi.
 * @export
 * @interface DocumentGedApiApiDocumentgedFileIdDocumentGetRequest
 */
export interface DocumentGedApiApiDocumentgedFileIdDocumentGetRequest {
    /**
     * DocumentGed identifier
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedFileIdDocumentGet
     */
    readonly idDocument: string
}

/**
 * Request parameters for apiDocumentgedFilePost operation in DocumentGedApi.
 * @export
 * @interface DocumentGedApiApiDocumentgedFilePostRequest
 */
export interface DocumentGedApiApiDocumentgedFilePostRequest {
    /**
     * 
     * @type {File}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly file: File

    /**
     * 
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly fileName: string

    /**
     * 
     * @type {number}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly idPrescripteur: number

    /**
     * 
     * @type {number}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly idSociete: number

    /**
     * 
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly chemin?: string

    /**
     * 
     * @type {number}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly idReglement?: number

    /**
     * 
     * @type {number}
     * @memberof DocumentGedApiApiDocumentgedFilePost
     */
    readonly idDossierFormalite?: number
}

/**
 * Request parameters for apiDocumentgedTypeApplicationtagGetCollection operation in DocumentGedApi.
 * @export
 * @interface DocumentGedApiApiDocumentgedTypeApplicationtagGetCollectionRequest
 */
export interface DocumentGedApiApiDocumentgedTypeApplicationtagGetCollectionRequest {
    /**
     * DocumentGed identifier
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedTypeApplicationtagGetCollection
     */
    readonly type: string

    /**
     * DocumentGed identifier
     * @type {string}
     * @memberof DocumentGedApiApiDocumentgedTypeApplicationtagGetCollection
     */
    readonly applicationtag: string

    /**
     * Map of tags
     * @type {Array<ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner>}
     * @memberof DocumentGedApiApiDocumentgedTypeApplicationtagGetCollection
     */
    readonly tags?: Array<ApiDocumentgedTypeApplicationtagGetCollectionTagsParameterInner>

    /**
     * The collection page number
     * @type {number}
     * @memberof DocumentGedApiApiDocumentgedTypeApplicationtagGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DocumentGedApiApiDocumentgedTypeApplicationtagGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * DocumentGedApi - object-oriented interface
 * @export
 * @class DocumentGedApi
 * @extends {BaseAPI}
 */
export class DocumentGedApi extends BaseAPI {
    /**
     * Retrieves a Document Ged resource.
     * @summary Retrieves a Document Ged resource.
     * @param {DocumentGedApiApiDocumentgedFileContentIdDocumentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentGedApi
     */
    public apiDocumentgedFileContentIdDocumentGet(requestParameters: DocumentGedApiApiDocumentgedFileContentIdDocumentGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentGedApiFp(this.configuration).apiDocumentgedFileContentIdDocumentGet(requestParameters.idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the Document Ged resource.
     * @summary Removes the Document Ged resource.
     * @param {DocumentGedApiApiDocumentgedFileIdDocumentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentGedApi
     */
    public apiDocumentgedFileIdDocumentDelete(requestParameters: DocumentGedApiApiDocumentgedFileIdDocumentDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentGedApiFp(this.configuration).apiDocumentgedFileIdDocumentDelete(requestParameters.idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Document Ged resource.
     * @summary Retrieves a Document Ged resource.
     * @param {DocumentGedApiApiDocumentgedFileIdDocumentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentGedApi
     */
    public apiDocumentgedFileIdDocumentGet(requestParameters: DocumentGedApiApiDocumentgedFileIdDocumentGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentGedApiFp(this.configuration).apiDocumentgedFileIdDocumentGet(requestParameters.idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document Ged resource.
     * @summary Créer un document GED
     * @param {DocumentGedApiApiDocumentgedFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentGedApi
     */
    public apiDocumentgedFilePost(requestParameters: DocumentGedApiApiDocumentgedFilePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentGedApiFp(this.configuration).apiDocumentgedFilePost(requestParameters.file, requestParameters.fileName, requestParameters.idPrescripteur, requestParameters.idSociete, requestParameters.chemin, requestParameters.idReglement, requestParameters.idDossierFormalite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les documents de la ged parmis ceux autorisés et en filtrant sur l\'idPrescripteur si besoin
     * @summary Lister les documents de la ged
     * @param {DocumentGedApiApiDocumentgedTypeApplicationtagGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentGedApi
     */
    public apiDocumentgedTypeApplicationtagGetCollection(requestParameters: DocumentGedApiApiDocumentgedTypeApplicationtagGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return DocumentGedApiFp(this.configuration).apiDocumentgedTypeApplicationtagGetCollection(requestParameters.type, requestParameters.applicationtag, requestParameters.tags, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DomainesApi - axios parameter creator
 * @export
 */
export const DomainesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer la liste des domaines
         * @summary Récupérer la liste des domaines
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/domaines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un domaine
         * @summary Récupérer les informations d\'un domaine
         * @param {string} id TblDefDomaine identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDomainesIdGet', 'id', id)
            const localVarPath = `/formalite/domaines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DomainesApi - functional programming interface
 * @export
 */
export const DomainesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DomainesApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer la liste des domaines
         * @summary Récupérer la liste des domaines
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDomainesGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDomainesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDomainesGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainesApi.apiDomainesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un domaine
         * @summary Récupérer les informations d\'un domaine
         * @param {string} id TblDefDomaine identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDomainesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainesJsonldDomaineRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDomainesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainesApi.apiDomainesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DomainesApi - factory interface
 * @export
 */
export const DomainesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DomainesApiFp(configuration)
    return {
        /**
         * Récupérer la liste des domaines
         * @summary Récupérer la liste des domaines
         * @param {DomainesApiApiDomainesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesGetCollection(requestParameters: DomainesApiApiDomainesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDomainesGetCollection200Response> {
            return localVarFp.apiDomainesGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un domaine
         * @summary Récupérer les informations d\'un domaine
         * @param {DomainesApiApiDomainesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesIdGet(requestParameters: DomainesApiApiDomainesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DomainesJsonldDomaineRead> {
            return localVarFp.apiDomainesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDomainesGetCollection operation in DomainesApi.
 * @export
 * @interface DomainesApiApiDomainesGetCollectionRequest
 */
export interface DomainesApiApiDomainesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DomainesApiApiDomainesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DomainesApiApiDomainesGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiDomainesIdGet operation in DomainesApi.
 * @export
 * @interface DomainesApiApiDomainesIdGetRequest
 */
export interface DomainesApiApiDomainesIdGetRequest {
    /**
     * TblDefDomaine identifier
     * @type {string}
     * @memberof DomainesApiApiDomainesIdGet
     */
    readonly id: string
}

/**
 * DomainesApi - object-oriented interface
 * @export
 * @class DomainesApi
 * @extends {BaseAPI}
 */
export class DomainesApi extends BaseAPI {
    /**
     * Récupérer la liste des domaines
     * @summary Récupérer la liste des domaines
     * @param {DomainesApiApiDomainesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainesApi
     */
    public apiDomainesGetCollection(requestParameters: DomainesApiApiDomainesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DomainesApiFp(this.configuration).apiDomainesGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un domaine
     * @summary Récupérer les informations d\'un domaine
     * @param {DomainesApiApiDomainesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainesApi
     */
    public apiDomainesIdGet(requestParameters: DomainesApiApiDomainesIdGetRequest, options?: RawAxiosRequestConfig) {
        return DomainesApiFp(this.configuration).apiDomainesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DossierApi - axios parameter creator
 * @export
 */
export const DossierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dateCreationBefore] 
         * @param {string} [dateCreationStrictlyBefore] 
         * @param {string} [dateCreationAfter] 
         * @param {string} [dateCreationStrictlyAfter] 
         * @param {string} [numero] 
         * @param {string} [societeDenomination] 
         * @param {string} [societeSiren] 
         * @param {string} [affaire] 
         * @param {number} [idDematfacile] 
         * @param {number} [statutId] 
         * @param {Array<number>} [statutId2] 
         * @param {number} [prestationsFormaliteId] 
         * @param {Array<number>} [prestationsFormaliteId2] 
         * @param {number} [collectionId] 
         * @param {Array<number>} [collectionId2] 
         * @param {ApiDossiersGetCollectionOrderNumeroEnum} [orderNumero] 
         * @param {ApiDossiersGetCollectionOrderSocieteDenominationEnum} [orderSocieteDenomination] 
         * @param {ApiDossiersGetCollectionOrderContactNomEnum} [orderContactNom] 
         * @param {ApiDossiersGetCollectionOrderDateCreationEnum} [orderDateCreation] 
         * @param {ApiDossiersGetCollectionOrderStatutLibelleEnum} [orderStatutLibelle] 
         * @param {ApiDossiersGetCollectionOrderFormalisteNomEnum} [orderFormalisteNom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersGetCollection: async (page?: number, itemsPerPage?: number, dateCreationBefore?: string, dateCreationStrictlyBefore?: string, dateCreationAfter?: string, dateCreationStrictlyAfter?: string, numero?: string, societeDenomination?: string, societeSiren?: string, affaire?: string, idDematfacile?: number, statutId?: number, statutId2?: Array<number>, prestationsFormaliteId?: number, prestationsFormaliteId2?: Array<number>, collectionId?: number, collectionId2?: Array<number>, orderNumero?: ApiDossiersGetCollectionOrderNumeroEnum, orderSocieteDenomination?: ApiDossiersGetCollectionOrderSocieteDenominationEnum, orderContactNom?: ApiDossiersGetCollectionOrderContactNomEnum, orderDateCreation?: ApiDossiersGetCollectionOrderDateCreationEnum, orderStatutLibelle?: ApiDossiersGetCollectionOrderStatutLibelleEnum, orderFormalisteNom?: ApiDossiersGetCollectionOrderFormalisteNomEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dateCreationBefore !== undefined) {
                localVarQueryParameter['dateCreation[before]'] = dateCreationBefore;
            }

            if (dateCreationStrictlyBefore !== undefined) {
                localVarQueryParameter['dateCreation[strictly_before]'] = dateCreationStrictlyBefore;
            }

            if (dateCreationAfter !== undefined) {
                localVarQueryParameter['dateCreation[after]'] = dateCreationAfter;
            }

            if (dateCreationStrictlyAfter !== undefined) {
                localVarQueryParameter['dateCreation[strictly_after]'] = dateCreationStrictlyAfter;
            }

            if (numero !== undefined) {
                localVarQueryParameter['numero'] = numero;
            }

            if (societeDenomination !== undefined) {
                localVarQueryParameter['societeDenomination'] = societeDenomination;
            }

            if (societeSiren !== undefined) {
                localVarQueryParameter['societeSiren'] = societeSiren;
            }

            if (affaire !== undefined) {
                localVarQueryParameter['affaire'] = affaire;
            }

            if (idDematfacile !== undefined) {
                localVarQueryParameter['idDematfacile'] = idDematfacile;
            }

            if (statutId !== undefined) {
                localVarQueryParameter['statut.id'] = statutId;
            }

            if (statutId2) {
                localVarQueryParameter['statut.id[]'] = statutId2;
            }

            if (prestationsFormaliteId !== undefined) {
                localVarQueryParameter['prestations.formalite.id'] = prestationsFormaliteId;
            }

            if (prestationsFormaliteId2) {
                localVarQueryParameter['prestations.formalite.id[]'] = prestationsFormaliteId2;
            }

            if (collectionId !== undefined) {
                localVarQueryParameter['collection.id'] = collectionId;
            }

            if (collectionId2) {
                localVarQueryParameter['collection.id[]'] = collectionId2;
            }

            if (orderNumero !== undefined) {
                localVarQueryParameter['order[numero]'] = orderNumero;
            }

            if (orderSocieteDenomination !== undefined) {
                localVarQueryParameter['order[societeDenomination]'] = orderSocieteDenomination;
            }

            if (orderContactNom !== undefined) {
                localVarQueryParameter['order[contact.nom]'] = orderContactNom;
            }

            if (orderDateCreation !== undefined) {
                localVarQueryParameter['order[dateCreation]'] = orderDateCreation;
            }

            if (orderStatutLibelle !== undefined) {
                localVarQueryParameter['order[statut.libelle]'] = orderStatutLibelle;
            }

            if (orderFormalisteNom !== undefined) {
                localVarQueryParameter['order[formaliste.nom]'] = orderFormalisteNom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour une collection de dossier
         * @summary Mettre à jour une collection de dossier
         * @param {DossierDossiersGroupesPatchRequestDto} dossierDossiersGroupesPatchRequestDto The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersGroupesPatch: async (dossierDossiersGroupesPatchRequestDto: DossierDossiersGroupesPatchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierDossiersGroupesPatchRequestDto' is not null or undefined
            assertParamExists('apiDossiersGroupesPatch', 'dossierDossiersGroupesPatchRequestDto', dossierDossiersGroupesPatchRequestDto)
            const localVarPath = `/formalite/dossiers/groupes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierDossiersGroupesPatchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Déclencher une action pour mettre à jour le statut d\'un dossier
         * @summary Déclencher une action pour mettre à jour le statut d\'un dossier
         * @param {number} id L\&#39;identifiant du dossier
         * @param {ApiDossiersIdActionPutActionEnum} action L\&#39;action à déclencher
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdActionPut: async (id: number, action: ApiDossiersIdActionPutActionEnum, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdActionPut', 'id', id)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('apiDossiersIdActionPut', 'action', action)
            const localVarPath = `/formalite/dossiers/{id}/{action}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les annonces légales d\'un dossier
         * @summary Récupérer les annonces légales d\'un dossier
         * @param {number} id ID du dossier de formalité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdAnnonceLegaleGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdAnnonceLegaleGet', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/annonce-legale`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour les articles d\'une collection de dossier
         * @summary Mettre à jour les articles d\'une collection de dossier
         * @param {string} id FproDossier identifier
         * @param {DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle} dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdArticlesPatch: async (id: string, dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle: DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdArticlesPatch', 'id', id)
            // verify required parameter 'dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle' is not null or undefined
            assertParamExists('apiDossiersIdArticlesPatch', 'dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle', dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle)
            const localVarPath = `/formalite/dossiers/{id}/articles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un dossier
         * @summary Supprimer un dossier
         * @param {string} id FproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdDelete', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pousse toutes les pièces jointes non envoyées vers Dematfacile pour le dossier donné.
         * @summary Pousser les pièces jointes du dossier vers Dematfacile
         * @param {number} id Identifiant du dossier
         * @param {DossierJsonld} dossierJsonld The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDematFacileDocumentsPut: async (id: number, dossierJsonld: DossierJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdDematFacileDocumentsPut', 'id', id)
            // verify required parameter 'dossierJsonld' is not null or undefined
            assertParamExists('apiDossiersIdDematFacileDocumentsPut', 'dossierJsonld', dossierJsonld)
            const localVarPath = `/formalite/dossiers/{id}/demat-facile/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer le client et le dossier dematfacile
         * @summary Créer le client et le dossier dematfacile
         * @param {number} id L\&#39;identifiant du dossier
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDematFacilePut: async (id: number, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdDematFacilePut', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/demat-facile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Déplacer une ou des formalités dans un autre dossier de la collection
         * @summary Déplacer une ou des formalités dans un autre dossier de la collection
         * @param {string} id FproDossier identifier
         * @param {ApiDossiersIdDeplacerPatchRequest} [apiDossiersIdDeplacerPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDeplacerPatch: async (id: string, apiDossiersIdDeplacerPatchRequest?: ApiDossiersIdDeplacerPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdDeplacerPatch', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/deplacer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDossiersIdDeplacerPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dissocier un dossier
         * @summary Dissocier un dossier
         * @param {string} id FproDossier identifier
         * @param {ApiDossiersIdDissocierPatchRequest} [apiDossiersIdDissocierPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDissocierPatch: async (id: string, apiDossiersIdDissocierPatchRequest?: ApiDossiersIdDissocierPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdDissocierPatch', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/dissocier`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDossiersIdDissocierPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the Dossier resource.
         * @summary supprimer les fichiers d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdFichiersDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdFichiersDelete', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/fichiers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the Dossier resource.
         * @summary Supprimer une formalité d\'un dossier
         * @param {number} id Identifiant du dossier
         * @param {number} formalityId Identifiant de la formalité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdFormalityFormalityIdDelete: async (id: number, formalityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdFormalityFormalityIdDelete', 'id', id)
            // verify required parameter 'formalityId' is not null or undefined
            assertParamExists('apiDossiersIdFormalityFormalityIdDelete', 'formalityId', formalityId)
            const localVarPath = `/formalite/dossiers/{id}/formality/{formalityId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"formalityId"}}`, encodeURIComponent(String(formalityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un dossier
         * @summary Récupérer les informations d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdGet', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer la liste des notes associées à un dossier de formalité avec possibilité de filtrage et pagination
         * @summary Récupérer les notes d\'un dossier de formalité
         * @param {number} id ID du dossier de formalité
         * @param {boolean} [highlighted] Filtrer par notes importantes uniquement
         * @param {boolean} [memoClient] Filtrer par notes mémo client uniquement
         * @param {ApiDossiersIdNotesGetSortEnum} [sort] Champ de tri (défaut: createdAt)
         * @param {ApiDossiersIdNotesGetOrderEnum} [order] Ordre de tri (défaut: DESC)
         * @param {number} [page] Numéro de page (défaut: 1)
         * @param {number} [limit] Nombre d\&#39;éléments par page (défaut: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesGet: async (id: number, highlighted?: boolean, memoClient?: boolean, sort?: ApiDossiersIdNotesGetSortEnum, order?: ApiDossiersIdNotesGetOrderEnum, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdNotesGet', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (highlighted !== undefined) {
                localVarQueryParameter['highlighted'] = highlighted;
            }

            if (memoClient !== undefined) {
                localVarQueryParameter['memoClient'] = memoClient;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer définitivement une note d\'un dossier
         * @summary Supprimer une note d\'un dossier de formalité
         * @param {number} id ID du dossier
         * @param {number} noteId ID de la note à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesNoteIdDelete: async (id: number, noteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdNotesNoteIdDelete', 'id', id)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiDossiersIdNotesNoteIdDelete', 'noteId', noteId)
            const localVarPath = `/formalite/dossiers/{id}/notes/{noteId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifier le contenu et/ou le statut important d\'une note
         * @summary Modifier une note d\'un dossier de formalité
         * @param {number} id ID du dossier
         * @param {number} noteId ID de la note à modifier
         * @param {ApiDossiersIdNotesPostRequest} [apiDossiersIdNotesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesNoteIdPut: async (id: number, noteId: number, apiDossiersIdNotesPostRequest?: ApiDossiersIdNotesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdNotesNoteIdPut', 'id', id)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiDossiersIdNotesNoteIdPut', 'noteId', noteId)
            const localVarPath = `/formalite/dossiers/{id}/notes/{noteId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDossiersIdNotesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer une note pour un dossier de formalité
         * @summary Créer une note pour un dossier de formalité
         * @param {string} id FproDossier identifier
         * @param {ApiDossiersIdNotesPostRequest} [apiDossiersIdNotesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesPost: async (id: string, apiDossiersIdNotesPostRequest?: ApiDossiersIdNotesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdNotesPost', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDossiersIdNotesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour les informations d\'un dossier
         * @summary Mettre à jour les informations d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {DossierDossierUpdatePartial} dossierDossierUpdatePartial The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdPatch: async (id: string, dossierDossierUpdatePartial: DossierDossierUpdatePartial, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdPatch', 'id', id)
            // verify required parameter 'dossierDossierUpdatePartial' is not null or undefined
            assertParamExists('apiDossiersIdPatch', 'dossierDossierUpdatePartial', dossierDossierUpdatePartial)
            const localVarPath = `/formalite/dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierDossierUpdatePartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour les informations d\'un dossier
         * @summary Mettre à jour les informations d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {DossierJsonldDossierUpdate} dossierJsonldDossierUpdate The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdPut: async (id: string, dossierJsonldDossierUpdate: DossierJsonldDossierUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdPut', 'id', id)
            // verify required parameter 'dossierJsonldDossierUpdate' is not null or undefined
            assertParamExists('apiDossiersIdPut', 'dossierJsonldDossierUpdate', dossierJsonldDossierUpdate)
            const localVarPath = `/formalite/dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierJsonldDossierUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les actions possibles pour un dossier
         * @summary Lister les actions possibles pour un dossier
         * @param {number} id L\&#39;identifiant du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdTransitionsGetCollection: async (id: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersIdTransitionsGetCollection', 'id', id)
            const localVarPath = `/formalite/dossiers/{id}/transitions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un dossier
         * @summary Créer un dossier
         * @param {DossierJsonldDossierCreate} dossierJsonldDossierCreate The new Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersPost: async (dossierJsonldDossierCreate: DossierJsonldDossierCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierJsonldDossierCreate' is not null or undefined
            assertParamExists('apiDossiersPost', 'dossierJsonldDossierCreate', dossierJsonldDossierCreate)
            const localVarPath = `/formalite/dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierJsonldDossierCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossierApi - functional programming interface
 * @export
 */
export const DossierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossierApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dateCreationBefore] 
         * @param {string} [dateCreationStrictlyBefore] 
         * @param {string} [dateCreationAfter] 
         * @param {string} [dateCreationStrictlyAfter] 
         * @param {string} [numero] 
         * @param {string} [societeDenomination] 
         * @param {string} [societeSiren] 
         * @param {string} [affaire] 
         * @param {number} [idDematfacile] 
         * @param {number} [statutId] 
         * @param {Array<number>} [statutId2] 
         * @param {number} [prestationsFormaliteId] 
         * @param {Array<number>} [prestationsFormaliteId2] 
         * @param {number} [collectionId] 
         * @param {Array<number>} [collectionId2] 
         * @param {ApiDossiersGetCollectionOrderNumeroEnum} [orderNumero] 
         * @param {ApiDossiersGetCollectionOrderSocieteDenominationEnum} [orderSocieteDenomination] 
         * @param {ApiDossiersGetCollectionOrderContactNomEnum} [orderContactNom] 
         * @param {ApiDossiersGetCollectionOrderDateCreationEnum} [orderDateCreation] 
         * @param {ApiDossiersGetCollectionOrderStatutLibelleEnum} [orderStatutLibelle] 
         * @param {ApiDossiersGetCollectionOrderFormalisteNomEnum} [orderFormalisteNom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersGetCollection(page?: number, itemsPerPage?: number, dateCreationBefore?: string, dateCreationStrictlyBefore?: string, dateCreationAfter?: string, dateCreationStrictlyAfter?: string, numero?: string, societeDenomination?: string, societeSiren?: string, affaire?: string, idDematfacile?: number, statutId?: number, statutId2?: Array<number>, prestationsFormaliteId?: number, prestationsFormaliteId2?: Array<number>, collectionId?: number, collectionId2?: Array<number>, orderNumero?: ApiDossiersGetCollectionOrderNumeroEnum, orderSocieteDenomination?: ApiDossiersGetCollectionOrderSocieteDenominationEnum, orderContactNom?: ApiDossiersGetCollectionOrderContactNomEnum, orderDateCreation?: ApiDossiersGetCollectionOrderDateCreationEnum, orderStatutLibelle?: ApiDossiersGetCollectionOrderStatutLibelleEnum, orderFormalisteNom?: ApiDossiersGetCollectionOrderFormalisteNomEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersGetCollection(page, itemsPerPage, dateCreationBefore, dateCreationStrictlyBefore, dateCreationAfter, dateCreationStrictlyAfter, numero, societeDenomination, societeSiren, affaire, idDematfacile, statutId, statutId2, prestationsFormaliteId, prestationsFormaliteId2, collectionId, collectionId2, orderNumero, orderSocieteDenomination, orderContactNom, orderDateCreation, orderStatutLibelle, orderFormalisteNom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour une collection de dossier
         * @summary Mettre à jour une collection de dossier
         * @param {DossierDossiersGroupesPatchRequestDto} dossierDossiersGroupesPatchRequestDto The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersGroupesPatch(dossierDossiersGroupesPatchRequestDto: DossierDossiersGroupesPatchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersGroupesPatch(dossierDossiersGroupesPatchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersGroupesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Déclencher une action pour mettre à jour le statut d\'un dossier
         * @summary Déclencher une action pour mettre à jour le statut d\'un dossier
         * @param {number} id L\&#39;identifiant du dossier
         * @param {ApiDossiersIdActionPutActionEnum} action L\&#39;action à déclencher
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdActionPut(id: number, action: ApiDossiersIdActionPutActionEnum, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdActionPut(id, action, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdActionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les annonces légales d\'un dossier
         * @summary Récupérer les annonces légales d\'un dossier
         * @param {number} id ID du dossier de formalité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdAnnonceLegaleGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldValidatorsAlProcessRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdAnnonceLegaleGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdAnnonceLegaleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour les articles d\'une collection de dossier
         * @summary Mettre à jour les articles d\'une collection de dossier
         * @param {string} id FproDossier identifier
         * @param {DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle} dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdArticlesPatch(id: string, dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle: DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdArticlesPatch(id, dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdArticlesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un dossier
         * @summary Supprimer un dossier
         * @param {string} id FproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pousse toutes les pièces jointes non envoyées vers Dematfacile pour le dossier donné.
         * @summary Pousser les pièces jointes du dossier vers Dematfacile
         * @param {number} id Identifiant du dossier
         * @param {DossierJsonld} dossierJsonld The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdDematFacileDocumentsPut(id: number, dossierJsonld: DossierJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersIdDematFacileDocumentsPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdDematFacileDocumentsPut(id, dossierJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdDematFacileDocumentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer le client et le dossier dematfacile
         * @summary Créer le client et le dossier dematfacile
         * @param {number} id L\&#39;identifiant du dossier
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdDematFacilePut(id: number, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdDematFacilePut(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdDematFacilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Déplacer une ou des formalités dans un autre dossier de la collection
         * @summary Déplacer une ou des formalités dans un autre dossier de la collection
         * @param {string} id FproDossier identifier
         * @param {ApiDossiersIdDeplacerPatchRequest} [apiDossiersIdDeplacerPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdDeplacerPatch(id: string, apiDossiersIdDeplacerPatchRequest?: ApiDossiersIdDeplacerPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdDeplacerPatch(id, apiDossiersIdDeplacerPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdDeplacerPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dissocier un dossier
         * @summary Dissocier un dossier
         * @param {string} id FproDossier identifier
         * @param {ApiDossiersIdDissocierPatchRequest} [apiDossiersIdDissocierPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdDissocierPatch(id: string, apiDossiersIdDissocierPatchRequest?: ApiDossiersIdDissocierPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdDissocierPatch(id, apiDossiersIdDissocierPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdDissocierPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the Dossier resource.
         * @summary supprimer les fichiers d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdFichiersDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdFichiersDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdFichiersDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the Dossier resource.
         * @summary Supprimer une formalité d\'un dossier
         * @param {number} id Identifiant du dossier
         * @param {number} formalityId Identifiant de la formalité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdFormalityFormalityIdDelete(id: number, formalityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdFormalityFormalityIdDelete(id, formalityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdFormalityFormalityIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un dossier
         * @summary Récupérer les informations d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer la liste des notes associées à un dossier de formalité avec possibilité de filtrage et pagination
         * @summary Récupérer les notes d\'un dossier de formalité
         * @param {number} id ID du dossier de formalité
         * @param {boolean} [highlighted] Filtrer par notes importantes uniquement
         * @param {boolean} [memoClient] Filtrer par notes mémo client uniquement
         * @param {ApiDossiersIdNotesGetSortEnum} [sort] Champ de tri (défaut: createdAt)
         * @param {ApiDossiersIdNotesGetOrderEnum} [order] Ordre de tri (défaut: DESC)
         * @param {number} [page] Numéro de page (défaut: 1)
         * @param {number} [limit] Nombre d\&#39;éléments par page (défaut: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdNotesGet(id: number, highlighted?: boolean, memoClient?: boolean, sort?: ApiDossiersIdNotesGetSortEnum, order?: ApiDossiersIdNotesGetOrderEnum, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersIdNotesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdNotesGet(id, highlighted, memoClient, sort, order, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer définitivement une note d\'un dossier
         * @summary Supprimer une note d\'un dossier de formalité
         * @param {number} id ID du dossier
         * @param {number} noteId ID de la note à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdNotesNoteIdDelete(id: number, noteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdNotesNoteIdDelete(id, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdNotesNoteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifier le contenu et/ou le statut important d\'une note
         * @summary Modifier une note d\'un dossier de formalité
         * @param {number} id ID du dossier
         * @param {number} noteId ID de la note à modifier
         * @param {ApiDossiersIdNotesPostRequest} [apiDossiersIdNotesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdNotesNoteIdPut(id: number, noteId: number, apiDossiersIdNotesPostRequest?: ApiDossiersIdNotesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersIdNotesNoteIdPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdNotesNoteIdPut(id, noteId, apiDossiersIdNotesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdNotesNoteIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer une note pour un dossier de formalité
         * @summary Créer une note pour un dossier de formalité
         * @param {string} id FproDossier identifier
         * @param {ApiDossiersIdNotesPostRequest} [apiDossiersIdNotesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdNotesPost(id: string, apiDossiersIdNotesPostRequest?: ApiDossiersIdNotesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdNotesPost(id, apiDossiersIdNotesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour les informations d\'un dossier
         * @summary Mettre à jour les informations d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {DossierDossierUpdatePartial} dossierDossierUpdatePartial The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdPatch(id: string, dossierDossierUpdatePartial: DossierDossierUpdatePartial, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdPatch(id, dossierDossierUpdatePartial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour les informations d\'un dossier
         * @summary Mettre à jour les informations d\'un dossier
         * @param {string} id FproDossier identifier
         * @param {DossierJsonldDossierUpdate} dossierJsonldDossierUpdate The updated Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdPut(id: string, dossierJsonldDossierUpdate: DossierJsonldDossierUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdPut(id, dossierJsonldDossierUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les actions possibles pour un dossier
         * @summary Lister les actions possibles pour un dossier
         * @param {number} id L\&#39;identifiant du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersIdTransitionsGetCollection(id: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersIdTransitionsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersIdTransitionsGetCollection(id, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersIdTransitionsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un dossier
         * @summary Créer un dossier
         * @param {DossierJsonldDossierCreate} dossierJsonldDossierCreate The new Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersPost(dossierJsonldDossierCreate: DossierJsonldDossierCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersPost(dossierJsonldDossierCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierApi.apiDossiersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DossierApi - factory interface
 * @export
 */
export const DossierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossierApiFp(configuration)
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {DossierApiApiDossiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersGetCollection(requestParameters: DossierApiApiDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersGetCollection200Response> {
            return localVarFp.apiDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dateCreationBefore, requestParameters.dateCreationStrictlyBefore, requestParameters.dateCreationAfter, requestParameters.dateCreationStrictlyAfter, requestParameters.numero, requestParameters.societeDenomination, requestParameters.societeSiren, requestParameters.affaire, requestParameters.idDematfacile, requestParameters.statutId, requestParameters.statutId2, requestParameters.prestationsFormaliteId, requestParameters.prestationsFormaliteId2, requestParameters.collectionId, requestParameters.collectionId2, requestParameters.orderNumero, requestParameters.orderSocieteDenomination, requestParameters.orderContactNom, requestParameters.orderDateCreation, requestParameters.orderStatutLibelle, requestParameters.orderFormalisteNom, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour une collection de dossier
         * @summary Mettre à jour une collection de dossier
         * @param {DossierApiApiDossiersGroupesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersGroupesPatch(requestParameters: DossierApiApiDossiersGroupesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierDossiersGroupesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersGroupesPatch(requestParameters.dossierDossiersGroupesPatchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Déclencher une action pour mettre à jour le statut d\'un dossier
         * @summary Déclencher une action pour mettre à jour le statut d\'un dossier
         * @param {DossierApiApiDossiersIdActionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdActionPut(requestParameters: DossierApiApiDossiersIdActionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdActionPut(requestParameters.id, requestParameters.action, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les annonces légales d\'un dossier
         * @summary Récupérer les annonces légales d\'un dossier
         * @param {DossierApiApiDossiersIdAnnonceLegaleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdAnnonceLegaleGet(requestParameters: DossierApiApiDossiersIdAnnonceLegaleGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldValidatorsAlProcessRead> {
            return localVarFp.apiDossiersIdAnnonceLegaleGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour les articles d\'une collection de dossier
         * @summary Mettre à jour les articles d\'une collection de dossier
         * @param {DossierApiApiDossiersIdArticlesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdArticlesPatch(requestParameters: DossierApiApiDossiersIdArticlesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdArticlesPatch(requestParameters.id, requestParameters.dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un dossier
         * @summary Supprimer un dossier
         * @param {DossierApiApiDossiersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDelete(requestParameters: DossierApiApiDossiersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDossiersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Pousse toutes les pièces jointes non envoyées vers Dematfacile pour le dossier donné.
         * @summary Pousser les pièces jointes du dossier vers Dematfacile
         * @param {DossierApiApiDossiersIdDematFacileDocumentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDematFacileDocumentsPut(requestParameters: DossierApiApiDossiersIdDematFacileDocumentsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersIdDematFacileDocumentsPut200Response> {
            return localVarFp.apiDossiersIdDematFacileDocumentsPut(requestParameters.id, requestParameters.dossierJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer le client et le dossier dematfacile
         * @summary Créer le client et le dossier dematfacile
         * @param {DossierApiApiDossiersIdDematFacilePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDematFacilePut(requestParameters: DossierApiApiDossiersIdDematFacilePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdDematFacilePut(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Déplacer une ou des formalités dans un autre dossier de la collection
         * @summary Déplacer une ou des formalités dans un autre dossier de la collection
         * @param {DossierApiApiDossiersIdDeplacerPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDeplacerPatch(requestParameters: DossierApiApiDossiersIdDeplacerPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdDeplacerPatch(requestParameters.id, requestParameters.apiDossiersIdDeplacerPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Dissocier un dossier
         * @summary Dissocier un dossier
         * @param {DossierApiApiDossiersIdDissocierPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdDissocierPatch(requestParameters: DossierApiApiDossiersIdDissocierPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdDissocierPatch(requestParameters.id, requestParameters.apiDossiersIdDissocierPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the Dossier resource.
         * @summary supprimer les fichiers d\'un dossier
         * @param {DossierApiApiDossiersIdFichiersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdFichiersDelete(requestParameters: DossierApiApiDossiersIdFichiersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDossiersIdFichiersDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the Dossier resource.
         * @summary Supprimer une formalité d\'un dossier
         * @param {DossierApiApiDossiersIdFormalityFormalityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdFormalityFormalityIdDelete(requestParameters: DossierApiApiDossiersIdFormalityFormalityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDossiersIdFormalityFormalityIdDelete(requestParameters.id, requestParameters.formalityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un dossier
         * @summary Récupérer les informations d\'un dossier
         * @param {DossierApiApiDossiersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdGet(requestParameters: DossierApiApiDossiersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer la liste des notes associées à un dossier de formalité avec possibilité de filtrage et pagination
         * @summary Récupérer les notes d\'un dossier de formalité
         * @param {DossierApiApiDossiersIdNotesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesGet(requestParameters: DossierApiApiDossiersIdNotesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersIdNotesGet200Response> {
            return localVarFp.apiDossiersIdNotesGet(requestParameters.id, requestParameters.highlighted, requestParameters.memoClient, requestParameters.sort, requestParameters.order, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer définitivement une note d\'un dossier
         * @summary Supprimer une note d\'un dossier de formalité
         * @param {DossierApiApiDossiersIdNotesNoteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesNoteIdDelete(requestParameters: DossierApiApiDossiersIdNotesNoteIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDossiersIdNotesNoteIdDelete(requestParameters.id, requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifier le contenu et/ou le statut important d\'une note
         * @summary Modifier une note d\'un dossier de formalité
         * @param {DossierApiApiDossiersIdNotesNoteIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesNoteIdPut(requestParameters: DossierApiApiDossiersIdNotesNoteIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersIdNotesNoteIdPut200Response> {
            return localVarFp.apiDossiersIdNotesNoteIdPut(requestParameters.id, requestParameters.noteId, requestParameters.apiDossiersIdNotesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer une note pour un dossier de formalité
         * @summary Créer une note pour un dossier de formalité
         * @param {DossierApiApiDossiersIdNotesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdNotesPost(requestParameters: DossierApiApiDossiersIdNotesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonld> {
            return localVarFp.apiDossiersIdNotesPost(requestParameters.id, requestParameters.apiDossiersIdNotesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour les informations d\'un dossier
         * @summary Mettre à jour les informations d\'un dossier
         * @param {DossierApiApiDossiersIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdPatch(requestParameters: DossierApiApiDossiersIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdPatch(requestParameters.id, requestParameters.dossierDossierUpdatePartial, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour les informations d\'un dossier
         * @summary Mettre à jour les informations d\'un dossier
         * @param {DossierApiApiDossiersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdPut(requestParameters: DossierApiApiDossiersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersIdPut(requestParameters.id, requestParameters.dossierJsonldDossierUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les actions possibles pour un dossier
         * @summary Lister les actions possibles pour un dossier
         * @param {DossierApiApiDossiersIdTransitionsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersIdTransitionsGetCollection(requestParameters: DossierApiApiDossiersIdTransitionsGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersIdTransitionsGetCollection200Response> {
            return localVarFp.apiDossiersIdTransitionsGetCollection(requestParameters.id, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un dossier
         * @summary Créer un dossier
         * @param {DossierApiApiDossiersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersPost(requestParameters: DossierApiApiDossiersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> {
            return localVarFp.apiDossiersPost(requestParameters.dossierJsonldDossierCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersGetCollection operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersGetCollectionRequest
 */
export interface DossierApiApiDossiersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly dateCreationBefore?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly dateCreationStrictlyBefore?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly dateCreationAfter?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly dateCreationStrictlyAfter?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly numero?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly societeDenomination?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly societeSiren?: string

    /**
     * 
     * @type {string}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly affaire?: string

    /**
     * 
     * @type {number}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly idDematfacile?: number

    /**
     * 
     * @type {number}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly statutId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly statutId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly prestationsFormaliteId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly prestationsFormaliteId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly collectionId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly collectionId2?: Array<number>

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly orderNumero?: ApiDossiersGetCollectionOrderNumeroEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly orderSocieteDenomination?: ApiDossiersGetCollectionOrderSocieteDenominationEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly orderContactNom?: ApiDossiersGetCollectionOrderContactNomEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly orderDateCreation?: ApiDossiersGetCollectionOrderDateCreationEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly orderStatutLibelle?: ApiDossiersGetCollectionOrderStatutLibelleEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DossierApiApiDossiersGetCollection
     */
    readonly orderFormalisteNom?: ApiDossiersGetCollectionOrderFormalisteNomEnum
}

/**
 * Request parameters for apiDossiersGroupesPatch operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersGroupesPatchRequest
 */
export interface DossierApiApiDossiersGroupesPatchRequest {
    /**
     * The updated Dossier resource
     * @type {DossierDossiersGroupesPatchRequestDto}
     * @memberof DossierApiApiDossiersGroupesPatch
     */
    readonly dossierDossiersGroupesPatchRequestDto: DossierDossiersGroupesPatchRequestDto
}

/**
 * Request parameters for apiDossiersIdActionPut operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdActionPutRequest
 */
export interface DossierApiApiDossiersIdActionPutRequest {
    /**
     * L\&#39;identifiant du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdActionPut
     */
    readonly id: number

    /**
     * L\&#39;action à déclencher
     * @type {'validate' | 'cancel' | 'suspend' | 'unsuspend' | 'reject' | 'relance' | 'regulate' | 'send-to-validators' | 'process-regulation' | 'invoice' | 'paid' | 'archive' | 'to-check' | 'checked' | 'ready-to-drop-off'}
     * @memberof DossierApiApiDossiersIdActionPut
     */
    readonly action: ApiDossiersIdActionPutActionEnum

    /**
     * 
     * @type {object}
     * @memberof DossierApiApiDossiersIdActionPut
     */
    readonly body?: object
}

/**
 * Request parameters for apiDossiersIdAnnonceLegaleGet operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdAnnonceLegaleGetRequest
 */
export interface DossierApiApiDossiersIdAnnonceLegaleGetRequest {
    /**
     * ID du dossier de formalité
     * @type {number}
     * @memberof DossierApiApiDossiersIdAnnonceLegaleGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDossiersIdArticlesPatch operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdArticlesPatchRequest
 */
export interface DossierApiApiDossiersIdArticlesPatchRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdArticlesPatch
     */
    readonly id: string

    /**
     * The updated Dossier resource
     * @type {DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle}
     * @memberof DossierApiApiDossiersIdArticlesPatch
     */
    readonly dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle: DossierDossiersArticlesPatchRequestDtoDossierUpdateArticle
}

/**
 * Request parameters for apiDossiersIdDelete operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdDeleteRequest
 */
export interface DossierApiApiDossiersIdDeleteRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiDossiersIdDematFacileDocumentsPut operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdDematFacileDocumentsPutRequest
 */
export interface DossierApiApiDossiersIdDematFacileDocumentsPutRequest {
    /**
     * Identifiant du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdDematFacileDocumentsPut
     */
    readonly id: number

    /**
     * The updated Dossier resource
     * @type {DossierJsonld}
     * @memberof DossierApiApiDossiersIdDematFacileDocumentsPut
     */
    readonly dossierJsonld: DossierJsonld
}

/**
 * Request parameters for apiDossiersIdDematFacilePut operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdDematFacilePutRequest
 */
export interface DossierApiApiDossiersIdDematFacilePutRequest {
    /**
     * L\&#39;identifiant du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdDematFacilePut
     */
    readonly id: number

    /**
     * 
     * @type {object}
     * @memberof DossierApiApiDossiersIdDematFacilePut
     */
    readonly body?: object
}

/**
 * Request parameters for apiDossiersIdDeplacerPatch operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdDeplacerPatchRequest
 */
export interface DossierApiApiDossiersIdDeplacerPatchRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdDeplacerPatch
     */
    readonly id: string

    /**
     * 
     * @type {ApiDossiersIdDeplacerPatchRequest}
     * @memberof DossierApiApiDossiersIdDeplacerPatch
     */
    readonly apiDossiersIdDeplacerPatchRequest?: ApiDossiersIdDeplacerPatchRequest
}

/**
 * Request parameters for apiDossiersIdDissocierPatch operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdDissocierPatchRequest
 */
export interface DossierApiApiDossiersIdDissocierPatchRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdDissocierPatch
     */
    readonly id: string

    /**
     * 
     * @type {ApiDossiersIdDissocierPatchRequest}
     * @memberof DossierApiApiDossiersIdDissocierPatch
     */
    readonly apiDossiersIdDissocierPatchRequest?: ApiDossiersIdDissocierPatchRequest
}

/**
 * Request parameters for apiDossiersIdFichiersDelete operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdFichiersDeleteRequest
 */
export interface DossierApiApiDossiersIdFichiersDeleteRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdFichiersDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiDossiersIdFormalityFormalityIdDelete operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdFormalityFormalityIdDeleteRequest
 */
export interface DossierApiApiDossiersIdFormalityFormalityIdDeleteRequest {
    /**
     * Identifiant du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdFormalityFormalityIdDelete
     */
    readonly id: number

    /**
     * Identifiant de la formalité
     * @type {number}
     * @memberof DossierApiApiDossiersIdFormalityFormalityIdDelete
     */
    readonly formalityId: number
}

/**
 * Request parameters for apiDossiersIdGet operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdGetRequest
 */
export interface DossierApiApiDossiersIdGetRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiDossiersIdNotesGet operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdNotesGetRequest
 */
export interface DossierApiApiDossiersIdNotesGetRequest {
    /**
     * ID du dossier de formalité
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly id: number

    /**
     * Filtrer par notes importantes uniquement
     * @type {boolean}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly highlighted?: boolean

    /**
     * Filtrer par notes mémo client uniquement
     * @type {boolean}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly memoClient?: boolean

    /**
     * Champ de tri (défaut: createdAt)
     * @type {'createdAt' | 'updatedAt' | 'content'}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly sort?: ApiDossiersIdNotesGetSortEnum

    /**
     * Ordre de tri (défaut: DESC)
     * @type {'ASC' | 'DESC'}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly order?: ApiDossiersIdNotesGetOrderEnum

    /**
     * Numéro de page (défaut: 1)
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly page?: number

    /**
     * Nombre d\&#39;éléments par page (défaut: 20, max: 100)
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesGet
     */
    readonly limit?: number
}

/**
 * Request parameters for apiDossiersIdNotesNoteIdDelete operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdNotesNoteIdDeleteRequest
 */
export interface DossierApiApiDossiersIdNotesNoteIdDeleteRequest {
    /**
     * ID du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesNoteIdDelete
     */
    readonly id: number

    /**
     * ID de la note à supprimer
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesNoteIdDelete
     */
    readonly noteId: number
}

/**
 * Request parameters for apiDossiersIdNotesNoteIdPut operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdNotesNoteIdPutRequest
 */
export interface DossierApiApiDossiersIdNotesNoteIdPutRequest {
    /**
     * ID du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesNoteIdPut
     */
    readonly id: number

    /**
     * ID de la note à modifier
     * @type {number}
     * @memberof DossierApiApiDossiersIdNotesNoteIdPut
     */
    readonly noteId: number

    /**
     * 
     * @type {ApiDossiersIdNotesPostRequest}
     * @memberof DossierApiApiDossiersIdNotesNoteIdPut
     */
    readonly apiDossiersIdNotesPostRequest?: ApiDossiersIdNotesPostRequest
}

/**
 * Request parameters for apiDossiersIdNotesPost operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdNotesPostRequest
 */
export interface DossierApiApiDossiersIdNotesPostRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdNotesPost
     */
    readonly id: string

    /**
     * 
     * @type {ApiDossiersIdNotesPostRequest}
     * @memberof DossierApiApiDossiersIdNotesPost
     */
    readonly apiDossiersIdNotesPostRequest?: ApiDossiersIdNotesPostRequest
}

/**
 * Request parameters for apiDossiersIdPatch operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdPatchRequest
 */
export interface DossierApiApiDossiersIdPatchRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdPatch
     */
    readonly id: string

    /**
     * The updated Dossier resource
     * @type {DossierDossierUpdatePartial}
     * @memberof DossierApiApiDossiersIdPatch
     */
    readonly dossierDossierUpdatePartial: DossierDossierUpdatePartial
}

/**
 * Request parameters for apiDossiersIdPut operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdPutRequest
 */
export interface DossierApiApiDossiersIdPutRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossierApiApiDossiersIdPut
     */
    readonly id: string

    /**
     * The updated Dossier resource
     * @type {DossierJsonldDossierUpdate}
     * @memberof DossierApiApiDossiersIdPut
     */
    readonly dossierJsonldDossierUpdate: DossierJsonldDossierUpdate
}

/**
 * Request parameters for apiDossiersIdTransitionsGetCollection operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersIdTransitionsGetCollectionRequest
 */
export interface DossierApiApiDossiersIdTransitionsGetCollectionRequest {
    /**
     * L\&#39;identifiant du dossier
     * @type {number}
     * @memberof DossierApiApiDossiersIdTransitionsGetCollection
     */
    readonly id: number

    /**
     * The collection page number
     * @type {number}
     * @memberof DossierApiApiDossiersIdTransitionsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierApiApiDossiersIdTransitionsGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiDossiersPost operation in DossierApi.
 * @export
 * @interface DossierApiApiDossiersPostRequest
 */
export interface DossierApiApiDossiersPostRequest {
    /**
     * The new Dossier resource
     * @type {DossierJsonldDossierCreate}
     * @memberof DossierApiApiDossiersPost
     */
    readonly dossierJsonldDossierCreate: DossierJsonldDossierCreate
}

/**
 * DossierApi - object-oriented interface
 * @export
 * @class DossierApi
 * @extends {BaseAPI}
 */
export class DossierApi extends BaseAPI {
    /**
     * Lister les dossiers
     * @summary Lister les dossiers
     * @param {DossierApiApiDossiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersGetCollection(requestParameters: DossierApiApiDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dateCreationBefore, requestParameters.dateCreationStrictlyBefore, requestParameters.dateCreationAfter, requestParameters.dateCreationStrictlyAfter, requestParameters.numero, requestParameters.societeDenomination, requestParameters.societeSiren, requestParameters.affaire, requestParameters.idDematfacile, requestParameters.statutId, requestParameters.statutId2, requestParameters.prestationsFormaliteId, requestParameters.prestationsFormaliteId2, requestParameters.collectionId, requestParameters.collectionId2, requestParameters.orderNumero, requestParameters.orderSocieteDenomination, requestParameters.orderContactNom, requestParameters.orderDateCreation, requestParameters.orderStatutLibelle, requestParameters.orderFormalisteNom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour une collection de dossier
     * @summary Mettre à jour une collection de dossier
     * @param {DossierApiApiDossiersGroupesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersGroupesPatch(requestParameters: DossierApiApiDossiersGroupesPatchRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersGroupesPatch(requestParameters.dossierDossiersGroupesPatchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Déclencher une action pour mettre à jour le statut d\'un dossier
     * @summary Déclencher une action pour mettre à jour le statut d\'un dossier
     * @param {DossierApiApiDossiersIdActionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdActionPut(requestParameters: DossierApiApiDossiersIdActionPutRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdActionPut(requestParameters.id, requestParameters.action, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les annonces légales d\'un dossier
     * @summary Récupérer les annonces légales d\'un dossier
     * @param {DossierApiApiDossiersIdAnnonceLegaleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdAnnonceLegaleGet(requestParameters: DossierApiApiDossiersIdAnnonceLegaleGetRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdAnnonceLegaleGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour les articles d\'une collection de dossier
     * @summary Mettre à jour les articles d\'une collection de dossier
     * @param {DossierApiApiDossiersIdArticlesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdArticlesPatch(requestParameters: DossierApiApiDossiersIdArticlesPatchRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdArticlesPatch(requestParameters.id, requestParameters.dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un dossier
     * @summary Supprimer un dossier
     * @param {DossierApiApiDossiersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdDelete(requestParameters: DossierApiApiDossiersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pousse toutes les pièces jointes non envoyées vers Dematfacile pour le dossier donné.
     * @summary Pousser les pièces jointes du dossier vers Dematfacile
     * @param {DossierApiApiDossiersIdDematFacileDocumentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdDematFacileDocumentsPut(requestParameters: DossierApiApiDossiersIdDematFacileDocumentsPutRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdDematFacileDocumentsPut(requestParameters.id, requestParameters.dossierJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer le client et le dossier dematfacile
     * @summary Créer le client et le dossier dematfacile
     * @param {DossierApiApiDossiersIdDematFacilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdDematFacilePut(requestParameters: DossierApiApiDossiersIdDematFacilePutRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdDematFacilePut(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Déplacer une ou des formalités dans un autre dossier de la collection
     * @summary Déplacer une ou des formalités dans un autre dossier de la collection
     * @param {DossierApiApiDossiersIdDeplacerPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdDeplacerPatch(requestParameters: DossierApiApiDossiersIdDeplacerPatchRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdDeplacerPatch(requestParameters.id, requestParameters.apiDossiersIdDeplacerPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dissocier un dossier
     * @summary Dissocier un dossier
     * @param {DossierApiApiDossiersIdDissocierPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdDissocierPatch(requestParameters: DossierApiApiDossiersIdDissocierPatchRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdDissocierPatch(requestParameters.id, requestParameters.apiDossiersIdDissocierPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the Dossier resource.
     * @summary supprimer les fichiers d\'un dossier
     * @param {DossierApiApiDossiersIdFichiersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdFichiersDelete(requestParameters: DossierApiApiDossiersIdFichiersDeleteRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdFichiersDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the Dossier resource.
     * @summary Supprimer une formalité d\'un dossier
     * @param {DossierApiApiDossiersIdFormalityFormalityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdFormalityFormalityIdDelete(requestParameters: DossierApiApiDossiersIdFormalityFormalityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdFormalityFormalityIdDelete(requestParameters.id, requestParameters.formalityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un dossier
     * @summary Récupérer les informations d\'un dossier
     * @param {DossierApiApiDossiersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdGet(requestParameters: DossierApiApiDossiersIdGetRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer la liste des notes associées à un dossier de formalité avec possibilité de filtrage et pagination
     * @summary Récupérer les notes d\'un dossier de formalité
     * @param {DossierApiApiDossiersIdNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdNotesGet(requestParameters: DossierApiApiDossiersIdNotesGetRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdNotesGet(requestParameters.id, requestParameters.highlighted, requestParameters.memoClient, requestParameters.sort, requestParameters.order, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer définitivement une note d\'un dossier
     * @summary Supprimer une note d\'un dossier de formalité
     * @param {DossierApiApiDossiersIdNotesNoteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdNotesNoteIdDelete(requestParameters: DossierApiApiDossiersIdNotesNoteIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdNotesNoteIdDelete(requestParameters.id, requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifier le contenu et/ou le statut important d\'une note
     * @summary Modifier une note d\'un dossier de formalité
     * @param {DossierApiApiDossiersIdNotesNoteIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdNotesNoteIdPut(requestParameters: DossierApiApiDossiersIdNotesNoteIdPutRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdNotesNoteIdPut(requestParameters.id, requestParameters.noteId, requestParameters.apiDossiersIdNotesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer une note pour un dossier de formalité
     * @summary Créer une note pour un dossier de formalité
     * @param {DossierApiApiDossiersIdNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdNotesPost(requestParameters: DossierApiApiDossiersIdNotesPostRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdNotesPost(requestParameters.id, requestParameters.apiDossiersIdNotesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour les informations d\'un dossier
     * @summary Mettre à jour les informations d\'un dossier
     * @param {DossierApiApiDossiersIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdPatch(requestParameters: DossierApiApiDossiersIdPatchRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdPatch(requestParameters.id, requestParameters.dossierDossierUpdatePartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour les informations d\'un dossier
     * @summary Mettre à jour les informations d\'un dossier
     * @param {DossierApiApiDossiersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdPut(requestParameters: DossierApiApiDossiersIdPutRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdPut(requestParameters.id, requestParameters.dossierJsonldDossierUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les actions possibles pour un dossier
     * @summary Lister les actions possibles pour un dossier
     * @param {DossierApiApiDossiersIdTransitionsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersIdTransitionsGetCollection(requestParameters: DossierApiApiDossiersIdTransitionsGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersIdTransitionsGetCollection(requestParameters.id, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un dossier
     * @summary Créer un dossier
     * @param {DossierApiApiDossiersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierApi
     */
    public apiDossiersPost(requestParameters: DossierApiApiDossiersPostRequest, options?: RawAxiosRequestConfig) {
        return DossierApiFp(this.configuration).apiDossiersPost(requestParameters.dossierJsonldDossierCreate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiDossiersGetCollectionOrderNumeroEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersGetCollectionOrderNumeroEnum = typeof ApiDossiersGetCollectionOrderNumeroEnum[keyof typeof ApiDossiersGetCollectionOrderNumeroEnum];
/**
 * @export
 */
export const ApiDossiersGetCollectionOrderSocieteDenominationEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersGetCollectionOrderSocieteDenominationEnum = typeof ApiDossiersGetCollectionOrderSocieteDenominationEnum[keyof typeof ApiDossiersGetCollectionOrderSocieteDenominationEnum];
/**
 * @export
 */
export const ApiDossiersGetCollectionOrderContactNomEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersGetCollectionOrderContactNomEnum = typeof ApiDossiersGetCollectionOrderContactNomEnum[keyof typeof ApiDossiersGetCollectionOrderContactNomEnum];
/**
 * @export
 */
export const ApiDossiersGetCollectionOrderDateCreationEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersGetCollectionOrderDateCreationEnum = typeof ApiDossiersGetCollectionOrderDateCreationEnum[keyof typeof ApiDossiersGetCollectionOrderDateCreationEnum];
/**
 * @export
 */
export const ApiDossiersGetCollectionOrderStatutLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersGetCollectionOrderStatutLibelleEnum = typeof ApiDossiersGetCollectionOrderStatutLibelleEnum[keyof typeof ApiDossiersGetCollectionOrderStatutLibelleEnum];
/**
 * @export
 */
export const ApiDossiersGetCollectionOrderFormalisteNomEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersGetCollectionOrderFormalisteNomEnum = typeof ApiDossiersGetCollectionOrderFormalisteNomEnum[keyof typeof ApiDossiersGetCollectionOrderFormalisteNomEnum];
/**
 * @export
 */
export const ApiDossiersIdActionPutActionEnum = {
    Validate: 'validate',
    Cancel: 'cancel',
    Suspend: 'suspend',
    Unsuspend: 'unsuspend',
    Reject: 'reject',
    Relance: 'relance',
    Regulate: 'regulate',
    SendToValidators: 'send-to-validators',
    ProcessRegulation: 'process-regulation',
    Invoice: 'invoice',
    Paid: 'paid',
    Archive: 'archive',
    ToCheck: 'to-check',
    Checked: 'checked',
    ReadyToDropOff: 'ready-to-drop-off'
} as const;
export type ApiDossiersIdActionPutActionEnum = typeof ApiDossiersIdActionPutActionEnum[keyof typeof ApiDossiersIdActionPutActionEnum];
/**
 * @export
 */
export const ApiDossiersIdNotesGetSortEnum = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Content: 'content'
} as const;
export type ApiDossiersIdNotesGetSortEnum = typeof ApiDossiersIdNotesGetSortEnum[keyof typeof ApiDossiersIdNotesGetSortEnum];
/**
 * @export
 */
export const ApiDossiersIdNotesGetOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ApiDossiersIdNotesGetOrderEnum = typeof ApiDossiersIdNotesGetOrderEnum[keyof typeof ApiDossiersIdNotesGetOrderEnum];


/**
 * DossierOpenSearchApi - axios parameter creator
 * @export
 */
export const DossierOpenSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les clients des dossiers indexés sur Open Search
         * @summary Lister les clients des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchClientsGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les contacts des dossiers indexés sur Open Search
         * @summary Lister les contacts des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchContactsGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les collections de dossiers indexés sur Open Search
         * @summary Lister les collections de dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersCollectionsGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/dossiers/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les dossiers indexés sur Open Search
         * @summary Lister les dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [collectionId] Filter dossiers list by collection
         * @param {Array<number>} [clientId] Filter dossiers list by client opere
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {Array<number>} [workGroupId] Filter dossiers list by work group
         * @param {Array<number>} [stepId] Filter dossiers list by step
         * @param {Array<number>} [statutId] Filter dossiers list by status
         * @param {Array<number>} [statutValideurId] Filter dossiers list by validator status
         * @param {Array<string>} [numero] Filter dossiers list by number
         * @param {Array<string>} [societeReference] Filter dossiers list by societeRef
         * @param {Array<number>} [formaliteId] Filter dossiers list by formalite
         * @param {Array<number>} [groupId] Filter dossiers list by object group
         * @param {Array<number>} [contactId] Filter dossiers list by contact ID
         * @param {Array<number>} [prescriberId] Filter dossiers list by prescriber ID
         * @param {Array<number>} [societeId] Filter dossiers list by societe ID
         * @param {Array<number>} [offerId] Filter dossiers list by offer ID
         * @param {Array<number>} [greffeId] Filter dossiers list by greffe ID
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {boolean} [hasMissingRequiredDocuments] Filter list by only showing dossiers with missing required documents
         * @param {boolean} [demo] Filter list by only showing dossiers demo
         * @param {boolean} [hasMessageUnreadClient] Filter list by only showing dossiers with client message(s) unread
         * @param {boolean} [hasMessageUnreadInterne] Filter list by only showing dossiers with interne message(s) unread
         * @param {boolean} [critical] Filter list by critical flag
         * @param {string} [orderNumero] Sort dossier by numero
         * @param {string} [orderSocieteDenomination] Sort dossier by societeDenomination
         * @param {string} [orderContactNom] Sort dossier by contact\&#39;s name
         * @param {string} [orderDateCreation] Sort dossier by dateCreation
         * @param {string} [orderStatutLibelle] Sort dossier by statutLibelle
         * @param {string} [orderFormalisteNom] Sort dossier by formaliste\&#39;s name
         * @param {string} [orderPrescripteurLibelle] Sort dossier by prescriber\&#39;s name
         * @param {string} [orderOffreLibelle] Sort dossier by offer\&#39;s name
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersGetCollection: async (page?: number, itemsPerPage?: number, collectionId?: Array<number>, clientId?: Array<number>, formalisteId?: Array<number>, workGroupId?: Array<number>, stepId?: Array<number>, statutId?: Array<number>, statutValideurId?: Array<number>, numero?: Array<string>, societeReference?: Array<string>, formaliteId?: Array<number>, groupId?: Array<number>, contactId?: Array<number>, prescriberId?: Array<number>, societeId?: Array<number>, offerId?: Array<number>, greffeId?: Array<number>, startDate?: string, endDate?: string, hasMissingRequiredDocuments?: boolean, demo?: boolean, hasMessageUnreadClient?: boolean, hasMessageUnreadInterne?: boolean, critical?: boolean, orderNumero?: string, orderSocieteDenomination?: string, orderContactNom?: string, orderDateCreation?: string, orderStatutLibelle?: string, orderFormalisteNom?: string, orderPrescripteurLibelle?: string, orderOffreLibelle?: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (collectionId) {
                localVarQueryParameter['collectionId[]'] = collectionId;
            }

            if (clientId) {
                localVarQueryParameter['clientId[]'] = clientId;
            }

            if (formalisteId) {
                localVarQueryParameter['formalisteId[]'] = formalisteId;
            }

            if (workGroupId) {
                localVarQueryParameter['workGroupId[]'] = workGroupId;
            }

            if (stepId) {
                localVarQueryParameter['stepId[]'] = stepId;
            }

            if (statutId) {
                localVarQueryParameter['statutId[]'] = statutId;
            }

            if (statutValideurId) {
                localVarQueryParameter['statutValideurId[]'] = statutValideurId;
            }

            if (numero) {
                localVarQueryParameter['numero[]'] = numero;
            }

            if (societeReference) {
                localVarQueryParameter['societeReference[]'] = societeReference;
            }

            if (formaliteId) {
                localVarQueryParameter['formaliteId[]'] = formaliteId;
            }

            if (groupId) {
                localVarQueryParameter['groupId[]'] = groupId;
            }

            if (contactId) {
                localVarQueryParameter['contactId[]'] = contactId;
            }

            if (prescriberId) {
                localVarQueryParameter['prescriberId[]'] = prescriberId;
            }

            if (societeId) {
                localVarQueryParameter['societeId[]'] = societeId;
            }

            if (offerId) {
                localVarQueryParameter['offerId[]'] = offerId;
            }

            if (greffeId) {
                localVarQueryParameter['greffeId[]'] = greffeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (hasMissingRequiredDocuments !== undefined) {
                localVarQueryParameter['hasMissingRequiredDocuments'] = hasMissingRequiredDocuments;
            }

            if (demo !== undefined) {
                localVarQueryParameter['demo'] = demo;
            }

            if (hasMessageUnreadClient !== undefined) {
                localVarQueryParameter['hasMessageUnreadClient'] = hasMessageUnreadClient;
            }

            if (hasMessageUnreadInterne !== undefined) {
                localVarQueryParameter['hasMessageUnreadInterne'] = hasMessageUnreadInterne;
            }

            if (critical !== undefined) {
                localVarQueryParameter['critical'] = critical;
            }

            if (orderNumero !== undefined) {
                localVarQueryParameter['order[numero]'] = orderNumero;
            }

            if (orderSocieteDenomination !== undefined) {
                localVarQueryParameter['order[societeDenomination]'] = orderSocieteDenomination;
            }

            if (orderContactNom !== undefined) {
                localVarQueryParameter['order[contactNom]'] = orderContactNom;
            }

            if (orderDateCreation !== undefined) {
                localVarQueryParameter['order[dateCreation]'] = orderDateCreation;
            }

            if (orderStatutLibelle !== undefined) {
                localVarQueryParameter['order[statutLibelle]'] = orderStatutLibelle;
            }

            if (orderFormalisteNom !== undefined) {
                localVarQueryParameter['order[formalisteNom]'] = orderFormalisteNom;
            }

            if (orderPrescripteurLibelle !== undefined) {
                localVarQueryParameter['order[prescripteurLibelle]'] = orderPrescripteurLibelle;
            }

            if (orderOffreLibelle !== undefined) {
                localVarQueryParameter['order[offreLibelle]'] = orderOffreLibelle;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un dossier indexé sur Open Search
         * @summary Récupérer les informations d\'un dossier indexé sur Open Search
         * @param {string} id Dossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOpensearchDossiersIdGet', 'id', id)
            const localVarPath = `/formalite/opensearch/dossiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Indexer un lot de dossiers sur Open Search
         * @summary Indexer un lot de dossiers sur Open Search
         * @param {DossierOpenSearchJsonldOpensearchDossierIndexBatch} dossierOpenSearchJsonldOpensearchDossierIndexBatch The new Dossier Open Search resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersIndexByIdsPost: async (dossierOpenSearchJsonldOpensearchDossierIndexBatch: DossierOpenSearchJsonldOpensearchDossierIndexBatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierOpenSearchJsonldOpensearchDossierIndexBatch' is not null or undefined
            assertParamExists('apiOpensearchDossiersIndexByIdsPost', 'dossierOpenSearchJsonldOpensearchDossierIndexBatch', dossierOpenSearchJsonldOpensearchDossierIndexBatch)
            const localVarPath = `/formalite/opensearch/dossiers/index-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierOpenSearchJsonldOpensearchDossierIndexBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les formalistes des dossiers indexés sur Open Search
         * @summary Lister les formalistes des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {Array<number>} [statutId] Filter dossiers list by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalistesGetCollection: async (page?: number, itemsPerPage?: number, q?: string, formalisteId?: Array<number>, startDate?: string, endDate?: string, statutId?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/formalistes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (formalisteId) {
                localVarQueryParameter['formalisteId[]'] = formalisteId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (statutId) {
                localVarQueryParameter['statutId[]'] = statutId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les greffes des dossiers indexés sur Open Search
         * @summary Lister les greffes des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchGreffesGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/greffes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les numéros des dossiers indexés sur Open Search
         * @summary Lister les numéros des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchNumerosGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/numeros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les groupes des dossiers indexés sur Open Search
         * @summary Lister les groupes des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [groupId] Filter dossiersGroup list by object group id
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchObjectGroupsGetCollection: async (page?: number, itemsPerPage?: number, groupId?: Array<number>, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/object-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (groupId) {
                localVarQueryParameter['groupId[]'] = groupId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les offres des dossiers indexés sur Open Search
         * @summary Lister les offres des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchOffersGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les prefiltres et totaux des dossiers indexés sur Open Search
         * @summary Lister les prefiltres et totaux des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchPrefiltersGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/prefilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les prescripteurs des dossiers indexés sur Open Search
         * @summary Lister les prescripteurs des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchPrescripteursGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/prescripteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les référence de sociétés des dossiers indexés sur Open Search
         * @summary Lister les référence de sociétés des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchSocieteReferenceGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/societe-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les statuts des dossiers indexés sur Open Search
         * @summary Lister les statuts des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchStatusesGetCollection: async (page?: number, itemsPerPage?: number, formalisteId?: Array<number>, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (formalisteId) {
                localVarQueryParameter['formalisteId[]'] = formalisteId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les valideurs et status liés indexés sur Open Search
         * @summary Lister les valideurs et status liés indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchValideursStatusGetCollection: async (page?: number, itemsPerPage?: number, q?: string, formalisteId?: Array<number>, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/valideurs-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (formalisteId) {
                localVarQueryParameter['formalisteId[]'] = formalisteId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les groupes de travail des dossiers indexés sur Open Search
         * @summary Lister les groupes de travail des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchWorkingGroupsGetCollection: async (page?: number, itemsPerPage?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/working-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossierOpenSearchApi - functional programming interface
 * @export
 */
export const DossierOpenSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossierOpenSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les clients des dossiers indexés sur Open Search
         * @summary Lister les clients des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchClientsGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchClientsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchClientsGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchClientsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les contacts des dossiers indexés sur Open Search
         * @summary Lister les contacts des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchContactsGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchContactsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchContactsGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchContactsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les collections de dossiers indexés sur Open Search
         * @summary Lister les collections de dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchDossiersCollectionsGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchDossiersCollectionsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchDossiersCollectionsGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchDossiersCollectionsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les dossiers indexés sur Open Search
         * @summary Lister les dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [collectionId] Filter dossiers list by collection
         * @param {Array<number>} [clientId] Filter dossiers list by client opere
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {Array<number>} [workGroupId] Filter dossiers list by work group
         * @param {Array<number>} [stepId] Filter dossiers list by step
         * @param {Array<number>} [statutId] Filter dossiers list by status
         * @param {Array<number>} [statutValideurId] Filter dossiers list by validator status
         * @param {Array<string>} [numero] Filter dossiers list by number
         * @param {Array<string>} [societeReference] Filter dossiers list by societeRef
         * @param {Array<number>} [formaliteId] Filter dossiers list by formalite
         * @param {Array<number>} [groupId] Filter dossiers list by object group
         * @param {Array<number>} [contactId] Filter dossiers list by contact ID
         * @param {Array<number>} [prescriberId] Filter dossiers list by prescriber ID
         * @param {Array<number>} [societeId] Filter dossiers list by societe ID
         * @param {Array<number>} [offerId] Filter dossiers list by offer ID
         * @param {Array<number>} [greffeId] Filter dossiers list by greffe ID
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {boolean} [hasMissingRequiredDocuments] Filter list by only showing dossiers with missing required documents
         * @param {boolean} [demo] Filter list by only showing dossiers demo
         * @param {boolean} [hasMessageUnreadClient] Filter list by only showing dossiers with client message(s) unread
         * @param {boolean} [hasMessageUnreadInterne] Filter list by only showing dossiers with interne message(s) unread
         * @param {boolean} [critical] Filter list by critical flag
         * @param {string} [orderNumero] Sort dossier by numero
         * @param {string} [orderSocieteDenomination] Sort dossier by societeDenomination
         * @param {string} [orderContactNom] Sort dossier by contact\&#39;s name
         * @param {string} [orderDateCreation] Sort dossier by dateCreation
         * @param {string} [orderStatutLibelle] Sort dossier by statutLibelle
         * @param {string} [orderFormalisteNom] Sort dossier by formaliste\&#39;s name
         * @param {string} [orderPrescripteurLibelle] Sort dossier by prescriber\&#39;s name
         * @param {string} [orderOffreLibelle] Sort dossier by offer\&#39;s name
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchDossiersGetCollection(page?: number, itemsPerPage?: number, collectionId?: Array<number>, clientId?: Array<number>, formalisteId?: Array<number>, workGroupId?: Array<number>, stepId?: Array<number>, statutId?: Array<number>, statutValideurId?: Array<number>, numero?: Array<string>, societeReference?: Array<string>, formaliteId?: Array<number>, groupId?: Array<number>, contactId?: Array<number>, prescriberId?: Array<number>, societeId?: Array<number>, offerId?: Array<number>, greffeId?: Array<number>, startDate?: string, endDate?: string, hasMissingRequiredDocuments?: boolean, demo?: boolean, hasMessageUnreadClient?: boolean, hasMessageUnreadInterne?: boolean, critical?: boolean, orderNumero?: string, orderSocieteDenomination?: string, orderContactNom?: string, orderDateCreation?: string, orderStatutLibelle?: string, orderFormalisteNom?: string, orderPrescripteurLibelle?: string, orderOffreLibelle?: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchDossiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchDossiersGetCollection(page, itemsPerPage, collectionId, clientId, formalisteId, workGroupId, stepId, statutId, statutValideurId, numero, societeReference, formaliteId, groupId, contactId, prescriberId, societeId, offerId, greffeId, startDate, endDate, hasMissingRequiredDocuments, demo, hasMessageUnreadClient, hasMessageUnreadInterne, critical, orderNumero, orderSocieteDenomination, orderContactNom, orderDateCreation, orderStatutLibelle, orderFormalisteNom, orderPrescripteurLibelle, orderOffreLibelle, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchDossiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un dossier indexé sur Open Search
         * @summary Récupérer les informations d\'un dossier indexé sur Open Search
         * @param {string} id Dossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchDossiersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierOpenSearchCombinedJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchDossiersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchDossiersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Indexer un lot de dossiers sur Open Search
         * @summary Indexer un lot de dossiers sur Open Search
         * @param {DossierOpenSearchJsonldOpensearchDossierIndexBatch} dossierOpenSearchJsonldOpensearchDossierIndexBatch The new Dossier Open Search resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchDossiersIndexByIdsPost(dossierOpenSearchJsonldOpensearchDossierIndexBatch: DossierOpenSearchJsonldOpensearchDossierIndexBatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchDossiersIndexByIdsPost(dossierOpenSearchJsonldOpensearchDossierIndexBatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchDossiersIndexByIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les formalistes des dossiers indexés sur Open Search
         * @summary Lister les formalistes des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {Array<number>} [statutId] Filter dossiers list by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFormalistesGetCollection(page?: number, itemsPerPage?: number, q?: string, formalisteId?: Array<number>, startDate?: string, endDate?: string, statutId?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFormalistesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFormalistesGetCollection(page, itemsPerPage, q, formalisteId, startDate, endDate, statutId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchFormalistesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les greffes des dossiers indexés sur Open Search
         * @summary Lister les greffes des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchGreffesGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchGreffesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchGreffesGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchGreffesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les numéros des dossiers indexés sur Open Search
         * @summary Lister les numéros des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchNumerosGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchDossiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchNumerosGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchNumerosGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les groupes des dossiers indexés sur Open Search
         * @summary Lister les groupes des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [groupId] Filter dossiersGroup list by object group id
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchObjectGroupsGetCollection(page?: number, itemsPerPage?: number, groupId?: Array<number>, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchObjectGroupsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchObjectGroupsGetCollection(page, itemsPerPage, groupId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchObjectGroupsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les offres des dossiers indexés sur Open Search
         * @summary Lister les offres des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchOffersGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchOffersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchOffersGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchOffersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les prefiltres et totaux des dossiers indexés sur Open Search
         * @summary Lister les prefiltres et totaux des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchPrefiltersGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchPrefiltersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchPrefiltersGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchPrefiltersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les prescripteurs des dossiers indexés sur Open Search
         * @summary Lister les prescripteurs des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchPrescripteursGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchPrescripteursGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchPrescripteursGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchPrescripteursGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les référence de sociétés des dossiers indexés sur Open Search
         * @summary Lister les référence de sociétés des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchSocieteReferenceGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchSocieteReferenceGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchSocieteReferenceGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchSocieteReferenceGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les statuts des dossiers indexés sur Open Search
         * @summary Lister les statuts des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchStatusesGetCollection(page?: number, itemsPerPage?: number, formalisteId?: Array<number>, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchStatusesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchStatusesGetCollection(page, itemsPerPage, formalisteId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchStatusesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les valideurs et status liés indexés sur Open Search
         * @summary Lister les valideurs et status liés indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {Array<number>} [formalisteId] Filter dossiers list by formaliste
         * @param {string} [startDate] Filter dossiers list by creation date
         * @param {string} [endDate] Filter dossiers list by creation date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchValideursStatusGetCollection(page?: number, itemsPerPage?: number, q?: string, formalisteId?: Array<number>, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchValideursStatusGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchValideursStatusGetCollection(page, itemsPerPage, q, formalisteId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchValideursStatusGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les groupes de travail des dossiers indexés sur Open Search
         * @summary Lister les groupes de travail des dossiers indexés sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchWorkingGroupsGetCollection(page?: number, itemsPerPage?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchWorkingGroupsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchWorkingGroupsGetCollection(page, itemsPerPage, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierOpenSearchApi.apiOpensearchWorkingGroupsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DossierOpenSearchApi - factory interface
 * @export
 */
export const DossierOpenSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossierOpenSearchApiFp(configuration)
    return {
        /**
         * Lister les clients des dossiers indexés sur Open Search
         * @summary Lister les clients des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchClientsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchClientsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchClientsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchClientsGetCollection200Response> {
            return localVarFp.apiOpensearchClientsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les contacts des dossiers indexés sur Open Search
         * @summary Lister les contacts des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchContactsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchContactsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchContactsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchContactsGetCollection200Response> {
            return localVarFp.apiOpensearchContactsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les collections de dossiers indexés sur Open Search
         * @summary Lister les collections de dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersCollectionsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchDossiersCollectionsGetCollection200Response> {
            return localVarFp.apiOpensearchDossiersCollectionsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les dossiers indexés sur Open Search
         * @summary Lister les dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchDossiersGetCollection200Response> {
            return localVarFp.apiOpensearchDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.collectionId, requestParameters.clientId, requestParameters.formalisteId, requestParameters.workGroupId, requestParameters.stepId, requestParameters.statutId, requestParameters.statutValideurId, requestParameters.numero, requestParameters.societeReference, requestParameters.formaliteId, requestParameters.groupId, requestParameters.contactId, requestParameters.prescriberId, requestParameters.societeId, requestParameters.offerId, requestParameters.greffeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hasMissingRequiredDocuments, requestParameters.demo, requestParameters.hasMessageUnreadClient, requestParameters.hasMessageUnreadInterne, requestParameters.critical, requestParameters.orderNumero, requestParameters.orderSocieteDenomination, requestParameters.orderContactNom, requestParameters.orderDateCreation, requestParameters.orderStatutLibelle, requestParameters.orderFormalisteNom, requestParameters.orderPrescripteurLibelle, requestParameters.orderOffreLibelle, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un dossier indexé sur Open Search
         * @summary Récupérer les informations d\'un dossier indexé sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchDossiersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersIdGet(requestParameters: DossierOpenSearchApiApiOpensearchDossiersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierOpenSearchCombinedJsonld> {
            return localVarFp.apiOpensearchDossiersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Indexer un lot de dossiers sur Open Search
         * @summary Indexer un lot de dossiers sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchDossiersIndexByIdsPost(requestParameters: DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierOpenSearchIndexBatchDossierResponseJsonldOpensearchDossierIndexBatch> {
            return localVarFp.apiOpensearchDossiersIndexByIdsPost(requestParameters.dossierOpenSearchJsonldOpensearchDossierIndexBatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les formalistes des dossiers indexés sur Open Search
         * @summary Lister les formalistes des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchFormalistesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalistesGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchFormalistesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFormalistesGetCollection200Response> {
            return localVarFp.apiOpensearchFormalistesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, requestParameters.formalisteId, requestParameters.startDate, requestParameters.endDate, requestParameters.statutId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les greffes des dossiers indexés sur Open Search
         * @summary Lister les greffes des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchGreffesGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchGreffesGetCollection200Response> {
            return localVarFp.apiOpensearchGreffesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les numéros des dossiers indexés sur Open Search
         * @summary Lister les numéros des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchNumerosGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchNumerosGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchNumerosGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchDossiersGetCollection200Response> {
            return localVarFp.apiOpensearchNumerosGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les groupes des dossiers indexés sur Open Search
         * @summary Lister les groupes des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchObjectGroupsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchObjectGroupsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchObjectGroupsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchObjectGroupsGetCollection200Response> {
            return localVarFp.apiOpensearchObjectGroupsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.groupId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les offres des dossiers indexés sur Open Search
         * @summary Lister les offres des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchOffersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchOffersGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchOffersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchOffersGetCollection200Response> {
            return localVarFp.apiOpensearchOffersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les prefiltres et totaux des dossiers indexés sur Open Search
         * @summary Lister les prefiltres et totaux des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchPrefiltersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchPrefiltersGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchPrefiltersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchPrefiltersGetCollection200Response> {
            return localVarFp.apiOpensearchPrefiltersGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les prescripteurs des dossiers indexés sur Open Search
         * @summary Lister les prescripteurs des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchPrescripteursGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchPrescripteursGetCollection200Response> {
            return localVarFp.apiOpensearchPrescripteursGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les référence de sociétés des dossiers indexés sur Open Search
         * @summary Lister les référence de sociétés des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchSocieteReferenceGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchSocieteReferenceGetCollection200Response> {
            return localVarFp.apiOpensearchSocieteReferenceGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les statuts des dossiers indexés sur Open Search
         * @summary Lister les statuts des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchStatusesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchStatusesGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchStatusesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchStatusesGetCollection200Response> {
            return localVarFp.apiOpensearchStatusesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.formalisteId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les valideurs et status liés indexés sur Open Search
         * @summary Lister les valideurs et status liés indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchValideursStatusGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchValideursStatusGetCollection200Response> {
            return localVarFp.apiOpensearchValideursStatusGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, requestParameters.formalisteId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les groupes de travail des dossiers indexés sur Open Search
         * @summary Lister les groupes de travail des dossiers indexés sur Open Search
         * @param {DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchWorkingGroupsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchWorkingGroupsGetCollection200Response> {
            return localVarFp.apiOpensearchWorkingGroupsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiOpensearchClientsGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchClientsGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchClientsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchClientsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchClientsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchClientsGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchContactsGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchContactsGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchContactsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchContactsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchContactsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchContactsGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchDossiersCollectionsGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchDossiersGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter dossiers list by collection
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly collectionId?: Array<number>

    /**
     * Filter dossiers list by client opere
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly clientId?: Array<number>

    /**
     * Filter dossiers list by formaliste
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly formalisteId?: Array<number>

    /**
     * Filter dossiers list by work group
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly workGroupId?: Array<number>

    /**
     * Filter dossiers list by step
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly stepId?: Array<number>

    /**
     * Filter dossiers list by status
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly statutId?: Array<number>

    /**
     * Filter dossiers list by validator status
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly statutValideurId?: Array<number>

    /**
     * Filter dossiers list by number
     * @type {Array<string>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly numero?: Array<string>

    /**
     * Filter dossiers list by societeRef
     * @type {Array<string>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly societeReference?: Array<string>

    /**
     * Filter dossiers list by formalite
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly formaliteId?: Array<number>

    /**
     * Filter dossiers list by object group
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly groupId?: Array<number>

    /**
     * Filter dossiers list by contact ID
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly contactId?: Array<number>

    /**
     * Filter dossiers list by prescriber ID
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly prescriberId?: Array<number>

    /**
     * Filter dossiers list by societe ID
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly societeId?: Array<number>

    /**
     * Filter dossiers list by offer ID
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly offerId?: Array<number>

    /**
     * Filter dossiers list by greffe ID
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly greffeId?: Array<number>

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly startDate?: string

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly endDate?: string

    /**
     * Filter list by only showing dossiers with missing required documents
     * @type {boolean}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly hasMissingRequiredDocuments?: boolean

    /**
     * Filter list by only showing dossiers demo
     * @type {boolean}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly demo?: boolean

    /**
     * Filter list by only showing dossiers with client message(s) unread
     * @type {boolean}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly hasMessageUnreadClient?: boolean

    /**
     * Filter list by only showing dossiers with interne message(s) unread
     * @type {boolean}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly hasMessageUnreadInterne?: boolean

    /**
     * Filter list by critical flag
     * @type {boolean}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly critical?: boolean

    /**
     * Sort dossier by numero
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderNumero?: string

    /**
     * Sort dossier by societeDenomination
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderSocieteDenomination?: string

    /**
     * Sort dossier by contact\&#39;s name
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderContactNom?: string

    /**
     * Sort dossier by dateCreation
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderDateCreation?: string

    /**
     * Sort dossier by statutLibelle
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderStatutLibelle?: string

    /**
     * Sort dossier by formaliste\&#39;s name
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderFormalisteNom?: string

    /**
     * Sort dossier by prescriber\&#39;s name
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderPrescripteurLibelle?: string

    /**
     * Sort dossier by offer\&#39;s name
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly orderOffreLibelle?: string

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchDossiersIdGet operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchDossiersIdGetRequest
 */
export interface DossierOpenSearchApiApiOpensearchDossiersIdGetRequest {
    /**
     * Dossier identifier
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiOpensearchDossiersIndexByIdsPost operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPostRequest
 */
export interface DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPostRequest {
    /**
     * The new Dossier Open Search resource
     * @type {DossierOpenSearchJsonldOpensearchDossierIndexBatch}
     * @memberof DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPost
     */
    readonly dossierOpenSearchJsonldOpensearchDossierIndexBatch: DossierOpenSearchJsonldOpensearchDossierIndexBatch
}

/**
 * Request parameters for apiOpensearchFormalistesGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchFormalistesGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchFormalistesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly q?: string

    /**
     * Filter dossiers list by formaliste
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly formalisteId?: Array<number>

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly startDate?: string

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly endDate?: string

    /**
     * Filter dossiers list by status
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchFormalistesGetCollection
     */
    readonly statutId?: Array<number>
}

/**
 * Request parameters for apiOpensearchGreffesGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchGreffesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchGreffesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchGreffesGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchNumerosGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchNumerosGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchNumerosGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchNumerosGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchNumerosGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchNumerosGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchObjectGroupsGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchObjectGroupsGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchObjectGroupsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchObjectGroupsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchObjectGroupsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter dossiersGroup list by object group id
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchObjectGroupsGetCollection
     */
    readonly groupId?: Array<number>

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchObjectGroupsGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchOffersGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchOffersGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchOffersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchOffersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchOffersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchOffersGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchPrefiltersGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchPrefiltersGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchPrefiltersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchPrefiltersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchPrefiltersGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiOpensearchPrescripteursGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchPrescripteursGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchPrescripteursGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchPrescripteursGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchSocieteReferenceGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchStatusesGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchStatusesGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchStatusesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchStatusesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchStatusesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter dossiers list by formaliste
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchStatusesGetCollection
     */
    readonly formalisteId?: Array<number>

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchStatusesGetCollection
     */
    readonly startDate?: string

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchStatusesGetCollection
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiOpensearchValideursStatusGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchValideursStatusGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchValideursStatusGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchValideursStatusGetCollection
     */
    readonly q?: string

    /**
     * Filter dossiers list by formaliste
     * @type {Array<number>}
     * @memberof DossierOpenSearchApiApiOpensearchValideursStatusGetCollection
     */
    readonly formalisteId?: Array<number>

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchValideursStatusGetCollection
     */
    readonly startDate?: string

    /**
     * Filter dossiers list by creation date
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchValideursStatusGetCollection
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiOpensearchWorkingGroupsGetCollection operation in DossierOpenSearchApi.
 * @export
 * @interface DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollectionRequest
 */
export interface DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Search term
     * @type {string}
     * @memberof DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollection
     */
    readonly q?: string
}

/**
 * DossierOpenSearchApi - object-oriented interface
 * @export
 * @class DossierOpenSearchApi
 * @extends {BaseAPI}
 */
export class DossierOpenSearchApi extends BaseAPI {
    /**
     * Lister les clients des dossiers indexés sur Open Search
     * @summary Lister les clients des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchClientsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchClientsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchClientsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchClientsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les contacts des dossiers indexés sur Open Search
     * @summary Lister les contacts des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchContactsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchContactsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchContactsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchContactsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les collections de dossiers indexés sur Open Search
     * @summary Lister les collections de dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchDossiersCollectionsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchDossiersCollectionsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchDossiersCollectionsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les dossiers indexés sur Open Search
     * @summary Lister les dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchDossiersGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.collectionId, requestParameters.clientId, requestParameters.formalisteId, requestParameters.workGroupId, requestParameters.stepId, requestParameters.statutId, requestParameters.statutValideurId, requestParameters.numero, requestParameters.societeReference, requestParameters.formaliteId, requestParameters.groupId, requestParameters.contactId, requestParameters.prescriberId, requestParameters.societeId, requestParameters.offerId, requestParameters.greffeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hasMissingRequiredDocuments, requestParameters.demo, requestParameters.hasMessageUnreadClient, requestParameters.hasMessageUnreadInterne, requestParameters.critical, requestParameters.orderNumero, requestParameters.orderSocieteDenomination, requestParameters.orderContactNom, requestParameters.orderDateCreation, requestParameters.orderStatutLibelle, requestParameters.orderFormalisteNom, requestParameters.orderPrescripteurLibelle, requestParameters.orderOffreLibelle, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un dossier indexé sur Open Search
     * @summary Récupérer les informations d\'un dossier indexé sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchDossiersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchDossiersIdGet(requestParameters: DossierOpenSearchApiApiOpensearchDossiersIdGetRequest, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchDossiersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Indexer un lot de dossiers sur Open Search
     * @summary Indexer un lot de dossiers sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchDossiersIndexByIdsPost(requestParameters: DossierOpenSearchApiApiOpensearchDossiersIndexByIdsPostRequest, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchDossiersIndexByIdsPost(requestParameters.dossierOpenSearchJsonldOpensearchDossierIndexBatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les formalistes des dossiers indexés sur Open Search
     * @summary Lister les formalistes des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchFormalistesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchFormalistesGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchFormalistesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchFormalistesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, requestParameters.formalisteId, requestParameters.startDate, requestParameters.endDate, requestParameters.statutId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les greffes des dossiers indexés sur Open Search
     * @summary Lister les greffes des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchGreffesGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchGreffesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les numéros des dossiers indexés sur Open Search
     * @summary Lister les numéros des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchNumerosGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchNumerosGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchNumerosGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchNumerosGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les groupes des dossiers indexés sur Open Search
     * @summary Lister les groupes des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchObjectGroupsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchObjectGroupsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchObjectGroupsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchObjectGroupsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.groupId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les offres des dossiers indexés sur Open Search
     * @summary Lister les offres des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchOffersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchOffersGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchOffersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchOffersGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les prefiltres et totaux des dossiers indexés sur Open Search
     * @summary Lister les prefiltres et totaux des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchPrefiltersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchPrefiltersGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchPrefiltersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchPrefiltersGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les prescripteurs des dossiers indexés sur Open Search
     * @summary Lister les prescripteurs des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchPrescripteursGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchPrescripteursGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les référence de sociétés des dossiers indexés sur Open Search
     * @summary Lister les référence de sociétés des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchSocieteReferenceGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchSocieteReferenceGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchSocieteReferenceGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les statuts des dossiers indexés sur Open Search
     * @summary Lister les statuts des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchStatusesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchStatusesGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchStatusesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchStatusesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.formalisteId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les valideurs et status liés indexés sur Open Search
     * @summary Lister les valideurs et status liés indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchValideursStatusGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchValideursStatusGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, requestParameters.formalisteId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les groupes de travail des dossiers indexés sur Open Search
     * @summary Lister les groupes de travail des dossiers indexés sur Open Search
     * @param {DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierOpenSearchApi
     */
    public apiOpensearchWorkingGroupsGetCollection(requestParameters: DossierOpenSearchApiApiOpensearchWorkingGroupsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DossierOpenSearchApiFp(this.configuration).apiOpensearchWorkingGroupsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DossierReportApi - axios parameter creator
 * @export
 */
export const DossierReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Envoyer le récapitulatif d\'un ou plusieurs dossiers
         * @summary Envoyer le récapitulatif d\'un ou plusieurs dossiers
         * @param {DossierReportJsonld} dossierReportJsonld The new Dossier report resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersReportPost: async (dossierReportJsonld: DossierReportJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierReportJsonld' is not null or undefined
            assertParamExists('apiDossiersReportPost', 'dossierReportJsonld', dossierReportJsonld)
            const localVarPath = `/formalite/dossiers/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierReportJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossierReportApi - functional programming interface
 * @export
 */
export const DossierReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossierReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Envoyer le récapitulatif d\'un ou plusieurs dossiers
         * @summary Envoyer le récapitulatif d\'un ou plusieurs dossiers
         * @param {DossierReportJsonld} dossierReportJsonld The new Dossier report resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersReportPost(dossierReportJsonld: DossierReportJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierReportJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersReportPost(dossierReportJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossierReportApi.apiDossiersReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DossierReportApi - factory interface
 * @export
 */
export const DossierReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossierReportApiFp(configuration)
    return {
        /**
         * Envoyer le récapitulatif d\'un ou plusieurs dossiers
         * @summary Envoyer le récapitulatif d\'un ou plusieurs dossiers
         * @param {DossierReportApiApiDossiersReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersReportPost(requestParameters: DossierReportApiApiDossiersReportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossierReportJsonld> {
            return localVarFp.apiDossiersReportPost(requestParameters.dossierReportJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersReportPost operation in DossierReportApi.
 * @export
 * @interface DossierReportApiApiDossiersReportPostRequest
 */
export interface DossierReportApiApiDossiersReportPostRequest {
    /**
     * The new Dossier report resource
     * @type {DossierReportJsonld}
     * @memberof DossierReportApiApiDossiersReportPost
     */
    readonly dossierReportJsonld: DossierReportJsonld
}

/**
 * DossierReportApi - object-oriented interface
 * @export
 * @class DossierReportApi
 * @extends {BaseAPI}
 */
export class DossierReportApi extends BaseAPI {
    /**
     * Envoyer le récapitulatif d\'un ou plusieurs dossiers
     * @summary Envoyer le récapitulatif d\'un ou plusieurs dossiers
     * @param {DossierReportApiApiDossiersReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossierReportApi
     */
    public apiDossiersReportPost(requestParameters: DossierReportApiApiDossiersReportPostRequest, options?: RawAxiosRequestConfig) {
        return DossierReportApiFp(this.configuration).apiDossiersReportPost(requestParameters.dossierReportJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DossiersDeSignatureLectroniqueApi - axios parameter creator
 * @export
 */
export const DossiersDeSignatureLectroniqueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Télécharger un document signé
         * @summary Télécharger un document signé
         * @param {string} id FproDossierDossierSignDocument identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierDossiersSignFileIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossierDossiersSignFileIdGet', 'id', id)
            const localVarPath = `/formalite/dossier/dossiers-sign/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les dossiers de signature liés à des dossiers de formalité
         * @summary Lister les dossiers de signature liés à des dossiers de formalité
         * @param {string} id FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierIdDossiersSignGetCollection: async (id: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossierIdDossiersSignGetCollection', 'id', id)
            const localVarPath = `/formalite/dossier/{id}/dossiers-sign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un dossier de signature lié à un dossier de formalité
         * @summary Créer un dossier de signature lié à un dossier de formalité
         * @param {string} id FproDossier identifier
         * @param {DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite} dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite The new Dossiers de signature électronique resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierIdDossiersSignPost: async (id: string, dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite: DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossierIdDossiersSignPost', 'id', id)
            // verify required parameter 'dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite' is not null or undefined
            assertParamExists('apiDossierIdDossiersSignPost', 'dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite', dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite)
            const localVarPath = `/formalite/dossier/{id}/dossiers-sign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour un dossier de signature lié à un dossier de formalité
         * @summary Mettre à jour un dossier de signature lié à un dossier de formalité
         * @param {DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback} dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback The new Dossiers de signature électronique resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignCallbackPost: async (dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback: DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback' is not null or undefined
            assertParamExists('apiSignCallbackPost', 'dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback', dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback)
            const localVarPath = `/formalite/sign/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossiersDeSignatureLectroniqueApi - functional programming interface
 * @export
 */
export const DossiersDeSignatureLectroniqueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossiersDeSignatureLectroniqueApiAxiosParamCreator(configuration)
    return {
        /**
         * Télécharger un document signé
         * @summary Télécharger un document signé
         * @param {string} id FproDossierDossierSignDocument identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossierDossiersSignFileIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossierDossiersSignFileIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossiersDeSignatureLectroniqueApi.apiDossierDossiersSignFileIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les dossiers de signature liés à des dossiers de formalité
         * @summary Lister les dossiers de signature liés à des dossiers de formalité
         * @param {string} id FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossierIdDossiersSignGetCollection(id: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossierIdDossiersSignGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossierIdDossiersSignGetCollection(id, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossiersDeSignatureLectroniqueApi.apiDossierIdDossiersSignGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un dossier de signature lié à un dossier de formalité
         * @summary Créer un dossier de signature lié à un dossier de formalité
         * @param {string} id FproDossier identifier
         * @param {DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite} dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite The new Dossiers de signature électronique resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossierIdDossiersSignPost(id: string, dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite: DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossierIdDossiersSignPost(id, dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossiersDeSignatureLectroniqueApi.apiDossierIdDossiersSignPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour un dossier de signature lié à un dossier de formalité
         * @summary Mettre à jour un dossier de signature lié à un dossier de formalité
         * @param {DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback} dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback The new Dossiers de signature électronique resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignCallbackPost(dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback: DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignCallbackPost(dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DossiersDeSignatureLectroniqueApi.apiSignCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DossiersDeSignatureLectroniqueApi - factory interface
 * @export
 */
export const DossiersDeSignatureLectroniqueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossiersDeSignatureLectroniqueApiFp(configuration)
    return {
        /**
         * Télécharger un document signé
         * @summary Télécharger un document signé
         * @param {DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierDossiersSignFileIdGet(requestParameters: DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDossierDossiersSignFileIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les dossiers de signature liés à des dossiers de formalité
         * @summary Lister les dossiers de signature liés à des dossiers de formalité
         * @param {DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierIdDossiersSignGetCollection(requestParameters: DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossierIdDossiersSignGetCollection200Response> {
            return localVarFp.apiDossierIdDossiersSignGetCollection(requestParameters.id, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un dossier de signature lié à un dossier de formalité
         * @summary Créer un dossier de signature lié à un dossier de formalité
         * @param {DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierIdDossiersSignPost(requestParameters: DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossiersDeSignatureLectroniqueDossierSignDtoJsonldDossierDossierSignRead> {
            return localVarFp.apiDossierIdDossiersSignPost(requestParameters.id, requestParameters.dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour un dossier de signature lié à un dossier de formalité
         * @summary Mettre à jour un dossier de signature lié à un dossier de formalité
         * @param {DossiersDeSignatureLectroniqueApiApiSignCallbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignCallbackPost(requestParameters: DossiersDeSignatureLectroniqueApiApiSignCallbackPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DossiersDeSignatureLectroniqueJsonldDossierDossierSignRead> {
            return localVarFp.apiSignCallbackPost(requestParameters.dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossierDossiersSignFileIdGet operation in DossiersDeSignatureLectroniqueApi.
 * @export
 * @interface DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGetRequest
 */
export interface DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGetRequest {
    /**
     * FproDossierDossierSignDocument identifier
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiDossierIdDossiersSignGetCollection operation in DossiersDeSignatureLectroniqueApi.
 * @export
 * @interface DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollectionRequest
 */
export interface DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollection
     */
    readonly id: string

    /**
     * The collection page number
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiDossierIdDossiersSignPost operation in DossiersDeSignatureLectroniqueApi.
 * @export
 * @interface DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPostRequest
 */
export interface DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPostRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPost
     */
    readonly id: string

    /**
     * The new Dossiers de signature électronique resource
     * @type {DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite}
     * @memberof DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPost
     */
    readonly dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite: DossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite
}

/**
 * Request parameters for apiSignCallbackPost operation in DossiersDeSignatureLectroniqueApi.
 * @export
 * @interface DossiersDeSignatureLectroniqueApiApiSignCallbackPostRequest
 */
export interface DossiersDeSignatureLectroniqueApiApiSignCallbackPostRequest {
    /**
     * The new Dossiers de signature électronique resource
     * @type {DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback}
     * @memberof DossiersDeSignatureLectroniqueApiApiSignCallbackPost
     */
    readonly dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback: DossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback
}

/**
 * DossiersDeSignatureLectroniqueApi - object-oriented interface
 * @export
 * @class DossiersDeSignatureLectroniqueApi
 * @extends {BaseAPI}
 */
export class DossiersDeSignatureLectroniqueApi extends BaseAPI {
    /**
     * Télécharger un document signé
     * @summary Télécharger un document signé
     * @param {DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersDeSignatureLectroniqueApi
     */
    public apiDossierDossiersSignFileIdGet(requestParameters: DossiersDeSignatureLectroniqueApiApiDossierDossiersSignFileIdGetRequest, options?: RawAxiosRequestConfig) {
        return DossiersDeSignatureLectroniqueApiFp(this.configuration).apiDossierDossiersSignFileIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les dossiers de signature liés à des dossiers de formalité
     * @summary Lister les dossiers de signature liés à des dossiers de formalité
     * @param {DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersDeSignatureLectroniqueApi
     */
    public apiDossierIdDossiersSignGetCollection(requestParameters: DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return DossiersDeSignatureLectroniqueApiFp(this.configuration).apiDossierIdDossiersSignGetCollection(requestParameters.id, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un dossier de signature lié à un dossier de formalité
     * @summary Créer un dossier de signature lié à un dossier de formalité
     * @param {DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersDeSignatureLectroniqueApi
     */
    public apiDossierIdDossiersSignPost(requestParameters: DossiersDeSignatureLectroniqueApiApiDossierIdDossiersSignPostRequest, options?: RawAxiosRequestConfig) {
        return DossiersDeSignatureLectroniqueApiFp(this.configuration).apiDossierIdDossiersSignPost(requestParameters.id, requestParameters.dossiersDeSignatureLectroniqueCreateDossierSignJsonldDossierDossierSignWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour un dossier de signature lié à un dossier de formalité
     * @summary Mettre à jour un dossier de signature lié à un dossier de formalité
     * @param {DossiersDeSignatureLectroniqueApiApiSignCallbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersDeSignatureLectroniqueApi
     */
    public apiSignCallbackPost(requestParameters: DossiersDeSignatureLectroniqueApiApiSignCallbackPostRequest, options?: RawAxiosRequestConfig) {
        return DossiersDeSignatureLectroniqueApiFp(this.configuration).apiSignCallbackPost(requestParameters.dossiersDeSignatureLectroniqueCallbackJsonldDossierDossierSignCallback, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FichiersDossierApi - axios parameter creator
 * @export
 */
export const FichiersDossierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les fichiers liés au dossier
         * @summary Lister les fichiers liés au dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {number} [expediteur] 
         * @param {Array<number>} [expediteur2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierFichiersGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, dossierNumero?: string, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, expediteur?: number, expediteur2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierFichiersGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/fichiers`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (dossierId !== undefined) {
                localVarQueryParameter['dossier.id'] = dossierId;
            }

            if (dossierId2) {
                localVarQueryParameter['dossier.id[]'] = dossierId2;
            }

            if (dossierPrescripteurId !== undefined) {
                localVarQueryParameter['dossier.prescripteur.id'] = dossierPrescripteurId;
            }

            if (dossierPrescripteurId2) {
                localVarQueryParameter['dossier.prescripteur.id[]'] = dossierPrescripteurId2;
            }

            if (expediteur !== undefined) {
                localVarQueryParameter['expediteur'] = expediteur;
            }

            if (expediteur2) {
                localVarQueryParameter['expediteur[]'] = expediteur2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un fichier
         * @summary Supprimer un fichier
         * @param {string} id FproDosDocFile identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFichiersIdDelete', 'id', id)
            const localVarPath = `/formalite/fichiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Fichiers Dossier resource.
         * @summary Retrieves a Fichiers Dossier resource.
         * @param {string} id FproDosDocFile identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdFileGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFichiersIdFileGet', 'id', id)
            const localVarPath = `/formalite/fichiers/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Fichiers Dossier resource.
         * @summary Retrieves a Fichiers Dossier resource.
         * @param {string} id FproDosDocFile identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFichiersIdGet', 'id', id)
            const localVarPath = `/formalite/fichiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Fichiers Dossier resource.
         * @summary Updates the Fichiers Dossier resource.
         * @param {string} id FproDosDocFile identifier
         * @param {FichiersDossierUpdateDocumentFileDocumentfileUpdate} fichiersDossierUpdateDocumentFileDocumentfileUpdate The updated Fichiers Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdPatch: async (id: string, fichiersDossierUpdateDocumentFileDocumentfileUpdate: FichiersDossierUpdateDocumentFileDocumentfileUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFichiersIdPatch', 'id', id)
            // verify required parameter 'fichiersDossierUpdateDocumentFileDocumentfileUpdate' is not null or undefined
            assertParamExists('apiFichiersIdPatch', 'fichiersDossierUpdateDocumentFileDocumentfileUpdate', fichiersDossierUpdateDocumentFileDocumentfileUpdate)
            const localVarPath = `/formalite/fichiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fichiersDossierUpdateDocumentFileDocumentfileUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ajouter un fichier
         * @summary Ajouter un fichier
         * @param {string | null} dossier 
         * @param {File | null} file 
         * @param {ApiFichiersPostExpediteurEnum} [expediteur] 
         * @param {ApiFichiersPostExpeditionEnum} [expedition] 
         * @param {number | null} [idDocDf] 
         * @param {number | null} [idReglement] 
         * @param {string | null} [typeDoc] 
         * @param {FproDosDocFileDocumentfileCreate | null} [docSigned] 
         * @param {FproDosDocFileDocumentfileCreate | null} [docOriginal] 
         * @param {boolean | null} [typageAuto] 
         * @param {boolean | null} [deliassageAuto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersPost: async (dossier: string | null, file: File | null, expediteur?: ApiFichiersPostExpediteurEnum, expedition?: ApiFichiersPostExpeditionEnum, idDocDf?: number | null, idReglement?: number | null, typeDoc?: string | null, docSigned?: FproDosDocFileDocumentfileCreate | null, docOriginal?: FproDosDocFileDocumentfileCreate | null, typageAuto?: boolean | null, deliassageAuto?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiFichiersPost', 'dossier', dossier)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiFichiersPost', 'file', file)
            const localVarPath = `/formalite/fichiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


            if (dossier !== undefined) { 
                localVarFormParams.append('dossier', dossier as any);
            }
    
            if (expediteur !== undefined) { 
                localVarFormParams.append('expediteur', expediteur as any);
            }
    
            if (expedition !== undefined) { 
                localVarFormParams.append('expedition', expedition as any);
            }
    
            if (idDocDf !== undefined) { 
                localVarFormParams.append('idDocDf', idDocDf as any);
            }
    
            if (idReglement !== undefined) { 
                localVarFormParams.append('idReglement', idReglement as any);
            }
    
            if (typeDoc !== undefined) { 
                localVarFormParams.append('typeDoc', typeDoc as any);
            }
    
            if (docSigned !== undefined) { 
                localVarFormParams.append('docSigned', new Blob([JSON.stringify(docSigned)], { type: "application/json", }));
            }
    
            if (docOriginal !== undefined) { 
                localVarFormParams.append('docOriginal', new Blob([JSON.stringify(docOriginal)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (typageAuto !== undefined) { 
                localVarFormParams.append('typageAuto', String(typageAuto) as any);
            }
    
            if (deliassageAuto !== undefined) { 
                localVarFormParams.append('deliassageAuto', String(deliassageAuto) as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FichiersDossierApi - functional programming interface
 * @export
 */
export const FichiersDossierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FichiersDossierApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les fichiers liés au dossier
         * @summary Lister les fichiers liés au dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {number} [expediteur] 
         * @param {Array<number>} [expediteur2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierFichiersGetCollection(dossier: string, page?: number, itemsPerPage?: number, dossierNumero?: string, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, expediteur?: number, expediteur2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierFichiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierFichiersGetCollection(dossier, page, itemsPerPage, dossierNumero, dossierId, dossierId2, dossierPrescripteurId, dossierPrescripteurId2, expediteur, expediteur2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FichiersDossierApi.apiDossiersDossierFichiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un fichier
         * @summary Supprimer un fichier
         * @param {string} id FproDosDocFile identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFichiersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFichiersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FichiersDossierApi.apiFichiersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Fichiers Dossier resource.
         * @summary Retrieves a Fichiers Dossier resource.
         * @param {string} id FproDosDocFile identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFichiersIdFileGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFichiersIdFileGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FichiersDossierApi.apiFichiersIdFileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Fichiers Dossier resource.
         * @summary Retrieves a Fichiers Dossier resource.
         * @param {string} id FproDosDocFile identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFichiersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FichiersDossierJsonldDocumentfileRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFichiersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FichiersDossierApi.apiFichiersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Fichiers Dossier resource.
         * @summary Updates the Fichiers Dossier resource.
         * @param {string} id FproDosDocFile identifier
         * @param {FichiersDossierUpdateDocumentFileDocumentfileUpdate} fichiersDossierUpdateDocumentFileDocumentfileUpdate The updated Fichiers Dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFichiersIdPatch(id: string, fichiersDossierUpdateDocumentFileDocumentfileUpdate: FichiersDossierUpdateDocumentFileDocumentfileUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFichiersIdPatch(id, fichiersDossierUpdateDocumentFileDocumentfileUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FichiersDossierApi.apiFichiersIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ajouter un fichier
         * @summary Ajouter un fichier
         * @param {string | null} dossier 
         * @param {File | null} file 
         * @param {ApiFichiersPostExpediteurEnum} [expediteur] 
         * @param {ApiFichiersPostExpeditionEnum} [expedition] 
         * @param {number | null} [idDocDf] 
         * @param {number | null} [idReglement] 
         * @param {string | null} [typeDoc] 
         * @param {FproDosDocFileDocumentfileCreate | null} [docSigned] 
         * @param {FproDosDocFileDocumentfileCreate | null} [docOriginal] 
         * @param {boolean | null} [typageAuto] 
         * @param {boolean | null} [deliassageAuto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFichiersPost(dossier: string | null, file: File | null, expediteur?: ApiFichiersPostExpediteurEnum, expedition?: ApiFichiersPostExpeditionEnum, idDocDf?: number | null, idReglement?: number | null, typeDoc?: string | null, docSigned?: FproDosDocFileDocumentfileCreate | null, docOriginal?: FproDosDocFileDocumentfileCreate | null, typageAuto?: boolean | null, deliassageAuto?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFichiersPost(dossier, file, expediteur, expedition, idDocDf, idReglement, typeDoc, docSigned, docOriginal, typageAuto, deliassageAuto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FichiersDossierApi.apiFichiersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FichiersDossierApi - factory interface
 * @export
 */
export const FichiersDossierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FichiersDossierApiFp(configuration)
    return {
        /**
         * Lister les fichiers liés au dossier
         * @summary Lister les fichiers liés au dossier
         * @param {FichiersDossierApiApiDossiersDossierFichiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierFichiersGetCollection(requestParameters: FichiersDossierApiApiDossiersDossierFichiersGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierFichiersGetCollection200Response> {
            return localVarFp.apiDossiersDossierFichiersGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, requestParameters.expediteur, requestParameters.expediteur2, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un fichier
         * @summary Supprimer un fichier
         * @param {FichiersDossierApiApiFichiersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdDelete(requestParameters: FichiersDossierApiApiFichiersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFichiersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Fichiers Dossier resource.
         * @summary Retrieves a Fichiers Dossier resource.
         * @param {FichiersDossierApiApiFichiersIdFileGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdFileGet(requestParameters: FichiersDossierApiApiFichiersIdFileGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFichiersIdFileGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Fichiers Dossier resource.
         * @summary Retrieves a Fichiers Dossier resource.
         * @param {FichiersDossierApiApiFichiersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdGet(requestParameters: FichiersDossierApiApiFichiersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FichiersDossierJsonldDocumentfileRead> {
            return localVarFp.apiFichiersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Fichiers Dossier resource.
         * @summary Updates the Fichiers Dossier resource.
         * @param {FichiersDossierApiApiFichiersIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersIdPatch(requestParameters: FichiersDossierApiApiFichiersIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<FichiersDossierUpdatedFilePatchResponseDtoJsonldDocumentfileRead> {
            return localVarFp.apiFichiersIdPatch(requestParameters.id, requestParameters.fichiersDossierUpdateDocumentFileDocumentfileUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Ajouter un fichier
         * @summary Ajouter un fichier
         * @param {FichiersDossierApiApiFichiersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFichiersPost(requestParameters: FichiersDossierApiApiFichiersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FichiersDossierCreatedFilesPostResponseDtoJsonldDocumentfileRead> {
            return localVarFp.apiFichiersPost(requestParameters.dossier, requestParameters.file, requestParameters.expediteur, requestParameters.expedition, requestParameters.idDocDf, requestParameters.idReglement, requestParameters.typeDoc, requestParameters.docSigned, requestParameters.docOriginal, requestParameters.typageAuto, requestParameters.deliassageAuto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierFichiersGetCollection operation in FichiersDossierApi.
 * @export
 * @interface FichiersDossierApiApiDossiersDossierFichiersGetCollectionRequest
 */
export interface FichiersDossierApiApiDossiersDossierFichiersGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly dossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly dossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly dossierPrescripteurId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly dossierPrescripteurId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly expediteur?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FichiersDossierApiApiDossiersDossierFichiersGetCollection
     */
    readonly expediteur2?: Array<number>
}

/**
 * Request parameters for apiFichiersIdDelete operation in FichiersDossierApi.
 * @export
 * @interface FichiersDossierApiApiFichiersIdDeleteRequest
 */
export interface FichiersDossierApiApiFichiersIdDeleteRequest {
    /**
     * FproDosDocFile identifier
     * @type {string}
     * @memberof FichiersDossierApiApiFichiersIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiFichiersIdFileGet operation in FichiersDossierApi.
 * @export
 * @interface FichiersDossierApiApiFichiersIdFileGetRequest
 */
export interface FichiersDossierApiApiFichiersIdFileGetRequest {
    /**
     * FproDosDocFile identifier
     * @type {string}
     * @memberof FichiersDossierApiApiFichiersIdFileGet
     */
    readonly id: string
}

/**
 * Request parameters for apiFichiersIdGet operation in FichiersDossierApi.
 * @export
 * @interface FichiersDossierApiApiFichiersIdGetRequest
 */
export interface FichiersDossierApiApiFichiersIdGetRequest {
    /**
     * FproDosDocFile identifier
     * @type {string}
     * @memberof FichiersDossierApiApiFichiersIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiFichiersIdPatch operation in FichiersDossierApi.
 * @export
 * @interface FichiersDossierApiApiFichiersIdPatchRequest
 */
export interface FichiersDossierApiApiFichiersIdPatchRequest {
    /**
     * FproDosDocFile identifier
     * @type {string}
     * @memberof FichiersDossierApiApiFichiersIdPatch
     */
    readonly id: string

    /**
     * The updated Fichiers Dossier resource
     * @type {FichiersDossierUpdateDocumentFileDocumentfileUpdate}
     * @memberof FichiersDossierApiApiFichiersIdPatch
     */
    readonly fichiersDossierUpdateDocumentFileDocumentfileUpdate: FichiersDossierUpdateDocumentFileDocumentfileUpdate
}

/**
 * Request parameters for apiFichiersPost operation in FichiersDossierApi.
 * @export
 * @interface FichiersDossierApiApiFichiersPostRequest
 */
export interface FichiersDossierApiApiFichiersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly dossier: string | null

    /**
     * 
     * @type {File}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly file: File | null

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly expediteur?: ApiFichiersPostExpediteurEnum

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly expedition?: ApiFichiersPostExpeditionEnum

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly idDocDf?: number | null

    /**
     * 
     * @type {number}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly idReglement?: number | null

    /**
     * 
     * @type {string}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly typeDoc?: string | null

    /**
     * 
     * @type {FproDosDocFileDocumentfileCreate}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly docSigned?: FproDosDocFileDocumentfileCreate | null

    /**
     * 
     * @type {FproDosDocFileDocumentfileCreate}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly docOriginal?: FproDosDocFileDocumentfileCreate | null

    /**
     * 
     * @type {boolean}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly typageAuto?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof FichiersDossierApiApiFichiersPost
     */
    readonly deliassageAuto?: boolean | null
}

/**
 * FichiersDossierApi - object-oriented interface
 * @export
 * @class FichiersDossierApi
 * @extends {BaseAPI}
 */
export class FichiersDossierApi extends BaseAPI {
    /**
     * Lister les fichiers liés au dossier
     * @summary Lister les fichiers liés au dossier
     * @param {FichiersDossierApiApiDossiersDossierFichiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersDossierApi
     */
    public apiDossiersDossierFichiersGetCollection(requestParameters: FichiersDossierApiApiDossiersDossierFichiersGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return FichiersDossierApiFp(this.configuration).apiDossiersDossierFichiersGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, requestParameters.expediteur, requestParameters.expediteur2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un fichier
     * @summary Supprimer un fichier
     * @param {FichiersDossierApiApiFichiersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersDossierApi
     */
    public apiFichiersIdDelete(requestParameters: FichiersDossierApiApiFichiersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FichiersDossierApiFp(this.configuration).apiFichiersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Fichiers Dossier resource.
     * @summary Retrieves a Fichiers Dossier resource.
     * @param {FichiersDossierApiApiFichiersIdFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersDossierApi
     */
    public apiFichiersIdFileGet(requestParameters: FichiersDossierApiApiFichiersIdFileGetRequest, options?: RawAxiosRequestConfig) {
        return FichiersDossierApiFp(this.configuration).apiFichiersIdFileGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Fichiers Dossier resource.
     * @summary Retrieves a Fichiers Dossier resource.
     * @param {FichiersDossierApiApiFichiersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersDossierApi
     */
    public apiFichiersIdGet(requestParameters: FichiersDossierApiApiFichiersIdGetRequest, options?: RawAxiosRequestConfig) {
        return FichiersDossierApiFp(this.configuration).apiFichiersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Fichiers Dossier resource.
     * @summary Updates the Fichiers Dossier resource.
     * @param {FichiersDossierApiApiFichiersIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersDossierApi
     */
    public apiFichiersIdPatch(requestParameters: FichiersDossierApiApiFichiersIdPatchRequest, options?: RawAxiosRequestConfig) {
        return FichiersDossierApiFp(this.configuration).apiFichiersIdPatch(requestParameters.id, requestParameters.fichiersDossierUpdateDocumentFileDocumentfileUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ajouter un fichier
     * @summary Ajouter un fichier
     * @param {FichiersDossierApiApiFichiersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersDossierApi
     */
    public apiFichiersPost(requestParameters: FichiersDossierApiApiFichiersPostRequest, options?: RawAxiosRequestConfig) {
        return FichiersDossierApiFp(this.configuration).apiFichiersPost(requestParameters.dossier, requestParameters.file, requestParameters.expediteur, requestParameters.expedition, requestParameters.idDocDf, requestParameters.idReglement, requestParameters.typeDoc, requestParameters.docSigned, requestParameters.docOriginal, requestParameters.typageAuto, requestParameters.deliassageAuto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiFichiersPostExpediteurEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type ApiFichiersPostExpediteurEnum = typeof ApiFichiersPostExpediteurEnum[keyof typeof ApiFichiersPostExpediteurEnum];
/**
 * @export
 */
export const ApiFichiersPostExpeditionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;
export type ApiFichiersPostExpeditionEnum = typeof ApiFichiersPostExpeditionEnum[keyof typeof ApiFichiersPostExpeditionEnum];


/**
 * FormalisteApi - axios parameter creator
 * @export
 */
export const FormalisteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des formalistes
         * @summary Obtenir la liste des formalistes
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [fullname] Filtre les formalistes par nom ou prénom (partial search)
         * @param {boolean} [deleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalistesGetCollection: async (page?: number, itemsPerPage?: number, fullname?: string, deleted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/formalistes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (fullname !== undefined) {
                localVarQueryParameter['fullname'] = fullname;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un formaliste
         * @summary Récupérer les informations d\'un formaliste
         * @param {string} id TblUtilisateur identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalistesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormalistesIdGet', 'id', id)
            const localVarPath = `/formalite/formalistes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormalisteApi - functional programming interface
 * @export
 */
export const FormalisteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormalisteApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des formalistes
         * @summary Obtenir la liste des formalistes
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [fullname] Filtre les formalistes par nom ou prénom (partial search)
         * @param {boolean} [deleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalistesGetCollection(page?: number, itemsPerPage?: number, fullname?: string, deleted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFormalistesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalistesGetCollection(page, itemsPerPage, fullname, deleted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormalisteApi.apiFormalistesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un formaliste
         * @summary Récupérer les informations d\'un formaliste
         * @param {string} id TblUtilisateur identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalistesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormalisteJsonldFormalisteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalistesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormalisteApi.apiFormalistesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormalisteApi - factory interface
 * @export
 */
export const FormalisteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormalisteApiFp(configuration)
    return {
        /**
         * Obtenir la liste des formalistes
         * @summary Obtenir la liste des formalistes
         * @param {FormalisteApiApiFormalistesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalistesGetCollection(requestParameters: FormalisteApiApiFormalistesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiFormalistesGetCollection200Response> {
            return localVarFp.apiFormalistesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.fullname, requestParameters.deleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un formaliste
         * @summary Récupérer les informations d\'un formaliste
         * @param {FormalisteApiApiFormalistesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalistesIdGet(requestParameters: FormalisteApiApiFormalistesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormalisteJsonldFormalisteRead> {
            return localVarFp.apiFormalistesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFormalistesGetCollection operation in FormalisteApi.
 * @export
 * @interface FormalisteApiApiFormalistesGetCollectionRequest
 */
export interface FormalisteApiApiFormalistesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof FormalisteApiApiFormalistesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FormalisteApiApiFormalistesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filtre les formalistes par nom ou prénom (partial search)
     * @type {string}
     * @memberof FormalisteApiApiFormalistesGetCollection
     */
    readonly fullname?: string

    /**
     * 
     * @type {boolean}
     * @memberof FormalisteApiApiFormalistesGetCollection
     */
    readonly deleted?: boolean
}

/**
 * Request parameters for apiFormalistesIdGet operation in FormalisteApi.
 * @export
 * @interface FormalisteApiApiFormalistesIdGetRequest
 */
export interface FormalisteApiApiFormalistesIdGetRequest {
    /**
     * TblUtilisateur identifier
     * @type {string}
     * @memberof FormalisteApiApiFormalistesIdGet
     */
    readonly id: string
}

/**
 * FormalisteApi - object-oriented interface
 * @export
 * @class FormalisteApi
 * @extends {BaseAPI}
 */
export class FormalisteApi extends BaseAPI {
    /**
     * Obtenir la liste des formalistes
     * @summary Obtenir la liste des formalistes
     * @param {FormalisteApiApiFormalistesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalisteApi
     */
    public apiFormalistesGetCollection(requestParameters: FormalisteApiApiFormalistesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FormalisteApiFp(this.configuration).apiFormalistesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.fullname, requestParameters.deleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un formaliste
     * @summary Récupérer les informations d\'un formaliste
     * @param {FormalisteApiApiFormalistesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalisteApi
     */
    public apiFormalistesIdGet(requestParameters: FormalisteApiApiFormalistesIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormalisteApiFp(this.configuration).apiFormalistesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormaliteApi - axios parameter creator
 * @export
 */
export const FormaliteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des formalites
         * @summary Obtenir la liste des formalites
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {number} [categorieId] 
         * @param {Array<number>} [categorieId2] 
         * @param {ApiFormalitesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {ApiFormalitesGetCollectionOrderCategorieLibelleEnum} [orderCategorieLibelle] 
         * @param {ApiFormalitesGetCollectionOrderRangEnum} [orderRang] 
         * @param {ApiFormalitesGetCollectionOrderChargeEnum} [orderCharge] 
         * @param {boolean} [deleted] 
         * @param {number} [compatibleWith] Retrieve compatible formalities by formality ID
         * @param {number} [groupement] Filtre les formalités par groupement
         * @param {string} [multiFieldSearch] Partial search in chosen fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesGetCollection: async (page?: number, itemsPerPage?: number, libelle?: string, categorieId?: number, categorieId2?: Array<number>, orderLibelle?: ApiFormalitesGetCollectionOrderLibelleEnum, orderCategorieLibelle?: ApiFormalitesGetCollectionOrderCategorieLibelleEnum, orderRang?: ApiFormalitesGetCollectionOrderRangEnum, orderCharge?: ApiFormalitesGetCollectionOrderChargeEnum, deleted?: boolean, compatibleWith?: number, groupement?: number, multiFieldSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/formalites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }

            if (categorieId !== undefined) {
                localVarQueryParameter['categorie.id'] = categorieId;
            }

            if (categorieId2) {
                localVarQueryParameter['categorie.id[]'] = categorieId2;
            }

            if (orderLibelle !== undefined) {
                localVarQueryParameter['order[libelle]'] = orderLibelle;
            }

            if (orderCategorieLibelle !== undefined) {
                localVarQueryParameter['order[categorie.libelle]'] = orderCategorieLibelle;
            }

            if (orderRang !== undefined) {
                localVarQueryParameter['order[rang]'] = orderRang;
            }

            if (orderCharge !== undefined) {
                localVarQueryParameter['order[charge]'] = orderCharge;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (compatibleWith !== undefined) {
                localVarQueryParameter['compatibleWith'] = compatibleWith;
            }

            if (groupement !== undefined) {
                localVarQueryParameter['groupement'] = groupement;
            }

            if (multiFieldSearch !== undefined) {
                localVarQueryParameter['MultiFieldSearch'] = multiFieldSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suprimmer une formalité
         * @summary Suprimmer une formalité
         * @param {string} id FproFormaliteArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormalitesIdDelete', 'id', id)
            const localVarPath = `/formalite/formalites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une formalite
         * @summary Récupérer les informations d\'une formalite
         * @param {string} id FproFormaliteArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormalitesIdGet', 'id', id)
            const localVarPath = `/formalite/formalites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Formalite resource.
         * @summary Modifier une formalité
         * @param {string} id FproFormaliteArticle identifier
         * @param {FormaliteFormaliteUpdatePartial} formaliteFormaliteUpdatePartial The updated Formalite resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdPatch: async (id: string, formaliteFormaliteUpdatePartial: FormaliteFormaliteUpdatePartial, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormalitesIdPatch', 'id', id)
            // verify required parameter 'formaliteFormaliteUpdatePartial' is not null or undefined
            assertParamExists('apiFormalitesIdPatch', 'formaliteFormaliteUpdatePartial', formaliteFormaliteUpdatePartial)
            const localVarPath = `/formalite/formalites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formaliteFormaliteUpdatePartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Formalite resource.
         * @summary Modifier une formalité
         * @param {string} id FproFormaliteArticle identifier
         * @param {FormaliteJsonldFormaliteUpdate} formaliteJsonldFormaliteUpdate The updated Formalite resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdPut: async (id: string, formaliteJsonldFormaliteUpdate: FormaliteJsonldFormaliteUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormalitesIdPut', 'id', id)
            // verify required parameter 'formaliteJsonldFormaliteUpdate' is not null or undefined
            assertParamExists('apiFormalitesIdPut', 'formaliteJsonldFormaliteUpdate', formaliteJsonldFormaliteUpdate)
            const localVarPath = `/formalite/formalites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formaliteJsonldFormaliteUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Formalite resource.
         * @summary Créer une formalité
         * @param {FormaliteJsonldFormaliteCreate} formaliteJsonldFormaliteCreate The new Formalite resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesPost: async (formaliteJsonldFormaliteCreate: FormaliteJsonldFormaliteCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formaliteJsonldFormaliteCreate' is not null or undefined
            assertParamExists('apiFormalitesPost', 'formaliteJsonldFormaliteCreate', formaliteJsonldFormaliteCreate)
            const localVarPath = `/formalite/formalites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formaliteJsonldFormaliteCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormaliteApi - functional programming interface
 * @export
 */
export const FormaliteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormaliteApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des formalites
         * @summary Obtenir la liste des formalites
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {number} [categorieId] 
         * @param {Array<number>} [categorieId2] 
         * @param {ApiFormalitesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {ApiFormalitesGetCollectionOrderCategorieLibelleEnum} [orderCategorieLibelle] 
         * @param {ApiFormalitesGetCollectionOrderRangEnum} [orderRang] 
         * @param {ApiFormalitesGetCollectionOrderChargeEnum} [orderCharge] 
         * @param {boolean} [deleted] 
         * @param {number} [compatibleWith] Retrieve compatible formalities by formality ID
         * @param {number} [groupement] Filtre les formalités par groupement
         * @param {string} [multiFieldSearch] Partial search in chosen fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalitesGetCollection(page?: number, itemsPerPage?: number, libelle?: string, categorieId?: number, categorieId2?: Array<number>, orderLibelle?: ApiFormalitesGetCollectionOrderLibelleEnum, orderCategorieLibelle?: ApiFormalitesGetCollectionOrderCategorieLibelleEnum, orderRang?: ApiFormalitesGetCollectionOrderRangEnum, orderCharge?: ApiFormalitesGetCollectionOrderChargeEnum, deleted?: boolean, compatibleWith?: number, groupement?: number, multiFieldSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFormalitesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalitesGetCollection(page, itemsPerPage, libelle, categorieId, categorieId2, orderLibelle, orderCategorieLibelle, orderRang, orderCharge, deleted, compatibleWith, groupement, multiFieldSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteApi.apiFormalitesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Suprimmer une formalité
         * @summary Suprimmer une formalité
         * @param {string} id FproFormaliteArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalitesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalitesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteApi.apiFormalitesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une formalite
         * @summary Récupérer les informations d\'une formalite
         * @param {string} id FproFormaliteArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalitesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormaliteJsonldFormaliteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalitesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteApi.apiFormalitesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Formalite resource.
         * @summary Modifier une formalité
         * @param {string} id FproFormaliteArticle identifier
         * @param {FormaliteFormaliteUpdatePartial} formaliteFormaliteUpdatePartial The updated Formalite resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalitesIdPatch(id: string, formaliteFormaliteUpdatePartial: FormaliteFormaliteUpdatePartial, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormaliteJsonldFormaliteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalitesIdPatch(id, formaliteFormaliteUpdatePartial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteApi.apiFormalitesIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Formalite resource.
         * @summary Modifier une formalité
         * @param {string} id FproFormaliteArticle identifier
         * @param {FormaliteJsonldFormaliteUpdate} formaliteJsonldFormaliteUpdate The updated Formalite resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalitesIdPut(id: string, formaliteJsonldFormaliteUpdate: FormaliteJsonldFormaliteUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormaliteJsonldFormaliteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalitesIdPut(id, formaliteJsonldFormaliteUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteApi.apiFormalitesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Formalite resource.
         * @summary Créer une formalité
         * @param {FormaliteJsonldFormaliteCreate} formaliteJsonldFormaliteCreate The new Formalite resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormalitesPost(formaliteJsonldFormaliteCreate: FormaliteJsonldFormaliteCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormaliteJsonldFormaliteCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormalitesPost(formaliteJsonldFormaliteCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteApi.apiFormalitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormaliteApi - factory interface
 * @export
 */
export const FormaliteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormaliteApiFp(configuration)
    return {
        /**
         * Obtenir la liste des formalites
         * @summary Obtenir la liste des formalites
         * @param {FormaliteApiApiFormalitesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesGetCollection(requestParameters: FormaliteApiApiFormalitesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiFormalitesGetCollection200Response> {
            return localVarFp.apiFormalitesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.categorieId, requestParameters.categorieId2, requestParameters.orderLibelle, requestParameters.orderCategorieLibelle, requestParameters.orderRang, requestParameters.orderCharge, requestParameters.deleted, requestParameters.compatibleWith, requestParameters.groupement, requestParameters.multiFieldSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Suprimmer une formalité
         * @summary Suprimmer une formalité
         * @param {FormaliteApiApiFormalitesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdDelete(requestParameters: FormaliteApiApiFormalitesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFormalitesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une formalite
         * @summary Récupérer les informations d\'une formalite
         * @param {FormaliteApiApiFormalitesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdGet(requestParameters: FormaliteApiApiFormalitesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormaliteJsonldFormaliteRead> {
            return localVarFp.apiFormalitesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Formalite resource.
         * @summary Modifier une formalité
         * @param {FormaliteApiApiFormalitesIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdPatch(requestParameters: FormaliteApiApiFormalitesIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormaliteJsonldFormaliteRead> {
            return localVarFp.apiFormalitesIdPatch(requestParameters.id, requestParameters.formaliteFormaliteUpdatePartial, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Formalite resource.
         * @summary Modifier une formalité
         * @param {FormaliteApiApiFormalitesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesIdPut(requestParameters: FormaliteApiApiFormalitesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormaliteJsonldFormaliteRead> {
            return localVarFp.apiFormalitesIdPut(requestParameters.id, requestParameters.formaliteJsonldFormaliteUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Formalite resource.
         * @summary Créer une formalité
         * @param {FormaliteApiApiFormalitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormalitesPost(requestParameters: FormaliteApiApiFormalitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormaliteJsonldFormaliteCreated> {
            return localVarFp.apiFormalitesPost(requestParameters.formaliteJsonldFormaliteCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFormalitesGetCollection operation in FormaliteApi.
 * @export
 * @interface FormaliteApiApiFormalitesGetCollectionRequest
 */
export interface FormaliteApiApiFormalitesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly libelle?: string

    /**
     * 
     * @type {number}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly categorieId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly categorieId2?: Array<number>

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly orderLibelle?: ApiFormalitesGetCollectionOrderLibelleEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly orderCategorieLibelle?: ApiFormalitesGetCollectionOrderCategorieLibelleEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly orderRang?: ApiFormalitesGetCollectionOrderRangEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly orderCharge?: ApiFormalitesGetCollectionOrderChargeEnum

    /**
     * 
     * @type {boolean}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly deleted?: boolean

    /**
     * Retrieve compatible formalities by formality ID
     * @type {number}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly compatibleWith?: number

    /**
     * Filtre les formalités par groupement
     * @type {number}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly groupement?: number

    /**
     * Partial search in chosen fields
     * @type {string}
     * @memberof FormaliteApiApiFormalitesGetCollection
     */
    readonly multiFieldSearch?: string
}

/**
 * Request parameters for apiFormalitesIdDelete operation in FormaliteApi.
 * @export
 * @interface FormaliteApiApiFormalitesIdDeleteRequest
 */
export interface FormaliteApiApiFormalitesIdDeleteRequest {
    /**
     * FproFormaliteArticle identifier
     * @type {string}
     * @memberof FormaliteApiApiFormalitesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiFormalitesIdGet operation in FormaliteApi.
 * @export
 * @interface FormaliteApiApiFormalitesIdGetRequest
 */
export interface FormaliteApiApiFormalitesIdGetRequest {
    /**
     * FproFormaliteArticle identifier
     * @type {string}
     * @memberof FormaliteApiApiFormalitesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiFormalitesIdPatch operation in FormaliteApi.
 * @export
 * @interface FormaliteApiApiFormalitesIdPatchRequest
 */
export interface FormaliteApiApiFormalitesIdPatchRequest {
    /**
     * FproFormaliteArticle identifier
     * @type {string}
     * @memberof FormaliteApiApiFormalitesIdPatch
     */
    readonly id: string

    /**
     * The updated Formalite resource
     * @type {FormaliteFormaliteUpdatePartial}
     * @memberof FormaliteApiApiFormalitesIdPatch
     */
    readonly formaliteFormaliteUpdatePartial: FormaliteFormaliteUpdatePartial
}

/**
 * Request parameters for apiFormalitesIdPut operation in FormaliteApi.
 * @export
 * @interface FormaliteApiApiFormalitesIdPutRequest
 */
export interface FormaliteApiApiFormalitesIdPutRequest {
    /**
     * FproFormaliteArticle identifier
     * @type {string}
     * @memberof FormaliteApiApiFormalitesIdPut
     */
    readonly id: string

    /**
     * The updated Formalite resource
     * @type {FormaliteJsonldFormaliteUpdate}
     * @memberof FormaliteApiApiFormalitesIdPut
     */
    readonly formaliteJsonldFormaliteUpdate: FormaliteJsonldFormaliteUpdate
}

/**
 * Request parameters for apiFormalitesPost operation in FormaliteApi.
 * @export
 * @interface FormaliteApiApiFormalitesPostRequest
 */
export interface FormaliteApiApiFormalitesPostRequest {
    /**
     * The new Formalite resource
     * @type {FormaliteJsonldFormaliteCreate}
     * @memberof FormaliteApiApiFormalitesPost
     */
    readonly formaliteJsonldFormaliteCreate: FormaliteJsonldFormaliteCreate
}

/**
 * FormaliteApi - object-oriented interface
 * @export
 * @class FormaliteApi
 * @extends {BaseAPI}
 */
export class FormaliteApi extends BaseAPI {
    /**
     * Obtenir la liste des formalites
     * @summary Obtenir la liste des formalites
     * @param {FormaliteApiApiFormalitesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteApi
     */
    public apiFormalitesGetCollection(requestParameters: FormaliteApiApiFormalitesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FormaliteApiFp(this.configuration).apiFormalitesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.categorieId, requestParameters.categorieId2, requestParameters.orderLibelle, requestParameters.orderCategorieLibelle, requestParameters.orderRang, requestParameters.orderCharge, requestParameters.deleted, requestParameters.compatibleWith, requestParameters.groupement, requestParameters.multiFieldSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suprimmer une formalité
     * @summary Suprimmer une formalité
     * @param {FormaliteApiApiFormalitesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteApi
     */
    public apiFormalitesIdDelete(requestParameters: FormaliteApiApiFormalitesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormaliteApiFp(this.configuration).apiFormalitesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une formalite
     * @summary Récupérer les informations d\'une formalite
     * @param {FormaliteApiApiFormalitesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteApi
     */
    public apiFormalitesIdGet(requestParameters: FormaliteApiApiFormalitesIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormaliteApiFp(this.configuration).apiFormalitesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Formalite resource.
     * @summary Modifier une formalité
     * @param {FormaliteApiApiFormalitesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteApi
     */
    public apiFormalitesIdPatch(requestParameters: FormaliteApiApiFormalitesIdPatchRequest, options?: RawAxiosRequestConfig) {
        return FormaliteApiFp(this.configuration).apiFormalitesIdPatch(requestParameters.id, requestParameters.formaliteFormaliteUpdatePartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Formalite resource.
     * @summary Modifier une formalité
     * @param {FormaliteApiApiFormalitesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteApi
     */
    public apiFormalitesIdPut(requestParameters: FormaliteApiApiFormalitesIdPutRequest, options?: RawAxiosRequestConfig) {
        return FormaliteApiFp(this.configuration).apiFormalitesIdPut(requestParameters.id, requestParameters.formaliteJsonldFormaliteUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Formalite resource.
     * @summary Créer une formalité
     * @param {FormaliteApiApiFormalitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteApi
     */
    public apiFormalitesPost(requestParameters: FormaliteApiApiFormalitesPostRequest, options?: RawAxiosRequestConfig) {
        return FormaliteApiFp(this.configuration).apiFormalitesPost(requestParameters.formaliteJsonldFormaliteCreate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiFormalitesGetCollectionOrderLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFormalitesGetCollectionOrderLibelleEnum = typeof ApiFormalitesGetCollectionOrderLibelleEnum[keyof typeof ApiFormalitesGetCollectionOrderLibelleEnum];
/**
 * @export
 */
export const ApiFormalitesGetCollectionOrderCategorieLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFormalitesGetCollectionOrderCategorieLibelleEnum = typeof ApiFormalitesGetCollectionOrderCategorieLibelleEnum[keyof typeof ApiFormalitesGetCollectionOrderCategorieLibelleEnum];
/**
 * @export
 */
export const ApiFormalitesGetCollectionOrderRangEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFormalitesGetCollectionOrderRangEnum = typeof ApiFormalitesGetCollectionOrderRangEnum[keyof typeof ApiFormalitesGetCollectionOrderRangEnum];
/**
 * @export
 */
export const ApiFormalitesGetCollectionOrderChargeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFormalitesGetCollectionOrderChargeEnum = typeof ApiFormalitesGetCollectionOrderChargeEnum[keyof typeof ApiFormalitesGetCollectionOrderChargeEnum];


/**
 * FormaliteArticleOpenSearchApi - axios parameter creator
 * @export
 */
export const FormaliteArticleOpenSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les formalités indexées sur Open Search
         * @summary Lister les formalités indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] Filter formalites by libelle (partial match)
         * @param {string} [q] Filter formalites by libelle or category libelle
         * @param {Array<number>} [categorieId] Filter formalites by categorie ID
         * @param {boolean} [deleted] Filter formalites by deleted status
         * @param {string} [orderLibelle] Sort formalites by libelle
         * @param {string} [orderCategorieLibelle] Sort formalites by categorie libelle
         * @param {string} [orderRang] Sort formalites by rang
         * @param {string} [orderCharge] Sort formalites by charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalitesGetCollection: async (page?: number, itemsPerPage?: number, libelle?: string, q?: string, categorieId?: Array<number>, deleted?: boolean, orderLibelle?: string, orderCategorieLibelle?: string, orderRang?: string, orderCharge?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/opensearch/formalites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (categorieId) {
                localVarQueryParameter['categorie.id[]'] = categorieId;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (orderLibelle !== undefined) {
                localVarQueryParameter['order[libelle]'] = orderLibelle;
            }

            if (orderCategorieLibelle !== undefined) {
                localVarQueryParameter['order[categorie.libelle]'] = orderCategorieLibelle;
            }

            if (orderRang !== undefined) {
                localVarQueryParameter['order[rang]'] = orderRang;
            }

            if (orderCharge !== undefined) {
                localVarQueryParameter['order[charge]'] = orderCharge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une formalité indexée sur Open Search
         * @summary Récupérer les informations d\'une formalité indexée sur Open Search
         * @param {string} id Formalite identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalitesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOpensearchFormalitesIdGet', 'id', id)
            const localVarPath = `/formalite/opensearch/formalites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Indexer un lot de formalités sur Open Search
         * @summary Indexer un lot de formalités sur Open Search
         * @param {FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch} formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch The new Formalite Article Open Search resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalitesIndexByIdsPost: async (formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch: FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch' is not null or undefined
            assertParamExists('apiOpensearchFormalitesIndexByIdsPost', 'formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch', formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch)
            const localVarPath = `/formalite/opensearch/formalites/index-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormaliteArticleOpenSearchApi - functional programming interface
 * @export
 */
export const FormaliteArticleOpenSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormaliteArticleOpenSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les formalités indexées sur Open Search
         * @summary Lister les formalités indexées sur Open Search
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] Filter formalites by libelle (partial match)
         * @param {string} [q] Filter formalites by libelle or category libelle
         * @param {Array<number>} [categorieId] Filter formalites by categorie ID
         * @param {boolean} [deleted] Filter formalites by deleted status
         * @param {string} [orderLibelle] Sort formalites by libelle
         * @param {string} [orderCategorieLibelle] Sort formalites by categorie libelle
         * @param {string} [orderRang] Sort formalites by rang
         * @param {string} [orderCharge] Sort formalites by charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFormalitesGetCollection(page?: number, itemsPerPage?: number, libelle?: string, q?: string, categorieId?: Array<number>, deleted?: boolean, orderLibelle?: string, orderCategorieLibelle?: string, orderRang?: string, orderCharge?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFormalitesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFormalitesGetCollection(page, itemsPerPage, libelle, q, categorieId, deleted, orderLibelle, orderCategorieLibelle, orderRang, orderCharge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteArticleOpenSearchApi.apiOpensearchFormalitesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une formalité indexée sur Open Search
         * @summary Récupérer les informations d\'une formalité indexée sur Open Search
         * @param {string} id Formalite identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFormalitesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFormalitesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteArticleOpenSearchApi.apiOpensearchFormalitesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Indexer un lot de formalités sur Open Search
         * @summary Indexer un lot de formalités sur Open Search
         * @param {FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch} formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch The new Formalite Article Open Search resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFormalitesIndexByIdsPost(formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch: FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFormalitesIndexByIdsPost(formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormaliteArticleOpenSearchApi.apiOpensearchFormalitesIndexByIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormaliteArticleOpenSearchApi - factory interface
 * @export
 */
export const FormaliteArticleOpenSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormaliteArticleOpenSearchApiFp(configuration)
    return {
        /**
         * Lister les formalités indexées sur Open Search
         * @summary Lister les formalités indexées sur Open Search
         * @param {FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalitesGetCollection(requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFormalitesGetCollection200Response> {
            return localVarFp.apiOpensearchFormalitesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.q, requestParameters.categorieId, requestParameters.deleted, requestParameters.orderLibelle, requestParameters.orderCategorieLibelle, requestParameters.orderRang, requestParameters.orderCharge, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une formalité indexée sur Open Search
         * @summary Récupérer les informations d\'une formalité indexée sur Open Search
         * @param {FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalitesIdGet(requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead> {
            return localVarFp.apiOpensearchFormalitesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Indexer un lot de formalités sur Open Search
         * @summary Indexer un lot de formalités sur Open Search
         * @param {FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFormalitesIndexByIdsPost(requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormaliteArticleOpenSearchIndexBatchFormaliteResponseJsonldOpensearchFormaliteIndexBatch> {
            return localVarFp.apiOpensearchFormalitesIndexByIdsPost(requestParameters.formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiOpensearchFormalitesGetCollection operation in FormaliteArticleOpenSearchApi.
 * @export
 * @interface FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest
 */
export interface FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter formalites by libelle (partial match)
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly libelle?: string

    /**
     * Filter formalites by libelle or category libelle
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly q?: string

    /**
     * Filter formalites by categorie ID
     * @type {Array<number>}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly categorieId?: Array<number>

    /**
     * Filter formalites by deleted status
     * @type {boolean}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly deleted?: boolean

    /**
     * Sort formalites by libelle
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly orderLibelle?: string

    /**
     * Sort formalites by categorie libelle
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly orderCategorieLibelle?: string

    /**
     * Sort formalites by rang
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly orderRang?: string

    /**
     * Sort formalites by charge
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollection
     */
    readonly orderCharge?: string
}

/**
 * Request parameters for apiOpensearchFormalitesIdGet operation in FormaliteArticleOpenSearchApi.
 * @export
 * @interface FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGetRequest
 */
export interface FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGetRequest {
    /**
     * Formalite identifier
     * @type {string}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiOpensearchFormalitesIndexByIdsPost operation in FormaliteArticleOpenSearchApi.
 * @export
 * @interface FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPostRequest
 */
export interface FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPostRequest {
    /**
     * The new Formalite Article Open Search resource
     * @type {FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch}
     * @memberof FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPost
     */
    readonly formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch: FormaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch
}

/**
 * FormaliteArticleOpenSearchApi - object-oriented interface
 * @export
 * @class FormaliteArticleOpenSearchApi
 * @extends {BaseAPI}
 */
export class FormaliteArticleOpenSearchApi extends BaseAPI {
    /**
     * Lister les formalités indexées sur Open Search
     * @summary Lister les formalités indexées sur Open Search
     * @param {FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteArticleOpenSearchApi
     */
    public apiOpensearchFormalitesGetCollection(requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FormaliteArticleOpenSearchApiFp(this.configuration).apiOpensearchFormalitesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.q, requestParameters.categorieId, requestParameters.deleted, requestParameters.orderLibelle, requestParameters.orderCategorieLibelle, requestParameters.orderRang, requestParameters.orderCharge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une formalité indexée sur Open Search
     * @summary Récupérer les informations d\'une formalité indexée sur Open Search
     * @param {FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteArticleOpenSearchApi
     */
    public apiOpensearchFormalitesIdGet(requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormaliteArticleOpenSearchApiFp(this.configuration).apiOpensearchFormalitesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Indexer un lot de formalités sur Open Search
     * @summary Indexer un lot de formalités sur Open Search
     * @param {FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormaliteArticleOpenSearchApi
     */
    public apiOpensearchFormalitesIndexByIdsPost(requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesIndexByIdsPostRequest, options?: RawAxiosRequestConfig) {
        return FormaliteArticleOpenSearchApiFp(this.configuration).apiOpensearchFormalitesIndexByIdsPost(requestParameters.formaliteArticleOpenSearchJsonldOpensearchFormaliteIndexBatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormeJuridiqueApi - axios parameter creator
 * @export
 */
export const FormeJuridiqueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des formes juridiques
         * @summary Obtenir la liste des formes juridiques
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [nomenclature] 
         * @param {Array<string>} [nomenclature2] 
         * @param {string} [abreviation] 
         * @param {Array<string>} [abreviation2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormesJuridiquesGetCollection: async (page?: number, itemsPerPage?: number, nomenclature?: string, nomenclature2?: Array<string>, abreviation?: string, abreviation2?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/formes-juridiques`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (nomenclature !== undefined) {
                localVarQueryParameter['nomenclature'] = nomenclature;
            }

            if (nomenclature2) {
                localVarQueryParameter['nomenclature[]'] = nomenclature2;
            }

            if (abreviation !== undefined) {
                localVarQueryParameter['abreviation'] = abreviation;
            }

            if (abreviation2) {
                localVarQueryParameter['abreviation[]'] = abreviation2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une forme juridique
         * @summary Récupérer les informations d\'une forme juridique
         * @param {string} id TblAnnonceSTypeDetail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormesJuridiquesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormesJuridiquesIdGet', 'id', id)
            const localVarPath = `/formalite/formes-juridiques/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormeJuridiqueApi - functional programming interface
 * @export
 */
export const FormeJuridiqueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormeJuridiqueApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des formes juridiques
         * @summary Obtenir la liste des formes juridiques
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [nomenclature] 
         * @param {Array<string>} [nomenclature2] 
         * @param {string} [abreviation] 
         * @param {Array<string>} [abreviation2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormesJuridiquesGetCollection(page?: number, itemsPerPage?: number, nomenclature?: string, nomenclature2?: Array<string>, abreviation?: string, abreviation2?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFormesJuridiquesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormesJuridiquesGetCollection(page, itemsPerPage, nomenclature, nomenclature2, abreviation, abreviation2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormeJuridiqueApi.apiFormesJuridiquesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une forme juridique
         * @summary Récupérer les informations d\'une forme juridique
         * @param {string} id TblAnnonceSTypeDetail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormesJuridiquesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormeJuridiqueJsonldFormejuridiqueRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormesJuridiquesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormeJuridiqueApi.apiFormesJuridiquesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormeJuridiqueApi - factory interface
 * @export
 */
export const FormeJuridiqueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormeJuridiqueApiFp(configuration)
    return {
        /**
         * Obtenir la liste des formes juridiques
         * @summary Obtenir la liste des formes juridiques
         * @param {FormeJuridiqueApiApiFormesJuridiquesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormesJuridiquesGetCollection(requestParameters: FormeJuridiqueApiApiFormesJuridiquesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiFormesJuridiquesGetCollection200Response> {
            return localVarFp.apiFormesJuridiquesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.nomenclature, requestParameters.nomenclature2, requestParameters.abreviation, requestParameters.abreviation2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une forme juridique
         * @summary Récupérer les informations d\'une forme juridique
         * @param {FormeJuridiqueApiApiFormesJuridiquesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormesJuridiquesIdGet(requestParameters: FormeJuridiqueApiApiFormesJuridiquesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormeJuridiqueJsonldFormejuridiqueRead> {
            return localVarFp.apiFormesJuridiquesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFormesJuridiquesGetCollection operation in FormeJuridiqueApi.
 * @export
 * @interface FormeJuridiqueApiApiFormesJuridiquesGetCollectionRequest
 */
export interface FormeJuridiqueApiApiFormesJuridiquesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesGetCollection
     */
    readonly nomenclature?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesGetCollection
     */
    readonly nomenclature2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesGetCollection
     */
    readonly abreviation?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesGetCollection
     */
    readonly abreviation2?: Array<string>
}

/**
 * Request parameters for apiFormesJuridiquesIdGet operation in FormeJuridiqueApi.
 * @export
 * @interface FormeJuridiqueApiApiFormesJuridiquesIdGetRequest
 */
export interface FormeJuridiqueApiApiFormesJuridiquesIdGetRequest {
    /**
     * TblAnnonceSTypeDetail identifier
     * @type {string}
     * @memberof FormeJuridiqueApiApiFormesJuridiquesIdGet
     */
    readonly id: string
}

/**
 * FormeJuridiqueApi - object-oriented interface
 * @export
 * @class FormeJuridiqueApi
 * @extends {BaseAPI}
 */
export class FormeJuridiqueApi extends BaseAPI {
    /**
     * Obtenir la liste des formes juridiques
     * @summary Obtenir la liste des formes juridiques
     * @param {FormeJuridiqueApiApiFormesJuridiquesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormeJuridiqueApi
     */
    public apiFormesJuridiquesGetCollection(requestParameters: FormeJuridiqueApiApiFormesJuridiquesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FormeJuridiqueApiFp(this.configuration).apiFormesJuridiquesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.nomenclature, requestParameters.nomenclature2, requestParameters.abreviation, requestParameters.abreviation2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une forme juridique
     * @summary Récupérer les informations d\'une forme juridique
     * @param {FormeJuridiqueApiApiFormesJuridiquesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormeJuridiqueApi
     */
    public apiFormesJuridiquesIdGet(requestParameters: FormeJuridiqueApiApiFormesJuridiquesIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormeJuridiqueApiFp(this.configuration).apiFormesJuridiquesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GreffeApi - axios parameter creator
 * @export
 */
export const GreffeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des greffes
         * @summary Obtenir la liste des greffes
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dep] 
         * @param {Array<string>} [dep2] 
         * @param {string} [greffes] 
         * @param {ApiGreffesGetCollectionOrderGreffesEnum} [orderGreffes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGreffesGetCollection: async (page?: number, itemsPerPage?: number, dep?: string, dep2?: Array<string>, greffes?: string, orderGreffes?: ApiGreffesGetCollectionOrderGreffesEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/greffes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dep !== undefined) {
                localVarQueryParameter['dep'] = dep;
            }

            if (dep2) {
                localVarQueryParameter['dep[]'] = dep2;
            }

            if (greffes !== undefined) {
                localVarQueryParameter['greffes'] = greffes;
            }

            if (orderGreffes !== undefined) {
                localVarQueryParameter['order[greffes]'] = orderGreffes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un greffe
         * @summary Récupérer les informations d\'un greffe
         * @param {string} id TblGreffes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGreffesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiGreffesIdGet', 'id', id)
            const localVarPath = `/formalite/greffes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des greffes d\'une prestation
         * @summary Obtenir la liste des greffes d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dep] 
         * @param {Array<string>} [dep2] 
         * @param {string} [greffes] 
         * @param {ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum} [orderGreffes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesGetCollection: async (prestation: string, page?: number, itemsPerPage?: number, dep?: string, dep2?: Array<string>, greffes?: string, orderGreffes?: ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestation' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesGetCollection', 'prestation', prestation)
            const localVarPath = `/formalite/prestations/{prestation}/greffes`
                .replace(`{${"prestation"}}`, encodeURIComponent(String(prestation)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dep !== undefined) {
                localVarQueryParameter['dep'] = dep;
            }

            if (dep2) {
                localVarQueryParameter['dep[]'] = dep2;
            }

            if (greffes !== undefined) {
                localVarQueryParameter['greffes'] = greffes;
            }

            if (orderGreffes !== undefined) {
                localVarQueryParameter['order[greffes]'] = orderGreffes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retirer un greffe d\'une prestation
         * @summary Retirer un greffe d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {string} id TblGreffes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesIdDelete: async (prestation: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestation' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdDelete', 'prestation', prestation)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdDelete', 'id', id)
            const localVarPath = `/formalite/prestations/{prestation}/greffes/{id}`
                .replace(`{${"prestation"}}`, encodeURIComponent(String(prestation)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer un greffe d\'une prestation
         * @summary Récupérer un greffe d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {string} id TblGreffes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesIdGet: async (prestation: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestation' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdGet', 'prestation', prestation)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdGet', 'id', id)
            const localVarPath = `/formalite/prestations/{prestation}/greffes/{id}`
                .replace(`{${"prestation"}}`, encodeURIComponent(String(prestation)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour un greffe d\'une prestation
         * @summary Mettre à jour un greffe d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {string} id TblGreffes identifier
         * @param {GreffeJsonld} greffeJsonld The updated Greffe resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesIdPut: async (prestation: string, id: string, greffeJsonld: GreffeJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestation' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdPut', 'prestation', prestation)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdPut', 'id', id)
            // verify required parameter 'greffeJsonld' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesIdPut', 'greffeJsonld', greffeJsonld)
            const localVarPath = `/formalite/prestations/{prestation}/greffes/{id}`
                .replace(`{${"prestation"}}`, encodeURIComponent(String(prestation)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greffeJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ajouter un greffe à une prestation
         * @summary Ajouter un greffe à une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {GreffeJsonld} greffeJsonld The new Greffe resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesPost: async (prestation: string, greffeJsonld: GreffeJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestation' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesPost', 'prestation', prestation)
            // verify required parameter 'greffeJsonld' is not null or undefined
            assertParamExists('apiPrestationsPrestationGreffesPost', 'greffeJsonld', greffeJsonld)
            const localVarPath = `/formalite/prestations/{prestation}/greffes`
                .replace(`{${"prestation"}}`, encodeURIComponent(String(prestation)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greffeJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GreffeApi - functional programming interface
 * @export
 */
export const GreffeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GreffeApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des greffes
         * @summary Obtenir la liste des greffes
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dep] 
         * @param {Array<string>} [dep2] 
         * @param {string} [greffes] 
         * @param {ApiGreffesGetCollectionOrderGreffesEnum} [orderGreffes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGreffesGetCollection(page?: number, itemsPerPage?: number, dep?: string, dep2?: Array<string>, greffes?: string, orderGreffes?: ApiGreffesGetCollectionOrderGreffesEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGreffesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGreffesGetCollection(page, itemsPerPage, dep, dep2, greffes, orderGreffes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiGreffesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un greffe
         * @summary Récupérer les informations d\'un greffe
         * @param {string} id TblGreffes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGreffesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GreffeJsonldGreffeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGreffesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiGreffesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des greffes d\'une prestation
         * @summary Obtenir la liste des greffes d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dep] 
         * @param {Array<string>} [dep2] 
         * @param {string} [greffes] 
         * @param {ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum} [orderGreffes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPrestationGreffesGetCollection(prestation: string, page?: number, itemsPerPage?: number, dep?: string, dep2?: Array<string>, greffes?: string, orderGreffes?: ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGreffesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPrestationGreffesGetCollection(prestation, page, itemsPerPage, dep, dep2, greffes, orderGreffes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiPrestationsPrestationGreffesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retirer un greffe d\'une prestation
         * @summary Retirer un greffe d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {string} id TblGreffes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPrestationGreffesIdDelete(prestation: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPrestationGreffesIdDelete(prestation, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiPrestationsPrestationGreffesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer un greffe d\'une prestation
         * @summary Récupérer un greffe d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {string} id TblGreffes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPrestationGreffesIdGet(prestation: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GreffeJsonldGreffeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPrestationGreffesIdGet(prestation, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiPrestationsPrestationGreffesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour un greffe d\'une prestation
         * @summary Mettre à jour un greffe d\'une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {string} id TblGreffes identifier
         * @param {GreffeJsonld} greffeJsonld The updated Greffe resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPrestationGreffesIdPut(prestation: string, id: string, greffeJsonld: GreffeJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GreffeJsonldGreffeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPrestationGreffesIdPut(prestation, id, greffeJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiPrestationsPrestationGreffesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ajouter un greffe à une prestation
         * @summary Ajouter un greffe à une prestation
         * @param {string} prestation FproPrestation identifier
         * @param {GreffeJsonld} greffeJsonld The new Greffe resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPrestationGreffesPost(prestation: string, greffeJsonld: GreffeJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GreffeJsonldGreffeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPrestationGreffesPost(prestation, greffeJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GreffeApi.apiPrestationsPrestationGreffesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GreffeApi - factory interface
 * @export
 */
export const GreffeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GreffeApiFp(configuration)
    return {
        /**
         * Obtenir la liste des greffes
         * @summary Obtenir la liste des greffes
         * @param {GreffeApiApiGreffesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGreffesGetCollection(requestParameters: GreffeApiApiGreffesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiGreffesGetCollection200Response> {
            return localVarFp.apiGreffesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dep, requestParameters.dep2, requestParameters.greffes, requestParameters.orderGreffes, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un greffe
         * @summary Récupérer les informations d\'un greffe
         * @param {GreffeApiApiGreffesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGreffesIdGet(requestParameters: GreffeApiApiGreffesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GreffeJsonldGreffeRead> {
            return localVarFp.apiGreffesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des greffes d\'une prestation
         * @summary Obtenir la liste des greffes d\'une prestation
         * @param {GreffeApiApiPrestationsPrestationGreffesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesGetCollection(requestParameters: GreffeApiApiPrestationsPrestationGreffesGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiGreffesGetCollection200Response> {
            return localVarFp.apiPrestationsPrestationGreffesGetCollection(requestParameters.prestation, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dep, requestParameters.dep2, requestParameters.greffes, requestParameters.orderGreffes, options).then((request) => request(axios, basePath));
        },
        /**
         * Retirer un greffe d\'une prestation
         * @summary Retirer un greffe d\'une prestation
         * @param {GreffeApiApiPrestationsPrestationGreffesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesIdDelete(requestParameters: GreffeApiApiPrestationsPrestationGreffesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiPrestationsPrestationGreffesIdDelete(requestParameters.prestation, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer un greffe d\'une prestation
         * @summary Récupérer un greffe d\'une prestation
         * @param {GreffeApiApiPrestationsPrestationGreffesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesIdGet(requestParameters: GreffeApiApiPrestationsPrestationGreffesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GreffeJsonldGreffeRead> {
            return localVarFp.apiPrestationsPrestationGreffesIdGet(requestParameters.prestation, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour un greffe d\'une prestation
         * @summary Mettre à jour un greffe d\'une prestation
         * @param {GreffeApiApiPrestationsPrestationGreffesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesIdPut(requestParameters: GreffeApiApiPrestationsPrestationGreffesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GreffeJsonldGreffeRead> {
            return localVarFp.apiPrestationsPrestationGreffesIdPut(requestParameters.prestation, requestParameters.id, requestParameters.greffeJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Ajouter un greffe à une prestation
         * @summary Ajouter un greffe à une prestation
         * @param {GreffeApiApiPrestationsPrestationGreffesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationGreffesPost(requestParameters: GreffeApiApiPrestationsPrestationGreffesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GreffeJsonldGreffeRead> {
            return localVarFp.apiPrestationsPrestationGreffesPost(requestParameters.prestation, requestParameters.greffeJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiGreffesGetCollection operation in GreffeApi.
 * @export
 * @interface GreffeApiApiGreffesGetCollectionRequest
 */
export interface GreffeApiApiGreffesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof GreffeApiApiGreffesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof GreffeApiApiGreffesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof GreffeApiApiGreffesGetCollection
     */
    readonly dep?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof GreffeApiApiGreffesGetCollection
     */
    readonly dep2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof GreffeApiApiGreffesGetCollection
     */
    readonly greffes?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof GreffeApiApiGreffesGetCollection
     */
    readonly orderGreffes?: ApiGreffesGetCollectionOrderGreffesEnum
}

/**
 * Request parameters for apiGreffesIdGet operation in GreffeApi.
 * @export
 * @interface GreffeApiApiGreffesIdGetRequest
 */
export interface GreffeApiApiGreffesIdGetRequest {
    /**
     * TblGreffes identifier
     * @type {string}
     * @memberof GreffeApiApiGreffesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiPrestationsPrestationGreffesGetCollection operation in GreffeApi.
 * @export
 * @interface GreffeApiApiPrestationsPrestationGreffesGetCollectionRequest
 */
export interface GreffeApiApiPrestationsPrestationGreffesGetCollectionRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly prestation: string

    /**
     * The collection page number
     * @type {number}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly dep?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly dep2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly greffes?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof GreffeApiApiPrestationsPrestationGreffesGetCollection
     */
    readonly orderGreffes?: ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum
}

/**
 * Request parameters for apiPrestationsPrestationGreffesIdDelete operation in GreffeApi.
 * @export
 * @interface GreffeApiApiPrestationsPrestationGreffesIdDeleteRequest
 */
export interface GreffeApiApiPrestationsPrestationGreffesIdDeleteRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdDelete
     */
    readonly prestation: string

    /**
     * TblGreffes identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiPrestationsPrestationGreffesIdGet operation in GreffeApi.
 * @export
 * @interface GreffeApiApiPrestationsPrestationGreffesIdGetRequest
 */
export interface GreffeApiApiPrestationsPrestationGreffesIdGetRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdGet
     */
    readonly prestation: string

    /**
     * TblGreffes identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiPrestationsPrestationGreffesIdPut operation in GreffeApi.
 * @export
 * @interface GreffeApiApiPrestationsPrestationGreffesIdPutRequest
 */
export interface GreffeApiApiPrestationsPrestationGreffesIdPutRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdPut
     */
    readonly prestation: string

    /**
     * TblGreffes identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdPut
     */
    readonly id: string

    /**
     * The updated Greffe resource
     * @type {GreffeJsonld}
     * @memberof GreffeApiApiPrestationsPrestationGreffesIdPut
     */
    readonly greffeJsonld: GreffeJsonld
}

/**
 * Request parameters for apiPrestationsPrestationGreffesPost operation in GreffeApi.
 * @export
 * @interface GreffeApiApiPrestationsPrestationGreffesPostRequest
 */
export interface GreffeApiApiPrestationsPrestationGreffesPostRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof GreffeApiApiPrestationsPrestationGreffesPost
     */
    readonly prestation: string

    /**
     * The new Greffe resource
     * @type {GreffeJsonld}
     * @memberof GreffeApiApiPrestationsPrestationGreffesPost
     */
    readonly greffeJsonld: GreffeJsonld
}

/**
 * GreffeApi - object-oriented interface
 * @export
 * @class GreffeApi
 * @extends {BaseAPI}
 */
export class GreffeApi extends BaseAPI {
    /**
     * Obtenir la liste des greffes
     * @summary Obtenir la liste des greffes
     * @param {GreffeApiApiGreffesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiGreffesGetCollection(requestParameters: GreffeApiApiGreffesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiGreffesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dep, requestParameters.dep2, requestParameters.greffes, requestParameters.orderGreffes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un greffe
     * @summary Récupérer les informations d\'un greffe
     * @param {GreffeApiApiGreffesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiGreffesIdGet(requestParameters: GreffeApiApiGreffesIdGetRequest, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiGreffesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des greffes d\'une prestation
     * @summary Obtenir la liste des greffes d\'une prestation
     * @param {GreffeApiApiPrestationsPrestationGreffesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiPrestationsPrestationGreffesGetCollection(requestParameters: GreffeApiApiPrestationsPrestationGreffesGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiPrestationsPrestationGreffesGetCollection(requestParameters.prestation, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dep, requestParameters.dep2, requestParameters.greffes, requestParameters.orderGreffes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retirer un greffe d\'une prestation
     * @summary Retirer un greffe d\'une prestation
     * @param {GreffeApiApiPrestationsPrestationGreffesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiPrestationsPrestationGreffesIdDelete(requestParameters: GreffeApiApiPrestationsPrestationGreffesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiPrestationsPrestationGreffesIdDelete(requestParameters.prestation, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer un greffe d\'une prestation
     * @summary Récupérer un greffe d\'une prestation
     * @param {GreffeApiApiPrestationsPrestationGreffesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiPrestationsPrestationGreffesIdGet(requestParameters: GreffeApiApiPrestationsPrestationGreffesIdGetRequest, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiPrestationsPrestationGreffesIdGet(requestParameters.prestation, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour un greffe d\'une prestation
     * @summary Mettre à jour un greffe d\'une prestation
     * @param {GreffeApiApiPrestationsPrestationGreffesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiPrestationsPrestationGreffesIdPut(requestParameters: GreffeApiApiPrestationsPrestationGreffesIdPutRequest, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiPrestationsPrestationGreffesIdPut(requestParameters.prestation, requestParameters.id, requestParameters.greffeJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ajouter un greffe à une prestation
     * @summary Ajouter un greffe à une prestation
     * @param {GreffeApiApiPrestationsPrestationGreffesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GreffeApi
     */
    public apiPrestationsPrestationGreffesPost(requestParameters: GreffeApiApiPrestationsPrestationGreffesPostRequest, options?: RawAxiosRequestConfig) {
        return GreffeApiFp(this.configuration).apiPrestationsPrestationGreffesPost(requestParameters.prestation, requestParameters.greffeJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiGreffesGetCollectionOrderGreffesEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiGreffesGetCollectionOrderGreffesEnum = typeof ApiGreffesGetCollectionOrderGreffesEnum[keyof typeof ApiGreffesGetCollectionOrderGreffesEnum];
/**
 * @export
 */
export const ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum = typeof ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum[keyof typeof ApiPrestationsPrestationGreffesGetCollectionOrderGreffesEnum];


/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des messages
         * @summary Obtenir la liste des messages
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [expediteur] 
         * @param {Array<number>} [expediteur2] 
         * @param {boolean} [readByPrescri] 
         * @param {boolean} [readByFrmlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierMessagesGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, expediteur?: number, expediteur2?: Array<number>, readByPrescri?: boolean, readByFrmlist?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierMessagesGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/messages`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (expediteur !== undefined) {
                localVarQueryParameter['expediteur'] = expediteur;
            }

            if (expediteur2) {
                localVarQueryParameter['expediteur[]'] = expediteur2;
            }

            if (readByPrescri !== undefined) {
                localVarQueryParameter['readByPrescri'] = readByPrescri;
            }

            if (readByFrmlist !== undefined) {
                localVarQueryParameter['readByFrmlist'] = readByFrmlist;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Message resource.
         * @summary Modifier un message
         * @param {string} id FproDosMessage identifier
         * @param {MessageJsonld} messageJsonld The updated Message resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdAckPut: async (id: string, messageJsonld: MessageJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMessagesIdAckPut', 'id', id)
            // verify required parameter 'messageJsonld' is not null or undefined
            assertParamExists('apiMessagesIdAckPut', 'messageJsonld', messageJsonld)
            const localVarPath = `/formalite/messages/{id}/ack`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un message
         * @summary Supprimer un message
         * @param {string} id FproDosMessage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMessagesIdDelete', 'id', id)
            const localVarPath = `/formalite/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un message
         * @summary Récupérer les informations d\'un message
         * @param {string} id FproDosMessage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMessagesIdGet', 'id', id)
            const localVarPath = `/formalite/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Message resource.
         * @summary Créer un message
         * @param {MessageJsonldMessageCreate} messageJsonldMessageCreate The new Message resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesPost: async (messageJsonldMessageCreate: MessageJsonldMessageCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageJsonldMessageCreate' is not null or undefined
            assertParamExists('apiMessagesPost', 'messageJsonldMessageCreate', messageJsonldMessageCreate)
            const localVarPath = `/formalite/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageJsonldMessageCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des messages
         * @summary Obtenir la liste des messages
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [expediteur] 
         * @param {Array<number>} [expediteur2] 
         * @param {boolean} [readByPrescri] 
         * @param {boolean} [readByFrmlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierMessagesGetCollection(dossier: string, page?: number, itemsPerPage?: number, expediteur?: number, expediteur2?: Array<number>, readByPrescri?: boolean, readByFrmlist?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierMessagesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierMessagesGetCollection(dossier, page, itemsPerPage, expediteur, expediteur2, readByPrescri, readByFrmlist, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.apiDossiersDossierMessagesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Message resource.
         * @summary Modifier un message
         * @param {string} id FproDosMessage identifier
         * @param {MessageJsonld} messageJsonld The updated Message resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesIdAckPut(id: string, messageJsonld: MessageJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageJsonldMessageRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesIdAckPut(id, messageJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.apiMessagesIdAckPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un message
         * @summary Supprimer un message
         * @param {string} id FproDosMessage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.apiMessagesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un message
         * @summary Récupérer les informations d\'un message
         * @param {string} id FproDosMessage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageJsonldMessageRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.apiMessagesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Message resource.
         * @summary Créer un message
         * @param {MessageJsonldMessageCreate} messageJsonldMessageCreate The new Message resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesPost(messageJsonldMessageCreate: MessageJsonldMessageCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageJsonldMessageCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesPost(messageJsonldMessageCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.apiMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageApiFp(configuration)
    return {
        /**
         * Obtenir la liste des messages
         * @summary Obtenir la liste des messages
         * @param {MessageApiApiDossiersDossierMessagesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierMessagesGetCollection(requestParameters: MessageApiApiDossiersDossierMessagesGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierMessagesGetCollection200Response> {
            return localVarFp.apiDossiersDossierMessagesGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.expediteur, requestParameters.expediteur2, requestParameters.readByPrescri, requestParameters.readByFrmlist, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Message resource.
         * @summary Modifier un message
         * @param {MessageApiApiMessagesIdAckPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdAckPut(requestParameters: MessageApiApiMessagesIdAckPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageJsonldMessageRead> {
            return localVarFp.apiMessagesIdAckPut(requestParameters.id, requestParameters.messageJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un message
         * @summary Supprimer un message
         * @param {MessageApiApiMessagesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdDelete(requestParameters: MessageApiApiMessagesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiMessagesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un message
         * @summary Récupérer les informations d\'un message
         * @param {MessageApiApiMessagesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdGet(requestParameters: MessageApiApiMessagesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageJsonldMessageRead> {
            return localVarFp.apiMessagesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Message resource.
         * @summary Créer un message
         * @param {MessageApiApiMessagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesPost(requestParameters: MessageApiApiMessagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageJsonldMessageCreated> {
            return localVarFp.apiMessagesPost(requestParameters.messageJsonldMessageCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierMessagesGetCollection operation in MessageApi.
 * @export
 * @interface MessageApiApiDossiersDossierMessagesGetCollectionRequest
 */
export interface MessageApiApiDossiersDossierMessagesGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly expediteur?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly expediteur2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly readByPrescri?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof MessageApiApiDossiersDossierMessagesGetCollection
     */
    readonly readByFrmlist?: boolean
}

/**
 * Request parameters for apiMessagesIdAckPut operation in MessageApi.
 * @export
 * @interface MessageApiApiMessagesIdAckPutRequest
 */
export interface MessageApiApiMessagesIdAckPutRequest {
    /**
     * FproDosMessage identifier
     * @type {string}
     * @memberof MessageApiApiMessagesIdAckPut
     */
    readonly id: string

    /**
     * The updated Message resource
     * @type {MessageJsonld}
     * @memberof MessageApiApiMessagesIdAckPut
     */
    readonly messageJsonld: MessageJsonld
}

/**
 * Request parameters for apiMessagesIdDelete operation in MessageApi.
 * @export
 * @interface MessageApiApiMessagesIdDeleteRequest
 */
export interface MessageApiApiMessagesIdDeleteRequest {
    /**
     * FproDosMessage identifier
     * @type {string}
     * @memberof MessageApiApiMessagesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiMessagesIdGet operation in MessageApi.
 * @export
 * @interface MessageApiApiMessagesIdGetRequest
 */
export interface MessageApiApiMessagesIdGetRequest {
    /**
     * FproDosMessage identifier
     * @type {string}
     * @memberof MessageApiApiMessagesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiMessagesPost operation in MessageApi.
 * @export
 * @interface MessageApiApiMessagesPostRequest
 */
export interface MessageApiApiMessagesPostRequest {
    /**
     * The new Message resource
     * @type {MessageJsonldMessageCreate}
     * @memberof MessageApiApiMessagesPost
     */
    readonly messageJsonldMessageCreate: MessageJsonldMessageCreate
}

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI {
    /**
     * Obtenir la liste des messages
     * @summary Obtenir la liste des messages
     * @param {MessageApiApiDossiersDossierMessagesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiDossiersDossierMessagesGetCollection(requestParameters: MessageApiApiDossiersDossierMessagesGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiDossiersDossierMessagesGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.expediteur, requestParameters.expediteur2, requestParameters.readByPrescri, requestParameters.readByFrmlist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Message resource.
     * @summary Modifier un message
     * @param {MessageApiApiMessagesIdAckPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesIdAckPut(requestParameters: MessageApiApiMessagesIdAckPutRequest, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesIdAckPut(requestParameters.id, requestParameters.messageJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un message
     * @summary Supprimer un message
     * @param {MessageApiApiMessagesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesIdDelete(requestParameters: MessageApiApiMessagesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un message
     * @summary Récupérer les informations d\'un message
     * @param {MessageApiApiMessagesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesIdGet(requestParameters: MessageApiApiMessagesIdGetRequest, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Message resource.
     * @summary Créer un message
     * @param {MessageApiApiMessagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public apiMessagesPost(requestParameters: MessageApiApiMessagesPostRequest, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).apiMessagesPost(requestParameters.messageJsonldMessageCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotesApi - axios parameter creator
 * @export
 */
export const NotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des notes
         * @summary Obtenir la liste des notes
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierNotesGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierNotesGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/notes`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une note
         * @summary Récupérer les informations d\'une note
         * @param {string} id TblEvenement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotesIdGet', 'id', id)
            const localVarPath = `/formalite/notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Notes et rappels resource.
         * @summary Modifier une note
         * @param {string} id TblEvenement identifier
         * @param {NotesEtRappelsJsonldNoteUpdate} notesEtRappelsJsonldNoteUpdate The updated Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesIdPut: async (id: string, notesEtRappelsJsonldNoteUpdate: NotesEtRappelsJsonldNoteUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotesIdPut', 'id', id)
            // verify required parameter 'notesEtRappelsJsonldNoteUpdate' is not null or undefined
            assertParamExists('apiNotesIdPut', 'notesEtRappelsJsonldNoteUpdate', notesEtRappelsJsonldNoteUpdate)
            const localVarPath = `/formalite/notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notesEtRappelsJsonldNoteUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Notes et rappels resource.
         * @summary Créer une note
         * @param {NotesEtRappelsJsonldNoteCreate} notesEtRappelsJsonldNoteCreate The new Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesPost: async (notesEtRappelsJsonldNoteCreate: NotesEtRappelsJsonldNoteCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notesEtRappelsJsonldNoteCreate' is not null or undefined
            assertParamExists('apiNotesPost', 'notesEtRappelsJsonldNoteCreate', notesEtRappelsJsonldNoteCreate)
            const localVarPath = `/formalite/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notesEtRappelsJsonldNoteCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotesApi - functional programming interface
 * @export
 */
export const NotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotesApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des notes
         * @summary Obtenir la liste des notes
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierNotesGetCollection(dossier: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierNotesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierNotesGetCollection(dossier, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotesApi.apiDossiersDossierNotesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une note
         * @summary Récupérer les informations d\'une note
         * @param {string} id TblEvenement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesEtRappelsJsonldNoteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotesApi.apiNotesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Notes et rappels resource.
         * @summary Modifier une note
         * @param {string} id TblEvenement identifier
         * @param {NotesEtRappelsJsonldNoteUpdate} notesEtRappelsJsonldNoteUpdate The updated Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotesIdPut(id: string, notesEtRappelsJsonldNoteUpdate: NotesEtRappelsJsonldNoteUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesEtRappelsJsonldNoteRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotesIdPut(id, notesEtRappelsJsonldNoteUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotesApi.apiNotesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Notes et rappels resource.
         * @summary Créer une note
         * @param {NotesEtRappelsJsonldNoteCreate} notesEtRappelsJsonldNoteCreate The new Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotesPost(notesEtRappelsJsonldNoteCreate: NotesEtRappelsJsonldNoteCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesEtRappelsJsonldNoteCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotesPost(notesEtRappelsJsonldNoteCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotesApi.apiNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotesApi - factory interface
 * @export
 */
export const NotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotesApiFp(configuration)
    return {
        /**
         * Obtenir la liste des notes
         * @summary Obtenir la liste des notes
         * @param {NotesApiApiDossiersDossierNotesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierNotesGetCollection(requestParameters: NotesApiApiDossiersDossierNotesGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierNotesGetCollection200Response> {
            return localVarFp.apiDossiersDossierNotesGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une note
         * @summary Récupérer les informations d\'une note
         * @param {NotesApiApiNotesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesIdGet(requestParameters: NotesApiApiNotesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotesEtRappelsJsonldNoteRead> {
            return localVarFp.apiNotesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Notes et rappels resource.
         * @summary Modifier une note
         * @param {NotesApiApiNotesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesIdPut(requestParameters: NotesApiApiNotesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotesEtRappelsJsonldNoteRead> {
            return localVarFp.apiNotesIdPut(requestParameters.id, requestParameters.notesEtRappelsJsonldNoteUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Notes et rappels resource.
         * @summary Créer une note
         * @param {NotesApiApiNotesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesPost(requestParameters: NotesApiApiNotesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotesEtRappelsJsonldNoteCreated> {
            return localVarFp.apiNotesPost(requestParameters.notesEtRappelsJsonldNoteCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierNotesGetCollection operation in NotesApi.
 * @export
 * @interface NotesApiApiDossiersDossierNotesGetCollectionRequest
 */
export interface NotesApiApiDossiersDossierNotesGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof NotesApiApiDossiersDossierNotesGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof NotesApiApiDossiersDossierNotesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof NotesApiApiDossiersDossierNotesGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiNotesIdGet operation in NotesApi.
 * @export
 * @interface NotesApiApiNotesIdGetRequest
 */
export interface NotesApiApiNotesIdGetRequest {
    /**
     * TblEvenement identifier
     * @type {string}
     * @memberof NotesApiApiNotesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiNotesIdPut operation in NotesApi.
 * @export
 * @interface NotesApiApiNotesIdPutRequest
 */
export interface NotesApiApiNotesIdPutRequest {
    /**
     * TblEvenement identifier
     * @type {string}
     * @memberof NotesApiApiNotesIdPut
     */
    readonly id: string

    /**
     * The updated Notes et rappels resource
     * @type {NotesEtRappelsJsonldNoteUpdate}
     * @memberof NotesApiApiNotesIdPut
     */
    readonly notesEtRappelsJsonldNoteUpdate: NotesEtRappelsJsonldNoteUpdate
}

/**
 * Request parameters for apiNotesPost operation in NotesApi.
 * @export
 * @interface NotesApiApiNotesPostRequest
 */
export interface NotesApiApiNotesPostRequest {
    /**
     * The new Notes et rappels resource
     * @type {NotesEtRappelsJsonldNoteCreate}
     * @memberof NotesApiApiNotesPost
     */
    readonly notesEtRappelsJsonldNoteCreate: NotesEtRappelsJsonldNoteCreate
}

/**
 * NotesApi - object-oriented interface
 * @export
 * @class NotesApi
 * @extends {BaseAPI}
 */
export class NotesApi extends BaseAPI {
    /**
     * Obtenir la liste des notes
     * @summary Obtenir la liste des notes
     * @param {NotesApiApiDossiersDossierNotesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiDossiersDossierNotesGetCollection(requestParameters: NotesApiApiDossiersDossierNotesGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return NotesApiFp(this.configuration).apiDossiersDossierNotesGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une note
     * @summary Récupérer les informations d\'une note
     * @param {NotesApiApiNotesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiNotesIdGet(requestParameters: NotesApiApiNotesIdGetRequest, options?: RawAxiosRequestConfig) {
        return NotesApiFp(this.configuration).apiNotesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Notes et rappels resource.
     * @summary Modifier une note
     * @param {NotesApiApiNotesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiNotesIdPut(requestParameters: NotesApiApiNotesIdPutRequest, options?: RawAxiosRequestConfig) {
        return NotesApiFp(this.configuration).apiNotesIdPut(requestParameters.id, requestParameters.notesEtRappelsJsonldNoteUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Notes et rappels resource.
     * @summary Créer une note
     * @param {NotesApiApiNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiNotesPost(requestParameters: NotesApiApiNotesPostRequest, options?: RawAxiosRequestConfig) {
        return NotesApiFp(this.configuration).apiNotesPost(requestParameters.notesEtRappelsJsonldNoteCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObjectGroupsApi - axios parameter creator
 * @export
 */
export const ObjectGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsGetCollection: async (page?: number, itemsPerPage?: number, label?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/object-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un groupe de dossier
         * @summary Supprimer un groupe de dossier
         * @param {string} id TblObjectGroup identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiObjectGroupsIdDelete', 'id', id)
            const localVarPath = `/formalite/object-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un groupe de dossier
         * @summary Récupérer les informations d\'un groupe de dossier
         * @param {string} id TblObjectGroup identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiObjectGroupsIdGet', 'id', id)
            const localVarPath = `/formalite/object-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Editer un groupe de dossier
         * @summary Editer un groupe de dossier
         * @param {string} id TblObjectGroup identifier
         * @param {ObjectGroupsObjectGroupUpdate} objectGroupsObjectGroupUpdate The updated Object groups resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsIdPatch: async (id: string, objectGroupsObjectGroupUpdate: ObjectGroupsObjectGroupUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiObjectGroupsIdPatch', 'id', id)
            // verify required parameter 'objectGroupsObjectGroupUpdate' is not null or undefined
            assertParamExists('apiObjectGroupsIdPatch', 'objectGroupsObjectGroupUpdate', objectGroupsObjectGroupUpdate)
            const localVarPath = `/formalite/object-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectGroupsObjectGroupUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un groupe de dossier
         * @summary Créer un groupe de dossier
         * @param {ObjectGroupsJsonldObjectGroupCreate} objectGroupsJsonldObjectGroupCreate The new Object groups resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsPost: async (objectGroupsJsonldObjectGroupCreate: ObjectGroupsJsonldObjectGroupCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectGroupsJsonldObjectGroupCreate' is not null or undefined
            assertParamExists('apiObjectGroupsPost', 'objectGroupsJsonldObjectGroupCreate', objectGroupsJsonldObjectGroupCreate)
            const localVarPath = `/formalite/object-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectGroupsJsonldObjectGroupCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectGroupsApi - functional programming interface
 * @export
 */
export const ObjectGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObjectGroupsGetCollection(page?: number, itemsPerPage?: number, label?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiObjectGroupsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObjectGroupsGetCollection(page, itemsPerPage, label, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectGroupsApi.apiObjectGroupsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un groupe de dossier
         * @summary Supprimer un groupe de dossier
         * @param {string} id TblObjectGroup identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObjectGroupsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObjectGroupsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectGroupsApi.apiObjectGroupsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un groupe de dossier
         * @summary Récupérer les informations d\'un groupe de dossier
         * @param {string} id TblObjectGroup identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObjectGroupsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectGroupsJsonldObjectGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObjectGroupsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectGroupsApi.apiObjectGroupsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Editer un groupe de dossier
         * @summary Editer un groupe de dossier
         * @param {string} id TblObjectGroup identifier
         * @param {ObjectGroupsObjectGroupUpdate} objectGroupsObjectGroupUpdate The updated Object groups resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObjectGroupsIdPatch(id: string, objectGroupsObjectGroupUpdate: ObjectGroupsObjectGroupUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectGroupsJsonldObjectGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObjectGroupsIdPatch(id, objectGroupsObjectGroupUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectGroupsApi.apiObjectGroupsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un groupe de dossier
         * @summary Créer un groupe de dossier
         * @param {ObjectGroupsJsonldObjectGroupCreate} objectGroupsJsonldObjectGroupCreate The new Object groups resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObjectGroupsPost(objectGroupsJsonldObjectGroupCreate: ObjectGroupsJsonldObjectGroupCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectGroupsJsonldObjectGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObjectGroupsPost(objectGroupsJsonldObjectGroupCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectGroupsApi.apiObjectGroupsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectGroupsApi - factory interface
 * @export
 */
export const ObjectGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectGroupsApiFp(configuration)
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {ObjectGroupsApiApiObjectGroupsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsGetCollection(requestParameters: ObjectGroupsApiApiObjectGroupsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiObjectGroupsGetCollection200Response> {
            return localVarFp.apiObjectGroupsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.label, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un groupe de dossier
         * @summary Supprimer un groupe de dossier
         * @param {ObjectGroupsApiApiObjectGroupsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsIdDelete(requestParameters: ObjectGroupsApiApiObjectGroupsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiObjectGroupsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un groupe de dossier
         * @summary Récupérer les informations d\'un groupe de dossier
         * @param {ObjectGroupsApiApiObjectGroupsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsIdGet(requestParameters: ObjectGroupsApiApiObjectGroupsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectGroupsJsonldObjectGroupRead> {
            return localVarFp.apiObjectGroupsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Editer un groupe de dossier
         * @summary Editer un groupe de dossier
         * @param {ObjectGroupsApiApiObjectGroupsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsIdPatch(requestParameters: ObjectGroupsApiApiObjectGroupsIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectGroupsJsonldObjectGroupRead> {
            return localVarFp.apiObjectGroupsIdPatch(requestParameters.id, requestParameters.objectGroupsObjectGroupUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un groupe de dossier
         * @summary Créer un groupe de dossier
         * @param {ObjectGroupsApiApiObjectGroupsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObjectGroupsPost(requestParameters: ObjectGroupsApiApiObjectGroupsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectGroupsJsonldObjectGroupRead> {
            return localVarFp.apiObjectGroupsPost(requestParameters.objectGroupsJsonldObjectGroupCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiObjectGroupsGetCollection operation in ObjectGroupsApi.
 * @export
 * @interface ObjectGroupsApiApiObjectGroupsGetCollectionRequest
 */
export interface ObjectGroupsApiApiObjectGroupsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ObjectGroupsApiApiObjectGroupsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ObjectGroupsApiApiObjectGroupsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof ObjectGroupsApiApiObjectGroupsGetCollection
     */
    readonly label?: string
}

/**
 * Request parameters for apiObjectGroupsIdDelete operation in ObjectGroupsApi.
 * @export
 * @interface ObjectGroupsApiApiObjectGroupsIdDeleteRequest
 */
export interface ObjectGroupsApiApiObjectGroupsIdDeleteRequest {
    /**
     * TblObjectGroup identifier
     * @type {string}
     * @memberof ObjectGroupsApiApiObjectGroupsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiObjectGroupsIdGet operation in ObjectGroupsApi.
 * @export
 * @interface ObjectGroupsApiApiObjectGroupsIdGetRequest
 */
export interface ObjectGroupsApiApiObjectGroupsIdGetRequest {
    /**
     * TblObjectGroup identifier
     * @type {string}
     * @memberof ObjectGroupsApiApiObjectGroupsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiObjectGroupsIdPatch operation in ObjectGroupsApi.
 * @export
 * @interface ObjectGroupsApiApiObjectGroupsIdPatchRequest
 */
export interface ObjectGroupsApiApiObjectGroupsIdPatchRequest {
    /**
     * TblObjectGroup identifier
     * @type {string}
     * @memberof ObjectGroupsApiApiObjectGroupsIdPatch
     */
    readonly id: string

    /**
     * The updated Object groups resource
     * @type {ObjectGroupsObjectGroupUpdate}
     * @memberof ObjectGroupsApiApiObjectGroupsIdPatch
     */
    readonly objectGroupsObjectGroupUpdate: ObjectGroupsObjectGroupUpdate
}

/**
 * Request parameters for apiObjectGroupsPost operation in ObjectGroupsApi.
 * @export
 * @interface ObjectGroupsApiApiObjectGroupsPostRequest
 */
export interface ObjectGroupsApiApiObjectGroupsPostRequest {
    /**
     * The new Object groups resource
     * @type {ObjectGroupsJsonldObjectGroupCreate}
     * @memberof ObjectGroupsApiApiObjectGroupsPost
     */
    readonly objectGroupsJsonldObjectGroupCreate: ObjectGroupsJsonldObjectGroupCreate
}

/**
 * ObjectGroupsApi - object-oriented interface
 * @export
 * @class ObjectGroupsApi
 * @extends {BaseAPI}
 */
export class ObjectGroupsApi extends BaseAPI {
    /**
     * Lister les dossiers
     * @summary Lister les dossiers
     * @param {ObjectGroupsApiApiObjectGroupsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectGroupsApi
     */
    public apiObjectGroupsGetCollection(requestParameters: ObjectGroupsApiApiObjectGroupsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ObjectGroupsApiFp(this.configuration).apiObjectGroupsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.label, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un groupe de dossier
     * @summary Supprimer un groupe de dossier
     * @param {ObjectGroupsApiApiObjectGroupsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectGroupsApi
     */
    public apiObjectGroupsIdDelete(requestParameters: ObjectGroupsApiApiObjectGroupsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ObjectGroupsApiFp(this.configuration).apiObjectGroupsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un groupe de dossier
     * @summary Récupérer les informations d\'un groupe de dossier
     * @param {ObjectGroupsApiApiObjectGroupsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectGroupsApi
     */
    public apiObjectGroupsIdGet(requestParameters: ObjectGroupsApiApiObjectGroupsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ObjectGroupsApiFp(this.configuration).apiObjectGroupsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Editer un groupe de dossier
     * @summary Editer un groupe de dossier
     * @param {ObjectGroupsApiApiObjectGroupsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectGroupsApi
     */
    public apiObjectGroupsIdPatch(requestParameters: ObjectGroupsApiApiObjectGroupsIdPatchRequest, options?: RawAxiosRequestConfig) {
        return ObjectGroupsApiFp(this.configuration).apiObjectGroupsIdPatch(requestParameters.id, requestParameters.objectGroupsObjectGroupUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un groupe de dossier
     * @summary Créer un groupe de dossier
     * @param {ObjectGroupsApiApiObjectGroupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectGroupsApi
     */
    public apiObjectGroupsPost(requestParameters: ObjectGroupsApiApiObjectGroupsPostRequest, options?: RawAxiosRequestConfig) {
        return ObjectGroupsApiFp(this.configuration).apiObjectGroupsPost(requestParameters.objectGroupsJsonldObjectGroupCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrigineApi - axios parameter creator
 * @export
 */
export const OrigineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Origine resource.
         * @summary Retrieves a Origine resource.
         * @param {string} id TblOrigine identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOriginesIdFormatGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOriginesIdFormatGet', 'id', id)
            const localVarPath = `/formalite/origines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrigineApi - functional programming interface
 * @export
 */
export const OrigineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrigineApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Origine resource.
         * @summary Retrieves a Origine resource.
         * @param {string} id TblOrigine identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOriginesIdFormatGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOriginesIdFormatGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrigineApi.apiOriginesIdFormatGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrigineApi - factory interface
 * @export
 */
export const OrigineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrigineApiFp(configuration)
    return {
        /**
         * Retrieves a Origine resource.
         * @summary Retrieves a Origine resource.
         * @param {OrigineApiApiOriginesIdFormatGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOriginesIdFormatGet(requestParameters: OrigineApiApiOriginesIdFormatGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiOriginesIdFormatGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiOriginesIdFormatGet operation in OrigineApi.
 * @export
 * @interface OrigineApiApiOriginesIdFormatGetRequest
 */
export interface OrigineApiApiOriginesIdFormatGetRequest {
    /**
     * TblOrigine identifier
     * @type {string}
     * @memberof OrigineApiApiOriginesIdFormatGet
     */
    readonly id: string
}

/**
 * OrigineApi - object-oriented interface
 * @export
 * @class OrigineApi
 * @extends {BaseAPI}
 */
export class OrigineApi extends BaseAPI {
    /**
     * Retrieves a Origine resource.
     * @summary Retrieves a Origine resource.
     * @param {OrigineApiApiOriginesIdFormatGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrigineApi
     */
    public apiOriginesIdFormatGet(requestParameters: OrigineApiApiOriginesIdFormatGetRequest, options?: RawAxiosRequestConfig) {
        return OrigineApiFp(this.configuration).apiOriginesIdFormatGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrestationApi - axios parameter creator
 * @export
 */
export const PrestationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des prestations du dossier
         * @summary Obtenir la liste des prestations du dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {string} [libelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierPrestationsGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, dossierNumero?: string, libelle?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierPrestationsGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/prestations`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les prestations
         * @summary Lister les prestations
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {string} [libelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsGetCollection: async (page?: number, itemsPerPage?: number, dossierNumero?: string, libelle?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une prestation
         * @summary Récupérer les informations d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsIdGet', 'id', id)
            const localVarPath = `/formalite/prestations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
         * @summary Synchroniser les greffes d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {ApiPrestationsIdGreffesPutRequest} [apiPrestationsIdGreffesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdGreffesPost: async (id: string, apiPrestationsIdGreffesPutRequest?: ApiPrestationsIdGreffesPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsIdGreffesPost', 'id', id)
            const localVarPath = `/formalite/prestations/{id}/greffes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPrestationsIdGreffesPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
         * @summary Synchroniser les greffes d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {ApiPrestationsIdGreffesPutRequest} [apiPrestationsIdGreffesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdGreffesPut: async (id: string, apiPrestationsIdGreffesPutRequest?: ApiPrestationsIdGreffesPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsIdGreffesPut', 'id', id)
            const localVarPath = `/formalite/prestations/{id}/greffes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPrestationsIdGreffesPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour les informations d\'une prestation
         * @summary Mettre à jour les informations d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {PrestationJsonldPrestationUpdate} prestationJsonldPrestationUpdate The updated Prestation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdPut: async (id: string, prestationJsonldPrestationUpdate: PrestationJsonldPrestationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPrestationsIdPut', 'id', id)
            // verify required parameter 'prestationJsonldPrestationUpdate' is not null or undefined
            assertParamExists('apiPrestationsIdPut', 'prestationJsonldPrestationUpdate', prestationJsonldPrestationUpdate)
            const localVarPath = `/formalite/prestations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prestationJsonldPrestationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer une prestation
         * @summary Créer une prestation
         * @param {PrestationCreatePrestationDtoJsonldPrestationCreate} prestationCreatePrestationDtoJsonldPrestationCreate The new Prestation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPost: async (prestationCreatePrestationDtoJsonldPrestationCreate: PrestationCreatePrestationDtoJsonldPrestationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestationCreatePrestationDtoJsonldPrestationCreate' is not null or undefined
            assertParamExists('apiPrestationsPost', 'prestationCreatePrestationDtoJsonldPrestationCreate', prestationCreatePrestationDtoJsonldPrestationCreate)
            const localVarPath = `/formalite/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prestationCreatePrestationDtoJsonldPrestationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrestationApi - functional programming interface
 * @export
 */
export const PrestationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrestationApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des prestations du dossier
         * @summary Obtenir la liste des prestations du dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {string} [libelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierPrestationsGetCollection(dossier: string, page?: number, itemsPerPage?: number, dossierNumero?: string, libelle?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierPrestationsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierPrestationsGetCollection(dossier, page, itemsPerPage, dossierNumero, libelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiDossiersDossierPrestationsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les prestations
         * @summary Lister les prestations
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {string} [libelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsGetCollection(page?: number, itemsPerPage?: number, dossierNumero?: string, libelle?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierPrestationsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsGetCollection(page, itemsPerPage, dossierNumero, libelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiPrestationsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une prestation
         * @summary Récupérer les informations d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationJsonldPrestationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiPrestationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
         * @summary Synchroniser les greffes d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {ApiPrestationsIdGreffesPutRequest} [apiPrestationsIdGreffesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsIdGreffesPost(id: string, apiPrestationsIdGreffesPutRequest?: ApiPrestationsIdGreffesPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsIdGreffesPost(id, apiPrestationsIdGreffesPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiPrestationsIdGreffesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
         * @summary Synchroniser les greffes d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {ApiPrestationsIdGreffesPutRequest} [apiPrestationsIdGreffesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsIdGreffesPut(id: string, apiPrestationsIdGreffesPutRequest?: ApiPrestationsIdGreffesPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsIdGreffesPut(id, apiPrestationsIdGreffesPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiPrestationsIdGreffesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour les informations d\'une prestation
         * @summary Mettre à jour les informations d\'une prestation
         * @param {string} id FproPrestation identifier
         * @param {PrestationJsonldPrestationUpdate} prestationJsonldPrestationUpdate The updated Prestation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsIdPut(id: string, prestationJsonldPrestationUpdate: PrestationJsonldPrestationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationJsonldPrestationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsIdPut(id, prestationJsonldPrestationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiPrestationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer une prestation
         * @summary Créer une prestation
         * @param {PrestationCreatePrestationDtoJsonldPrestationCreate} prestationCreatePrestationDtoJsonldPrestationCreate The new Prestation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPost(prestationCreatePrestationDtoJsonldPrestationCreate: PrestationCreatePrestationDtoJsonldPrestationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationJsonldPrestationCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPost(prestationCreatePrestationDtoJsonldPrestationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationApi.apiPrestationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrestationApi - factory interface
 * @export
 */
export const PrestationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrestationApiFp(configuration)
    return {
        /**
         * Obtenir la liste des prestations du dossier
         * @summary Obtenir la liste des prestations du dossier
         * @param {PrestationApiApiDossiersDossierPrestationsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierPrestationsGetCollection(requestParameters: PrestationApiApiDossiersDossierPrestationsGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierPrestationsGetCollection200Response> {
            return localVarFp.apiDossiersDossierPrestationsGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.libelle, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les prestations
         * @summary Lister les prestations
         * @param {PrestationApiApiPrestationsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsGetCollection(requestParameters: PrestationApiApiPrestationsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierPrestationsGetCollection200Response> {
            return localVarFp.apiPrestationsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.libelle, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une prestation
         * @summary Récupérer les informations d\'une prestation
         * @param {PrestationApiApiPrestationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdGet(requestParameters: PrestationApiApiPrestationsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationJsonldPrestationRead> {
            return localVarFp.apiPrestationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
         * @summary Synchroniser les greffes d\'une prestation
         * @param {PrestationApiApiPrestationsIdGreffesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdGreffesPost(requestParameters: PrestationApiApiPrestationsIdGreffesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiPrestationsIdGreffesPost(requestParameters.id, requestParameters.apiPrestationsIdGreffesPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
         * @summary Synchroniser les greffes d\'une prestation
         * @param {PrestationApiApiPrestationsIdGreffesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdGreffesPut(requestParameters: PrestationApiApiPrestationsIdGreffesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiPrestationsIdGreffesPut(requestParameters.id, requestParameters.apiPrestationsIdGreffesPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour les informations d\'une prestation
         * @summary Mettre à jour les informations d\'une prestation
         * @param {PrestationApiApiPrestationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsIdPut(requestParameters: PrestationApiApiPrestationsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationJsonldPrestationRead> {
            return localVarFp.apiPrestationsIdPut(requestParameters.id, requestParameters.prestationJsonldPrestationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer une prestation
         * @summary Créer une prestation
         * @param {PrestationApiApiPrestationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPost(requestParameters: PrestationApiApiPrestationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationJsonldPrestationCreated> {
            return localVarFp.apiPrestationsPost(requestParameters.prestationCreatePrestationDtoJsonldPrestationCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierPrestationsGetCollection operation in PrestationApi.
 * @export
 * @interface PrestationApiApiDossiersDossierPrestationsGetCollectionRequest
 */
export interface PrestationApiApiDossiersDossierPrestationsGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof PrestationApiApiDossiersDossierPrestationsGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof PrestationApiApiDossiersDossierPrestationsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PrestationApiApiDossiersDossierPrestationsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof PrestationApiApiDossiersDossierPrestationsGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {string}
     * @memberof PrestationApiApiDossiersDossierPrestationsGetCollection
     */
    readonly libelle?: string
}

/**
 * Request parameters for apiPrestationsGetCollection operation in PrestationApi.
 * @export
 * @interface PrestationApiApiPrestationsGetCollectionRequest
 */
export interface PrestationApiApiPrestationsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof PrestationApiApiPrestationsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PrestationApiApiPrestationsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof PrestationApiApiPrestationsGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {string}
     * @memberof PrestationApiApiPrestationsGetCollection
     */
    readonly libelle?: string
}

/**
 * Request parameters for apiPrestationsIdGet operation in PrestationApi.
 * @export
 * @interface PrestationApiApiPrestationsIdGetRequest
 */
export interface PrestationApiApiPrestationsIdGetRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof PrestationApiApiPrestationsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiPrestationsIdGreffesPost operation in PrestationApi.
 * @export
 * @interface PrestationApiApiPrestationsIdGreffesPostRequest
 */
export interface PrestationApiApiPrestationsIdGreffesPostRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof PrestationApiApiPrestationsIdGreffesPost
     */
    readonly id: string

    /**
     * 
     * @type {ApiPrestationsIdGreffesPutRequest}
     * @memberof PrestationApiApiPrestationsIdGreffesPost
     */
    readonly apiPrestationsIdGreffesPutRequest?: ApiPrestationsIdGreffesPutRequest
}

/**
 * Request parameters for apiPrestationsIdGreffesPut operation in PrestationApi.
 * @export
 * @interface PrestationApiApiPrestationsIdGreffesPutRequest
 */
export interface PrestationApiApiPrestationsIdGreffesPutRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof PrestationApiApiPrestationsIdGreffesPut
     */
    readonly id: string

    /**
     * 
     * @type {ApiPrestationsIdGreffesPutRequest}
     * @memberof PrestationApiApiPrestationsIdGreffesPut
     */
    readonly apiPrestationsIdGreffesPutRequest?: ApiPrestationsIdGreffesPutRequest
}

/**
 * Request parameters for apiPrestationsIdPut operation in PrestationApi.
 * @export
 * @interface PrestationApiApiPrestationsIdPutRequest
 */
export interface PrestationApiApiPrestationsIdPutRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof PrestationApiApiPrestationsIdPut
     */
    readonly id: string

    /**
     * The updated Prestation resource
     * @type {PrestationJsonldPrestationUpdate}
     * @memberof PrestationApiApiPrestationsIdPut
     */
    readonly prestationJsonldPrestationUpdate: PrestationJsonldPrestationUpdate
}

/**
 * Request parameters for apiPrestationsPost operation in PrestationApi.
 * @export
 * @interface PrestationApiApiPrestationsPostRequest
 */
export interface PrestationApiApiPrestationsPostRequest {
    /**
     * The new Prestation resource
     * @type {PrestationCreatePrestationDtoJsonldPrestationCreate}
     * @memberof PrestationApiApiPrestationsPost
     */
    readonly prestationCreatePrestationDtoJsonldPrestationCreate: PrestationCreatePrestationDtoJsonldPrestationCreate
}

/**
 * PrestationApi - object-oriented interface
 * @export
 * @class PrestationApi
 * @extends {BaseAPI}
 */
export class PrestationApi extends BaseAPI {
    /**
     * Obtenir la liste des prestations du dossier
     * @summary Obtenir la liste des prestations du dossier
     * @param {PrestationApiApiDossiersDossierPrestationsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiDossiersDossierPrestationsGetCollection(requestParameters: PrestationApiApiDossiersDossierPrestationsGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiDossiersDossierPrestationsGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.libelle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les prestations
     * @summary Lister les prestations
     * @param {PrestationApiApiPrestationsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiPrestationsGetCollection(requestParameters: PrestationApiApiPrestationsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiPrestationsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.libelle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une prestation
     * @summary Récupérer les informations d\'une prestation
     * @param {PrestationApiApiPrestationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiPrestationsIdGet(requestParameters: PrestationApiApiPrestationsIdGetRequest, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiPrestationsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
     * @summary Synchroniser les greffes d\'une prestation
     * @param {PrestationApiApiPrestationsIdGreffesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiPrestationsIdGreffesPost(requestParameters: PrestationApiApiPrestationsIdGreffesPostRequest, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiPrestationsIdGreffesPost(requestParameters.id, requestParameters.apiPrestationsIdGreffesPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remplace la liste complète des greffes d\'une prestation. Les associations manquantes sont créées et celles absentes du payload sont supprimées.
     * @summary Synchroniser les greffes d\'une prestation
     * @param {PrestationApiApiPrestationsIdGreffesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiPrestationsIdGreffesPut(requestParameters: PrestationApiApiPrestationsIdGreffesPutRequest, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiPrestationsIdGreffesPut(requestParameters.id, requestParameters.apiPrestationsIdGreffesPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour les informations d\'une prestation
     * @summary Mettre à jour les informations d\'une prestation
     * @param {PrestationApiApiPrestationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiPrestationsIdPut(requestParameters: PrestationApiApiPrestationsIdPutRequest, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiPrestationsIdPut(requestParameters.id, requestParameters.prestationJsonldPrestationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer une prestation
     * @summary Créer une prestation
     * @param {PrestationApiApiPrestationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationApi
     */
    public apiPrestationsPost(requestParameters: PrestationApiApiPrestationsPostRequest, options?: RawAxiosRequestConfig) {
        return PrestationApiFp(this.configuration).apiPrestationsPost(requestParameters.prestationCreatePrestationDtoJsonldPrestationCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrestationArticlesApi - axios parameter creator
 * @export
 */
export const PrestationArticlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les articles de prestation
         * @summary Lister les articles de prestation
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {string} [factArticleRubArticle] 
         * @param {Array<string>} [factArticleRubArticle2] 
         * @param {string} [factArticleNatureTva] 
         * @param {Array<string>} [factArticleNatureTva2] 
         * @param {number} [idPrestaId] 
         * @param {Array<number>} [idPrestaId2] 
         * @param {number} [factArticleId] 
         * @param {Array<number>} [factArticleId2] 
         * @param {number} [idPrestaDossierId] 
         * @param {Array<number>} [idPrestaDossierId2] 
         * @param {number} [factArticleCategoryId] 
         * @param {Array<number>} [factArticleCategoryId2] 
         * @param {boolean} [fDonneesVerifiees] 
         * @param {boolean} [fMasqueCalcul] 
         * @param {boolean} [fAjouteCalcul] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationFactureGetCollection: async (page?: number, itemsPerPage?: number, libelle?: string, factArticleRubArticle?: string, factArticleRubArticle2?: Array<string>, factArticleNatureTva?: string, factArticleNatureTva2?: Array<string>, idPrestaId?: number, idPrestaId2?: Array<number>, factArticleId?: number, factArticleId2?: Array<number>, idPrestaDossierId?: number, idPrestaDossierId2?: Array<number>, factArticleCategoryId?: number, factArticleCategoryId2?: Array<number>, fDonneesVerifiees?: boolean, fMasqueCalcul?: boolean, fAjouteCalcul?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/articles-prestation-facture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }

            if (factArticleRubArticle !== undefined) {
                localVarQueryParameter['factArticle.rubArticle'] = factArticleRubArticle;
            }

            if (factArticleRubArticle2) {
                localVarQueryParameter['factArticle.rubArticle[]'] = factArticleRubArticle2;
            }

            if (factArticleNatureTva !== undefined) {
                localVarQueryParameter['factArticle.natureTva'] = factArticleNatureTva;
            }

            if (factArticleNatureTva2) {
                localVarQueryParameter['factArticle.natureTva[]'] = factArticleNatureTva2;
            }

            if (idPrestaId !== undefined) {
                localVarQueryParameter['idPresta.id'] = idPrestaId;
            }

            if (idPrestaId2) {
                localVarQueryParameter['idPresta.id[]'] = idPrestaId2;
            }

            if (factArticleId !== undefined) {
                localVarQueryParameter['factArticle.id'] = factArticleId;
            }

            if (factArticleId2) {
                localVarQueryParameter['factArticle.id[]'] = factArticleId2;
            }

            if (idPrestaDossierId !== undefined) {
                localVarQueryParameter['idPresta.dossier.id'] = idPrestaDossierId;
            }

            if (idPrestaDossierId2) {
                localVarQueryParameter['idPresta.dossier.id[]'] = idPrestaDossierId2;
            }

            if (factArticleCategoryId !== undefined) {
                localVarQueryParameter['factArticle.category.id'] = factArticleCategoryId;
            }

            if (factArticleCategoryId2) {
                localVarQueryParameter['factArticle.category.id[]'] = factArticleCategoryId2;
            }

            if (fDonneesVerifiees !== undefined) {
                localVarQueryParameter['fDonneesVerifiees'] = fDonneesVerifiees;
            }

            if (fMasqueCalcul !== undefined) {
                localVarQueryParameter['fMasqueCalcul'] = fMasqueCalcul;
            }

            if (fAjouteCalcul !== undefined) {
                localVarQueryParameter['fAjouteCalcul'] = fAjouteCalcul;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un article d\'une prestation
         * @summary Récupérer les informations d\'un article d\'une prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationFactureIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiArticlesPrestationFactureIdGet', 'id', id)
            const localVarPath = `/formalite/articles-prestation-facture/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les articles de prestation
         * @summary Lister les articles de prestation
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {string} [factArticleRubArticle] 
         * @param {Array<string>} [factArticleRubArticle2] 
         * @param {string} [factArticleNatureTva] 
         * @param {Array<string>} [factArticleNatureTva2] 
         * @param {number} [idPrestaId] 
         * @param {Array<number>} [idPrestaId2] 
         * @param {number} [factArticleId] 
         * @param {Array<number>} [factArticleId2] 
         * @param {number} [idPrestaDossierId] 
         * @param {Array<number>} [idPrestaDossierId2] 
         * @param {number} [factArticleCategoryId] 
         * @param {Array<number>} [factArticleCategoryId2] 
         * @param {boolean} [fDonneesVerifiees] 
         * @param {boolean} [fMasqueCalcul] 
         * @param {boolean} [fAjouteCalcul] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationGetCollection: async (page?: number, itemsPerPage?: number, libelle?: string, factArticleRubArticle?: string, factArticleRubArticle2?: Array<string>, factArticleNatureTva?: string, factArticleNatureTva2?: Array<string>, idPrestaId?: number, idPrestaId2?: Array<number>, factArticleId?: number, factArticleId2?: Array<number>, idPrestaDossierId?: number, idPrestaDossierId2?: Array<number>, factArticleCategoryId?: number, factArticleCategoryId2?: Array<number>, fDonneesVerifiees?: boolean, fMasqueCalcul?: boolean, fAjouteCalcul?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/articles-prestation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }

            if (factArticleRubArticle !== undefined) {
                localVarQueryParameter['factArticle.rubArticle'] = factArticleRubArticle;
            }

            if (factArticleRubArticle2) {
                localVarQueryParameter['factArticle.rubArticle[]'] = factArticleRubArticle2;
            }

            if (factArticleNatureTva !== undefined) {
                localVarQueryParameter['factArticle.natureTva'] = factArticleNatureTva;
            }

            if (factArticleNatureTva2) {
                localVarQueryParameter['factArticle.natureTva[]'] = factArticleNatureTva2;
            }

            if (idPrestaId !== undefined) {
                localVarQueryParameter['idPresta.id'] = idPrestaId;
            }

            if (idPrestaId2) {
                localVarQueryParameter['idPresta.id[]'] = idPrestaId2;
            }

            if (factArticleId !== undefined) {
                localVarQueryParameter['factArticle.id'] = factArticleId;
            }

            if (factArticleId2) {
                localVarQueryParameter['factArticle.id[]'] = factArticleId2;
            }

            if (idPrestaDossierId !== undefined) {
                localVarQueryParameter['idPresta.dossier.id'] = idPrestaDossierId;
            }

            if (idPrestaDossierId2) {
                localVarQueryParameter['idPresta.dossier.id[]'] = idPrestaDossierId2;
            }

            if (factArticleCategoryId !== undefined) {
                localVarQueryParameter['factArticle.category.id'] = factArticleCategoryId;
            }

            if (factArticleCategoryId2) {
                localVarQueryParameter['factArticle.category.id[]'] = factArticleCategoryId2;
            }

            if (fDonneesVerifiees !== undefined) {
                localVarQueryParameter['fDonneesVerifiees'] = fDonneesVerifiees;
            }

            if (fMasqueCalcul !== undefined) {
                localVarQueryParameter['fMasqueCalcul'] = fMasqueCalcul;
            }

            if (fAjouteCalcul !== undefined) {
                localVarQueryParameter['fAjouteCalcul'] = fAjouteCalcul;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
         * @summary Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
         * @param {number} id L\&#39;identifiant de l\&#39;article de prestation
         * @param {ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest} [apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdAttacherAnnonceLegalePatch: async (id: number, apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest?: ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiArticlesPrestationIdAttacherAnnonceLegalePatch', 'id', id)
            const localVarPath = `/formalite/articles-prestation/{id}/attacher-annonce-legale`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un article de prestation
         * @summary Supprimer un article de prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiArticlesPrestationIdDelete', 'id', id)
            const localVarPath = `/formalite/articles-prestation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un article d\'une prestation
         * @summary Récupérer les informations d\'un article d\'une prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiArticlesPrestationIdGet', 'id', id)
            const localVarPath = `/formalite/articles-prestation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour les informations d\'un article de prestation
         * @summary Mettre à jour les informations d\'un article de prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {PrestationArticlesJsonldPrestationrelationUpdate} prestationArticlesJsonldPrestationrelationUpdate The updated Prestation articles resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdPut: async (id: string, prestationArticlesJsonldPrestationrelationUpdate: PrestationArticlesJsonldPrestationrelationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiArticlesPrestationIdPut', 'id', id)
            // verify required parameter 'prestationArticlesJsonldPrestationrelationUpdate' is not null or undefined
            assertParamExists('apiArticlesPrestationIdPut', 'prestationArticlesJsonldPrestationrelationUpdate', prestationArticlesJsonldPrestationrelationUpdate)
            const localVarPath = `/formalite/articles-prestation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prestationArticlesJsonldPrestationrelationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un article de prestation
         * @summary Créer un article de prestation
         * @param {PrestationArticlesJsonldPrestationrelationCreate} prestationArticlesJsonldPrestationrelationCreate The new Prestation articles resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationPost: async (prestationArticlesJsonldPrestationrelationCreate: PrestationArticlesJsonldPrestationrelationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestationArticlesJsonldPrestationrelationCreate' is not null or undefined
            assertParamExists('apiArticlesPrestationPost', 'prestationArticlesJsonldPrestationrelationCreate', prestationArticlesJsonldPrestationrelationCreate)
            const localVarPath = `/formalite/articles-prestation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prestationArticlesJsonldPrestationrelationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des articles par prestation
         * @summary Obtenir la liste des articles par prestation
         * @param {string} prestation FproPrestation identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {string} [factArticleRubArticle] 
         * @param {Array<string>} [factArticleRubArticle2] 
         * @param {string} [factArticleNatureTva] 
         * @param {Array<string>} [factArticleNatureTva2] 
         * @param {number} [idPrestaId] 
         * @param {Array<number>} [idPrestaId2] 
         * @param {number} [factArticleId] 
         * @param {Array<number>} [factArticleId2] 
         * @param {number} [idPrestaDossierId] 
         * @param {Array<number>} [idPrestaDossierId2] 
         * @param {number} [factArticleCategoryId] 
         * @param {Array<number>} [factArticleCategoryId2] 
         * @param {boolean} [fDonneesVerifiees] 
         * @param {boolean} [fMasqueCalcul] 
         * @param {boolean} [fAjouteCalcul] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationArticlesPrestationGetCollection: async (prestation: string, page?: number, itemsPerPage?: number, libelle?: string, factArticleRubArticle?: string, factArticleRubArticle2?: Array<string>, factArticleNatureTva?: string, factArticleNatureTva2?: Array<string>, idPrestaId?: number, idPrestaId2?: Array<number>, factArticleId?: number, factArticleId2?: Array<number>, idPrestaDossierId?: number, idPrestaDossierId2?: Array<number>, factArticleCategoryId?: number, factArticleCategoryId2?: Array<number>, fDonneesVerifiees?: boolean, fMasqueCalcul?: boolean, fAjouteCalcul?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prestation' is not null or undefined
            assertParamExists('apiPrestationsPrestationArticlesPrestationGetCollection', 'prestation', prestation)
            const localVarPath = `/formalite/prestations/{prestation}/articles-prestation`
                .replace(`{${"prestation"}}`, encodeURIComponent(String(prestation)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (libelle !== undefined) {
                localVarQueryParameter['libelle'] = libelle;
            }

            if (factArticleRubArticle !== undefined) {
                localVarQueryParameter['factArticle.rubArticle'] = factArticleRubArticle;
            }

            if (factArticleRubArticle2) {
                localVarQueryParameter['factArticle.rubArticle[]'] = factArticleRubArticle2;
            }

            if (factArticleNatureTva !== undefined) {
                localVarQueryParameter['factArticle.natureTva'] = factArticleNatureTva;
            }

            if (factArticleNatureTva2) {
                localVarQueryParameter['factArticle.natureTva[]'] = factArticleNatureTva2;
            }

            if (idPrestaId !== undefined) {
                localVarQueryParameter['idPresta.id'] = idPrestaId;
            }

            if (idPrestaId2) {
                localVarQueryParameter['idPresta.id[]'] = idPrestaId2;
            }

            if (factArticleId !== undefined) {
                localVarQueryParameter['factArticle.id'] = factArticleId;
            }

            if (factArticleId2) {
                localVarQueryParameter['factArticle.id[]'] = factArticleId2;
            }

            if (idPrestaDossierId !== undefined) {
                localVarQueryParameter['idPresta.dossier.id'] = idPrestaDossierId;
            }

            if (idPrestaDossierId2) {
                localVarQueryParameter['idPresta.dossier.id[]'] = idPrestaDossierId2;
            }

            if (factArticleCategoryId !== undefined) {
                localVarQueryParameter['factArticle.category.id'] = factArticleCategoryId;
            }

            if (factArticleCategoryId2) {
                localVarQueryParameter['factArticle.category.id[]'] = factArticleCategoryId2;
            }

            if (fDonneesVerifiees !== undefined) {
                localVarQueryParameter['fDonneesVerifiees'] = fDonneesVerifiees;
            }

            if (fMasqueCalcul !== undefined) {
                localVarQueryParameter['fMasqueCalcul'] = fMasqueCalcul;
            }

            if (fAjouteCalcul !== undefined) {
                localVarQueryParameter['fAjouteCalcul'] = fAjouteCalcul;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrestationArticlesApi - functional programming interface
 * @export
 */
export const PrestationArticlesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrestationArticlesApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les articles de prestation
         * @summary Lister les articles de prestation
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {string} [factArticleRubArticle] 
         * @param {Array<string>} [factArticleRubArticle2] 
         * @param {string} [factArticleNatureTva] 
         * @param {Array<string>} [factArticleNatureTva2] 
         * @param {number} [idPrestaId] 
         * @param {Array<number>} [idPrestaId2] 
         * @param {number} [factArticleId] 
         * @param {Array<number>} [factArticleId2] 
         * @param {number} [idPrestaDossierId] 
         * @param {Array<number>} [idPrestaDossierId2] 
         * @param {number} [factArticleCategoryId] 
         * @param {Array<number>} [factArticleCategoryId2] 
         * @param {boolean} [fDonneesVerifiees] 
         * @param {boolean} [fMasqueCalcul] 
         * @param {boolean} [fAjouteCalcul] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationFactureGetCollection(page?: number, itemsPerPage?: number, libelle?: string, factArticleRubArticle?: string, factArticleRubArticle2?: Array<string>, factArticleNatureTva?: string, factArticleNatureTva2?: Array<string>, idPrestaId?: number, idPrestaId2?: Array<number>, factArticleId?: number, factArticleId2?: Array<number>, idPrestaDossierId?: number, idPrestaDossierId2?: Array<number>, factArticleCategoryId?: number, factArticleCategoryId2?: Array<number>, fDonneesVerifiees?: boolean, fMasqueCalcul?: boolean, fAjouteCalcul?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArticlesPrestationFactureGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationFactureGetCollection(page, itemsPerPage, libelle, factArticleRubArticle, factArticleRubArticle2, factArticleNatureTva, factArticleNatureTva2, idPrestaId, idPrestaId2, factArticleId, factArticleId2, idPrestaDossierId, idPrestaDossierId2, factArticleCategoryId, factArticleCategoryId2, fDonneesVerifiees, fMasqueCalcul, fAjouteCalcul, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationFactureGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un article d\'une prestation
         * @summary Récupérer les informations d\'un article d\'une prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationFactureIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationArticlesJsonldPrestationrelationfactureRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationFactureIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationFactureIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les articles de prestation
         * @summary Lister les articles de prestation
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {string} [factArticleRubArticle] 
         * @param {Array<string>} [factArticleRubArticle2] 
         * @param {string} [factArticleNatureTva] 
         * @param {Array<string>} [factArticleNatureTva2] 
         * @param {number} [idPrestaId] 
         * @param {Array<number>} [idPrestaId2] 
         * @param {number} [factArticleId] 
         * @param {Array<number>} [factArticleId2] 
         * @param {number} [idPrestaDossierId] 
         * @param {Array<number>} [idPrestaDossierId2] 
         * @param {number} [factArticleCategoryId] 
         * @param {Array<number>} [factArticleCategoryId2] 
         * @param {boolean} [fDonneesVerifiees] 
         * @param {boolean} [fMasqueCalcul] 
         * @param {boolean} [fAjouteCalcul] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationGetCollection(page?: number, itemsPerPage?: number, libelle?: string, factArticleRubArticle?: string, factArticleRubArticle2?: Array<string>, factArticleNatureTva?: string, factArticleNatureTva2?: Array<string>, idPrestaId?: number, idPrestaId2?: Array<number>, factArticleId?: number, factArticleId2?: Array<number>, idPrestaDossierId?: number, idPrestaDossierId2?: Array<number>, factArticleCategoryId?: number, factArticleCategoryId2?: Array<number>, fDonneesVerifiees?: boolean, fMasqueCalcul?: boolean, fAjouteCalcul?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArticlesPrestationGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationGetCollection(page, itemsPerPage, libelle, factArticleRubArticle, factArticleRubArticle2, factArticleNatureTva, factArticleNatureTva2, idPrestaId, idPrestaId2, factArticleId, factArticleId2, idPrestaDossierId, idPrestaDossierId2, factArticleCategoryId, factArticleCategoryId2, fDonneesVerifiees, fMasqueCalcul, fAjouteCalcul, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
         * @summary Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
         * @param {number} id L\&#39;identifiant de l\&#39;article de prestation
         * @param {ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest} [apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationIdAttacherAnnonceLegalePatch(id: number, apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest?: ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationArticlesJsonldPrestationrelationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationIdAttacherAnnonceLegalePatch(id, apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationIdAttacherAnnonceLegalePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un article de prestation
         * @summary Supprimer un article de prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un article d\'une prestation
         * @summary Récupérer les informations d\'un article d\'une prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationArticlesJsonldPrestationrelationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour les informations d\'un article de prestation
         * @summary Mettre à jour les informations d\'un article de prestation
         * @param {string} id FproPrestationArticle identifier
         * @param {PrestationArticlesJsonldPrestationrelationUpdate} prestationArticlesJsonldPrestationrelationUpdate The updated Prestation articles resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationIdPut(id: string, prestationArticlesJsonldPrestationrelationUpdate: PrestationArticlesJsonldPrestationrelationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationArticlesJsonldPrestationrelationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationIdPut(id, prestationArticlesJsonldPrestationrelationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un article de prestation
         * @summary Créer un article de prestation
         * @param {PrestationArticlesJsonldPrestationrelationCreate} prestationArticlesJsonldPrestationrelationCreate The new Prestation articles resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArticlesPrestationPost(prestationArticlesJsonldPrestationrelationCreate: PrestationArticlesJsonldPrestationrelationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationArticlesJsonldPrestationrelationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArticlesPrestationPost(prestationArticlesJsonldPrestationrelationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiArticlesPrestationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des articles par prestation
         * @summary Obtenir la liste des articles par prestation
         * @param {string} prestation FproPrestation identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [libelle] 
         * @param {string} [factArticleRubArticle] 
         * @param {Array<string>} [factArticleRubArticle2] 
         * @param {string} [factArticleNatureTva] 
         * @param {Array<string>} [factArticleNatureTva2] 
         * @param {number} [idPrestaId] 
         * @param {Array<number>} [idPrestaId2] 
         * @param {number} [factArticleId] 
         * @param {Array<number>} [factArticleId2] 
         * @param {number} [idPrestaDossierId] 
         * @param {Array<number>} [idPrestaDossierId2] 
         * @param {number} [factArticleCategoryId] 
         * @param {Array<number>} [factArticleCategoryId2] 
         * @param {boolean} [fDonneesVerifiees] 
         * @param {boolean} [fMasqueCalcul] 
         * @param {boolean} [fAjouteCalcul] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrestationsPrestationArticlesPrestationGetCollection(prestation: string, page?: number, itemsPerPage?: number, libelle?: string, factArticleRubArticle?: string, factArticleRubArticle2?: Array<string>, factArticleNatureTva?: string, factArticleNatureTva2?: Array<string>, idPrestaId?: number, idPrestaId2?: Array<number>, factArticleId?: number, factArticleId2?: Array<number>, idPrestaDossierId?: number, idPrestaDossierId2?: Array<number>, factArticleCategoryId?: number, factArticleCategoryId2?: Array<number>, fDonneesVerifiees?: boolean, fMasqueCalcul?: boolean, fAjouteCalcul?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArticlesPrestationGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrestationsPrestationArticlesPrestationGetCollection(prestation, page, itemsPerPage, libelle, factArticleRubArticle, factArticleRubArticle2, factArticleNatureTva, factArticleNatureTva2, idPrestaId, idPrestaId2, factArticleId, factArticleId2, idPrestaDossierId, idPrestaDossierId2, factArticleCategoryId, factArticleCategoryId2, fDonneesVerifiees, fMasqueCalcul, fAjouteCalcul, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationArticlesApi.apiPrestationsPrestationArticlesPrestationGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrestationArticlesApi - factory interface
 * @export
 */
export const PrestationArticlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrestationArticlesApiFp(configuration)
    return {
        /**
         * Lister les articles de prestation
         * @summary Lister les articles de prestation
         * @param {PrestationArticlesApiApiArticlesPrestationFactureGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationFactureGetCollection(requestParameters: PrestationArticlesApiApiArticlesPrestationFactureGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiArticlesPrestationFactureGetCollection200Response> {
            return localVarFp.apiArticlesPrestationFactureGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.factArticleRubArticle, requestParameters.factArticleRubArticle2, requestParameters.factArticleNatureTva, requestParameters.factArticleNatureTva2, requestParameters.idPrestaId, requestParameters.idPrestaId2, requestParameters.factArticleId, requestParameters.factArticleId2, requestParameters.idPrestaDossierId, requestParameters.idPrestaDossierId2, requestParameters.factArticleCategoryId, requestParameters.factArticleCategoryId2, requestParameters.fDonneesVerifiees, requestParameters.fMasqueCalcul, requestParameters.fAjouteCalcul, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un article d\'une prestation
         * @summary Récupérer les informations d\'un article d\'une prestation
         * @param {PrestationArticlesApiApiArticlesPrestationFactureIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationFactureIdGet(requestParameters: PrestationArticlesApiApiArticlesPrestationFactureIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationArticlesJsonldPrestationrelationfactureRead> {
            return localVarFp.apiArticlesPrestationFactureIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les articles de prestation
         * @summary Lister les articles de prestation
         * @param {PrestationArticlesApiApiArticlesPrestationGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationGetCollection(requestParameters: PrestationArticlesApiApiArticlesPrestationGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiArticlesPrestationGetCollection200Response> {
            return localVarFp.apiArticlesPrestationGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.factArticleRubArticle, requestParameters.factArticleRubArticle2, requestParameters.factArticleNatureTva, requestParameters.factArticleNatureTva2, requestParameters.idPrestaId, requestParameters.idPrestaId2, requestParameters.factArticleId, requestParameters.factArticleId2, requestParameters.idPrestaDossierId, requestParameters.idPrestaDossierId2, requestParameters.factArticleCategoryId, requestParameters.factArticleCategoryId2, requestParameters.fDonneesVerifiees, requestParameters.fMasqueCalcul, requestParameters.fAjouteCalcul, options).then((request) => request(axios, basePath));
        },
        /**
         * Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
         * @summary Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
         * @param {PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdAttacherAnnonceLegalePatch(requestParameters: PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationArticlesJsonldPrestationrelationRead> {
            return localVarFp.apiArticlesPrestationIdAttacherAnnonceLegalePatch(requestParameters.id, requestParameters.apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un article de prestation
         * @summary Supprimer un article de prestation
         * @param {PrestationArticlesApiApiArticlesPrestationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdDelete(requestParameters: PrestationArticlesApiApiArticlesPrestationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArticlesPrestationIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un article d\'une prestation
         * @summary Récupérer les informations d\'un article d\'une prestation
         * @param {PrestationArticlesApiApiArticlesPrestationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdGet(requestParameters: PrestationArticlesApiApiArticlesPrestationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationArticlesJsonldPrestationrelationRead> {
            return localVarFp.apiArticlesPrestationIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour les informations d\'un article de prestation
         * @summary Mettre à jour les informations d\'un article de prestation
         * @param {PrestationArticlesApiApiArticlesPrestationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationIdPut(requestParameters: PrestationArticlesApiApiArticlesPrestationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationArticlesJsonldPrestationrelationRead> {
            return localVarFp.apiArticlesPrestationIdPut(requestParameters.id, requestParameters.prestationArticlesJsonldPrestationrelationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un article de prestation
         * @summary Créer un article de prestation
         * @param {PrestationArticlesApiApiArticlesPrestationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlesPrestationPost(requestParameters: PrestationArticlesApiApiArticlesPrestationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationArticlesJsonldPrestationrelationRead> {
            return localVarFp.apiArticlesPrestationPost(requestParameters.prestationArticlesJsonldPrestationrelationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des articles par prestation
         * @summary Obtenir la liste des articles par prestation
         * @param {PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrestationsPrestationArticlesPrestationGetCollection(requestParameters: PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiArticlesPrestationGetCollection200Response> {
            return localVarFp.apiPrestationsPrestationArticlesPrestationGetCollection(requestParameters.prestation, requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.factArticleRubArticle, requestParameters.factArticleRubArticle2, requestParameters.factArticleNatureTva, requestParameters.factArticleNatureTva2, requestParameters.idPrestaId, requestParameters.idPrestaId2, requestParameters.factArticleId, requestParameters.factArticleId2, requestParameters.idPrestaDossierId, requestParameters.idPrestaDossierId2, requestParameters.factArticleCategoryId, requestParameters.factArticleCategoryId2, requestParameters.fDonneesVerifiees, requestParameters.fMasqueCalcul, requestParameters.fAjouteCalcul, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiArticlesPrestationFactureGetCollection operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationFactureGetCollectionRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationFactureGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly libelle?: string

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleRubArticle?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleRubArticle2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleNatureTva?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleNatureTva2?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly idPrestaId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly idPrestaId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly idPrestaDossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly idPrestaDossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleCategoryId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly factArticleCategoryId2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly fDonneesVerifiees?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly fMasqueCalcul?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureGetCollection
     */
    readonly fAjouteCalcul?: boolean
}

/**
 * Request parameters for apiArticlesPrestationFactureIdGet operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationFactureIdGetRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationFactureIdGetRequest {
    /**
     * FproPrestationArticle identifier
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationFactureIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiArticlesPrestationGetCollection operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationGetCollectionRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly libelle?: string

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleRubArticle?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleRubArticle2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleNatureTva?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleNatureTva2?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly idPrestaId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly idPrestaId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly idPrestaDossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly idPrestaDossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleCategoryId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly factArticleCategoryId2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly fDonneesVerifiees?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly fMasqueCalcul?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiArticlesPrestationGetCollection
     */
    readonly fAjouteCalcul?: boolean
}

/**
 * Request parameters for apiArticlesPrestationIdAttacherAnnonceLegalePatch operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest {
    /**
     * L\&#39;identifiant de l\&#39;article de prestation
     * @type {number}
     * @memberof PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatch
     */
    readonly id: number

    /**
     * 
     * @type {ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest}
     * @memberof PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatch
     */
    readonly apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest?: ApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest
}

/**
 * Request parameters for apiArticlesPrestationIdDelete operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationIdDeleteRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationIdDeleteRequest {
    /**
     * FproPrestationArticle identifier
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiArticlesPrestationIdGet operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationIdGetRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationIdGetRequest {
    /**
     * FproPrestationArticle identifier
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiArticlesPrestationIdPut operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationIdPutRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationIdPutRequest {
    /**
     * FproPrestationArticle identifier
     * @type {string}
     * @memberof PrestationArticlesApiApiArticlesPrestationIdPut
     */
    readonly id: string

    /**
     * The updated Prestation articles resource
     * @type {PrestationArticlesJsonldPrestationrelationUpdate}
     * @memberof PrestationArticlesApiApiArticlesPrestationIdPut
     */
    readonly prestationArticlesJsonldPrestationrelationUpdate: PrestationArticlesJsonldPrestationrelationUpdate
}

/**
 * Request parameters for apiArticlesPrestationPost operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiArticlesPrestationPostRequest
 */
export interface PrestationArticlesApiApiArticlesPrestationPostRequest {
    /**
     * The new Prestation articles resource
     * @type {PrestationArticlesJsonldPrestationrelationCreate}
     * @memberof PrestationArticlesApiApiArticlesPrestationPost
     */
    readonly prestationArticlesJsonldPrestationrelationCreate: PrestationArticlesJsonldPrestationrelationCreate
}

/**
 * Request parameters for apiPrestationsPrestationArticlesPrestationGetCollection operation in PrestationArticlesApi.
 * @export
 * @interface PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollectionRequest
 */
export interface PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollectionRequest {
    /**
     * FproPrestation identifier
     * @type {string}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly prestation: string

    /**
     * The collection page number
     * @type {number}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly libelle?: string

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleRubArticle?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleRubArticle2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleNatureTva?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleNatureTva2?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly idPrestaId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly idPrestaId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly idPrestaDossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly idPrestaDossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleCategoryId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly factArticleCategoryId2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly fDonneesVerifiees?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly fMasqueCalcul?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollection
     */
    readonly fAjouteCalcul?: boolean
}

/**
 * PrestationArticlesApi - object-oriented interface
 * @export
 * @class PrestationArticlesApi
 * @extends {BaseAPI}
 */
export class PrestationArticlesApi extends BaseAPI {
    /**
     * Lister les articles de prestation
     * @summary Lister les articles de prestation
     * @param {PrestationArticlesApiApiArticlesPrestationFactureGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationFactureGetCollection(requestParameters: PrestationArticlesApiApiArticlesPrestationFactureGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationFactureGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.factArticleRubArticle, requestParameters.factArticleRubArticle2, requestParameters.factArticleNatureTva, requestParameters.factArticleNatureTva2, requestParameters.idPrestaId, requestParameters.idPrestaId2, requestParameters.factArticleId, requestParameters.factArticleId2, requestParameters.idPrestaDossierId, requestParameters.idPrestaDossierId2, requestParameters.factArticleCategoryId, requestParameters.factArticleCategoryId2, requestParameters.fDonneesVerifiees, requestParameters.fMasqueCalcul, requestParameters.fAjouteCalcul, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un article d\'une prestation
     * @summary Récupérer les informations d\'un article d\'une prestation
     * @param {PrestationArticlesApiApiArticlesPrestationFactureIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationFactureIdGet(requestParameters: PrestationArticlesApiApiArticlesPrestationFactureIdGetRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationFactureIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les articles de prestation
     * @summary Lister les articles de prestation
     * @param {PrestationArticlesApiApiArticlesPrestationGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationGetCollection(requestParameters: PrestationArticlesApiApiArticlesPrestationGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.factArticleRubArticle, requestParameters.factArticleRubArticle2, requestParameters.factArticleNatureTva, requestParameters.factArticleNatureTva2, requestParameters.idPrestaId, requestParameters.idPrestaId2, requestParameters.factArticleId, requestParameters.factArticleId2, requestParameters.idPrestaDossierId, requestParameters.idPrestaDossierId2, requestParameters.factArticleCategoryId, requestParameters.factArticleCategoryId2, requestParameters.fDonneesVerifiees, requestParameters.fMasqueCalcul, requestParameters.fAjouteCalcul, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
     * @summary Attacher une annone et ajouter des articles depuis les lignes de devis d\'une annonce légale
     * @param {PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationIdAttacherAnnonceLegalePatch(requestParameters: PrestationArticlesApiApiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationIdAttacherAnnonceLegalePatch(requestParameters.id, requestParameters.apiArticlesPrestationIdAttacherAnnonceLegalePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un article de prestation
     * @summary Supprimer un article de prestation
     * @param {PrestationArticlesApiApiArticlesPrestationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationIdDelete(requestParameters: PrestationArticlesApiApiArticlesPrestationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un article d\'une prestation
     * @summary Récupérer les informations d\'un article d\'une prestation
     * @param {PrestationArticlesApiApiArticlesPrestationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationIdGet(requestParameters: PrestationArticlesApiApiArticlesPrestationIdGetRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour les informations d\'un article de prestation
     * @summary Mettre à jour les informations d\'un article de prestation
     * @param {PrestationArticlesApiApiArticlesPrestationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationIdPut(requestParameters: PrestationArticlesApiApiArticlesPrestationIdPutRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationIdPut(requestParameters.id, requestParameters.prestationArticlesJsonldPrestationrelationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un article de prestation
     * @summary Créer un article de prestation
     * @param {PrestationArticlesApiApiArticlesPrestationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiArticlesPrestationPost(requestParameters: PrestationArticlesApiApiArticlesPrestationPostRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiArticlesPrestationPost(requestParameters.prestationArticlesJsonldPrestationrelationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des articles par prestation
     * @summary Obtenir la liste des articles par prestation
     * @param {PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationArticlesApi
     */
    public apiPrestationsPrestationArticlesPrestationGetCollection(requestParameters: PrestationArticlesApiApiPrestationsPrestationArticlesPrestationGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return PrestationArticlesApiFp(this.configuration).apiPrestationsPrestationArticlesPrestationGetCollection(requestParameters.prestation, requestParameters.page, requestParameters.itemsPerPage, requestParameters.libelle, requestParameters.factArticleRubArticle, requestParameters.factArticleRubArticle2, requestParameters.factArticleNatureTva, requestParameters.factArticleNatureTva2, requestParameters.idPrestaId, requestParameters.idPrestaId2, requestParameters.factArticleId, requestParameters.factArticleId2, requestParameters.idPrestaDossierId, requestParameters.idPrestaDossierId2, requestParameters.factArticleCategoryId, requestParameters.factArticleCategoryId2, requestParameters.fDonneesVerifiees, requestParameters.fMasqueCalcul, requestParameters.fAjouteCalcul, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcdureDeValidationDesDossiersApi - axios parameter creator
 * @export
 */
export const ProcdureDeValidationDesDossiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les procédures de validation des dossiers
         * @summary Lister les procédures de validation des dossiers
         * @param {number} dossier L\&#39;identifiant du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierValidationGetCollection: async (dossier: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierValidationGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/validation`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
         * @summary Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {string} action L\&#39;action à déclencher
         * @param {ApiDossiersValidationIdActionPutRequest} [apiDossiersValidationIdActionPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationIdActionPut: async (id: number, action: string, apiDossiersValidationIdActionPutRequest?: ApiDossiersValidationIdActionPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersValidationIdActionPut', 'id', id)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('apiDossiersValidationIdActionPut', 'action', action)
            const localVarPath = `/formalite/dossiers-validation/{id}/{action}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDossiersValidationIdActionPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une procédure de validation d\'un dossier
         * @summary Récupérer les informations d\'une procédure de validation d\'un dossier
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersValidationIdGet', 'id', id)
            const localVarPath = `/formalite/dossiers-validation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Procédure de validation des dossiers resource.
         * @summary Creates a Procédure de validation des dossiers resource.
         * @param {ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate} procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate The new Procédure de validation des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationPost: async (procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate: ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate' is not null or undefined
            assertParamExists('apiDossiersValidationPost', 'procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate', procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate)
            const localVarPath = `/formalite/dossiers-validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mise à jour des articles d\'une procédure de validation d\'un dossier
         * @summary Mise à jour des articles d\'une procédure de validation d\'un dossier
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {Array<ApiDossiersValidationPrestationArticlesIdPutRequestInner>} [apiDossiersValidationPrestationArticlesIdPutRequestInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationPrestationArticlesIdPut: async (id: number, apiDossiersValidationPrestationArticlesIdPutRequestInner?: Array<ApiDossiersValidationPrestationArticlesIdPutRequestInner>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersValidationPrestationArticlesIdPut', 'id', id)
            const localVarPath = `/formalite/dossiers-validation-prestation-articles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDossiersValidationPrestationArticlesIdPutRequestInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publier un dossier vers Demat Facile et passer le process au statut déposé
         * @summary Publier un dossier vers Demat Facile
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {any} body The updated Procédure de validation des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormaliteDossierValidationIdPublishDematFacilePut: async (id: number, body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFormaliteDossierValidationIdPublishDematFacilePut', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('apiFormaliteDossierValidationIdPublishDematFacilePut', 'body', body)
            const localVarPath = `/formalite/formalite/dossier-validation/{id}/publish-demat-facile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les statuts de valideurs
         * @summary Lister les statuts de valideurs
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [validatorId] 
         * @param {Array<number>} [validatorId2] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValideursStatusGetCollection: async (page?: number, itemsPerPage?: number, validatorId?: number, validatorId2?: Array<number>, code?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/valideurs-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (validatorId !== undefined) {
                localVarQueryParameter['validator.id'] = validatorId;
            }

            if (validatorId2) {
                localVarQueryParameter['validator.id[]'] = validatorId2;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un statut de valideur
         * @summary Récupérer les informations d\'un statut de valideur
         * @param {string} id FproDossierValidatorTypeStatus identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValideursStatusIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiValideursStatusIdGet', 'id', id)
            const localVarPath = `/formalite/valideurs-status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcdureDeValidationDesDossiersApi - functional programming interface
 * @export
 */
export const ProcdureDeValidationDesDossiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcdureDeValidationDesDossiersApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les procédures de validation des dossiers
         * @summary Lister les procédures de validation des dossiers
         * @param {number} dossier L\&#39;identifiant du dossier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierValidationGetCollection(dossier: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierValidationGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierValidationGetCollection(dossier, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiDossiersDossierValidationGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
         * @summary Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {string} action L\&#39;action à déclencher
         * @param {ApiDossiersValidationIdActionPutRequest} [apiDossiersValidationIdActionPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersValidationIdActionPut(id: number, action: string, apiDossiersValidationIdActionPutRequest?: ApiDossiersValidationIdActionPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersValidationIdActionPut(id, action, apiDossiersValidationIdActionPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiDossiersValidationIdActionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une procédure de validation d\'un dossier
         * @summary Récupérer les informations d\'une procédure de validation d\'un dossier
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersValidationIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersValidationIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiDossiersValidationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Procédure de validation des dossiers resource.
         * @summary Creates a Procédure de validation des dossiers resource.
         * @param {ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate} procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate The new Procédure de validation des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersValidationPost(procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate: ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersValidationPost(procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiDossiersValidationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mise à jour des articles d\'une procédure de validation d\'un dossier
         * @summary Mise à jour des articles d\'une procédure de validation d\'un dossier
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {Array<ApiDossiersValidationPrestationArticlesIdPutRequestInner>} [apiDossiersValidationPrestationArticlesIdPutRequestInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersValidationPrestationArticlesIdPut(id: number, apiDossiersValidationPrestationArticlesIdPutRequestInner?: Array<ApiDossiersValidationPrestationArticlesIdPutRequestInner>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersValidationPrestationArticlesIdPut(id, apiDossiersValidationPrestationArticlesIdPutRequestInner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiDossiersValidationPrestationArticlesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publier un dossier vers Demat Facile et passer le process au statut déposé
         * @summary Publier un dossier vers Demat Facile
         * @param {number} id L\&#39;identifiant de la procédure de validation
         * @param {any} body The updated Procédure de validation des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormaliteDossierValidationIdPublishDematFacilePut(id: number, body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormaliteDossierValidationIdPublishDematFacilePut(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiFormaliteDossierValidationIdPublishDematFacilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les statuts de valideurs
         * @summary Lister les statuts de valideurs
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [validatorId] 
         * @param {Array<number>} [validatorId2] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValideursStatusGetCollection(page?: number, itemsPerPage?: number, validatorId?: number, validatorId2?: Array<number>, code?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiValideursStatusGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValideursStatusGetCollection(page, itemsPerPage, validatorId, validatorId2, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiValideursStatusGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un statut de valideur
         * @summary Récupérer les informations d\'un statut de valideur
         * @param {string} id FproDossierValidatorTypeStatus identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValideursStatusIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValideursStatusIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcdureDeValidationDesDossiersApi.apiValideursStatusIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcdureDeValidationDesDossiersApi - factory interface
 * @export
 */
export const ProcdureDeValidationDesDossiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcdureDeValidationDesDossiersApiFp(configuration)
    return {
        /**
         * Lister les procédures de validation des dossiers
         * @summary Lister les procédures de validation des dossiers
         * @param {ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierValidationGetCollection(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierValidationGetCollection200Response> {
            return localVarFp.apiDossiersDossierValidationGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
         * @summary Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
         * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationIdActionPut(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead> {
            return localVarFp.apiDossiersValidationIdActionPut(requestParameters.id, requestParameters.action, requestParameters.apiDossiersValidationIdActionPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une procédure de validation d\'un dossier
         * @summary Récupérer les informations d\'une procédure de validation d\'un dossier
         * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationIdGet(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead> {
            return localVarFp.apiDossiersValidationIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Procédure de validation des dossiers resource.
         * @summary Creates a Procédure de validation des dossiers resource.
         * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationPost(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead> {
            return localVarFp.apiDossiersValidationPost(requestParameters.procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Mise à jour des articles d\'une procédure de validation d\'un dossier
         * @summary Mise à jour des articles d\'une procédure de validation d\'un dossier
         * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValidationPrestationArticlesIdPut(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead> {
            return localVarFp.apiDossiersValidationPrestationArticlesIdPut(requestParameters.id, requestParameters.apiDossiersValidationPrestationArticlesIdPutRequestInner, options).then((request) => request(axios, basePath));
        },
        /**
         * Publier un dossier vers Demat Facile et passer le process au statut déposé
         * @summary Publier un dossier vers Demat Facile
         * @param {ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormaliteDossierValidationIdPublishDematFacilePut(requestParameters: ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcDureDeValidationDesDossiersJsonldValidatorsProcessRead> {
            return localVarFp.apiFormaliteDossierValidationIdPublishDematFacilePut(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les statuts de valideurs
         * @summary Lister les statuts de valideurs
         * @param {ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValideursStatusGetCollection(requestParameters: ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiValideursStatusGetCollection200Response> {
            return localVarFp.apiValideursStatusGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.validatorId, requestParameters.validatorId2, requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un statut de valideur
         * @summary Récupérer les informations d\'un statut de valideur
         * @param {ProcdureDeValidationDesDossiersApiApiValideursStatusIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValideursStatusIdGet(requestParameters: ProcdureDeValidationDesDossiersApiApiValideursStatusIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead> {
            return localVarFp.apiValideursStatusIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierValidationGetCollection operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollectionRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollectionRequest {
    /**
     * L\&#39;identifiant du dossier
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollection
     */
    readonly dossier: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiDossiersValidationIdActionPut operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPutRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPutRequest {
    /**
     * L\&#39;identifiant de la procédure de validation
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPut
     */
    readonly id: number

    /**
     * L\&#39;action à déclencher
     * @type {string}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPut
     */
    readonly action: string

    /**
     * 
     * @type {ApiDossiersValidationIdActionPutRequest}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPut
     */
    readonly apiDossiersValidationIdActionPutRequest?: ApiDossiersValidationIdActionPutRequest
}

/**
 * Request parameters for apiDossiersValidationIdGet operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGetRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGetRequest {
    /**
     * L\&#39;identifiant de la procédure de validation
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDossiersValidationPost operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiDossiersValidationPostRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiDossiersValidationPostRequest {
    /**
     * The new Procédure de validation des dossiers resource
     * @type {ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationPost
     */
    readonly procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate: ProcDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate
}

/**
 * Request parameters for apiDossiersValidationPrestationArticlesIdPut operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPutRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPutRequest {
    /**
     * L\&#39;identifiant de la procédure de validation
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPut
     */
    readonly id: number

    /**
     * 
     * @type {Array<ApiDossiersValidationPrestationArticlesIdPutRequestInner>}
     * @memberof ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPut
     */
    readonly apiDossiersValidationPrestationArticlesIdPutRequestInner?: Array<ApiDossiersValidationPrestationArticlesIdPutRequestInner>
}

/**
 * Request parameters for apiFormaliteDossierValidationIdPublishDematFacilePut operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePutRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePutRequest {
    /**
     * L\&#39;identifiant de la procédure de validation
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePut
     */
    readonly id: number

    /**
     * The updated Procédure de validation des dossiers resource
     * @type {any}
     * @memberof ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePut
     */
    readonly body: any
}

/**
 * Request parameters for apiValideursStatusGetCollection operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollectionRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollection
     */
    readonly validatorId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollection
     */
    readonly validatorId2?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollection
     */
    readonly code?: string
}

/**
 * Request parameters for apiValideursStatusIdGet operation in ProcdureDeValidationDesDossiersApi.
 * @export
 * @interface ProcdureDeValidationDesDossiersApiApiValideursStatusIdGetRequest
 */
export interface ProcdureDeValidationDesDossiersApiApiValideursStatusIdGetRequest {
    /**
     * FproDossierValidatorTypeStatus identifier
     * @type {string}
     * @memberof ProcdureDeValidationDesDossiersApiApiValideursStatusIdGet
     */
    readonly id: string
}

/**
 * ProcdureDeValidationDesDossiersApi - object-oriented interface
 * @export
 * @class ProcdureDeValidationDesDossiersApi
 * @extends {BaseAPI}
 */
export class ProcdureDeValidationDesDossiersApi extends BaseAPI {
    /**
     * Lister les procédures de validation des dossiers
     * @summary Lister les procédures de validation des dossiers
     * @param {ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiDossiersDossierValidationGetCollection(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersDossierValidationGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiDossiersDossierValidationGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
     * @summary Déclencher une action pour mettre à jour une procédure de validation d\'un dossier
     * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiDossiersValidationIdActionPut(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationIdActionPutRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiDossiersValidationIdActionPut(requestParameters.id, requestParameters.action, requestParameters.apiDossiersValidationIdActionPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une procédure de validation d\'un dossier
     * @summary Récupérer les informations d\'une procédure de validation d\'un dossier
     * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiDossiersValidationIdGet(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiDossiersValidationIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Procédure de validation des dossiers resource.
     * @summary Creates a Procédure de validation des dossiers resource.
     * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiDossiersValidationPost(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationPostRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiDossiersValidationPost(requestParameters.procDureDeValidationDesDossiersCreateDossierValidationProcessDtoJsonldValidatorsProcessCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mise à jour des articles d\'une procédure de validation d\'un dossier
     * @summary Mise à jour des articles d\'une procédure de validation d\'un dossier
     * @param {ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiDossiersValidationPrestationArticlesIdPut(requestParameters: ProcdureDeValidationDesDossiersApiApiDossiersValidationPrestationArticlesIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiDossiersValidationPrestationArticlesIdPut(requestParameters.id, requestParameters.apiDossiersValidationPrestationArticlesIdPutRequestInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publier un dossier vers Demat Facile et passer le process au statut déposé
     * @summary Publier un dossier vers Demat Facile
     * @param {ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiFormaliteDossierValidationIdPublishDematFacilePut(requestParameters: ProcdureDeValidationDesDossiersApiApiFormaliteDossierValidationIdPublishDematFacilePutRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiFormaliteDossierValidationIdPublishDematFacilePut(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les statuts de valideurs
     * @summary Lister les statuts de valideurs
     * @param {ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiValideursStatusGetCollection(requestParameters: ProcdureDeValidationDesDossiersApiApiValideursStatusGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiValideursStatusGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.validatorId, requestParameters.validatorId2, requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un statut de valideur
     * @summary Récupérer les informations d\'un statut de valideur
     * @param {ProcdureDeValidationDesDossiersApiApiValideursStatusIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcdureDeValidationDesDossiersApi
     */
    public apiValideursStatusIdGet(requestParameters: ProcdureDeValidationDesDossiersApiApiValideursStatusIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProcdureDeValidationDesDossiersApiFp(this.configuration).apiValideursStatusIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RappelsApi - axios parameter creator
 * @export
 */
export const RappelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des rappels
         * @summary Obtenir la liste des rappels
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierRappelsGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierRappelsGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/rappels`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un rappel
         * @summary Récupérer les informations d\'un rappel
         * @param {string} id TblEvenementRappel identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRappelsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRappelsIdGet', 'id', id)
            const localVarPath = `/formalite/rappels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Notes et rappels resource.
         * @summary Modifier un rappel
         * @param {string} id TblEvenementRappel identifier
         * @param {NotesEtRappelsJsonldNoterappelUpdate} notesEtRappelsJsonldNoterappelUpdate The updated Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRappelsIdPut: async (id: string, notesEtRappelsJsonldNoterappelUpdate: NotesEtRappelsJsonldNoterappelUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRappelsIdPut', 'id', id)
            // verify required parameter 'notesEtRappelsJsonldNoterappelUpdate' is not null or undefined
            assertParamExists('apiRappelsIdPut', 'notesEtRappelsJsonldNoterappelUpdate', notesEtRappelsJsonldNoterappelUpdate)
            const localVarPath = `/formalite/rappels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notesEtRappelsJsonldNoterappelUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Notes et rappels resource.
         * @summary Créer un rappel
         * @param {NotesEtRappelsJsonldNoterappelCreate} notesEtRappelsJsonldNoterappelCreate The new Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRappelsPost: async (notesEtRappelsJsonldNoterappelCreate: NotesEtRappelsJsonldNoterappelCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notesEtRappelsJsonldNoterappelCreate' is not null or undefined
            assertParamExists('apiRappelsPost', 'notesEtRappelsJsonldNoterappelCreate', notesEtRappelsJsonldNoterappelCreate)
            const localVarPath = `/formalite/rappels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notesEtRappelsJsonldNoterappelCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RappelsApi - functional programming interface
 * @export
 */
export const RappelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RappelsApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des rappels
         * @summary Obtenir la liste des rappels
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierRappelsGetCollection(dossier: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierRappelsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierRappelsGetCollection(dossier, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RappelsApi.apiDossiersDossierRappelsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un rappel
         * @summary Récupérer les informations d\'un rappel
         * @param {string} id TblEvenementRappel identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRappelsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesEtRappelsJsonldNoterappelRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRappelsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RappelsApi.apiRappelsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Notes et rappels resource.
         * @summary Modifier un rappel
         * @param {string} id TblEvenementRappel identifier
         * @param {NotesEtRappelsJsonldNoterappelUpdate} notesEtRappelsJsonldNoterappelUpdate The updated Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRappelsIdPut(id: string, notesEtRappelsJsonldNoterappelUpdate: NotesEtRappelsJsonldNoterappelUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesEtRappelsJsonldNoterappelRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRappelsIdPut(id, notesEtRappelsJsonldNoterappelUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RappelsApi.apiRappelsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Notes et rappels resource.
         * @summary Créer un rappel
         * @param {NotesEtRappelsJsonldNoterappelCreate} notesEtRappelsJsonldNoterappelCreate The new Notes et rappels resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRappelsPost(notesEtRappelsJsonldNoterappelCreate: NotesEtRappelsJsonldNoterappelCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesEtRappelsJsonldNoterappelCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRappelsPost(notesEtRappelsJsonldNoterappelCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RappelsApi.apiRappelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RappelsApi - factory interface
 * @export
 */
export const RappelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RappelsApiFp(configuration)
    return {
        /**
         * Obtenir la liste des rappels
         * @summary Obtenir la liste des rappels
         * @param {RappelsApiApiDossiersDossierRappelsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierRappelsGetCollection(requestParameters: RappelsApiApiDossiersDossierRappelsGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierRappelsGetCollection200Response> {
            return localVarFp.apiDossiersDossierRappelsGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un rappel
         * @summary Récupérer les informations d\'un rappel
         * @param {RappelsApiApiRappelsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRappelsIdGet(requestParameters: RappelsApiApiRappelsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotesEtRappelsJsonldNoterappelRead> {
            return localVarFp.apiRappelsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Notes et rappels resource.
         * @summary Modifier un rappel
         * @param {RappelsApiApiRappelsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRappelsIdPut(requestParameters: RappelsApiApiRappelsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotesEtRappelsJsonldNoterappelRead> {
            return localVarFp.apiRappelsIdPut(requestParameters.id, requestParameters.notesEtRappelsJsonldNoterappelUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Notes et rappels resource.
         * @summary Créer un rappel
         * @param {RappelsApiApiRappelsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRappelsPost(requestParameters: RappelsApiApiRappelsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotesEtRappelsJsonldNoterappelCreated> {
            return localVarFp.apiRappelsPost(requestParameters.notesEtRappelsJsonldNoterappelCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierRappelsGetCollection operation in RappelsApi.
 * @export
 * @interface RappelsApiApiDossiersDossierRappelsGetCollectionRequest
 */
export interface RappelsApiApiDossiersDossierRappelsGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof RappelsApiApiDossiersDossierRappelsGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof RappelsApiApiDossiersDossierRappelsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof RappelsApiApiDossiersDossierRappelsGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiRappelsIdGet operation in RappelsApi.
 * @export
 * @interface RappelsApiApiRappelsIdGetRequest
 */
export interface RappelsApiApiRappelsIdGetRequest {
    /**
     * TblEvenementRappel identifier
     * @type {string}
     * @memberof RappelsApiApiRappelsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiRappelsIdPut operation in RappelsApi.
 * @export
 * @interface RappelsApiApiRappelsIdPutRequest
 */
export interface RappelsApiApiRappelsIdPutRequest {
    /**
     * TblEvenementRappel identifier
     * @type {string}
     * @memberof RappelsApiApiRappelsIdPut
     */
    readonly id: string

    /**
     * The updated Notes et rappels resource
     * @type {NotesEtRappelsJsonldNoterappelUpdate}
     * @memberof RappelsApiApiRappelsIdPut
     */
    readonly notesEtRappelsJsonldNoterappelUpdate: NotesEtRappelsJsonldNoterappelUpdate
}

/**
 * Request parameters for apiRappelsPost operation in RappelsApi.
 * @export
 * @interface RappelsApiApiRappelsPostRequest
 */
export interface RappelsApiApiRappelsPostRequest {
    /**
     * The new Notes et rappels resource
     * @type {NotesEtRappelsJsonldNoterappelCreate}
     * @memberof RappelsApiApiRappelsPost
     */
    readonly notesEtRappelsJsonldNoterappelCreate: NotesEtRappelsJsonldNoterappelCreate
}

/**
 * RappelsApi - object-oriented interface
 * @export
 * @class RappelsApi
 * @extends {BaseAPI}
 */
export class RappelsApi extends BaseAPI {
    /**
     * Obtenir la liste des rappels
     * @summary Obtenir la liste des rappels
     * @param {RappelsApiApiDossiersDossierRappelsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RappelsApi
     */
    public apiDossiersDossierRappelsGetCollection(requestParameters: RappelsApiApiDossiersDossierRappelsGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return RappelsApiFp(this.configuration).apiDossiersDossierRappelsGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un rappel
     * @summary Récupérer les informations d\'un rappel
     * @param {RappelsApiApiRappelsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RappelsApi
     */
    public apiRappelsIdGet(requestParameters: RappelsApiApiRappelsIdGetRequest, options?: RawAxiosRequestConfig) {
        return RappelsApiFp(this.configuration).apiRappelsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Notes et rappels resource.
     * @summary Modifier un rappel
     * @param {RappelsApiApiRappelsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RappelsApi
     */
    public apiRappelsIdPut(requestParameters: RappelsApiApiRappelsIdPutRequest, options?: RawAxiosRequestConfig) {
        return RappelsApiFp(this.configuration).apiRappelsIdPut(requestParameters.id, requestParameters.notesEtRappelsJsonldNoterappelUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Notes et rappels resource.
     * @summary Créer un rappel
     * @param {RappelsApiApiRappelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RappelsApi
     */
    public apiRappelsPost(requestParameters: RappelsApiApiRappelsPostRequest, options?: RawAxiosRequestConfig) {
        return RappelsApiFp(this.configuration).apiRappelsPost(requestParameters.notesEtRappelsJsonldNoterappelCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReglementsApi - axios parameter creator
 * @export
 */
export const ReglementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les documents des règlement parmi ceux autorisés et en filtrant sur l\'idPrescripteur, la collection, les dossier
         * @summary Lister les documents des règlement
         * @param {Array<ApiReglementsDocumentsGetCollectionTagsParameterInner>} [tags] Map of tags
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [dossierFormaliteId] 
         * @param {Array<number>} [dossierFormaliteId2] 
         * @param {number} [detailsReglementsIdCollectionId] 
         * @param {Array<number>} [detailsReglementsIdCollectionId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsDocumentsGetCollection: async (tags?: Array<ApiReglementsDocumentsGetCollectionTagsParameterInner>, page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, dossierFormaliteId?: number, dossierFormaliteId2?: Array<number>, detailsReglementsIdCollectionId?: number, detailsReglementsIdCollectionId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/reglements/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (tags) {
                localVarQueryParameter['tags'] = tags.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (dossierFormaliteId !== undefined) {
                localVarQueryParameter['dossierFormalite.id'] = dossierFormaliteId;
            }

            if (dossierFormaliteId2) {
                localVarQueryParameter['dossierFormalite.id[]'] = dossierFormaliteId2;
            }

            if (detailsReglementsIdCollectionId !== undefined) {
                localVarQueryParameter['detailsReglements.idCollection.id'] = detailsReglementsIdCollectionId;
            }

            if (detailsReglementsIdCollectionId2) {
                localVarQueryParameter['detailsReglements.idCollection.id[]'] = detailsReglementsIdCollectionId2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des règlements
         * @summary Obtenir la liste des règlements
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [dossierFormaliteId] 
         * @param {Array<number>} [dossierFormaliteId2] 
         * @param {number} [detailsReglementsIdCollectionId] 
         * @param {Array<number>} [detailsReglementsIdCollectionId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsGetCollection: async (page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, dossierFormaliteId?: number, dossierFormaliteId2?: Array<number>, detailsReglementsIdCollectionId?: number, detailsReglementsIdCollectionId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/reglements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (dossierFormaliteId !== undefined) {
                localVarQueryParameter['dossierFormalite.id'] = dossierFormaliteId;
            }

            if (dossierFormaliteId2) {
                localVarQueryParameter['dossierFormalite.id[]'] = dossierFormaliteId2;
            }

            if (detailsReglementsIdCollectionId !== undefined) {
                localVarQueryParameter['detailsReglements.idCollection.id'] = detailsReglementsIdCollectionId;
            }

            if (detailsReglementsIdCollectionId2) {
                localVarQueryParameter['detailsReglements.idCollection.id[]'] = detailsReglementsIdCollectionId2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un règlement
         * @summary Récupérer les informations d\'un règlement
         * @param {string} id TblReglement2 identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReglementsIdGet', 'id', id)
            const localVarPath = `/formalite/reglements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Reglements et acomptes CB resource.
         * @summary Créer un règlement
         * @param {ReglementsEtAcomptesCBJsonldReglementCreate} reglementsEtAcomptesCBJsonldReglementCreate The new Reglements et acomptes CB resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsPost: async (reglementsEtAcomptesCBJsonldReglementCreate: ReglementsEtAcomptesCBJsonldReglementCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reglementsEtAcomptesCBJsonldReglementCreate' is not null or undefined
            assertParamExists('apiReglementsPost', 'reglementsEtAcomptesCBJsonldReglementCreate', reglementsEtAcomptesCBJsonldReglementCreate)
            const localVarPath = `/formalite/reglements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reglementsEtAcomptesCBJsonldReglementCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReglementsApi - functional programming interface
 * @export
 */
export const ReglementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReglementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les documents des règlement parmi ceux autorisés et en filtrant sur l\'idPrescripteur, la collection, les dossier
         * @summary Lister les documents des règlement
         * @param {Array<ApiReglementsDocumentsGetCollectionTagsParameterInner>} [tags] Map of tags
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [dossierFormaliteId] 
         * @param {Array<number>} [dossierFormaliteId2] 
         * @param {number} [detailsReglementsIdCollectionId] 
         * @param {Array<number>} [detailsReglementsIdCollectionId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReglementsDocumentsGetCollection(tags?: Array<ApiReglementsDocumentsGetCollectionTagsParameterInner>, page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, dossierFormaliteId?: number, dossierFormaliteId2?: Array<number>, detailsReglementsIdCollectionId?: number, detailsReglementsIdCollectionId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReglementsDocumentsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReglementsDocumentsGetCollection(tags, page, itemsPerPage, id, id2, dossierFormaliteId, dossierFormaliteId2, detailsReglementsIdCollectionId, detailsReglementsIdCollectionId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReglementsApi.apiReglementsDocumentsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des règlements
         * @summary Obtenir la liste des règlements
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [dossierFormaliteId] 
         * @param {Array<number>} [dossierFormaliteId2] 
         * @param {number} [detailsReglementsIdCollectionId] 
         * @param {Array<number>} [detailsReglementsIdCollectionId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReglementsGetCollection(page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, dossierFormaliteId?: number, dossierFormaliteId2?: Array<number>, detailsReglementsIdCollectionId?: number, detailsReglementsIdCollectionId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReglementsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReglementsGetCollection(page, itemsPerPage, id, id2, dossierFormaliteId, dossierFormaliteId2, detailsReglementsIdCollectionId, detailsReglementsIdCollectionId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReglementsApi.apiReglementsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un règlement
         * @summary Récupérer les informations d\'un règlement
         * @param {string} id TblReglement2 identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReglementsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReglementsEtAcomptesCBJsonldReglementRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReglementsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReglementsApi.apiReglementsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Reglements et acomptes CB resource.
         * @summary Créer un règlement
         * @param {ReglementsEtAcomptesCBJsonldReglementCreate} reglementsEtAcomptesCBJsonldReglementCreate The new Reglements et acomptes CB resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReglementsPost(reglementsEtAcomptesCBJsonldReglementCreate: ReglementsEtAcomptesCBJsonldReglementCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReglementsEtAcomptesCBJsonldReglementCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReglementsPost(reglementsEtAcomptesCBJsonldReglementCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReglementsApi.apiReglementsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReglementsApi - factory interface
 * @export
 */
export const ReglementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReglementsApiFp(configuration)
    return {
        /**
         * Lister les documents des règlement parmi ceux autorisés et en filtrant sur l\'idPrescripteur, la collection, les dossier
         * @summary Lister les documents des règlement
         * @param {ReglementsApiApiReglementsDocumentsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsDocumentsGetCollection(requestParameters: ReglementsApiApiReglementsDocumentsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiReglementsDocumentsGetCollection200Response> {
            return localVarFp.apiReglementsDocumentsGetCollection(requestParameters.tags, requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.dossierFormaliteId, requestParameters.dossierFormaliteId2, requestParameters.detailsReglementsIdCollectionId, requestParameters.detailsReglementsIdCollectionId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des règlements
         * @summary Obtenir la liste des règlements
         * @param {ReglementsApiApiReglementsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsGetCollection(requestParameters: ReglementsApiApiReglementsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiReglementsGetCollection200Response> {
            return localVarFp.apiReglementsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.dossierFormaliteId, requestParameters.dossierFormaliteId2, requestParameters.detailsReglementsIdCollectionId, requestParameters.detailsReglementsIdCollectionId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un règlement
         * @summary Récupérer les informations d\'un règlement
         * @param {ReglementsApiApiReglementsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsIdGet(requestParameters: ReglementsApiApiReglementsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReglementsEtAcomptesCBJsonldReglementRead> {
            return localVarFp.apiReglementsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Reglements et acomptes CB resource.
         * @summary Créer un règlement
         * @param {ReglementsApiApiReglementsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsPost(requestParameters: ReglementsApiApiReglementsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReglementsEtAcomptesCBJsonldReglementCreated> {
            return localVarFp.apiReglementsPost(requestParameters.reglementsEtAcomptesCBJsonldReglementCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiReglementsDocumentsGetCollection operation in ReglementsApi.
 * @export
 * @interface ReglementsApiApiReglementsDocumentsGetCollectionRequest
 */
export interface ReglementsApiApiReglementsDocumentsGetCollectionRequest {
    /**
     * Map of tags
     * @type {Array<ApiReglementsDocumentsGetCollectionTagsParameterInner>}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly tags?: Array<ApiReglementsDocumentsGetCollectionTagsParameterInner>

    /**
     * The collection page number
     * @type {number}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly id2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly dossierFormaliteId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly dossierFormaliteId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly detailsReglementsIdCollectionId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ReglementsApiApiReglementsDocumentsGetCollection
     */
    readonly detailsReglementsIdCollectionId2?: Array<number>
}

/**
 * Request parameters for apiReglementsGetCollection operation in ReglementsApi.
 * @export
 * @interface ReglementsApiApiReglementsGetCollectionRequest
 */
export interface ReglementsApiApiReglementsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly id2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly dossierFormaliteId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly dossierFormaliteId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly detailsReglementsIdCollectionId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ReglementsApiApiReglementsGetCollection
     */
    readonly detailsReglementsIdCollectionId2?: Array<number>
}

/**
 * Request parameters for apiReglementsIdGet operation in ReglementsApi.
 * @export
 * @interface ReglementsApiApiReglementsIdGetRequest
 */
export interface ReglementsApiApiReglementsIdGetRequest {
    /**
     * TblReglement2 identifier
     * @type {string}
     * @memberof ReglementsApiApiReglementsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiReglementsPost operation in ReglementsApi.
 * @export
 * @interface ReglementsApiApiReglementsPostRequest
 */
export interface ReglementsApiApiReglementsPostRequest {
    /**
     * The new Reglements et acomptes CB resource
     * @type {ReglementsEtAcomptesCBJsonldReglementCreate}
     * @memberof ReglementsApiApiReglementsPost
     */
    readonly reglementsEtAcomptesCBJsonldReglementCreate: ReglementsEtAcomptesCBJsonldReglementCreate
}

/**
 * ReglementsApi - object-oriented interface
 * @export
 * @class ReglementsApi
 * @extends {BaseAPI}
 */
export class ReglementsApi extends BaseAPI {
    /**
     * Lister les documents des règlement parmi ceux autorisés et en filtrant sur l\'idPrescripteur, la collection, les dossier
     * @summary Lister les documents des règlement
     * @param {ReglementsApiApiReglementsDocumentsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReglementsApi
     */
    public apiReglementsDocumentsGetCollection(requestParameters: ReglementsApiApiReglementsDocumentsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ReglementsApiFp(this.configuration).apiReglementsDocumentsGetCollection(requestParameters.tags, requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.dossierFormaliteId, requestParameters.dossierFormaliteId2, requestParameters.detailsReglementsIdCollectionId, requestParameters.detailsReglementsIdCollectionId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des règlements
     * @summary Obtenir la liste des règlements
     * @param {ReglementsApiApiReglementsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReglementsApi
     */
    public apiReglementsGetCollection(requestParameters: ReglementsApiApiReglementsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ReglementsApiFp(this.configuration).apiReglementsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.dossierFormaliteId, requestParameters.dossierFormaliteId2, requestParameters.detailsReglementsIdCollectionId, requestParameters.detailsReglementsIdCollectionId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un règlement
     * @summary Récupérer les informations d\'un règlement
     * @param {ReglementsApiApiReglementsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReglementsApi
     */
    public apiReglementsIdGet(requestParameters: ReglementsApiApiReglementsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ReglementsApiFp(this.configuration).apiReglementsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Reglements et acomptes CB resource.
     * @summary Créer un règlement
     * @param {ReglementsApiApiReglementsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReglementsApi
     */
    public apiReglementsPost(requestParameters: ReglementsApiApiReglementsPostRequest, options?: RawAxiosRequestConfig) {
        return ReglementsApiFp(this.configuration).apiReglementsPost(requestParameters.reglementsEtAcomptesCBJsonldReglementCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReglementsDetailsApi - axios parameter creator
 * @export
 */
export const ReglementsDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsDetailsGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/reglements-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un dossier
         * @summary Récupérer les informations d\'un dossier
         * @param {string} id TblReglement2Details identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsDetailsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReglementsDetailsIdGet', 'id', id)
            const localVarPath = `/formalite/reglements-details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReglementsDetailsApi - functional programming interface
 * @export
 */
export const ReglementsDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReglementsDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReglementsDetailsGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReglementsDetailsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReglementsDetailsGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReglementsDetailsApi.apiReglementsDetailsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un dossier
         * @summary Récupérer les informations d\'un dossier
         * @param {string} id TblReglement2Details identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReglementsDetailsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReglementsDetailsJsonldReglementdetailsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReglementsDetailsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReglementsDetailsApi.apiReglementsDetailsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReglementsDetailsApi - factory interface
 * @export
 */
export const ReglementsDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReglementsDetailsApiFp(configuration)
    return {
        /**
         * Lister les dossiers
         * @summary Lister les dossiers
         * @param {ReglementsDetailsApiApiReglementsDetailsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsDetailsGetCollection(requestParameters: ReglementsDetailsApiApiReglementsDetailsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiReglementsDetailsGetCollection200Response> {
            return localVarFp.apiReglementsDetailsGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un dossier
         * @summary Récupérer les informations d\'un dossier
         * @param {ReglementsDetailsApiApiReglementsDetailsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReglementsDetailsIdGet(requestParameters: ReglementsDetailsApiApiReglementsDetailsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReglementsDetailsJsonldReglementdetailsRead> {
            return localVarFp.apiReglementsDetailsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiReglementsDetailsGetCollection operation in ReglementsDetailsApi.
 * @export
 * @interface ReglementsDetailsApiApiReglementsDetailsGetCollectionRequest
 */
export interface ReglementsDetailsApiApiReglementsDetailsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ReglementsDetailsApiApiReglementsDetailsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ReglementsDetailsApiApiReglementsDetailsGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiReglementsDetailsIdGet operation in ReglementsDetailsApi.
 * @export
 * @interface ReglementsDetailsApiApiReglementsDetailsIdGetRequest
 */
export interface ReglementsDetailsApiApiReglementsDetailsIdGetRequest {
    /**
     * TblReglement2Details identifier
     * @type {string}
     * @memberof ReglementsDetailsApiApiReglementsDetailsIdGet
     */
    readonly id: string
}

/**
 * ReglementsDetailsApi - object-oriented interface
 * @export
 * @class ReglementsDetailsApi
 * @extends {BaseAPI}
 */
export class ReglementsDetailsApi extends BaseAPI {
    /**
     * Lister les dossiers
     * @summary Lister les dossiers
     * @param {ReglementsDetailsApiApiReglementsDetailsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReglementsDetailsApi
     */
    public apiReglementsDetailsGetCollection(requestParameters: ReglementsDetailsApiApiReglementsDetailsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ReglementsDetailsApiFp(this.configuration).apiReglementsDetailsGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un dossier
     * @summary Récupérer les informations d\'un dossier
     * @param {ReglementsDetailsApiApiReglementsDetailsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReglementsDetailsApi
     */
    public apiReglementsDetailsIdGet(requestParameters: ReglementsDetailsApiApiReglementsDetailsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ReglementsDetailsApiFp(this.configuration).apiReglementsDetailsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatutApi - axios parameter creator
 * @export
 */
export const StatutApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des statuts
         * @summary Obtenir la liste des statuts
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [type] 
         * @param {Array<number>} [type2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsGetCollection: async (page?: number, itemsPerPage?: number, type?: number, type2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/statuts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (type2) {
                localVarQueryParameter['type[]'] = type2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un statut
         * @summary Supprimer un statut
         * @param {string} id FproDosStatut identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStatutsIdDelete', 'id', id)
            const localVarPath = `/formalite/statuts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un statut
         * @summary Récupérer les informations d\'un statut
         * @param {string} id FproDosStatut identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStatutsIdGet', 'id', id)
            const localVarPath = `/formalite/statuts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Statut resource.
         * @summary Modifier un statut
         * @param {string} id FproDosStatut identifier
         * @param {StatutJsonldStatutUpdate} statutJsonldStatutUpdate The updated Statut resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsIdPut: async (id: string, statutJsonldStatutUpdate: StatutJsonldStatutUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStatutsIdPut', 'id', id)
            // verify required parameter 'statutJsonldStatutUpdate' is not null or undefined
            assertParamExists('apiStatutsIdPut', 'statutJsonldStatutUpdate', statutJsonldStatutUpdate)
            const localVarPath = `/formalite/statuts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statutJsonldStatutUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Statut resource.
         * @summary Créer un statut
         * @param {StatutJsonldStatutCreate} statutJsonldStatutCreate The new Statut resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsPost: async (statutJsonldStatutCreate: StatutJsonldStatutCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statutJsonldStatutCreate' is not null or undefined
            assertParamExists('apiStatutsPost', 'statutJsonldStatutCreate', statutJsonldStatutCreate)
            const localVarPath = `/formalite/statuts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statutJsonldStatutCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatutApi - functional programming interface
 * @export
 */
export const StatutApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatutApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des statuts
         * @summary Obtenir la liste des statuts
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [type] 
         * @param {Array<number>} [type2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatutsGetCollection(page?: number, itemsPerPage?: number, type?: number, type2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiStatutsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatutsGetCollection(page, itemsPerPage, type, type2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatutApi.apiStatutsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un statut
         * @summary Supprimer un statut
         * @param {string} id FproDosStatut identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatutsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatutsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatutApi.apiStatutsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un statut
         * @summary Récupérer les informations d\'un statut
         * @param {string} id FproDosStatut identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatutsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutJsonldStatutRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatutsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatutApi.apiStatutsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Statut resource.
         * @summary Modifier un statut
         * @param {string} id FproDosStatut identifier
         * @param {StatutJsonldStatutUpdate} statutJsonldStatutUpdate The updated Statut resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatutsIdPut(id: string, statutJsonldStatutUpdate: StatutJsonldStatutUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutJsonldStatutRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatutsIdPut(id, statutJsonldStatutUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatutApi.apiStatutsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Statut resource.
         * @summary Créer un statut
         * @param {StatutJsonldStatutCreate} statutJsonldStatutCreate The new Statut resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatutsPost(statutJsonldStatutCreate: StatutJsonldStatutCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutJsonldStatutCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatutsPost(statutJsonldStatutCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatutApi.apiStatutsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatutApi - factory interface
 * @export
 */
export const StatutApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatutApiFp(configuration)
    return {
        /**
         * Obtenir la liste des statuts
         * @summary Obtenir la liste des statuts
         * @param {StatutApiApiStatutsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsGetCollection(requestParameters: StatutApiApiStatutsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiStatutsGetCollection200Response> {
            return localVarFp.apiStatutsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.type, requestParameters.type2, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un statut
         * @summary Supprimer un statut
         * @param {StatutApiApiStatutsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsIdDelete(requestParameters: StatutApiApiStatutsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStatutsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un statut
         * @summary Récupérer les informations d\'un statut
         * @param {StatutApiApiStatutsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsIdGet(requestParameters: StatutApiApiStatutsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatutJsonldStatutRead> {
            return localVarFp.apiStatutsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Statut resource.
         * @summary Modifier un statut
         * @param {StatutApiApiStatutsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsIdPut(requestParameters: StatutApiApiStatutsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatutJsonldStatutRead> {
            return localVarFp.apiStatutsIdPut(requestParameters.id, requestParameters.statutJsonldStatutUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Statut resource.
         * @summary Créer un statut
         * @param {StatutApiApiStatutsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatutsPost(requestParameters: StatutApiApiStatutsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatutJsonldStatutCreated> {
            return localVarFp.apiStatutsPost(requestParameters.statutJsonldStatutCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiStatutsGetCollection operation in StatutApi.
 * @export
 * @interface StatutApiApiStatutsGetCollectionRequest
 */
export interface StatutApiApiStatutsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof StatutApiApiStatutsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof StatutApiApiStatutsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof StatutApiApiStatutsGetCollection
     */
    readonly type?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof StatutApiApiStatutsGetCollection
     */
    readonly type2?: Array<number>
}

/**
 * Request parameters for apiStatutsIdDelete operation in StatutApi.
 * @export
 * @interface StatutApiApiStatutsIdDeleteRequest
 */
export interface StatutApiApiStatutsIdDeleteRequest {
    /**
     * FproDosStatut identifier
     * @type {string}
     * @memberof StatutApiApiStatutsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiStatutsIdGet operation in StatutApi.
 * @export
 * @interface StatutApiApiStatutsIdGetRequest
 */
export interface StatutApiApiStatutsIdGetRequest {
    /**
     * FproDosStatut identifier
     * @type {string}
     * @memberof StatutApiApiStatutsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiStatutsIdPut operation in StatutApi.
 * @export
 * @interface StatutApiApiStatutsIdPutRequest
 */
export interface StatutApiApiStatutsIdPutRequest {
    /**
     * FproDosStatut identifier
     * @type {string}
     * @memberof StatutApiApiStatutsIdPut
     */
    readonly id: string

    /**
     * The updated Statut resource
     * @type {StatutJsonldStatutUpdate}
     * @memberof StatutApiApiStatutsIdPut
     */
    readonly statutJsonldStatutUpdate: StatutJsonldStatutUpdate
}

/**
 * Request parameters for apiStatutsPost operation in StatutApi.
 * @export
 * @interface StatutApiApiStatutsPostRequest
 */
export interface StatutApiApiStatutsPostRequest {
    /**
     * The new Statut resource
     * @type {StatutJsonldStatutCreate}
     * @memberof StatutApiApiStatutsPost
     */
    readonly statutJsonldStatutCreate: StatutJsonldStatutCreate
}

/**
 * StatutApi - object-oriented interface
 * @export
 * @class StatutApi
 * @extends {BaseAPI}
 */
export class StatutApi extends BaseAPI {
    /**
     * Obtenir la liste des statuts
     * @summary Obtenir la liste des statuts
     * @param {StatutApiApiStatutsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutApi
     */
    public apiStatutsGetCollection(requestParameters: StatutApiApiStatutsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return StatutApiFp(this.configuration).apiStatutsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.type, requestParameters.type2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un statut
     * @summary Supprimer un statut
     * @param {StatutApiApiStatutsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutApi
     */
    public apiStatutsIdDelete(requestParameters: StatutApiApiStatutsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return StatutApiFp(this.configuration).apiStatutsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un statut
     * @summary Récupérer les informations d\'un statut
     * @param {StatutApiApiStatutsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutApi
     */
    public apiStatutsIdGet(requestParameters: StatutApiApiStatutsIdGetRequest, options?: RawAxiosRequestConfig) {
        return StatutApiFp(this.configuration).apiStatutsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Statut resource.
     * @summary Modifier un statut
     * @param {StatutApiApiStatutsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutApi
     */
    public apiStatutsIdPut(requestParameters: StatutApiApiStatutsIdPutRequest, options?: RawAxiosRequestConfig) {
        return StatutApiFp(this.configuration).apiStatutsIdPut(requestParameters.id, requestParameters.statutJsonldStatutUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Statut resource.
     * @summary Créer un statut
     * @param {StatutApiApiStatutsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutApi
     */
    public apiStatutsPost(requestParameters: StatutApiApiStatutsPostRequest, options?: RawAxiosRequestConfig) {
        return StatutApiFp(this.configuration).apiStatutsPost(requestParameters.statutJsonldStatutCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TachesEtRappelsDesDossierApi - axios parameter creator
 * @export
 */
export const TachesEtRappelsDesDossierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Suppression d\'une tache dossier
         * @summary Supprimer une tache dossier
         * @param {string} id TblRelTacheFproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTacheDossierIdDelete', 'id', id)
            const localVarPath = `/formalite/tache-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lire d\'une tache dossier
         * @summary Lire une tache dossier
         * @param {string} id TblRelTacheFproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTacheDossierIdGet', 'id', id)
            const localVarPath = `/formalite/tache-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edition d\'une tache dossier
         * @summary Editer une tache dossier
         * @param {string} id TblRelTacheFproDossier identifier
         * @param {TachesEtRappelsDesDossierTacheUpdate} tachesEtRappelsDesDossierTacheUpdate The updated Taches et rappels des dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierIdPatch: async (id: string, tachesEtRappelsDesDossierTacheUpdate: TachesEtRappelsDesDossierTacheUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTacheDossierIdPatch', 'id', id)
            // verify required parameter 'tachesEtRappelsDesDossierTacheUpdate' is not null or undefined
            assertParamExists('apiTacheDossierIdPatch', 'tachesEtRappelsDesDossierTacheUpdate', tachesEtRappelsDesDossierTacheUpdate)
            const localVarPath = `/formalite/tache-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tachesEtRappelsDesDossierTacheUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ajouter une tâche à un dossier
         * @summary Ajouter une tâche à un dossier
         * @param {ApiTacheDossierPostRequest} apiTacheDossierPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierPost: async (apiTacheDossierPostRequest: ApiTacheDossierPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiTacheDossierPostRequest' is not null or undefined
            assertParamExists('apiTacheDossierPost', 'apiTacheDossierPostRequest', apiTacheDossierPostRequest)
            const localVarPath = `/formalite/tache-dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTacheDossierPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupère toutes les tâches liées à des dossiers
         * @summary Lister les tâches de dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossier] 
         * @param {Array<string>} [dossier2] 
         * @param {string} [dossierNumero] 
         * @param {Array<string>} [dossierNumero2] 
         * @param {string} [tacheTitle] 
         * @param {string} [tacheAssignTo] 
         * @param {Array<string>} [tacheAssignTo2] 
         * @param {string} [tacheCreatedBy] 
         * @param {Array<string>} [tacheCreatedBy2] 
         * @param {number} [tachePriority] 
         * @param {Array<number>} [tachePriority2] 
         * @param {string} [tacheExpiredAtBefore] 
         * @param {string} [tacheExpiredAtStrictlyBefore] 
         * @param {string} [tacheExpiredAtAfter] 
         * @param {string} [tacheExpiredAtStrictlyAfter] 
         * @param {string} [tacheCreatedAtBefore] 
         * @param {string} [tacheCreatedAtStrictlyBefore] 
         * @param {string} [tacheCreatedAtAfter] 
         * @param {string} [tacheCreatedAtStrictlyAfter] 
         * @param {string} [tacheRemindAtBefore] 
         * @param {string} [tacheRemindAtStrictlyBefore] 
         * @param {string} [tacheRemindAtAfter] 
         * @param {string} [tacheRemindAtStrictlyAfter] 
         * @param {boolean} [tacheIsDone] 
         * @param {ApiTachesDossierGetCollectionOrderDossierNumeroEnum} [orderDossierNumero] 
         * @param {ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum} [orderTacheCreatedAt] 
         * @param {ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum} [orderTacheExpiredAt] 
         * @param {ApiTachesDossierGetCollectionOrderTacheIsDoneEnum} [orderTacheIsDone] 
         * @param {ApiTachesDossierGetCollectionOrderTacheTitleEnum} [orderTacheTitle] 
         * @param {ApiTachesDossierGetCollectionOrderTachePriorityEnum} [orderTachePriority] 
         * @param {ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum} [orderTacheAssignToPrenom] 
         * @param {ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum} [orderTacheAssignToNom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTachesDossierGetCollection: async (page?: number, itemsPerPage?: number, dossier?: string, dossier2?: Array<string>, dossierNumero?: string, dossierNumero2?: Array<string>, tacheTitle?: string, tacheAssignTo?: string, tacheAssignTo2?: Array<string>, tacheCreatedBy?: string, tacheCreatedBy2?: Array<string>, tachePriority?: number, tachePriority2?: Array<number>, tacheExpiredAtBefore?: string, tacheExpiredAtStrictlyBefore?: string, tacheExpiredAtAfter?: string, tacheExpiredAtStrictlyAfter?: string, tacheCreatedAtBefore?: string, tacheCreatedAtStrictlyBefore?: string, tacheCreatedAtAfter?: string, tacheCreatedAtStrictlyAfter?: string, tacheRemindAtBefore?: string, tacheRemindAtStrictlyBefore?: string, tacheRemindAtAfter?: string, tacheRemindAtStrictlyAfter?: string, tacheIsDone?: boolean, orderDossierNumero?: ApiTachesDossierGetCollectionOrderDossierNumeroEnum, orderTacheCreatedAt?: ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum, orderTacheExpiredAt?: ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum, orderTacheIsDone?: ApiTachesDossierGetCollectionOrderTacheIsDoneEnum, orderTacheTitle?: ApiTachesDossierGetCollectionOrderTacheTitleEnum, orderTachePriority?: ApiTachesDossierGetCollectionOrderTachePriorityEnum, orderTacheAssignToPrenom?: ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum, orderTacheAssignToNom?: ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/taches-dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossier !== undefined) {
                localVarQueryParameter['dossier'] = dossier;
            }

            if (dossier2) {
                localVarQueryParameter['dossier[]'] = dossier2;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (dossierNumero2) {
                localVarQueryParameter['dossier.numero[]'] = dossierNumero2;
            }

            if (tacheTitle !== undefined) {
                localVarQueryParameter['tache.title'] = tacheTitle;
            }

            if (tacheAssignTo !== undefined) {
                localVarQueryParameter['tache.assignTo'] = tacheAssignTo;
            }

            if (tacheAssignTo2) {
                localVarQueryParameter['tache.assignTo[]'] = tacheAssignTo2;
            }

            if (tacheCreatedBy !== undefined) {
                localVarQueryParameter['tache.createdBy'] = tacheCreatedBy;
            }

            if (tacheCreatedBy2) {
                localVarQueryParameter['tache.createdBy[]'] = tacheCreatedBy2;
            }

            if (tachePriority !== undefined) {
                localVarQueryParameter['tache.priority'] = tachePriority;
            }

            if (tachePriority2) {
                localVarQueryParameter['tache.priority[]'] = tachePriority2;
            }

            if (tacheExpiredAtBefore !== undefined) {
                localVarQueryParameter['tache.expiredAt[before]'] = tacheExpiredAtBefore;
            }

            if (tacheExpiredAtStrictlyBefore !== undefined) {
                localVarQueryParameter['tache.expiredAt[strictly_before]'] = tacheExpiredAtStrictlyBefore;
            }

            if (tacheExpiredAtAfter !== undefined) {
                localVarQueryParameter['tache.expiredAt[after]'] = tacheExpiredAtAfter;
            }

            if (tacheExpiredAtStrictlyAfter !== undefined) {
                localVarQueryParameter['tache.expiredAt[strictly_after]'] = tacheExpiredAtStrictlyAfter;
            }

            if (tacheCreatedAtBefore !== undefined) {
                localVarQueryParameter['tache.createdAt[before]'] = tacheCreatedAtBefore;
            }

            if (tacheCreatedAtStrictlyBefore !== undefined) {
                localVarQueryParameter['tache.createdAt[strictly_before]'] = tacheCreatedAtStrictlyBefore;
            }

            if (tacheCreatedAtAfter !== undefined) {
                localVarQueryParameter['tache.createdAt[after]'] = tacheCreatedAtAfter;
            }

            if (tacheCreatedAtStrictlyAfter !== undefined) {
                localVarQueryParameter['tache.createdAt[strictly_after]'] = tacheCreatedAtStrictlyAfter;
            }

            if (tacheRemindAtBefore !== undefined) {
                localVarQueryParameter['tache.remindAt[before]'] = tacheRemindAtBefore;
            }

            if (tacheRemindAtStrictlyBefore !== undefined) {
                localVarQueryParameter['tache.remindAt[strictly_before]'] = tacheRemindAtStrictlyBefore;
            }

            if (tacheRemindAtAfter !== undefined) {
                localVarQueryParameter['tache.remindAt[after]'] = tacheRemindAtAfter;
            }

            if (tacheRemindAtStrictlyAfter !== undefined) {
                localVarQueryParameter['tache.remindAt[strictly_after]'] = tacheRemindAtStrictlyAfter;
            }

            if (tacheIsDone !== undefined) {
                localVarQueryParameter['tache.isDone'] = tacheIsDone;
            }

            if (orderDossierNumero !== undefined) {
                localVarQueryParameter['order[dossier.numero]'] = orderDossierNumero;
            }

            if (orderTacheCreatedAt !== undefined) {
                localVarQueryParameter['order[tache.createdAt]'] = orderTacheCreatedAt;
            }

            if (orderTacheExpiredAt !== undefined) {
                localVarQueryParameter['order[tache.expiredAt]'] = orderTacheExpiredAt;
            }

            if (orderTacheIsDone !== undefined) {
                localVarQueryParameter['order[tache.isDone]'] = orderTacheIsDone;
            }

            if (orderTacheTitle !== undefined) {
                localVarQueryParameter['order[tache.title]'] = orderTacheTitle;
            }

            if (orderTachePriority !== undefined) {
                localVarQueryParameter['order[tache.priority]'] = orderTachePriority;
            }

            if (orderTacheAssignToPrenom !== undefined) {
                localVarQueryParameter['order[tache.assignTo.prenom]'] = orderTacheAssignToPrenom;
            }

            if (orderTacheAssignToNom !== undefined) {
                localVarQueryParameter['order[tache.assignTo.nom]'] = orderTacheAssignToNom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TachesEtRappelsDesDossierApi - functional programming interface
 * @export
 */
export const TachesEtRappelsDesDossierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TachesEtRappelsDesDossierApiAxiosParamCreator(configuration)
    return {
        /**
         * Suppression d\'une tache dossier
         * @summary Supprimer une tache dossier
         * @param {string} id TblRelTacheFproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTacheDossierIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTacheDossierIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TachesEtRappelsDesDossierApi.apiTacheDossierIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lire d\'une tache dossier
         * @summary Lire une tache dossier
         * @param {string} id TblRelTacheFproDossier identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTacheDossierIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TachesEtRappelsDesDossierJsonldTacheRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTacheDossierIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TachesEtRappelsDesDossierApi.apiTacheDossierIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edition d\'une tache dossier
         * @summary Editer une tache dossier
         * @param {string} id TblRelTacheFproDossier identifier
         * @param {TachesEtRappelsDesDossierTacheUpdate} tachesEtRappelsDesDossierTacheUpdate The updated Taches et rappels des dossier resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTacheDossierIdPatch(id: string, tachesEtRappelsDesDossierTacheUpdate: TachesEtRappelsDesDossierTacheUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TachesEtRappelsDesDossierJsonldTacheRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTacheDossierIdPatch(id, tachesEtRappelsDesDossierTacheUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TachesEtRappelsDesDossierApi.apiTacheDossierIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ajouter une tâche à un dossier
         * @summary Ajouter une tâche à un dossier
         * @param {ApiTacheDossierPostRequest} apiTacheDossierPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTacheDossierPost(apiTacheDossierPostRequest: ApiTacheDossierPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TachesEtRappelsDesDossierJsonldTacheRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTacheDossierPost(apiTacheDossierPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TachesEtRappelsDesDossierApi.apiTacheDossierPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupère toutes les tâches liées à des dossiers
         * @summary Lister les tâches de dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossier] 
         * @param {Array<string>} [dossier2] 
         * @param {string} [dossierNumero] 
         * @param {Array<string>} [dossierNumero2] 
         * @param {string} [tacheTitle] 
         * @param {string} [tacheAssignTo] 
         * @param {Array<string>} [tacheAssignTo2] 
         * @param {string} [tacheCreatedBy] 
         * @param {Array<string>} [tacheCreatedBy2] 
         * @param {number} [tachePriority] 
         * @param {Array<number>} [tachePriority2] 
         * @param {string} [tacheExpiredAtBefore] 
         * @param {string} [tacheExpiredAtStrictlyBefore] 
         * @param {string} [tacheExpiredAtAfter] 
         * @param {string} [tacheExpiredAtStrictlyAfter] 
         * @param {string} [tacheCreatedAtBefore] 
         * @param {string} [tacheCreatedAtStrictlyBefore] 
         * @param {string} [tacheCreatedAtAfter] 
         * @param {string} [tacheCreatedAtStrictlyAfter] 
         * @param {string} [tacheRemindAtBefore] 
         * @param {string} [tacheRemindAtStrictlyBefore] 
         * @param {string} [tacheRemindAtAfter] 
         * @param {string} [tacheRemindAtStrictlyAfter] 
         * @param {boolean} [tacheIsDone] 
         * @param {ApiTachesDossierGetCollectionOrderDossierNumeroEnum} [orderDossierNumero] 
         * @param {ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum} [orderTacheCreatedAt] 
         * @param {ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum} [orderTacheExpiredAt] 
         * @param {ApiTachesDossierGetCollectionOrderTacheIsDoneEnum} [orderTacheIsDone] 
         * @param {ApiTachesDossierGetCollectionOrderTacheTitleEnum} [orderTacheTitle] 
         * @param {ApiTachesDossierGetCollectionOrderTachePriorityEnum} [orderTachePriority] 
         * @param {ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum} [orderTacheAssignToPrenom] 
         * @param {ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum} [orderTacheAssignToNom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTachesDossierGetCollection(page?: number, itemsPerPage?: number, dossier?: string, dossier2?: Array<string>, dossierNumero?: string, dossierNumero2?: Array<string>, tacheTitle?: string, tacheAssignTo?: string, tacheAssignTo2?: Array<string>, tacheCreatedBy?: string, tacheCreatedBy2?: Array<string>, tachePriority?: number, tachePriority2?: Array<number>, tacheExpiredAtBefore?: string, tacheExpiredAtStrictlyBefore?: string, tacheExpiredAtAfter?: string, tacheExpiredAtStrictlyAfter?: string, tacheCreatedAtBefore?: string, tacheCreatedAtStrictlyBefore?: string, tacheCreatedAtAfter?: string, tacheCreatedAtStrictlyAfter?: string, tacheRemindAtBefore?: string, tacheRemindAtStrictlyBefore?: string, tacheRemindAtAfter?: string, tacheRemindAtStrictlyAfter?: string, tacheIsDone?: boolean, orderDossierNumero?: ApiTachesDossierGetCollectionOrderDossierNumeroEnum, orderTacheCreatedAt?: ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum, orderTacheExpiredAt?: ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum, orderTacheIsDone?: ApiTachesDossierGetCollectionOrderTacheIsDoneEnum, orderTacheTitle?: ApiTachesDossierGetCollectionOrderTacheTitleEnum, orderTachePriority?: ApiTachesDossierGetCollectionOrderTachePriorityEnum, orderTacheAssignToPrenom?: ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum, orderTacheAssignToNom?: ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTachesDossierGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTachesDossierGetCollection(page, itemsPerPage, dossier, dossier2, dossierNumero, dossierNumero2, tacheTitle, tacheAssignTo, tacheAssignTo2, tacheCreatedBy, tacheCreatedBy2, tachePriority, tachePriority2, tacheExpiredAtBefore, tacheExpiredAtStrictlyBefore, tacheExpiredAtAfter, tacheExpiredAtStrictlyAfter, tacheCreatedAtBefore, tacheCreatedAtStrictlyBefore, tacheCreatedAtAfter, tacheCreatedAtStrictlyAfter, tacheRemindAtBefore, tacheRemindAtStrictlyBefore, tacheRemindAtAfter, tacheRemindAtStrictlyAfter, tacheIsDone, orderDossierNumero, orderTacheCreatedAt, orderTacheExpiredAt, orderTacheIsDone, orderTacheTitle, orderTachePriority, orderTacheAssignToPrenom, orderTacheAssignToNom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TachesEtRappelsDesDossierApi.apiTachesDossierGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TachesEtRappelsDesDossierApi - factory interface
 * @export
 */
export const TachesEtRappelsDesDossierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TachesEtRappelsDesDossierApiFp(configuration)
    return {
        /**
         * Suppression d\'une tache dossier
         * @summary Supprimer une tache dossier
         * @param {TachesEtRappelsDesDossierApiApiTacheDossierIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierIdDelete(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTacheDossierIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lire d\'une tache dossier
         * @summary Lire une tache dossier
         * @param {TachesEtRappelsDesDossierApiApiTacheDossierIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierIdGet(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TachesEtRappelsDesDossierJsonldTacheRead> {
            return localVarFp.apiTacheDossierIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Edition d\'une tache dossier
         * @summary Editer une tache dossier
         * @param {TachesEtRappelsDesDossierApiApiTacheDossierIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierIdPatch(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TachesEtRappelsDesDossierJsonldTacheRead> {
            return localVarFp.apiTacheDossierIdPatch(requestParameters.id, requestParameters.tachesEtRappelsDesDossierTacheUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Ajouter une tâche à un dossier
         * @summary Ajouter une tâche à un dossier
         * @param {TachesEtRappelsDesDossierApiApiTacheDossierPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTacheDossierPost(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TachesEtRappelsDesDossierJsonldTacheRead> {
            return localVarFp.apiTacheDossierPost(requestParameters.apiTacheDossierPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupère toutes les tâches liées à des dossiers
         * @summary Lister les tâches de dossiers
         * @param {TachesEtRappelsDesDossierApiApiTachesDossierGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTachesDossierGetCollection(requestParameters: TachesEtRappelsDesDossierApiApiTachesDossierGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiTachesDossierGetCollection200Response> {
            return localVarFp.apiTachesDossierGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossier, requestParameters.dossier2, requestParameters.dossierNumero, requestParameters.dossierNumero2, requestParameters.tacheTitle, requestParameters.tacheAssignTo, requestParameters.tacheAssignTo2, requestParameters.tacheCreatedBy, requestParameters.tacheCreatedBy2, requestParameters.tachePriority, requestParameters.tachePriority2, requestParameters.tacheExpiredAtBefore, requestParameters.tacheExpiredAtStrictlyBefore, requestParameters.tacheExpiredAtAfter, requestParameters.tacheExpiredAtStrictlyAfter, requestParameters.tacheCreatedAtBefore, requestParameters.tacheCreatedAtStrictlyBefore, requestParameters.tacheCreatedAtAfter, requestParameters.tacheCreatedAtStrictlyAfter, requestParameters.tacheRemindAtBefore, requestParameters.tacheRemindAtStrictlyBefore, requestParameters.tacheRemindAtAfter, requestParameters.tacheRemindAtStrictlyAfter, requestParameters.tacheIsDone, requestParameters.orderDossierNumero, requestParameters.orderTacheCreatedAt, requestParameters.orderTacheExpiredAt, requestParameters.orderTacheIsDone, requestParameters.orderTacheTitle, requestParameters.orderTachePriority, requestParameters.orderTacheAssignToPrenom, requestParameters.orderTacheAssignToNom, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiTacheDossierIdDelete operation in TachesEtRappelsDesDossierApi.
 * @export
 * @interface TachesEtRappelsDesDossierApiApiTacheDossierIdDeleteRequest
 */
export interface TachesEtRappelsDesDossierApiApiTacheDossierIdDeleteRequest {
    /**
     * TblRelTacheFproDossier identifier
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTacheDossierIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiTacheDossierIdGet operation in TachesEtRappelsDesDossierApi.
 * @export
 * @interface TachesEtRappelsDesDossierApiApiTacheDossierIdGetRequest
 */
export interface TachesEtRappelsDesDossierApiApiTacheDossierIdGetRequest {
    /**
     * TblRelTacheFproDossier identifier
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTacheDossierIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiTacheDossierIdPatch operation in TachesEtRappelsDesDossierApi.
 * @export
 * @interface TachesEtRappelsDesDossierApiApiTacheDossierIdPatchRequest
 */
export interface TachesEtRappelsDesDossierApiApiTacheDossierIdPatchRequest {
    /**
     * TblRelTacheFproDossier identifier
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTacheDossierIdPatch
     */
    readonly id: string

    /**
     * The updated Taches et rappels des dossier resource
     * @type {TachesEtRappelsDesDossierTacheUpdate}
     * @memberof TachesEtRappelsDesDossierApiApiTacheDossierIdPatch
     */
    readonly tachesEtRappelsDesDossierTacheUpdate: TachesEtRappelsDesDossierTacheUpdate
}

/**
 * Request parameters for apiTacheDossierPost operation in TachesEtRappelsDesDossierApi.
 * @export
 * @interface TachesEtRappelsDesDossierApiApiTacheDossierPostRequest
 */
export interface TachesEtRappelsDesDossierApiApiTacheDossierPostRequest {
    /**
     * 
     * @type {ApiTacheDossierPostRequest}
     * @memberof TachesEtRappelsDesDossierApiApiTacheDossierPost
     */
    readonly apiTacheDossierPostRequest: ApiTacheDossierPostRequest
}

/**
 * Request parameters for apiTachesDossierGetCollection operation in TachesEtRappelsDesDossierApi.
 * @export
 * @interface TachesEtRappelsDesDossierApiApiTachesDossierGetCollectionRequest
 */
export interface TachesEtRappelsDesDossierApiApiTachesDossierGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly dossier?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly dossier2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly dossierNumero2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheTitle?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheAssignTo?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheAssignTo2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheCreatedBy?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheCreatedBy2?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tachePriority?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tachePriority2?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheExpiredAtBefore?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheExpiredAtStrictlyBefore?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheExpiredAtAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheExpiredAtStrictlyAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheCreatedAtBefore?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheCreatedAtStrictlyBefore?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheCreatedAtAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheCreatedAtStrictlyAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheRemindAtBefore?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheRemindAtStrictlyBefore?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheRemindAtAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheRemindAtStrictlyAfter?: string

    /**
     * 
     * @type {boolean}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly tacheIsDone?: boolean

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderDossierNumero?: ApiTachesDossierGetCollectionOrderDossierNumeroEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTacheCreatedAt?: ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTacheExpiredAt?: ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTacheIsDone?: ApiTachesDossierGetCollectionOrderTacheIsDoneEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTacheTitle?: ApiTachesDossierGetCollectionOrderTacheTitleEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTachePriority?: ApiTachesDossierGetCollectionOrderTachePriorityEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTacheAssignToPrenom?: ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TachesEtRappelsDesDossierApiApiTachesDossierGetCollection
     */
    readonly orderTacheAssignToNom?: ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum
}

/**
 * TachesEtRappelsDesDossierApi - object-oriented interface
 * @export
 * @class TachesEtRappelsDesDossierApi
 * @extends {BaseAPI}
 */
export class TachesEtRappelsDesDossierApi extends BaseAPI {
    /**
     * Suppression d\'une tache dossier
     * @summary Supprimer une tache dossier
     * @param {TachesEtRappelsDesDossierApiApiTacheDossierIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TachesEtRappelsDesDossierApi
     */
    public apiTacheDossierIdDelete(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TachesEtRappelsDesDossierApiFp(this.configuration).apiTacheDossierIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lire d\'une tache dossier
     * @summary Lire une tache dossier
     * @param {TachesEtRappelsDesDossierApiApiTacheDossierIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TachesEtRappelsDesDossierApi
     */
    public apiTacheDossierIdGet(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierIdGetRequest, options?: RawAxiosRequestConfig) {
        return TachesEtRappelsDesDossierApiFp(this.configuration).apiTacheDossierIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edition d\'une tache dossier
     * @summary Editer une tache dossier
     * @param {TachesEtRappelsDesDossierApiApiTacheDossierIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TachesEtRappelsDesDossierApi
     */
    public apiTacheDossierIdPatch(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TachesEtRappelsDesDossierApiFp(this.configuration).apiTacheDossierIdPatch(requestParameters.id, requestParameters.tachesEtRappelsDesDossierTacheUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ajouter une tâche à un dossier
     * @summary Ajouter une tâche à un dossier
     * @param {TachesEtRappelsDesDossierApiApiTacheDossierPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TachesEtRappelsDesDossierApi
     */
    public apiTacheDossierPost(requestParameters: TachesEtRappelsDesDossierApiApiTacheDossierPostRequest, options?: RawAxiosRequestConfig) {
        return TachesEtRappelsDesDossierApiFp(this.configuration).apiTacheDossierPost(requestParameters.apiTacheDossierPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupère toutes les tâches liées à des dossiers
     * @summary Lister les tâches de dossiers
     * @param {TachesEtRappelsDesDossierApiApiTachesDossierGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TachesEtRappelsDesDossierApi
     */
    public apiTachesDossierGetCollection(requestParameters: TachesEtRappelsDesDossierApiApiTachesDossierGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return TachesEtRappelsDesDossierApiFp(this.configuration).apiTachesDossierGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossier, requestParameters.dossier2, requestParameters.dossierNumero, requestParameters.dossierNumero2, requestParameters.tacheTitle, requestParameters.tacheAssignTo, requestParameters.tacheAssignTo2, requestParameters.tacheCreatedBy, requestParameters.tacheCreatedBy2, requestParameters.tachePriority, requestParameters.tachePriority2, requestParameters.tacheExpiredAtBefore, requestParameters.tacheExpiredAtStrictlyBefore, requestParameters.tacheExpiredAtAfter, requestParameters.tacheExpiredAtStrictlyAfter, requestParameters.tacheCreatedAtBefore, requestParameters.tacheCreatedAtStrictlyBefore, requestParameters.tacheCreatedAtAfter, requestParameters.tacheCreatedAtStrictlyAfter, requestParameters.tacheRemindAtBefore, requestParameters.tacheRemindAtStrictlyBefore, requestParameters.tacheRemindAtAfter, requestParameters.tacheRemindAtStrictlyAfter, requestParameters.tacheIsDone, requestParameters.orderDossierNumero, requestParameters.orderTacheCreatedAt, requestParameters.orderTacheExpiredAt, requestParameters.orderTacheIsDone, requestParameters.orderTacheTitle, requestParameters.orderTachePriority, requestParameters.orderTacheAssignToPrenom, requestParameters.orderTacheAssignToNom, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderDossierNumeroEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderDossierNumeroEnum = typeof ApiTachesDossierGetCollectionOrderDossierNumeroEnum[keyof typeof ApiTachesDossierGetCollectionOrderDossierNumeroEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum = typeof ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum[keyof typeof ApiTachesDossierGetCollectionOrderTacheCreatedAtEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum = typeof ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum[keyof typeof ApiTachesDossierGetCollectionOrderTacheExpiredAtEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTacheIsDoneEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTacheIsDoneEnum = typeof ApiTachesDossierGetCollectionOrderTacheIsDoneEnum[keyof typeof ApiTachesDossierGetCollectionOrderTacheIsDoneEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTacheTitleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTacheTitleEnum = typeof ApiTachesDossierGetCollectionOrderTacheTitleEnum[keyof typeof ApiTachesDossierGetCollectionOrderTacheTitleEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTachePriorityEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTachePriorityEnum = typeof ApiTachesDossierGetCollectionOrderTachePriorityEnum[keyof typeof ApiTachesDossierGetCollectionOrderTachePriorityEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum = typeof ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum[keyof typeof ApiTachesDossierGetCollectionOrderTacheAssignToPrenomEnum];
/**
 * @export
 */
export const ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum = typeof ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum[keyof typeof ApiTachesDossierGetCollectionOrderTacheAssignToNomEnum];


/**
 * TapesDeTraitementDesDossiersApi - axios parameter creator
 * @export
 */
export const TapesDeTraitementDesDossiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les étapes de traitement des dossiers
         * @summary Lister les étapes de traitement des dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEtapesDossiersGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/etapes-dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TapesDeTraitementDesDossiersApi - functional programming interface
 * @export
 */
export const TapesDeTraitementDesDossiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TapesDeTraitementDesDossiersApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les étapes de traitement des dossiers
         * @summary Lister les étapes de traitement des dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEtapesDossiersGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiEtapesDossiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEtapesDossiersGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TapesDeTraitementDesDossiersApi.apiEtapesDossiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TapesDeTraitementDesDossiersApi - factory interface
 * @export
 */
export const TapesDeTraitementDesDossiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TapesDeTraitementDesDossiersApiFp(configuration)
    return {
        /**
         * Lister les étapes de traitement des dossiers
         * @summary Lister les étapes de traitement des dossiers
         * @param {TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEtapesDossiersGetCollection(requestParameters: TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiEtapesDossiersGetCollection200Response> {
            return localVarFp.apiEtapesDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiEtapesDossiersGetCollection operation in TapesDeTraitementDesDossiersApi.
 * @export
 * @interface TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollectionRequest
 */
export interface TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * TapesDeTraitementDesDossiersApi - object-oriented interface
 * @export
 * @class TapesDeTraitementDesDossiersApi
 * @extends {BaseAPI}
 */
export class TapesDeTraitementDesDossiersApi extends BaseAPI {
    /**
     * Lister les étapes de traitement des dossiers
     * @summary Lister les étapes de traitement des dossiers
     * @param {TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TapesDeTraitementDesDossiersApi
     */
    public apiEtapesDossiersGetCollection(requestParameters: TapesDeTraitementDesDossiersApiApiEtapesDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return TapesDeTraitementDesDossiersApiFp(this.configuration).apiEtapesDossiersGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TiersApi - axios parameter creator
 * @export
 */
export const TiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Tiers resources.
         * @summary supprimer les fichiers des dossiers d\'un prescripteur
         * @param {number} idPrescripteur Identifiant du prescripteur
         * @param {number} idSociete Société du prescripteur
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection: async (idPrescripteur: number, idSociete: number, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPrescripteur' is not null or undefined
            assertParamExists('apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection', 'idPrescripteur', idPrescripteur)
            // verify required parameter 'idSociete' is not null or undefined
            assertParamExists('apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection', 'idSociete', idSociete)
            const localVarPath = `/formalite/prescripteur/{idPrescripteur}/societe/{idSociete}/purge-fichiers`
                .replace(`{${"idPrescripteur"}}`, encodeURIComponent(String(idPrescripteur)))
                .replace(`{${"idSociete"}}`, encodeURIComponent(String(idSociete)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TiersApi - functional programming interface
 * @export
 */
export const TiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TiersApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Tiers resources.
         * @summary supprimer les fichiers des dossiers d\'un prescripteur
         * @param {number} idPrescripteur Identifiant du prescripteur
         * @param {number} idSociete Société du prescripteur
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection(idPrescripteur: number, idSociete: number, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection(idPrescripteur, idSociete, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TiersApi - factory interface
 * @export
 */
export const TiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TiersApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Tiers resources.
         * @summary supprimer les fichiers des dossiers d\'un prescripteur
         * @param {TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection(requestParameters: TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection200Response> {
            return localVarFp.apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection(requestParameters.idPrescripteur, requestParameters.idSociete, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection operation in TiersApi.
 * @export
 * @interface TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollectionRequest
 */
export interface TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollectionRequest {
    /**
     * Identifiant du prescripteur
     * @type {number}
     * @memberof TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection
     */
    readonly idPrescripteur: number

    /**
     * Société du prescripteur
     * @type {number}
     * @memberof TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection
     */
    readonly idSociete: number

    /**
     * The collection page number
     * @type {number}
     * @memberof TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * TiersApi - object-oriented interface
 * @export
 * @class TiersApi
 * @extends {BaseAPI}
 */
export class TiersApi extends BaseAPI {
    /**
     * Retrieves the collection of Tiers resources.
     * @summary supprimer les fichiers des dossiers d\'un prescripteur
     * @param {TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection(requestParameters: TiersApiApiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).apiPrescripteurIdPrescripteurSocieteIdSocietePurgeFichiersGetCollection(requestParameters.idPrescripteur, requestParameters.idSociete, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypeDeDocumentApi - axios parameter creator
 * @export
 */
export const TypeDeDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des types de document
         * @summary Obtenir la liste des types de document
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [type] 
         * @param {Array<number>} [type2] 
         * @param {number} [domaineId] 
         * @param {Array<number>} [domaineId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsGetCollection: async (page?: number, itemsPerPage?: number, type?: number, type2?: Array<number>, domaineId?: number, domaineId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/types-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (type2) {
                localVarQueryParameter['type[]'] = type2;
            }

            if (domaineId !== undefined) {
                localVarQueryParameter['domaine.id'] = domaineId;
            }

            if (domaineId2) {
                localVarQueryParameter['domaine.id[]'] = domaineId2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer une relation type de document
         * @summary Supprimer une relation type de document
         * @param {string} id TblTypeDocument identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocumentsIdDelete', 'id', id)
            const localVarPath = `/formalite/types-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une relation type de document
         * @summary Récupérer les informations d\'une relation type de document
         * @param {string} id TblTypeDocument identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocumentsIdGet', 'id', id)
            const localVarPath = `/formalite/types-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Type de document resource.
         * @summary Modifier un type de document
         * @param {string} id TblTypeDocument identifier
         * @param {TypeDeDocumentJsonldTypedocumentUpdate} typeDeDocumentJsonldTypedocumentUpdate The updated Type de document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsIdPut: async (id: string, typeDeDocumentJsonldTypedocumentUpdate: TypeDeDocumentJsonldTypedocumentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocumentsIdPut', 'id', id)
            // verify required parameter 'typeDeDocumentJsonldTypedocumentUpdate' is not null or undefined
            assertParamExists('apiTypesDocumentsIdPut', 'typeDeDocumentJsonldTypedocumentUpdate', typeDeDocumentJsonldTypedocumentUpdate)
            const localVarPath = `/formalite/types-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typeDeDocumentJsonldTypedocumentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Type de document resource.
         * @summary Ajouter un type de document
         * @param {TypeDeDocumentJsonldTypedocumentCreate} typeDeDocumentJsonldTypedocumentCreate The new Type de document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsPost: async (typeDeDocumentJsonldTypedocumentCreate: TypeDeDocumentJsonldTypedocumentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeDeDocumentJsonldTypedocumentCreate' is not null or undefined
            assertParamExists('apiTypesDocumentsPost', 'typeDeDocumentJsonldTypedocumentCreate', typeDeDocumentJsonldTypedocumentCreate)
            const localVarPath = `/formalite/types-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typeDeDocumentJsonldTypedocumentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypeDeDocumentApi - functional programming interface
 * @export
 */
export const TypeDeDocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypeDeDocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des types de document
         * @summary Obtenir la liste des types de document
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [type] 
         * @param {Array<number>} [type2] 
         * @param {number} [domaineId] 
         * @param {Array<number>} [domaineId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocumentsGetCollection(page?: number, itemsPerPage?: number, type?: number, type2?: Array<number>, domaineId?: number, domaineId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTypesDocumentsGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocumentsGetCollection(page, itemsPerPage, type, type2, domaineId, domaineId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentApi.apiTypesDocumentsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer une relation type de document
         * @summary Supprimer une relation type de document
         * @param {string} id TblTypeDocument identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocumentsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocumentsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentApi.apiTypesDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une relation type de document
         * @summary Récupérer les informations d\'une relation type de document
         * @param {string} id TblTypeDocument identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocumentsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentJsonldTypedocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocumentsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentApi.apiTypesDocumentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Type de document resource.
         * @summary Modifier un type de document
         * @param {string} id TblTypeDocument identifier
         * @param {TypeDeDocumentJsonldTypedocumentUpdate} typeDeDocumentJsonldTypedocumentUpdate The updated Type de document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocumentsIdPut(id: string, typeDeDocumentJsonldTypedocumentUpdate: TypeDeDocumentJsonldTypedocumentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentJsonldTypedocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocumentsIdPut(id, typeDeDocumentJsonldTypedocumentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentApi.apiTypesDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Type de document resource.
         * @summary Ajouter un type de document
         * @param {TypeDeDocumentJsonldTypedocumentCreate} typeDeDocumentJsonldTypedocumentCreate The new Type de document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocumentsPost(typeDeDocumentJsonldTypedocumentCreate: TypeDeDocumentJsonldTypedocumentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentJsonldTypedocumentCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocumentsPost(typeDeDocumentJsonldTypedocumentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentApi.apiTypesDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypeDeDocumentApi - factory interface
 * @export
 */
export const TypeDeDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypeDeDocumentApiFp(configuration)
    return {
        /**
         * Obtenir la liste des types de document
         * @summary Obtenir la liste des types de document
         * @param {TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsGetCollection(requestParameters: TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiTypesDocumentsGetCollection200Response> {
            return localVarFp.apiTypesDocumentsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.type, requestParameters.type2, requestParameters.domaineId, requestParameters.domaineId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer une relation type de document
         * @summary Supprimer une relation type de document
         * @param {TypeDeDocumentApiApiTypesDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsIdDelete(requestParameters: TypeDeDocumentApiApiTypesDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTypesDocumentsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une relation type de document
         * @summary Récupérer les informations d\'une relation type de document
         * @param {TypeDeDocumentApiApiTypesDocumentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsIdGet(requestParameters: TypeDeDocumentApiApiTypesDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentJsonldTypedocumentRead> {
            return localVarFp.apiTypesDocumentsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Type de document resource.
         * @summary Modifier un type de document
         * @param {TypeDeDocumentApiApiTypesDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsIdPut(requestParameters: TypeDeDocumentApiApiTypesDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentJsonldTypedocumentRead> {
            return localVarFp.apiTypesDocumentsIdPut(requestParameters.id, requestParameters.typeDeDocumentJsonldTypedocumentUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Type de document resource.
         * @summary Ajouter un type de document
         * @param {TypeDeDocumentApiApiTypesDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocumentsPost(requestParameters: TypeDeDocumentApiApiTypesDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentJsonldTypedocumentCreated> {
            return localVarFp.apiTypesDocumentsPost(requestParameters.typeDeDocumentJsonldTypedocumentCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiTypesDocumentsGetCollection operation in TypeDeDocumentApi.
 * @export
 * @interface TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest
 */
export interface TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof TypeDeDocumentApiApiTypesDocumentsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof TypeDeDocumentApiApiTypesDocumentsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentApiApiTypesDocumentsGetCollection
     */
    readonly type?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof TypeDeDocumentApiApiTypesDocumentsGetCollection
     */
    readonly type2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof TypeDeDocumentApiApiTypesDocumentsGetCollection
     */
    readonly domaineId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof TypeDeDocumentApiApiTypesDocumentsGetCollection
     */
    readonly domaineId2?: Array<number>
}

/**
 * Request parameters for apiTypesDocumentsIdDelete operation in TypeDeDocumentApi.
 * @export
 * @interface TypeDeDocumentApiApiTypesDocumentsIdDeleteRequest
 */
export interface TypeDeDocumentApiApiTypesDocumentsIdDeleteRequest {
    /**
     * TblTypeDocument identifier
     * @type {string}
     * @memberof TypeDeDocumentApiApiTypesDocumentsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiTypesDocumentsIdGet operation in TypeDeDocumentApi.
 * @export
 * @interface TypeDeDocumentApiApiTypesDocumentsIdGetRequest
 */
export interface TypeDeDocumentApiApiTypesDocumentsIdGetRequest {
    /**
     * TblTypeDocument identifier
     * @type {string}
     * @memberof TypeDeDocumentApiApiTypesDocumentsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiTypesDocumentsIdPut operation in TypeDeDocumentApi.
 * @export
 * @interface TypeDeDocumentApiApiTypesDocumentsIdPutRequest
 */
export interface TypeDeDocumentApiApiTypesDocumentsIdPutRequest {
    /**
     * TblTypeDocument identifier
     * @type {string}
     * @memberof TypeDeDocumentApiApiTypesDocumentsIdPut
     */
    readonly id: string

    /**
     * The updated Type de document resource
     * @type {TypeDeDocumentJsonldTypedocumentUpdate}
     * @memberof TypeDeDocumentApiApiTypesDocumentsIdPut
     */
    readonly typeDeDocumentJsonldTypedocumentUpdate: TypeDeDocumentJsonldTypedocumentUpdate
}

/**
 * Request parameters for apiTypesDocumentsPost operation in TypeDeDocumentApi.
 * @export
 * @interface TypeDeDocumentApiApiTypesDocumentsPostRequest
 */
export interface TypeDeDocumentApiApiTypesDocumentsPostRequest {
    /**
     * The new Type de document resource
     * @type {TypeDeDocumentJsonldTypedocumentCreate}
     * @memberof TypeDeDocumentApiApiTypesDocumentsPost
     */
    readonly typeDeDocumentJsonldTypedocumentCreate: TypeDeDocumentJsonldTypedocumentCreate
}

/**
 * TypeDeDocumentApi - object-oriented interface
 * @export
 * @class TypeDeDocumentApi
 * @extends {BaseAPI}
 */
export class TypeDeDocumentApi extends BaseAPI {
    /**
     * Obtenir la liste des types de document
     * @summary Obtenir la liste des types de document
     * @param {TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentApi
     */
    public apiTypesDocumentsGetCollection(requestParameters: TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentApiFp(this.configuration).apiTypesDocumentsGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.type, requestParameters.type2, requestParameters.domaineId, requestParameters.domaineId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer une relation type de document
     * @summary Supprimer une relation type de document
     * @param {TypeDeDocumentApiApiTypesDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentApi
     */
    public apiTypesDocumentsIdDelete(requestParameters: TypeDeDocumentApiApiTypesDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentApiFp(this.configuration).apiTypesDocumentsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une relation type de document
     * @summary Récupérer les informations d\'une relation type de document
     * @param {TypeDeDocumentApiApiTypesDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentApi
     */
    public apiTypesDocumentsIdGet(requestParameters: TypeDeDocumentApiApiTypesDocumentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentApiFp(this.configuration).apiTypesDocumentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Type de document resource.
     * @summary Modifier un type de document
     * @param {TypeDeDocumentApiApiTypesDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentApi
     */
    public apiTypesDocumentsIdPut(requestParameters: TypeDeDocumentApiApiTypesDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentApiFp(this.configuration).apiTypesDocumentsIdPut(requestParameters.id, requestParameters.typeDeDocumentJsonldTypedocumentUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Type de document resource.
     * @summary Ajouter un type de document
     * @param {TypeDeDocumentApiApiTypesDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentApi
     */
    public apiTypesDocumentsPost(requestParameters: TypeDeDocumentApiApiTypesDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentApiFp(this.configuration).apiTypesDocumentsPost(requestParameters.typeDeDocumentJsonldTypedocumentCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypeDeDocumentDesDossiersApi - axios parameter creator
 * @export
 */
export const TypeDeDocumentDesDossiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des types de document liés au(x) dossier(s)
         * @summary Obtenir la liste des types de document liés au(x) dossier(s)
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {Array<string>} [dossierNumero2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierTypesDocDossierGetCollection: async (dossier: string, page?: number, itemsPerPage?: number, dossierNumero?: string, dossierNumero2?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierTypesDocDossierGetCollection', 'dossier', dossier)
            const localVarPath = `/formalite/dossiers/{dossier}/types-doc-dossier`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (dossierNumero2) {
                localVarQueryParameter['dossier.numero[]'] = dossierNumero2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer une relation type de document dossier
         * @summary Supprimer une relation type de document dossier
         * @param {string} id FproDossierDoc identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocDossierIdDelete', 'id', id)
            const localVarPath = `/formalite/types-doc-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une relation type de document dossier
         * @summary Récupérer les informations d\'une relation type de document dossier
         * @param {string} id FproDossierDoc identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocDossierIdGet', 'id', id)
            const localVarPath = `/formalite/types-doc-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Type de document des dossiers resource.
         * @summary Updates the Type de document des dossiers resource.
         * @param {string} id FproDossierDoc identifier
         * @param {TypeDeDocumentDesDossiersTypedocumentPatch} typeDeDocumentDesDossiersTypedocumentPatch The updated Type de document des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdPatch: async (id: string, typeDeDocumentDesDossiersTypedocumentPatch: TypeDeDocumentDesDossiersTypedocumentPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocDossierIdPatch', 'id', id)
            // verify required parameter 'typeDeDocumentDesDossiersTypedocumentPatch' is not null or undefined
            assertParamExists('apiTypesDocDossierIdPatch', 'typeDeDocumentDesDossiersTypedocumentPatch', typeDeDocumentDesDossiersTypedocumentPatch)
            const localVarPath = `/formalite/types-doc-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typeDeDocumentDesDossiersTypedocumentPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Type de document des dossiers resource.
         * @summary Modifier une relation type de document dossier
         * @param {string} id FproDossierDoc identifier
         * @param {TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate} typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate The updated Type de document des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdPut: async (id: string, typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate: TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTypesDocDossierIdPut', 'id', id)
            // verify required parameter 'typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate' is not null or undefined
            assertParamExists('apiTypesDocDossierIdPut', 'typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate', typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate)
            const localVarPath = `/formalite/types-doc-dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Type de document des dossiers resource.
         * @summary Créer une relation type de document dossier
         * @param {TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate} typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate The new Type de document des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierPost: async (typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate: TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate' is not null or undefined
            assertParamExists('apiTypesDocDossierPost', 'typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate', typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate)
            const localVarPath = `/formalite/types-doc-dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypeDeDocumentDesDossiersApi - functional programming interface
 * @export
 */
export const TypeDeDocumentDesDossiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypeDeDocumentDesDossiersApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des types de document liés au(x) dossier(s)
         * @summary Obtenir la liste des types de document liés au(x) dossier(s)
         * @param {string} dossier FproDossier identifier
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [dossierNumero] 
         * @param {Array<string>} [dossierNumero2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierTypesDocDossierGetCollection(dossier: string, page?: number, itemsPerPage?: number, dossierNumero?: string, dossierNumero2?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierTypesDocDossierGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierTypesDocDossierGetCollection(dossier, page, itemsPerPage, dossierNumero, dossierNumero2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentDesDossiersApi.apiDossiersDossierTypesDocDossierGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer une relation type de document dossier
         * @summary Supprimer une relation type de document dossier
         * @param {string} id FproDossierDoc identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocDossierIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocDossierIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentDesDossiersApi.apiTypesDocDossierIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une relation type de document dossier
         * @summary Récupérer les informations d\'une relation type de document dossier
         * @param {string} id FproDossierDoc identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocDossierIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocDossierIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentDesDossiersApi.apiTypesDocDossierIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Type de document des dossiers resource.
         * @summary Updates the Type de document des dossiers resource.
         * @param {string} id FproDossierDoc identifier
         * @param {TypeDeDocumentDesDossiersTypedocumentPatch} typeDeDocumentDesDossiersTypedocumentPatch The updated Type de document des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocDossierIdPatch(id: string, typeDeDocumentDesDossiersTypedocumentPatch: TypeDeDocumentDesDossiersTypedocumentPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocDossierIdPatch(id, typeDeDocumentDesDossiersTypedocumentPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentDesDossiersApi.apiTypesDocDossierIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Type de document des dossiers resource.
         * @summary Modifier une relation type de document dossier
         * @param {string} id FproDossierDoc identifier
         * @param {TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate} typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate The updated Type de document des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocDossierIdPut(id: string, typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate: TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocDossierIdPut(id, typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentDesDossiersApi.apiTypesDocDossierIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Type de document des dossiers resource.
         * @summary Créer une relation type de document dossier
         * @param {TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate} typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate The new Type de document des dossiers resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTypesDocDossierPost(typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate: TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTypesDocDossierPost(typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypeDeDocumentDesDossiersApi.apiTypesDocDossierPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypeDeDocumentDesDossiersApi - factory interface
 * @export
 */
export const TypeDeDocumentDesDossiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypeDeDocumentDesDossiersApiFp(configuration)
    return {
        /**
         * Obtenir la liste des types de document liés au(x) dossier(s)
         * @summary Obtenir la liste des types de document liés au(x) dossier(s)
         * @param {TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierTypesDocDossierGetCollection(requestParameters: TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierTypesDocDossierGetCollection200Response> {
            return localVarFp.apiDossiersDossierTypesDocDossierGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.dossierNumero2, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer une relation type de document dossier
         * @summary Supprimer une relation type de document dossier
         * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdDelete(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTypesDocDossierIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une relation type de document dossier
         * @summary Récupérer les informations d\'une relation type de document dossier
         * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdGet(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead> {
            return localVarFp.apiTypesDocDossierIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Type de document des dossiers resource.
         * @summary Updates the Type de document des dossiers resource.
         * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdPatch(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead> {
            return localVarFp.apiTypesDocDossierIdPatch(requestParameters.id, requestParameters.typeDeDocumentDesDossiersTypedocumentPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Type de document des dossiers resource.
         * @summary Modifier une relation type de document dossier
         * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierIdPut(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierRead> {
            return localVarFp.apiTypesDocDossierIdPut(requestParameters.id, requestParameters.typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Type de document des dossiers resource.
         * @summary Créer une relation type de document dossier
         * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTypesDocDossierPost(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreated> {
            return localVarFp.apiTypesDocDossierPost(requestParameters.typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierTypesDocDossierGetCollection operation in TypeDeDocumentDesDossiersApi.
 * @export
 * @interface TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollectionRequest
 */
export interface TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollection
     */
    readonly dossier: string

    /**
     * The collection page number
     * @type {number}
     * @memberof TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollection
     */
    readonly dossierNumero2?: Array<string>
}

/**
 * Request parameters for apiTypesDocDossierIdDelete operation in TypeDeDocumentDesDossiersApi.
 * @export
 * @interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDeleteRequest
 */
export interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDeleteRequest {
    /**
     * FproDossierDoc identifier
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiTypesDocDossierIdGet operation in TypeDeDocumentDesDossiersApi.
 * @export
 * @interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGetRequest
 */
export interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGetRequest {
    /**
     * FproDossierDoc identifier
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiTypesDocDossierIdPatch operation in TypeDeDocumentDesDossiersApi.
 * @export
 * @interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatchRequest
 */
export interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatchRequest {
    /**
     * FproDossierDoc identifier
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatch
     */
    readonly id: string

    /**
     * The updated Type de document des dossiers resource
     * @type {TypeDeDocumentDesDossiersTypedocumentPatch}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatch
     */
    readonly typeDeDocumentDesDossiersTypedocumentPatch: TypeDeDocumentDesDossiersTypedocumentPatch
}

/**
 * Request parameters for apiTypesDocDossierIdPut operation in TypeDeDocumentDesDossiersApi.
 * @export
 * @interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPutRequest
 */
export interface TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPutRequest {
    /**
     * FproDossierDoc identifier
     * @type {string}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPut
     */
    readonly id: string

    /**
     * The updated Type de document des dossiers resource
     * @type {TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPut
     */
    readonly typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate: TypeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate
}

/**
 * Request parameters for apiTypesDocDossierPost operation in TypeDeDocumentDesDossiersApi.
 * @export
 * @interface TypeDeDocumentDesDossiersApiApiTypesDocDossierPostRequest
 */
export interface TypeDeDocumentDesDossiersApiApiTypesDocDossierPostRequest {
    /**
     * The new Type de document des dossiers resource
     * @type {TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate}
     * @memberof TypeDeDocumentDesDossiersApiApiTypesDocDossierPost
     */
    readonly typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate: TypeDeDocumentDesDossiersJsonldTypedocumentdossierCreate
}

/**
 * TypeDeDocumentDesDossiersApi - object-oriented interface
 * @export
 * @class TypeDeDocumentDesDossiersApi
 * @extends {BaseAPI}
 */
export class TypeDeDocumentDesDossiersApi extends BaseAPI {
    /**
     * Obtenir la liste des types de document liés au(x) dossier(s)
     * @summary Obtenir la liste des types de document liés au(x) dossier(s)
     * @param {TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentDesDossiersApi
     */
    public apiDossiersDossierTypesDocDossierGetCollection(requestParameters: TypeDeDocumentDesDossiersApiApiDossiersDossierTypesDocDossierGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentDesDossiersApiFp(this.configuration).apiDossiersDossierTypesDocDossierGetCollection(requestParameters.dossier, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierNumero, requestParameters.dossierNumero2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer une relation type de document dossier
     * @summary Supprimer une relation type de document dossier
     * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentDesDossiersApi
     */
    public apiTypesDocDossierIdDelete(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentDesDossiersApiFp(this.configuration).apiTypesDocDossierIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une relation type de document dossier
     * @summary Récupérer les informations d\'une relation type de document dossier
     * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentDesDossiersApi
     */
    public apiTypesDocDossierIdGet(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdGetRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentDesDossiersApiFp(this.configuration).apiTypesDocDossierIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Type de document des dossiers resource.
     * @summary Updates the Type de document des dossiers resource.
     * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentDesDossiersApi
     */
    public apiTypesDocDossierIdPatch(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentDesDossiersApiFp(this.configuration).apiTypesDocDossierIdPatch(requestParameters.id, requestParameters.typeDeDocumentDesDossiersTypedocumentPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Type de document des dossiers resource.
     * @summary Modifier une relation type de document dossier
     * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentDesDossiersApi
     */
    public apiTypesDocDossierIdPut(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierIdPutRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentDesDossiersApiFp(this.configuration).apiTypesDocDossierIdPut(requestParameters.id, requestParameters.typeDeDocumentDesDossiersJsonldTypedocumentdossierUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Type de document des dossiers resource.
     * @summary Créer une relation type de document dossier
     * @param {TypeDeDocumentDesDossiersApiApiTypesDocDossierPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeDeDocumentDesDossiersApi
     */
    public apiTypesDocDossierPost(requestParameters: TypeDeDocumentDesDossiersApiApiTypesDocDossierPostRequest, options?: RawAxiosRequestConfig) {
        return TypeDeDocumentDesDossiersApiFp(this.configuration).apiTypesDocDossierPost(requestParameters.typeDeDocumentDesDossiersJsonldTypedocumentdossierCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ValideursDesDossiersApi - axios parameter creator
 * @export
 */
export const ValideursDesDossiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les valideurs des dossiers
         * @summary Lister les valideurs des dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValideursGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formalite/dossiers-valideurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un valideur de dossier
         * @summary Récupérer les informations d\'un valideur de dossier
         * @param {string} id FproDossierValidator identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValideursIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDossiersValideursIdGet', 'id', id)
            const localVarPath = `/formalite/dossiers-valideurs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValideursDesDossiersApi - functional programming interface
 * @export
 */
export const ValideursDesDossiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValideursDesDossiersApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les valideurs des dossiers
         * @summary Lister les valideurs des dossiers
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersValideursGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersValideursGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersValideursGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValideursDesDossiersApi.apiDossiersValideursGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un valideur de dossier
         * @summary Récupérer les informations d\'un valideur de dossier
         * @param {string} id FproDossierValidator identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersValideursIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersValideursIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValideursDesDossiersApi.apiDossiersValideursIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValideursDesDossiersApi - factory interface
 * @export
 */
export const ValideursDesDossiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValideursDesDossiersApiFp(configuration)
    return {
        /**
         * Lister les valideurs des dossiers
         * @summary Lister les valideurs des dossiers
         * @param {ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValideursGetCollection(requestParameters: ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersValideursGetCollection200Response> {
            return localVarFp.apiDossiersValideursGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un valideur de dossier
         * @summary Récupérer les informations d\'un valideur de dossier
         * @param {ValideursDesDossiersApiApiDossiersValideursIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersValideursIdGet(requestParameters: ValideursDesDossiersApiApiDossiersValideursIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead> {
            return localVarFp.apiDossiersValideursIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersValideursGetCollection operation in ValideursDesDossiersApi.
 * @export
 * @interface ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest
 */
export interface ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ValideursDesDossiersApiApiDossiersValideursGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ValideursDesDossiersApiApiDossiersValideursGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for apiDossiersValideursIdGet operation in ValideursDesDossiersApi.
 * @export
 * @interface ValideursDesDossiersApiApiDossiersValideursIdGetRequest
 */
export interface ValideursDesDossiersApiApiDossiersValideursIdGetRequest {
    /**
     * FproDossierValidator identifier
     * @type {string}
     * @memberof ValideursDesDossiersApiApiDossiersValideursIdGet
     */
    readonly id: string
}

/**
 * ValideursDesDossiersApi - object-oriented interface
 * @export
 * @class ValideursDesDossiersApi
 * @extends {BaseAPI}
 */
export class ValideursDesDossiersApi extends BaseAPI {
    /**
     * Lister les valideurs des dossiers
     * @summary Lister les valideurs des dossiers
     * @param {ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValideursDesDossiersApi
     */
    public apiDossiersValideursGetCollection(requestParameters: ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ValideursDesDossiersApiFp(this.configuration).apiDossiersValideursGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un valideur de dossier
     * @summary Récupérer les informations d\'un valideur de dossier
     * @param {ValideursDesDossiersApiApiDossiersValideursIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValideursDesDossiersApi
     */
    public apiDossiersValideursIdGet(requestParameters: ValideursDesDossiersApiApiDossiersValideursIdGetRequest, options?: RawAxiosRequestConfig) {
        return ValideursDesDossiersApiFp(this.configuration).apiDossiersValideursIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



